(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!**************************************************!*\
  !*** ./node_modules/moment/locale sync ^\.\/.*$ ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-SG": "./node_modules/moment/locale/en-SG.js",
	"./en-SG.js": "./node_modules/moment/locale/en-SG.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-agencia/administracion-agencia.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-agencia/administracion-agencia.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Administracion Agencias</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <form [formGroup]=\"agenciaGroup\" (ngSubmit)=\"procesoAgencia();\">\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\">\r\n        <mat-form-field>\r\n          <input matInput formControlName=\"formDescripcion\" placeholder=\"Descripción\">\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\" style=\"text-align: center;\">\r\n        <button *ngIf=\"!isEdit\" type=\"submit\" [disabled]=\"!agenciaGroup.valid || loading\" mat-raised-button color=\"primary\">Crear</button>\r\n        <button *ngIf=\"isEdit\" type=\"submit\" [disabled]=\"!agenciaGroup.valid || loading\" mat-raised-button color=\"accent\">Editar</button>&nbsp;&nbsp;\r\n        <button *ngIf=\"isEdit\" type=\"button\" (click)=\"cancelarEdit();\" mat-raised-button color=\"warn\">Cancelar</button>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n  </form>\r\n</mat-expansion-panel>\r\n\r\n<br>\r\n\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Listado Agencias</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"row\">\r\n    <div class=\"col s3 m3 l3\"></div>\r\n    <div class=\"col s6 m6 l6\">\r\n      <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n      <table [hidden]=\"!haveData\" datatable [dtOptions]=\"dtOptions\" [dtTrigger]=\"dtTrigger\" class=\"display\"\r\n        style=\"width:100%\">\r\n        <thead>\r\n          <tr>\r\n            <th style=\"text-align: center;\">Item</th>\r\n            <th style=\"text-align: center;\">Descripción</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let item of agencias\">\r\n            <td style=\"text-align: center;\">\r\n              <mat-icon style=\"color: gray; cursor: pointer;\" (click)=\"editar(item);\" matTooltip=\"Editar\" matTooltipPosition=\"above\">edit\r\n              </mat-icon>&nbsp;&nbsp;&nbsp;\r\n              <mat-icon style=\"color: red; cursor: pointer;\" (click)=\"eliminar(item);\" matTooltip=\"Eliminar\" matTooltipPosition=\"above\">delete\r\n              </mat-icon>\r\n            </td>\r\n            <td style=\"text-align: left;\">{{item.valor}}</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"col s3 m3 l3\"></div>\r\n  </div>\r\n\r\n</mat-expansion-panel>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.html":
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.html ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  administracion-causales-no-entrega works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-conductores/administracion-conductores.component.html":
/*!****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-conductores/administracion-conductores.component.html ***!
  \****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  administracion-conductores works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.html":
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.html ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  administracion-empresa-transporte works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-mensajes/administracion-mensajes.component.html":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-mensajes/administracion-mensajes.component.html ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  administracion-mensajes works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.html":
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.html ***!
  \****************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  administracion-motivo-devolucion works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/administracion-motivos.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/administracion-motivos.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contenedor-form\">\r\n    <div class=\"row\">\r\n  \r\n        <mat-card>\r\n  \r\n          <div class=\"row\">\r\n            <mat-tab-group (selectedTabChange)=\"tabClick($event)\">\r\n              <mat-tab>\r\n                <ng-template mat-tab-label>\r\n                  <mat-icon class=\"example-tab-icon\">announcement</mat-icon>\r\n                  Gestión Motivo\r\n                </ng-template>\r\n                <app-motivos></app-motivos>\r\n              </mat-tab>\r\n  \r\n              <mat-tab>\r\n                <ng-template mat-tab-label>\r\n                  <mat-icon class=\"example-tab-icon\">assignment_late</mat-icon>\r\n                  Gestión Tipo Motivo\r\n                </ng-template>\r\n                <app-tipo-motivo></app-tipo-motivo>\r\n              </mat-tab>\r\n  \r\n              <mat-tab>\r\n                <ng-template mat-tab-label>\r\n                  <mat-icon class=\"example-tab-icon\">assessment</mat-icon>\r\n                  Gestión Tipo Motivo Clas\r\n                </ng-template>\r\n                <app-tipo-motivo-clas></app-tipo-motivo-clas>\r\n                <!--<app-consultar-persona></app-consultar-persona>-->\r\n              </mat-tab>\r\n  \r\n              <!--<mat-tab>\r\n                <ng-template mat-tab-label>\r\n                  <mat-icon class=\"example-tab-icon\">search</mat-icon>\r\n                  Consultar\r\n                </ng-template>\r\n                <app-consultar-menu></app-consultar-menu>\r\n              </mat-tab>-->\r\n  \r\n  \r\n            </mat-tab-group>\r\n  \r\n          </div>\r\n  \r\n  \r\n        </mat-card>\r\n  \r\n  \r\n  \r\n    </div>\r\n  </div>\r\n  \r\n  \r\n  ");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/motivos/motivos.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/motivos/motivos.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Gestión Motivo</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <form [formGroup]=\"motivoGroup\" (ngSubmit)=\"procesoMotivo();\">\r\n    <div class=\"row\">\r\n      <div class=\"col s12 m3 l3\">\r\n        <mat-form-field>\r\n            <input matInput formControlName=\"formCodigo\" placeholder=\"Codigo\">\r\n          </mat-form-field>\r\n    </div>\r\n      <div class=\"col s12 m3 l3\">\r\n          <mat-form-field>\r\n              <input matInput formControlName=\"formDescripcion\" placeholder=\"Descripción\">\r\n            </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m3 l3\">\r\n          <mat-form-field>\r\n              <mat-label>TIPOS MOTIVO</mat-label>\r\n              <mat-select formControlName=\"formTipoMotivo\">\r\n                <mat-option *ngFor=\"let item of tiposMotivo\" [value]=\"item.id\">\r\n                  {{item.valor}}\r\n                </mat-option>\r\n              </mat-select>\r\n            </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m3 l3\">\r\n          <mat-form-field>\r\n              <mat-label>TIPO MOTIVO CLAS</mat-label>\r\n              <mat-select formControlName=\"formTipoMotivoClas\">\r\n                <mat-option *ngFor=\"let item of tiposMotivoClas\" [value]=\"item.id\">\r\n                  {{item.valor}}\r\n                </mat-option>\r\n              </mat-select>\r\n            </mat-form-field>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\" style=\"text-align: center;\">\r\n        <button *ngIf=\"!isEdit\" type=\"submit\" [disabled]=\"!motivoGroup.valid || loading\" mat-raised-button color=\"primary\">Crear</button>\r\n        <button *ngIf=\"isEdit\" type=\"submit\" [disabled]=\"!motivoGroup.valid || loading\" mat-raised-button color=\"accent\">Editar</button>&nbsp;&nbsp;\r\n        <button *ngIf=\"isEdit\" type=\"button\" (click)=\"cancelarEdit();\" mat-raised-button color=\"warn\">Cancelar</button>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n  </form>\r\n</mat-expansion-panel>\r\n\r\n<br>\r\n\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Listado Tipos Motivos</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"row\">    \r\n    <div class=\"col s12 m12 l12\">\r\n      <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n      <table [hidden]=\"!haveData\" datatable [dtOptions]=\"dtOptions\" [dtTrigger]=\"dtTrigger\" class=\"display\"\r\n        style=\"width:100%\">\r\n        <thead>\r\n          <tr>\r\n            <th style=\"text-align: center;\">Item</th>\r\n            <th style=\"text-align: center;\">Codigo</th>\r\n            <th style=\"text-align: center;\">Descripción</th>\r\n            <th style=\"text-align: center;\">Tipo Motivo</th>\r\n            <th style=\"text-align: center;\">Tipo Motivo Clas</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let item of motivos\">\r\n            <td style=\"text-align: center;\">\r\n              <mat-icon style=\"color: gray; cursor: pointer;\" (click)=\"editar(item);\" matTooltip=\"Editar\" matTooltipPosition=\"above\">edit\r\n              </mat-icon>&nbsp;&nbsp;&nbsp;\r\n              <mat-icon style=\"color: red; cursor: pointer;\" (click)=\"eliminar(item);\" matTooltip=\"Eliminar\" matTooltipPosition=\"above\">delete\r\n              </mat-icon>\r\n            </td>\r\n            <td style=\"text-align: left;\">{{item.idExMotivo}}</td>\r\n            <td style=\"text-align: left;\">{{item.valor}}</td>\r\n            <td style=\"text-align: left;\">{{item.tipoMotivo}}</td>\r\n            <td style=\"text-align: left;\">{{item.tipoMotivoClas}}</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>    \r\n  </div>\r\n\r\n</mat-expansion-panel>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Gestión Tipo Motivo Clas</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <form [formGroup]=\"tipoMotivoClasGroup\" (ngSubmit)=\"procesoTipoMotivoClas();\">\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\">\r\n        <mat-form-field>\r\n          <input matInput formControlName=\"formDescripcion\" placeholder=\"Descripción\">\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\" style=\"text-align: center;\">\r\n        <button *ngIf=\"!isEdit\" type=\"submit\" [disabled]=\"!tipoMotivoClasGroup.valid || loading\" mat-raised-button color=\"primary\">Crear</button>\r\n        <button *ngIf=\"isEdit\" type=\"submit\" [disabled]=\"!tipoMotivoClasGroup.valid || loading\" mat-raised-button color=\"accent\">Editar</button>&nbsp;&nbsp;\r\n        <button *ngIf=\"isEdit\" type=\"button\" (click)=\"cancelarEdit();\" mat-raised-button color=\"warn\">Cancelar</button>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n  </form>\r\n</mat-expansion-panel>\r\n\r\n<br>\r\n\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Listado Tipos Motivos Clas</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"row\">\r\n    <div class=\"col s3 m3 l3\"></div>\r\n    <div class=\"col s6 m6 l6\">\r\n      <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n      <table [hidden]=\"!haveData\" datatable [dtOptions]=\"dtOptions\" [dtTrigger]=\"dtTrigger\" class=\"display\"\r\n        style=\"width:100%\">\r\n        <thead>\r\n          <tr>\r\n            <th style=\"text-align: center;\">Item</th>\r\n            <th style=\"text-align: center;\">Descripción</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let item of tiposMotivoClas\">\r\n            <td style=\"text-align: center;\">\r\n              <mat-icon style=\"color: gray; cursor: pointer;\" (click)=\"editar(item);\" matTooltip=\"Editar\" matTooltipPosition=\"above\">edit\r\n              </mat-icon>&nbsp;&nbsp;&nbsp;\r\n              <mat-icon style=\"color: red; cursor: pointer;\" (click)=\"eliminar(item);\" matTooltip=\"Eliminar\" matTooltipPosition=\"above\">delete\r\n              </mat-icon>\r\n            </td>\r\n            <td style=\"text-align: left;\">{{item.valor}}</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"col s3 m3 l3\"></div>\r\n  </div>\r\n\r\n</mat-expansion-panel>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Gestión Tipo Motivo</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <form [formGroup]=\"tipoMotivoGroup\" (ngSubmit)=\"procesoTipoMotivo();\">\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\">\r\n        <mat-form-field>\r\n          <input matInput formControlName=\"formDescripcion\" placeholder=\"Descripción\">\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\" style=\"text-align: center;\">\r\n        <button *ngIf=\"!isEdit\" type=\"submit\" [disabled]=\"!tipoMotivoGroup.valid || loading\" mat-raised-button color=\"primary\">Crear</button>\r\n        <button *ngIf=\"isEdit\" type=\"submit\" [disabled]=\"!tipoMotivoGroup.valid || loading\" mat-raised-button color=\"accent\">Editar</button>&nbsp;&nbsp;\r\n        <button *ngIf=\"isEdit\" type=\"button\" (click)=\"cancelarEdit();\" mat-raised-button color=\"warn\">Cancelar</button>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n  </form>\r\n</mat-expansion-panel>\r\n\r\n<br>\r\n\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Listado Tipos Motivos</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"row\">\r\n    <div class=\"col s3 m3 l3\"></div>\r\n    <div class=\"col s6 m6 l6\">\r\n      <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n      <table [hidden]=\"!haveData\" datatable [dtOptions]=\"dtOptions\" [dtTrigger]=\"dtTrigger\" class=\"display\"\r\n        style=\"width:100%\">\r\n        <thead>\r\n          <tr>\r\n            <th style=\"text-align: center;\">Item</th>\r\n            <th style=\"text-align: center;\">Descripción</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let item of tiposMotivo\">\r\n            <td style=\"text-align: center;\">\r\n              <mat-icon style=\"color: gray; cursor: pointer;\" (click)=\"editar(item);\" matTooltip=\"Editar\" matTooltipPosition=\"above\">edit\r\n              </mat-icon>&nbsp;&nbsp;&nbsp;\r\n              <mat-icon style=\"color: red; cursor: pointer;\" (click)=\"eliminar(item);\" matTooltip=\"Eliminar\" matTooltipPosition=\"above\">delete\r\n              </mat-icon>\r\n            </td>\r\n            <td style=\"text-align: left;\">{{item.valor}}</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"col s3 m3 l3\"></div>\r\n  </div>\r\n\r\n</mat-expansion-panel>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.html":
/*!************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.html ***!
  \************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Administracion Agencias</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <form [formGroup]=\"tipoNovedadGroup\" (ngSubmit)=\"procesoAgencia();\">\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\">\r\n        <mat-form-field>\r\n          <input matInput formControlName=\"formDescripcion\" placeholder=\"Descripción\">\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s3 m3 l3\"></div>\r\n      <div class=\"col s6 m6 l6\" style=\"text-align: center;\">\r\n        <button *ngIf=\"!isEdit\" type=\"submit\" [disabled]=\"!tipoNovedadGroup.valid || loading\" mat-raised-button color=\"primary\">Crear</button>\r\n        <button *ngIf=\"isEdit\" type=\"submit\" [disabled]=\"!tipoNovedadGroup.valid || loading\" mat-raised-button color=\"accent\">Editar</button>&nbsp;&nbsp;\r\n        <button *ngIf=\"isEdit\" type=\"button\" (click)=\"cancelarEdit();\" mat-raised-button color=\"warn\">Cancelar</button>\r\n      </div>\r\n      <div class=\"col s3 m3 l3\"></div>\r\n    </div>\r\n  </form>\r\n</mat-expansion-panel>\r\n\r\n<br>\r\n\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Listado Agencias</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"row\">\r\n    <div class=\"col s3 m3 l3\"></div>\r\n    <div class=\"col s6 m6 l6\">\r\n      <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n      <table [hidden]=\"!haveData\" datatable [dtOptions]=\"dtOptions\" [dtTrigger]=\"dtTrigger\" class=\"display\"\r\n        style=\"width:100%\">\r\n        <thead>\r\n          <tr>\r\n            <th style=\"text-align: center;\">Item</th>\r\n            <th style=\"text-align: center;\">Descripción</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let item of tipoNovedades\">\r\n            <td style=\"text-align: center;\">\r\n              <mat-icon style=\"color: gray; cursor: pointer;\" (click)=\"editar(item);\" matTooltip=\"Editar\" matTooltipPosition=\"above\">edit\r\n              </mat-icon>&nbsp;&nbsp;&nbsp;\r\n              <mat-icon style=\"color: red; cursor: pointer;\" (click)=\"eliminar(item);\" matTooltip=\"Eliminar\" matTooltipPosition=\"above\">delete\r\n              </mat-icon>\r\n            </td>\r\n            <td style=\"text-align: left;\">{{item.valor}}</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"col s3 m3 l3\"></div>\r\n  </div>\r\n\r\n</mat-expansion-panel>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-usuario-web/administracion-usuario-web.component.html":
/*!****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-usuario-web/administracion-usuario-web.component.html ***!
  \****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  administracion-usuario-web works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-login style=\"background-color:#5CC5BA;\" *ngIf=\"!login\"></app-login>\r\n<app-navigation *ngIf=\"login\"></app-navigation>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-servicios/asignacion-servicios.component.html":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-servicios/asignacion-servicios.component.html ***!
  \****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contenedor-form\" [formGroup]=\"transportadorGroup\">\r\n  <div class=\"row\" *ngIf=\"transportadores.length > 0\">\r\n    <div class=\"col s12 m12 l6\">\r\n      <mat-form-field class=\"example-full-width\">\r\n        <input\r\n          matInput\r\n          placeholder=\"Transportador\"\r\n          aria-label=\"Transportador\"\r\n          [matAutocomplete]=\"auto\"\r\n          formControlName=\"transportadorCtrl\"\r\n        />\r\n        <mat-autocomplete\r\n          #auto=\"matAutocomplete\"\r\n          [displayWith]=\"displayFn\"\r\n          (optionSelected)=\"buscarServicios($event.option.value)\"\r\n        >\r\n          <mat-option\r\n            *ngFor=\"let transportador of (filteredTransportadores | async)\"\r\n            [value]=\"transportador\"\r\n          >\r\n            <span>{{ transportador.Valor }}</span>\r\n          </mat-option>\r\n        </mat-autocomplete>\r\n      </mat-form-field>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n      <div class=\"col s12 m12 l6\">\r\n          <h4 *ngIf=\"sinAsignar.length>0\">Servicios Sin Asignar</h4>\r\n          <div *ngFor=\"let servicio of sinAsignar\">\r\n            <mat-card class=\"example-card\" style=\"overflow:hidden;\">\r\n              <mat-card-header>\r\n                <mat-card-title style=\"margin-left: -20px;\"\r\n                  ><span class=\"bolder\">Servicio:</span>\r\n                  {{ servicio.NroServicio }}</mat-card-title\r\n                >\r\n                <mat-card-subtitle style=\"margin-left: -20px;\"><span class=\"bolder\">Fecha Visita:</span>{{servicio.fechaPrestacion}}</mat-card-subtitle>\r\n              </mat-card-header>\r\n              <mat-card-content>\r\n                <p>\r\n                  <span class=\"bolder\">Origen:</span> {{ servicio.DireccionOrigen }}\r\n                </p>\r\n                <p>\r\n                  <span class=\"bolder\">Destino:</span>\r\n                  {{ servicio.DireccionDestino }}\r\n                </p>\r\n              </mat-card-content>\r\n              <mat-card-actions>\r\n                  <button\r\n                    style=\"float:right;\"\r\n                    mat-button\r\n                    (click)=\"asignarServicio(servicio)\"\r\n                  >\r\n                    Asignar\r\n                    <mat-icon>arrow_forward_ios</mat-icon>\r\n                  </button>\r\n                </mat-card-actions>\r\n            </mat-card>\r\n            <mat-divider></mat-divider>\r\n            <br />\r\n          </div>\r\n        </div>\r\n    <div class=\"col s12 m12 l6\">\r\n      <h4 *ngIf=\"asignados.length>0\">Servicios Asignados</h4>\r\n      <div *ngFor=\"let servicio of asignados\">\r\n        <mat-card class=\"example-card\" style=\"overflow:hidden;\">\r\n          <mat-card-header>\r\n            <mat-card-title style=\"margin-left: -20px;\"\r\n              ><span class=\"bolder\">Servicio:</span>\r\n              {{ servicio.NroServicio }}</mat-card-title\r\n            >\r\n            <mat-card-subtitle style=\"margin-left: -20px;\"><span class=\"bolder\">Fecha Visita:</span>{{servicio.fechaPrestacion}}</mat-card-subtitle>\r\n          </mat-card-header>\r\n          <mat-card-content>\r\n            <p>\r\n              <span class=\"bolder\">Origen:</span> {{ servicio.DireccionOrigen }}\r\n            </p>\r\n            <p>\r\n              <span class=\"bolder\">Destino:</span>\r\n              {{ servicio.DireccionDestino }}\r\n            </p>\r\n          </mat-card-content>\r\n          <mat-card-actions>\r\n              <button\r\n                style=\"float:left;\"\r\n                mat-button\r\n                (click)=\"removerServicio(servicio)\"\r\n              >\r\n              <mat-icon>arrow_back_ios</mat-icon>\r\n                No asignar\r\n\r\n              </button>\r\n          </mat-card-actions>\r\n        </mat-card>\r\n        <mat-divider></mat-divider>\r\n        <br />\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.html":
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.html ***!
  \****************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  asignacion-transportador-agencia works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.html":
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.html ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br />\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Asignación Persona x Vehiculo</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <form [formGroup]=\"personaGroup\" class=\"example-form\">\r\n        <mat-form-field class=\"example-full-width\">\r\n          <input\r\n            matInput\r\n            placeholder=\"Documento, Nombre o Apelido\"\r\n            value=\"\"\r\n            formControlName=\"formPersona\"\r\n            (keydown.enter)=\"busqueda($event)\"\r\n          />\r\n        </mat-form-field>\r\n      </form>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\" *ngIf=\"!isSelectedPersona && dataPersona.length > 0\">\r\n    <div class=\"col s6 m6 l6\">\r\n      <mat-list>\r\n        <h3 mat-subheader>Personas</h3>\r\n        <mat-list-item\r\n          *ngFor=\"let item of dataPersona\"\r\n          style=\"cursor: pointer;\"\r\n          (click)=\"detallePersona(item)\"\r\n        >\r\n          <mat-icon mat-list-icon>account_circle</mat-icon>\r\n          <h4 mat-line>{{ item.Nombre }} {{ item.Apellido }}</h4>\r\n          <p mat-line>{{ item.NroDocId }}</p>\r\n        </mat-list-item>\r\n      </mat-list>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\" *ngIf=\"loading\">\r\n    <div class=\"col s6 m6 l6\">\r\n      <mat-spinner\r\n        [diameter]=\"100\"\r\n        style=\"margin:0 auto; top:15px;\"\r\n      ></mat-spinner>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\" *ngIf=\"isSelectedPersona\">\r\n    <div class=\"col s6 m6 l6\">\r\n      <mat-list *ngIf=\"dataPersonaVehiculo.length > 0\">\r\n        <h3 mat-subheader style=\"color: red;\">\r\n          Este usuario tiene un vehiculo asignado, si selecciona uno nuevo se\r\n          reasignará\r\n        </h3>\r\n        <mat-list-item *ngFor=\"let item of dataPersonaVehiculo\">\r\n          <mat-icon mat-list-icon>swap_horiz</mat-icon>\r\n          <h4 mat-line>{{ item.NroDocId }} -- {{ item.nombre }}</h4>\r\n          <p mat-line>Placa: {{ item.Placa }} -- {{ item.Descripcion }}</p>\r\n        </mat-list-item>\r\n      </mat-list>\r\n      <p *ngIf=\"tienePersonaVehiculo == 2\" mat-subheader style=\"color: green;\">\r\n        <span style=\"font-weight: bolder;\">{{personaSeleccionada.NroDocId}} -- {{personaSeleccionada.Nombre}} {{personaSeleccionada.Apellido}}</span>&nbsp; no tiene vehiculo asignado\r\n      </p>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\" *ngIf=\"tienePersonaVehiculo > 0\">\r\n      <form [formGroup]=\"vehiculoGroup\" class=\"example-form\">\r\n    <div class=\"col s12 m6 l6\">\r\n      \r\n        <mat-form-field class=\"example-full-width\">\r\n          <input\r\n            matInput\r\n            placeholder=\"Vehiculo\"\r\n            [matAutocomplete]=\"auto\"\r\n            formControlName=\"formVehiculo\"\r\n          />\r\n          <mat-autocomplete #auto=\"matAutocomplete\" [displayWith]=\"displayFn\">\r\n            <mat-option\r\n              *ngFor=\"let item of filteredVehiculos | async\"\r\n              [value]=\"item\"\r\n            >\r\n              <span>{{ item.valor }}</span>\r\n            </mat-option>\r\n          </mat-autocomplete>\r\n        </mat-form-field>\r\n      \r\n    </div>\r\n    <div class=\"col s12 m6 l6\">\r\n        <mat-form-field>\r\n            <mat-label>TIPO PERSONA VEHICULO</mat-label>\r\n            <mat-select formControlName=\"formTipoPersonaVehiculo\" (valueChange)=\"selectChange($event);\">\r\n              <mat-option *ngFor=\"let item of tipoPersonaVehiculo\" [value]=\"item.id\">\r\n                {{item.valor}}\r\n              </mat-option>\r\n            </mat-select>\r\n          </mat-form-field> \r\n    </div>\r\n  </form>\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"tienePersonaVehiculo > 0\">\r\n    <div class=\"col s12 m12 l12\" style=\"text-align: center;\">\r\n        <button \r\n        mat-raised-button \r\n        type=\"button\" \r\n        color=\"accent\" \r\n        [disabled]=\"dataAsignacion.idPersona == '' || dataAsignacion.idVehiculo == '' || dataAsignacion.idTipoPersonaVehiculo == ''\" \r\n        (click)=\"procesoPersonaVehiculo();\">\r\n          Asignar\r\n        </button>\r\n    </div>\r\n  </div>\r\n</mat-expansion-panel>\r\n\r\n<br />\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/cargues-usuario/cargues-usuario.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/cargues-usuario/cargues-usuario.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n    <mat-expansion-panel-header>\r\n      <mat-panel-title>\r\n        <h6 class=\"titulo-solicitud\">Informe De Cargues X Usuario</h6>\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n  \r\n    <div class=\"contenedor-form\">\r\n      <form [formGroup]=\"entregasGroup\" (ngSubmit)=\"busqueda();\" class=\"example-form\">        \r\n        <div class=\"row\">\r\n          <div class=\"col s12 m6 l2\">\r\n            <span *ngIf=\"loadingAgencias\">\r\n                <mat-spinner\r\n                [diameter]=\"30\"\r\n                style=\"margin:0 auto; top:15px;\"\r\n              ></mat-spinner>\r\n            </span>\r\n            <span *ngIf=\"!loadingAgencias\">\r\n              <mat-form-field>\r\n                <mat-label>AGENCIA</mat-label>\r\n                <mat-select formControlName=\"idAgencia\" (change)=\"cargarUsuariosAgencia();\">\r\n                  <mat-option *ngFor=\"let agencia of agencias\" [value]=\"agencia.id\">\r\n                    {{agencia.valor}}\r\n                  </mat-option>\r\n                </mat-select>\r\n              </mat-form-field>\r\n            </span>\r\n          </div>\r\n          <div class=\"col s12 m6 l4\">\r\n              <span *ngIf=\"loadingUsuarios\">\r\n                  <mat-spinner\r\n                  [diameter]=\"30\"\r\n                  style=\"margin:0 auto; top:15px;\"\r\n                ></mat-spinner>\r\n              </span>\r\n            <span *ngIf=\"!loadingUsuarios\">\r\n              <mat-form-field class=\"example-full-width\">\r\n                  <input matInput placeholder=\"Transportador\" [matAutocomplete]=\"auto\" formControlName=\"usuarioCtrl\">\r\n                  <mat-autocomplete #auto=\"matAutocomplete\" [displayWith]=\"displayFn\">\r\n                    <mat-option *ngFor=\"let usuario of filteredUsuarios | async\" [value]=\"usuario\">                    \r\n                      <span>{{usuario.valor}}</span>                 \r\n                    </mat-option>\r\n                  </mat-autocomplete>\r\n              </mat-form-field>\r\n            </span>  \r\n          </div>        \r\n          <div class=\"col s12 m6 l2\">\r\n              <mat-form-field>\r\n                  <input formControlName=\"fechaInicial\" readonly matInput [matDatepicker]=\"picker\" placeholder=\"Fecha Inicial\">\r\n                  <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n                  <mat-datepicker #picker></mat-datepicker>\r\n                </mat-form-field>              \r\n          </div>\r\n          <div class=\"col s12 m6 l2\">\r\n              <mat-form-field>\r\n                  <input formControlName=\"fechaFinal\" readonly matInput [matDatepicker]=\"picker1\" placeholder=\"Fecha Final\">\r\n                  <mat-datepicker-toggle matSuffix [for]=\"picker1\"></mat-datepicker-toggle>\r\n                  <mat-datepicker #picker1></mat-datepicker>\r\n                </mat-form-field>   \r\n          </div>\r\n          <div class=\"col s12 m6 l2\">\r\n              <button mat-raised-button color=\"accent\" type=\"submit\" [disabled]=\"!entregasGroup.valid || loading\">Consultar</button>\r\n          </div>\r\n        </div>      \r\n      </form>\r\n    </div>\r\n  </mat-expansion-panel>\r\n\r\n  <br>\r\n  <mat-expansion-panel expanded=\"true\">\r\n      <mat-expansion-panel-header>\r\n        <mat-panel-title>\r\n          <h6 class=\"titulo-solicitud\">Resultados</h6>\r\n        </mat-panel-title>\r\n      </mat-expansion-panel-header>\r\n      \r\n      <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n          <mat-spinner\r\n            [diameter]=\"100\"\r\n            style=\"margin:0 auto; top:15px;\"\r\n          ></mat-spinner>\r\n        </div>\r\n  \r\n        <table\r\n        \r\n      [hidden]=\"!haveData\"\r\n      datatable\r\n      [dtOptions]=\"dtOptions\"\r\n      [dtTrigger]=\"dtTrigger\"\r\n      class=\"display\"\r\n      style=\"width:100%\"\r\n    >\r\n      <thead>\r\n        <tr>        \r\n          <th>Usuario</th>\r\n          <th>Nombre</th>\r\n          <th>Agencia</th>          \r\n          <th>Fecha Inicio</th>\r\n          <th>Fecha Fin</th>\r\n          <th>Archivo</th>\r\n                \r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr *ngFor=\"let item of dataCargues\">\r\n          <td style=\"text-align: center;\">{{ item.Usuario }}</td>  \r\n          <td>{{ item.nombre }}</td>        \r\n          <td>{{ item.agencia }}</td>\r\n          <td>{{ item.fechaInicio  | date:'yyyy-MM-dd hh:mm:ss'}}</td>\r\n          <td>{{ item.fechaFin | date:'yyyy-MM-dd hh:mm:ss'}}</td>\r\n          <td style=\"text-align: center;\">\r\n            <mat-icon style=\"cursor: pointer;\" (click)=\"descargarArchivo(item);\" svgIcon=\"csv\" matTooltip=\"DESCARGAR ARCHIVO\" matTooltipPosition=\"above\">\r\n              \r\n            </mat-icon>                     \r\n          </td>            \r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n      \r\n    </mat-expansion-panel>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/consulta-persona/consulta-persona.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/consulta-persona/consulta-persona.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contenedor-form\">\r\n  <form [formGroup]=\"personaGroup\" class=\"example-form\">\r\n    <mat-form-field class=\"example-full-width\">\r\n      <input\r\n        matInput\r\n        placeholder=\"Documento, Nombre o Apelido\"\r\n        value=\"\"\r\n        formControlName=\"persona\"\r\n        (keydown.enter)=\"busqueda($event)\"\r\n      />\r\n    </mat-form-field>\r\n  </form>\r\n</div>\r\n\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Información Personas</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n\r\n  <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n    <mat-spinner\r\n      [diameter]=\"100\"\r\n      style=\"margin:0 auto; top:15px;\"\r\n    ></mat-spinner>\r\n  </div>\r\n\r\n  <table\r\n    [hidden]=\"!haveData\"\r\n    datatable\r\n    [dtOptions]=\"dtOptions\"\r\n    [dtTrigger]=\"dtTrigger\"\r\n    class=\"display\"\r\n    style=\"width:100%\"\r\n  >\r\n    <thead>\r\n      <tr>\r\n        <th>Items</th>\r\n        <th>Tipo Documento</th>\r\n        <th>No. Documento</th>\r\n        <th>Nombre</th>\r\n        <th>Fecha Nacimiento</th>\r\n        <th>Teléfono</th>\r\n      </tr>\r\n    </thead>\r\n    <tbody>\r\n      <tr *ngFor=\"let item of dataPersona\">\r\n        <td>\r\n          <button mat-icon-button (click)=\"editarPersona(item);\">\r\n            <mat-icon>edit</mat-icon>\r\n          </button>\r\n          <button mat-icon-button (click)=\"eliminarPersona(item);\">\r\n            <mat-icon>delete</mat-icon>\r\n          </button>\r\n        </td>\r\n        <td>{{ item.DescripcionTpoIdenti }}</td>\r\n        <td>{{ item.NroDocId }}</td>\r\n        <td>{{ item.Nombre }} {{ item.Apellido }}</td>\r\n        <td>{{ item.FechaNac | date:'yyyy-MM-dd' }}</td>\r\n        <td>{{ item.Telefono }}</td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n</mat-expansion-panel>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/consultar-persona/consultar-persona.component.html":
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/consultar-persona/consultar-persona.component.html ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<table #dataTable  class=\"display\" style=\"width:100%\">\r\n  <thead>\r\n    <tr>\r\n      <th>Name</th>\r\n      <th>Position</th>\r\n      <th>Office</th>\r\n      <th>Age</th>\r\n      <th>Start date</th>\r\n      <th>Salary</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr>\r\n      <td>Tiger Nixon</td>\r\n      <td>System Architect</td>\r\n      <td>Edinburgh</td>\r\n      <td>61</td>\r\n      <td>2011/04/25</td>\r\n      <td>$320,800</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Garrett Winters</td>\r\n      <td>Accountant</td>\r\n      <td>Tokyo</td>\r\n      <td>63</td>\r\n      <td>2011/07/25</td>\r\n      <td>$170,750</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Ashton Cox</td>\r\n      <td>Junior Technical Author</td>\r\n      <td>San Francisco</td>\r\n      <td>66</td>\r\n      <td>2009/01/12</td>\r\n      <td>$86,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Cedric Kelly</td>\r\n      <td>Senior Javascript Developer</td>\r\n      <td>Edinburgh</td>\r\n      <td>22</td>\r\n      <td>2012/03/29</td>\r\n      <td>$433,060</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Airi Satou</td>\r\n      <td>Accountant</td>\r\n      <td>Tokyo</td>\r\n      <td>33</td>\r\n      <td>2008/11/28</td>\r\n      <td>$162,700</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Brielle Williamson</td>\r\n      <td>Integration Specialist</td>\r\n      <td>New York</td>\r\n      <td>61</td>\r\n      <td>2012/12/02</td>\r\n      <td>$372,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Herrod Chandler</td>\r\n      <td>Sales Assistant</td>\r\n      <td>San Francisco</td>\r\n      <td>59</td>\r\n      <td>2012/08/06</td>\r\n      <td>$137,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Rhona Davidson</td>\r\n      <td>Integration Specialist</td>\r\n      <td>Tokyo</td>\r\n      <td>55</td>\r\n      <td>2010/10/14</td>\r\n      <td>$327,900</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Colleen Hurst</td>\r\n      <td>Javascript Developer</td>\r\n      <td>San Francisco</td>\r\n      <td>39</td>\r\n      <td>2009/09/15</td>\r\n      <td>$205,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Sonya Frost</td>\r\n      <td>Software Engineer</td>\r\n      <td>Edinburgh</td>\r\n      <td>23</td>\r\n      <td>2008/12/13</td>\r\n      <td>$103,600</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Jena Gaines</td>\r\n      <td>Office Manager</td>\r\n      <td>London</td>\r\n      <td>30</td>\r\n      <td>2008/12/19</td>\r\n      <td>$90,560</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Quinn Flynn</td>\r\n      <td>Support Lead</td>\r\n      <td>Edinburgh</td>\r\n      <td>22</td>\r\n      <td>2013/03/03</td>\r\n      <td>$342,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Charde Marshall</td>\r\n      <td>Regional Director</td>\r\n      <td>San Francisco</td>\r\n      <td>36</td>\r\n      <td>2008/10/16</td>\r\n      <td>$470,600</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Haley Kennedy</td>\r\n      <td>Senior Marketing Designer</td>\r\n      <td>London</td>\r\n      <td>43</td>\r\n      <td>2012/12/18</td>\r\n      <td>$313,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Tatyana Fitzpatrick</td>\r\n      <td>Regional Director</td>\r\n      <td>London</td>\r\n      <td>19</td>\r\n      <td>2010/03/17</td>\r\n      <td>$385,750</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Michael Silva</td>\r\n      <td>Marketing Designer</td>\r\n      <td>London</td>\r\n      <td>66</td>\r\n      <td>2012/11/27</td>\r\n      <td>$198,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Paul Byrd</td>\r\n      <td>Chief Financial Officer (CFO)</td>\r\n      <td>New York</td>\r\n      <td>64</td>\r\n      <td>2010/06/09</td>\r\n      <td>$725,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Gloria Little</td>\r\n      <td>Systems Administrator</td>\r\n      <td>New York</td>\r\n      <td>59</td>\r\n      <td>2009/04/10</td>\r\n      <td>$237,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Bradley Greer</td>\r\n      <td>Software Engineer</td>\r\n      <td>London</td>\r\n      <td>41</td>\r\n      <td>2012/10/13</td>\r\n      <td>$132,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Dai Rios</td>\r\n      <td>Personnel Lead</td>\r\n      <td>Edinburgh</td>\r\n      <td>35</td>\r\n      <td>2012/09/26</td>\r\n      <td>$217,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Jenette Caldwell</td>\r\n      <td>Development Lead</td>\r\n      <td>New York</td>\r\n      <td>30</td>\r\n      <td>2011/09/03</td>\r\n      <td>$345,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Yuri Berry</td>\r\n      <td>Chief Marketing Officer (CMO)</td>\r\n      <td>New York</td>\r\n      <td>40</td>\r\n      <td>2009/06/25</td>\r\n      <td>$675,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Caesar Vance</td>\r\n      <td>Pre-Sales Support</td>\r\n      <td>New York</td>\r\n      <td>21</td>\r\n      <td>2011/12/12</td>\r\n      <td>$106,450</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Doris Wilder</td>\r\n      <td>Sales Assistant</td>\r\n      <td>Sidney</td>\r\n      <td>23</td>\r\n      <td>2010/09/20</td>\r\n      <td>$85,600</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Angelica Ramos</td>\r\n      <td>Chief Executive Officer (CEO)</td>\r\n      <td>London</td>\r\n      <td>47</td>\r\n      <td>2009/10/09</td>\r\n      <td>$1,200,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Gavin Joyce</td>\r\n      <td>Developer</td>\r\n      <td>Edinburgh</td>\r\n      <td>42</td>\r\n      <td>2010/12/22</td>\r\n      <td>$92,575</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Jennifer Chang</td>\r\n      <td>Regional Director</td>\r\n      <td>Singapore</td>\r\n      <td>28</td>\r\n      <td>2010/11/14</td>\r\n      <td>$357,650</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Brenden Wagner</td>\r\n      <td>Software Engineer</td>\r\n      <td>San Francisco</td>\r\n      <td>28</td>\r\n      <td>2011/06/07</td>\r\n      <td>$206,850</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Fiona Green</td>\r\n      <td>Chief Operating Officer (COO)</td>\r\n      <td>San Francisco</td>\r\n      <td>48</td>\r\n      <td>2010/03/11</td>\r\n      <td>$850,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Shou Itou</td>\r\n      <td>Regional Marketing</td>\r\n      <td>Tokyo</td>\r\n      <td>20</td>\r\n      <td>2011/08/14</td>\r\n      <td>$163,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Michelle House</td>\r\n      <td>Integration Specialist</td>\r\n      <td>Sidney</td>\r\n      <td>37</td>\r\n      <td>2011/06/02</td>\r\n      <td>$95,400</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Suki Burks</td>\r\n      <td>Developer</td>\r\n      <td>London</td>\r\n      <td>53</td>\r\n      <td>2009/10/22</td>\r\n      <td>$114,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Prescott Bartlett</td>\r\n      <td>Technical Author</td>\r\n      <td>London</td>\r\n      <td>27</td>\r\n      <td>2011/05/07</td>\r\n      <td>$145,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Gavin Cortez</td>\r\n      <td>Team Leader</td>\r\n      <td>San Francisco</td>\r\n      <td>22</td>\r\n      <td>2008/10/26</td>\r\n      <td>$235,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Martena Mccray</td>\r\n      <td>Post-Sales support</td>\r\n      <td>Edinburgh</td>\r\n      <td>46</td>\r\n      <td>2011/03/09</td>\r\n      <td>$324,050</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Unity Butler</td>\r\n      <td>Marketing Designer</td>\r\n      <td>San Francisco</td>\r\n      <td>47</td>\r\n      <td>2009/12/09</td>\r\n      <td>$85,675</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Howard Hatfield</td>\r\n      <td>Office Manager</td>\r\n      <td>San Francisco</td>\r\n      <td>51</td>\r\n      <td>2008/12/16</td>\r\n      <td>$164,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Hope Fuentes</td>\r\n      <td>Secretary</td>\r\n      <td>San Francisco</td>\r\n      <td>41</td>\r\n      <td>2010/02/12</td>\r\n      <td>$109,850</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Vivian Harrell</td>\r\n      <td>Financial Controller</td>\r\n      <td>San Francisco</td>\r\n      <td>62</td>\r\n      <td>2009/02/14</td>\r\n      <td>$452,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Timothy Mooney</td>\r\n      <td>Office Manager</td>\r\n      <td>London</td>\r\n      <td>37</td>\r\n      <td>2008/12/11</td>\r\n      <td>$136,200</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Jackson Bradshaw</td>\r\n      <td>Director</td>\r\n      <td>New York</td>\r\n      <td>65</td>\r\n      <td>2008/09/26</td>\r\n      <td>$645,750</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Olivia Liang</td>\r\n      <td>Support Engineer</td>\r\n      <td>Singapore</td>\r\n      <td>64</td>\r\n      <td>2011/02/03</td>\r\n      <td>$234,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Bruno Nash</td>\r\n      <td>Software Engineer</td>\r\n      <td>London</td>\r\n      <td>38</td>\r\n      <td>2011/05/03</td>\r\n      <td>$163,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Sakura Yamamoto</td>\r\n      <td>Support Engineer</td>\r\n      <td>Tokyo</td>\r\n      <td>37</td>\r\n      <td>2009/08/19</td>\r\n      <td>$139,575</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Thor Walton</td>\r\n      <td>Developer</td>\r\n      <td>New York</td>\r\n      <td>61</td>\r\n      <td>2013/08/11</td>\r\n      <td>$98,540</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Finn Camacho</td>\r\n      <td>Support Engineer</td>\r\n      <td>San Francisco</td>\r\n      <td>47</td>\r\n      <td>2009/07/07</td>\r\n      <td>$87,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Serge Baldwin</td>\r\n      <td>Data Coordinator</td>\r\n      <td>Singapore</td>\r\n      <td>64</td>\r\n      <td>2012/04/09</td>\r\n      <td>$138,575</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Zenaida Frank</td>\r\n      <td>Software Engineer</td>\r\n      <td>New York</td>\r\n      <td>63</td>\r\n      <td>2010/01/04</td>\r\n      <td>$125,250</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Zorita Serrano</td>\r\n      <td>Software Engineer</td>\r\n      <td>San Francisco</td>\r\n      <td>56</td>\r\n      <td>2012/06/01</td>\r\n      <td>$115,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Jennifer Acosta</td>\r\n      <td>Junior Javascript Developer</td>\r\n      <td>Edinburgh</td>\r\n      <td>43</td>\r\n      <td>2013/02/01</td>\r\n      <td>$75,650</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Cara Stevens</td>\r\n      <td>Sales Assistant</td>\r\n      <td>New York</td>\r\n      <td>46</td>\r\n      <td>2011/12/06</td>\r\n      <td>$145,600</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Hermione Butler</td>\r\n      <td>Regional Director</td>\r\n      <td>London</td>\r\n      <td>47</td>\r\n      <td>2011/03/21</td>\r\n      <td>$356,250</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Lael Greer</td>\r\n      <td>Systems Administrator</td>\r\n      <td>London</td>\r\n      <td>21</td>\r\n      <td>2009/02/27</td>\r\n      <td>$103,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Jonas Alexander</td>\r\n      <td>Developer</td>\r\n      <td>San Francisco</td>\r\n      <td>30</td>\r\n      <td>2010/07/14</td>\r\n      <td>$86,500</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Shad Decker</td>\r\n      <td>Regional Director</td>\r\n      <td>Edinburgh</td>\r\n      <td>51</td>\r\n      <td>2008/11/13</td>\r\n      <td>$183,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Michael Bruce</td>\r\n      <td>Javascript Developer</td>\r\n      <td>Singapore</td>\r\n      <td>29</td>\r\n      <td>2011/06/27</td>\r\n      <td>$183,000</td>\r\n    </tr>\r\n    <tr>\r\n      <td>Donna Snider</td>\r\n      <td>Customer Support</td>\r\n      <td>New York</td>\r\n      <td>27</td>\r\n      <td>2011/01/25</td>\r\n      <td>$112,000</td>\r\n    </tr>\r\n  </tbody>\r\n  <tfoot>\r\n    <tr>\r\n      <th>Name</th>\r\n      <th>Position</th>\r\n      <th>Office</th>\r\n      <th>Age</th>\r\n      <th>Start date</th>\r\n      <th>Salary</th>\r\n    </tr>\r\n  </tfoot>\r\n</table>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionpersona/creacionpersona.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionpersona/creacionpersona.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n<div class=\"contenedor-form\" *ngIf=\"items\">\r\n  <app-dynamic-form [items]=\"items\" [descripcion]=\"descripcion\" [parametrosDestino]=\"parametrosDestino\" [procedimientoDestino]=\"procedimientoDestino\"></app-dynamic-form>\r\n</div>\r\n<div class=\"contenedor-form\" *ngIf=\"!items\">\r\n  <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n</div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionusuario/creacionusuario.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionusuario/creacionusuario.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n  <div class=\"contenedor-form\" *ngIf=\"items\">\r\n    <app-dynamic-form [items]=\"items\" [descripcion]=\"descripcion\" [parametrosDestino]=\"parametrosDestino\" [procedimientoDestino]=\"procedimientoDestino\"></app-dynamic-form>\r\n  </div>\r\n  <div class=\"contenedor-form\" *ngIf=\"!items\">\r\n    <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n  </div>\r\n  </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionusuarios.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionusuarios.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contenedor-form\">\r\n  <div class=\"row\">\r\n\r\n      <mat-card>\r\n\r\n        <div class=\"row\">\r\n          <mat-tab-group>\r\n            <mat-tab>\r\n              <ng-template mat-tab-label>\r\n                <mat-icon class=\"example-tab-icon\">person_add</mat-icon>\r\n                Crear Persona\r\n              </ng-template>\r\n              <app-crear-persona (actualizaPadrePersona)=\"actualizaPadrePersona($event);\"></app-crear-persona>\r\n            </mat-tab>\r\n\r\n            <mat-tab>\r\n              <ng-template mat-tab-label>\r\n                <mat-icon class=\"example-tab-icon\">assignment_ind</mat-icon>\r\n                Crear Usuario\r\n              </ng-template>\r\n              <app-crear-usuario [dataPersonaActualiza]=\"dataPersonaActualiza\"></app-crear-usuario>\r\n            </mat-tab>\r\n\r\n            <mat-tab>\r\n              <ng-template mat-tab-label>\r\n                <mat-icon class=\"example-tab-icon\">search</mat-icon>\r\n                Buscar Persona\r\n              </ng-template>\r\n              <app-consulta-persona></app-consulta-persona>\r\n              <!--<app-consultar-persona></app-consultar-persona>-->\r\n            </mat-tab>\r\n\r\n            <!--<mat-tab>\r\n              <ng-template mat-tab-label>\r\n                <mat-icon class=\"example-tab-icon\">search</mat-icon>\r\n                Consultar\r\n              </ng-template>\r\n              <app-consultar-menu></app-consultar-menu>\r\n            </mat-tab>-->\r\n\r\n\r\n          </mat-tab-group>\r\n\r\n        </div>\r\n\r\n\r\n      </mat-card>\r\n\r\n\r\n\r\n  </div>\r\n</div>\r\n\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/crear-persona/crear-persona.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/crear-persona/crear-persona.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n  <!--<h2>Gestión De Usuarios</h2>-->\r\n  <div class=\"contenedor-form\" *ngIf=\"items\">\r\n    <app-dynamic-form #resetForm [items]=\"items\" (dataFormulario)=\"dataFormulario($event);\" [descripcion]=\"descripcion\" [origenParent]=\"origenParent\" [parametrosDestino]=\"parametrosDestino\" [procedimientoDestino]=\"procedimientoDestino\"></app-dynamic-form>\r\n  </div>\r\n  <div class=\"contenedor-form\" *ngIf=\"!items\">\r\n    <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/crear-usuario/crear-usuario.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/crear-usuario/crear-usuario.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n  <!--<h2>Gestión De Usuarios</h2>-->\r\n  <div class=\"contenedor-form\" *ngIf=\"items\">\r\n    <app-dynamic-form #resetForm [items]=\"items\" (dataFormulario)=\"dataFormulario($event);\" [descripcion]=\"descripcion\" [origenParent]=\"origenParent\" [parametrosDestino]=\"parametrosDestino\" [procedimientoDestino]=\"procedimientoDestino\"></app-dynamic-form>\r\n  </div>\r\n  <div class=\"contenedor-form\" *ngIf=\"!items\">\r\n    <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.html":
/*!***********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.html ***!
  \***********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contenedor-form\" *ngIf=\"loadingDireccion\">\r\n  <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n</div>\r\n\r\n<div style=\"text-align: center; margin-bottom: 20px;\" *ngIf=\"!loadingDireccion\">\r\n  <form [formGroup]=\"direccionGroup\" (ngSubmit)=\"submitForm()\">\r\n    <div class=\"row\">\r\n      <div class=\"col s12 m4 l4\">\r\n        <mat-form-field class=\"example-full-width\">\r\n          <input matInput placeholder=\"NOMBRE DIRECCION\" formControlName=\"NombreDireccion\" type=\"text\" />\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n        <select style=\"margin-top: 15px;\" formControlName=\"idDepto\">\r\n          <option value=\"\" disabled selected>DEPARTAMENTO</option>\r\n          <option *ngFor=\"let opt of departamentos\" [value]=\"opt.id\">\r\n            {{ opt.valor }}\r\n          </option>\r\n        </select>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n        <select style=\"margin-top: 15px;\" formControlName=\"idMunicipio\">\r\n          <option value=\"\" disabled selected>CIUDAD</option>\r\n          <option *ngFor=\"let opt of ciudades\" [value]=\"opt.id\">\r\n            {{ opt.valor }}\r\n          </option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s12 m4 l4\">\r\n        <mat-form-field class=\"example-full-width\">\r\n          <input matInput placeholder=\"DIRECCIÓN\" formControlName=\"Direccion\" type=\"text\" />\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n        <mat-form-field class=\"example-full-width\">\r\n          <input matInput placeholder=\"TELEFONO\" formControlName=\"Telefono\" type=\"text\" />\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n        <mat-form-field class=\"example-full-width\">\r\n          <input matInput placeholder=\"TELEFONO 2\" formControlName=\"Telefono2\" type=\"text\" />\r\n        </mat-form-field>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s12 m4 l4\">\r\n        <mat-form-field class=\"example-full-width\">\r\n          <input matInput placeholder=\"OBSERVACIÓN\" formControlName=\"Observacion\" type=\"text\" />\r\n        </mat-form-field>\r\n      </div>\r\n    </div>\r\n    <button mat-raised-button type=\"submit\" color=\"accent\" [disabled]=\"!direccionGroup.valid\">\r\n      Actualizar\r\n    </button>\r\n  </form>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.html":
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.html ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contenedor-form\" *ngIf=\"loadingUsuario\">\r\n  <mat-spinner\r\n    [diameter]=\"100\"\r\n    style=\"margin:0 auto; top:15px;\"\r\n  ></mat-spinner>\r\n</div>\r\n\r\n<div style=\"text-align: center; margin-bottom: 20px;\" *ngIf=\"!loadingUsuario\">\r\n  <form [formGroup]=\"usuarioGrupo\" (ngSubmit)=\"submitForm()\">\r\n    <div class=\"row\">\r\n      <div class=\"col s12 m4 l4\">\r\n          <select style=\"margin-top: 15px;\" formControlName=\"IdTpoUsuario\">\r\n              <option value=\"\" disabled selected>TIPO USUARIO</option>\r\n              <option *ngFor=\"let opt of tiposUsuario\" [value]=\"opt.id\">\r\n                {{ opt.valor }}\r\n              </option>\r\n            </select>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n        <mat-form-field class=\"example-full-width\">\r\n          <input\r\n            matInput\r\n            placeholder=\"USUARIO\"\r\n            formControlName=\"Usuario\"\r\n            type=\"text\"\r\n          />\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n          <mat-form-field class=\"example-full-width\">\r\n              <input\r\n                matInput\r\n                placeholder=\"CLAVE\"\r\n                formControlName=\"Clave\"\r\n                type=\"password\"\r\n              />\r\n            </mat-form-field>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s6 m6 l6\">\r\n          <mat-form-field class=\"example-full-width\">\r\n              <input\r\n                matInput\r\n                placeholder=\"DESCRIPCION\"\r\n                formControlName=\"Descripcion\"\r\n                type=\"text\"\r\n              />\r\n            </mat-form-field>\r\n      </div>\r\n      <div class=\"col s6 m6 l6\">\r\n        <mat-form-field>\r\n          <mat-select placeholder=\"AGENCIAS\" formControlName=\"formAgencias\" multiple>                \r\n            <mat-option *ngFor=\"let item of agencias\" [value]=\"item.id\">{{item.valor}}</mat-option>\r\n          </mat-select>\r\n        </mat-form-field> \r\n      </div>\r\n    </div>\r\n    \r\n    <button\r\n      mat-raised-button\r\n      type=\"submit\"\r\n      color=\"accent\"\r\n      [disabled]=\"!usuarioGrupo.valid\"\r\n    >\r\n      Actualizar\r\n    </button>\r\n  </form>\r\n</div>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/reporte-personas/reporte-personas.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/reporte-personas/reporte-personas.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n  <div class=\"contenedor-form\" *ngIf=\"items\">\r\n    <app-dynamic-report (salidaReporte)=\"salidaReporte($event);\" [items]=\"items\" [descripcion]=\"descripcion\" [parametrosDestino]=\"parametrosDestino\" [procedimientoDestino]=\"procedimientoDestino\"></app-dynamic-report>\r\n  </div>\r\n  <div class=\"contenedor-form\" *ngIf=\"!items\">\r\n    <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n  </div>\r\n  </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-agencias/dialog-agencias.component.html":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-agencias/dialog-agencias.component.html ***!
  \**************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>Agencias</h2>\r\n<mat-dialog-content class=\"mat-typography\">\r\n    <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n  <strong><p>Por favor seleccione las agencias a las que desea asignar el usuario</p></strong>\r\n  <div class=\"row\" *ngIf=\"!loading\">\r\n      <div class=\"col-s3 m3 l3\"></div>\r\n    <div class=\"col s6 m6 l6\">\r\n      <form [formGroup]=\"agenciaGroup\">\r\n      <mat-form-field>\r\n            <mat-select (selectionChange)=\"setAgencias(selected)\" placeholder=\"AGENCIAS\" formControlName=\"formAgencias\" multiple>                \r\n              <mat-option *ngFor=\"let item of agencias\" [value]=\"item.id\">{{item.valor}}</mat-option>\r\n            </mat-select>\r\n          </mat-form-field>          \r\n        </form>  \r\n    </div>\r\n    <div class=\"col-s3 m3 l3\"></div>\r\n  </div>\r\n    \r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions align=\"end\">  \r\n  <button mat-raised-button color=\"primary\" [disabled]=\"agenciasSet==''\" [mat-dialog-close]=\"agenciasSet\">Aceptar</button>  \r\n</mat-dialog-actions>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.html":
/*!****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.html ***!
  \****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title *ngIf=\"!isDetail\">Copiar Encuesta</h2>\r\n<h2 mat-dialog-title *ngIf=\"isDetail\">{{ nombreEncuesta }}</h2>\r\n<mat-dialog-content class=\"mat-typography\" *ngIf=\"!isDetail\">\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l12\" style=\"text-align: center;\">\r\n      <mat-form-field class=\"example-full-width input-size\">\r\n        <mat-icon matSuffix>search</mat-icon>\r\n        <input type=\"search\" matInput placeholder=\"Buscar\" />\r\n      </mat-form-field>\r\n    </div>\r\n  </div>\r\n  <div class=\"contenedor-form\" *ngIf=\"loadingDetalle\">\r\n    <mat-spinner [diameter]=\"40\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <div class=\"contenedor-form\" *ngIf=\"loadingEncuesta\">\r\n        <mat-spinner\r\n          [diameter]=\"100\"\r\n          style=\"margin:0 auto; top:15px;\"\r\n        ></mat-spinner>\r\n      </div>\r\n      <mat-list>\r\n        <h3 mat-subheader>Encuestas</h3>\r\n        <mat-list-item\r\n          *ngFor=\"let encuesta of encuestas\"\r\n          (click)=\"selectEncuesta(encuesta)\"\r\n        >\r\n          <!--<mat-list-item (mouseover)=\"mouseHover(encuesta.id);\" (mouseleave)=\"mouseOut();\" *ngFor=\"let encuesta of encuestas\" (click)=\"selectEncuesta();\">-->\r\n          <mat-icon mat-list-icon>list_alt</mat-icon>\r\n          <h4 mat-line>{{ encuesta.valor | uppercase }}</h4>\r\n          <!--<button *ngIf=\"showBtn==encuesta.id\" mat-raised-button color=\"primary\" (click)=\"selectEdit($event);\" id=\"{{encuesta.id}}\">Editar</button>-->\r\n          <button mat-icon-button>\r\n            <mat-icon>chevron_right</mat-icon>\r\n          </button>\r\n        </mat-list-item>\r\n      </mat-list>\r\n    </div>\r\n  </div>\r\n</mat-dialog-content>\r\n<mat-dialog-content class=\"mat-typography\" *ngIf=\"isDetail\">\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <button mat-mini-fab (click)=\"volver();\">\r\n        <mat-icon>arrow_back</mat-icon>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" *ngFor=\"let bloque of encuestaCopiar.bloques\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <p class=\"primary-color\">{{ bloque.descripcion }}</p>\r\n      <span *ngFor=\"let pregunta of bloque.preguntas; let i = index\">\r\n        <p style=\"margin-left: 15px; margin-top: 15px;\">{{ [i + 1] }}. ¿{{ pregunta.enunciado }}?</p>\r\n        <span *ngIf=\"pregunta.opciones\">\r\n            <mat-selection-list style=\"margin-left: 25px;\">\r\n                <mat-list-option [disabled]=\"true\" checkboxPosition=\"before\" *ngFor=\"let opcion of pregunta.opciones\">\r\n                  {{opcion.descripcionOpcion}}\r\n                </mat-list-option>\r\n              </mat-selection-list>\r\n        </span>\r\n        <span *ngIf=\"!pregunta.opciones\">\r\n          <mat-form-field style=\"margin-left: 25px;\" class=\"example-full-width\">\r\n            <input matInput readonly=\"true\" type=\"text\" />\r\n          </mat-form-field>\r\n        </span>\r\n      </span>\r\n    </div>\r\n  </div>\r\n</mat-dialog-content>\r\n<div *ngIf=\"isDetail\" mat-dialog-actions align=\"end\">\r\n    <button mat-raised-button color=\"primary\" (click)=\"copiarEncuesta()\">\r\n      <mat-icon>file_copy</mat-icon>\r\n      Copiar\r\n    </button>\r\n  </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-documento/dialog-documento.component.html":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-documento/dialog-documento.component.html ***!
  \****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>Documentos Entrega</h2>\r\n<mat-dialog-content class=\"mat-typography\">\r\n    <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n  <p>Revisión de documentos</p>\r\n  <div class=\"row\" *ngFor=\"let imagen of imagenes\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <img [hidden]=\"loading\"   style=\"width: 100%;\" [src]=\"imagen\" />\r\n      <mat-divider></mat-divider>\r\n    </div>\r\n  </div>\r\n    \r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions align=\"end\">\r\n  <button mat-raised-button color=\"accent\" (click)=\"crearPDF();\" >PDF</button>\r\n  <button mat-raised-button color=\"primary\" [mat-dialog-close]=\"dataModified\" cdkFocusInitial>Cerrar</button>  \r\n</mat-dialog-actions>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.html":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.html ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>Detalle Persona</h2>\r\n<mat-dialog-content class=\"mat-typography\">\r\n\r\n  <mat-expansion-panel expanded=\"true\">\r\n        <mat-expansion-panel-header>\r\n          <mat-panel-title>\r\n            <h3 class=\"titulo-solicitud\">Información Básica</h3>\r\n          </mat-panel-title>\r\n        </mat-expansion-panel-header>\r\n\r\n        <div class=\"contenedor-form\" *ngIf=\"loadingPersona\">\r\n          <mat-spinner\r\n            [diameter]=\"100\"\r\n            style=\"margin:0 auto; top:15px;\"\r\n          ></mat-spinner>\r\n        </div>\r\n\r\n\r\n\r\n  <div style=\"text-align: center; margin-bottom: 20px;\" *ngIf=\"!loadingPersona\">\r\n  <form [formGroup]=\"personaGroup\" (ngSubmit)=\"submitForm()\">\r\n    <div class=\"row\">\r\n      <div class=\"col s12 m4 l4\">\r\n          <mat-form-field class=\"example-full-width\" >\r\n          <input matInput readonly placeholder=\"NÚMERO DOCUMENTO\" formControlName=\"NroDocId\" type=\"text\">\r\n          </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n          <mat-form-field class=\"example-full-width\" >\r\n          <input matInput placeholder=\"NOMBRE\" formControlName=\"Nombre\" type=\"text\">\r\n          </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n          <mat-form-field class=\"example-full-width\" >\r\n          <input matInput placeholder=\"APELLIDO\" formControlName=\"Apellido\" type=\"text\">\r\n          </mat-form-field>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col s12 m4 l4\">\r\n          <select style=\"margin-top: 15px;\" formControlName=\"IdTpoIdenti\">\r\n            <option value=\"\" disabled selected>TIPO DOCUMENTO</option>\r\n            <option *ngFor=\"let opt of tipoDocumentosSelect\" [value]=\"opt.Id\">\r\n              {{opt.Valor}}\r\n            </option>\r\n          </select>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n          <mat-form-field class=\"example-full-width\" >\r\n              <input matInput [matDatepicker]=\"picker1\" readonly placeholder=\"FECHA NACIMIENTO\" formControlName=\"FechaNac\">\r\n              <mat-datepicker-toggle matSuffix [for]=\"picker1\"></mat-datepicker-toggle>\r\n              <mat-datepicker #picker1></mat-datepicker>\r\n          </mat-form-field>\r\n      </div>\r\n      <div class=\"col s12 m4 l4\">\r\n          <mat-form-field class=\"example-full-width\" >\r\n          <input matInput placeholder=\"TELÉFONO\" formControlName=\"Telefono\" type=\"text\">\r\n          </mat-form-field>\r\n      </div>\r\n    </div>\r\n    <button mat-raised-button type=\"submit\" color=\"accent\" [disabled]=\"!personaGroup.valid\">Actualizar</button>\r\n  </form>\r\n  </div>\r\n\r\n</mat-expansion-panel>\r\n<br>\r\n<!--DIRECCIONES-->\r\n<mat-expansion-panel expanded=\"true\">\r\n    <mat-expansion-panel-header>\r\n      <mat-panel-title>\r\n        <h3 class=\"titulo-solicitud\">Información Direcciones</h3>\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n\r\n    <div class=\"contenedor-form\" *ngIf=\"loadingDetalle\">\r\n      <mat-spinner\r\n        [diameter]=\"100\"\r\n        style=\"margin:0 auto; top:15px;\"\r\n      ></mat-spinner>\r\n    </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col s12 m12 l12\" align=\"end\">\r\n            <!--<span class=oscuro>Agregar Dirección</span>-->\r\n            <button mat-fab (click)=\"crearDireccion();\">\r\n                <mat-icon>add</mat-icon>\r\n            </button>\r\n        </div>\r\n      </div>\r\n    <!--CREAR DIRECCIONES-->\r\n    <div *ngIf=\"creaDireccion\">\r\n        <div class=\"contenedor-form\" *ngIf=\"items\">\r\n          <!--<app-dynamic-form #resetForm [items]=\"items\" (dataFormulario)=\"dataFormulario($event);\" [descripcion]=\"descripcion\" [origenParent]=\"origenParent\" [parametrosDestino]=\"parametrosDestino\" [procedimientoDestino]=\"procedimientoDestino\"></app-dynamic-form>-->\r\n          \r\n          <form [formGroup]=\"direccionGroup\" (ngSubmit)=\"nuevaDireccion()\">\r\n            <div class=\"row\">\r\n              <div class=\"col s12 m4 l4\">\r\n                  <mat-form-field class=\"example-full-width\" >\r\n                  <input matInput placeholder=\"NOMBRE DIRECCION\" formControlName=\"nombreDireccion\" type=\"text\">\r\n                  </mat-form-field>\r\n              </div>\r\n              <div class=\"col s12 m4 l4\">\r\n                  <mat-form-field class=\"example-full-width\" >\r\n                  <input matInput placeholder=\"TELEFONO\" type=\"number\" formControlName=\"telefono\" type=\"text\">\r\n                  </mat-form-field>\r\n              </div>\r\n              <div class=\"col s12 m4 l4\">\r\n                  <mat-form-field class=\"example-full-width\" >\r\n                  <input matInput placeholder=\"TELEFONO 2\" type=\"number\" formControlName=\"telefono2\" type=\"text\">\r\n                  </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col s12 m4 l4\">\r\n                  <select style=\"margin-top: 15px;\" formControlName=\"departamento\"  (change)=\"getCiudades($event)\">\r\n                    <option value=\"\" disabled selected>DEPARTAMENTO</option>\r\n                    <option *ngFor=\"let opt of departamentosDireccion\" [value]=\"opt.id\">\r\n                      {{opt.valor}}\r\n                    </option>\r\n                  </select>\r\n              </div>\r\n              <div class=\"col s12 m4 l4\">\r\n                <select style=\"margin-top: 15px;\" formControlName=\"ciudad\">\r\n                  <option value=\"\" disabled selected>CIUDAD</option>\r\n                  <option *ngFor=\"let opt of ciudadesDireccion\" [value]=\"opt.id\">\r\n                    {{opt.valor}}\r\n                  </option>\r\n                </select>\r\n              </div>\r\n              <div class=\"col s12 m4 l4\">\r\n                  <mat-form-field class=\"example-full-width\" >\r\n                  <input matInput placeholder=\"DIRECCION\" formControlName=\"direccion\" type=\"text\">\r\n                  </mat-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col s12 m4 l4\">\r\n                <mat-form-field class=\"example-full-width\" >\r\n                <input matInput placeholder=\"OBSERVACION\" formControlName=\"observacion\" type=\"text\">\r\n                </mat-form-field>\r\n            </div>          \r\n            </div>\r\n            <button mat-raised-button type=\"submit\" color=\"accent\" [disabled]=\"!direccionGroup.valid\">Actualizar</button>\r\n          </form>\r\n\r\n        \r\n        </div>\r\n        <div class=\"contenedor-form\" *ngIf=\"!items\">\r\n          <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n        </div>\r\n      </div>\r\n    <!--FIN CREAR DIRECCIONES-->\r\n\r\n    <app-modificar-direccion-persona *ngIf=\"modificaDireccion\" [dataModificaDireccion]=\"dataModificaDireccion\" (propagar)=\"procesaPropagarDireccion($event)\"></app-modificar-direccion-persona>\r\n\r\n    <mat-list>\r\n        <mat-list-item *ngFor=\"let direccion of direcciones\">\r\n          <h4 mat-line><span class=\"oscuro\">Nombre Dirección:</span> {{direccion.NombreDireccion}}</h4>\r\n          <h4 mat-line><span class=\"oscuro\">Dirección:</span> {{direccion.Direccion}} <span class=\"oscuro\">Ciudad:</span> {{direccion.Descripcion}}</h4>\r\n          <p mat-line> <span class=\"oscuro\">Teléfono:</span> {{direccion.Telefono}} &nbsp;<span class=\"oscuro\">Teléfono:</span>{{direccion.Telefono2}} </p>\r\n          <p mat-line> <span class=\"oscuro\">Observación:</span> {{direccion.Observacion}}</p>\r\n          <button mat-icon-button (click)=\"editarDireccion(direccion);\">\r\n              <mat-icon>edit</mat-icon>\r\n          </button>\r\n          <button mat-icon-button (click)=\"eliminarDireccion(direccion);\">\r\n              <mat-icon>delete</mat-icon>\r\n            </button>\r\n            <mat-divider style=\"width:98%;\"></mat-divider>\r\n        </mat-list-item>\r\n      </mat-list>\r\n\r\n\r\n    </mat-expansion-panel>\r\n<br><!--USUARIOS-->\r\n<mat-expansion-panel expanded=\"true\">\r\n    <mat-expansion-panel-header>\r\n      <mat-panel-title>\r\n        <h3 class=\"titulo-solicitud\">Información Usuarios</h3>\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n\r\n    <div class=\"contenedor-form\" *ngIf=\"loadingDetalle\">\r\n      <mat-spinner\r\n        [diameter]=\"100\"\r\n        style=\"margin:0 auto; top:15px;\"\r\n      ></mat-spinner>\r\n    </div>\r\n\r\n\r\n\r\n    <app-modificar-usuario-persona *ngIf=\"modificaUsuario\" [dataModificaUsuario]=\"dataModificaUsuario\" (propagar)=\"procesaPropagar($event)\"></app-modificar-usuario-persona>\r\n\r\n    <mat-list>\r\n        <mat-list-item *ngFor=\"let usuario of usuarios\">\r\n          <h4 mat-line><span class=\"oscuro\">Usuario:</span> {{usuario.Usuario}} <span class=\"oscuro\">Tipo Usuario:</span> {{usuario.DescripcionTipo}}</h4>\r\n          <p mat-line> <span class=\"oscuro\">Observación:</span> {{usuario.Descripcion}} </p>\r\n          <button mat-icon-button (click)=\"editarUsuario(usuario);\">\r\n              <mat-icon>edit</mat-icon>\r\n            </button>\r\n          <button mat-icon-button (click)=\"eliminarUsuario(usuario);\">\r\n              <mat-icon>delete</mat-icon>\r\n            </button>\r\n            <mat-divider style=\"width:98%;\"></mat-divider>\r\n        </mat-list-item>\r\n      </mat-list>\r\n\r\n\r\n    </mat-expansion-panel>\r\n\r\n<br>\r\n\r\n</mat-dialog-content>\r\n\r\n<br>\r\n<mat-dialog-actions align=\"end\">\r\n  <button mat-button [mat-dialog-close]=\"dataModified\" cdkFocusInitial>Cerrar</button>\r\n  <!--<button mat-button (click)=\"ActualizarPersona();\" cdkFocusInitial>Actualizar</button>-->\r\n</mat-dialog-actions>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-firma/dialog-firma.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-firma/dialog-firma.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  dialog-firma works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-producto/dialog-producto.component.html":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-producto/dialog-producto.component.html ***!
  \**************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  dialog-producto works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-web-service/dialog-web-service.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-web-service/dialog-web-service.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>Detalle Entrega</h2>\r\n<mat-dialog-content class=\"mat-typography\">\r\n\r\n\r\n\r\n    <div class=\"timeline\">\r\n      <div class=\"timeline__group\" *ngFor=\"let item of detalleLogWS\">  \r\n\r\n        <div class=\"timeline__box\">\r\n          <div class=\"timeline__date\" [style.background-color]=\"item.codigoErrorWs == 0 ? green : red\">\r\n            <span class=\"timeline__day\">\r\n              <mat-icon style=\"color: white;\" *ngIf=\"item.codigoErrorWs == 0\">check_circle</mat-icon>\r\n              <mat-icon style=\"color: white;\" *ngIf=\"item.codigoErrorWs > 0\">error</mat-icon>\r\n            </span>\r\n            <!--<span class=\"timeline__month\"></span>-->\r\n          </div>\r\n          <div class=\"timeline__post\">\r\n            <div class=\"timeline__content\">\r\n              <span style=\"color: gray; font-weight:bolder;\">{{item.fecha | date:'yyyy-MM-dd hh:mm:ss'}}</span>\r\n              <p>{{item.descripcionErrorWs}}</p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        \r\n      </div>      \r\n    </div>\r\n\r\n  \r\n\r\n\r\n</mat-dialog-content>\r\n<mat-dialog-actions align=\"end\">  \r\n  <button mat-raised-button color=\"primary\" [mat-dialog-close]=\"dataModified\" cdkFocusInitial>Cerrar</button>  \r\n</mat-dialog-actions>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.html":
/*!**************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.html ***!
  \**************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-expansion-panel class=\"margen-expansion\" expanded=\"true\">\n    <mat-expansion-panel-header style=\"background-color: cornsilk;\">\n      <mat-panel-title>\n        <h6 class=\"titulo-solicitud\">Nueva Entrega</h6>\n      </mat-panel-title>\n    </mat-expansion-panel-header>\n    <div class=\"contenedor-form\">\n        <form [formGroup]=\"controlesCargue\"  class=\"example-form\">\n            <div class=\"row\">\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                      <mat-label>AGENCIA</mat-label>\n                       <mat-select\n                        formControlName=\"agencia\"> \n                        <mat-option *ngFor=\"let agencia of agencias\" [value]=\"agencia.id\">\n                            {{agencia.valor}}\n                          </mat-option>\n                      </mat-select>\n                    </mat-form-field>\n                  </div>\n                  <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                      <mat-label>Nro Orden</mat-label>\n                      <input matInput class=\"input-upper\" formControlName=\"ordenSap\" placeholder=\"Numero de Orden SAP\" maxlength=\"50\">\n                    </mat-form-field>\n                  </div>\n                  <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                      <mat-label>Entrega</mat-label>\n                      <input matInput class=\"input-upper\" formControlName=\"entrega\" placeholder=\"Numero de Entrega\" maxlength=\"50\">\n                    </mat-form-field>\n                  </div>\n                  <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                      <mat-label>Pedido</mat-label>\n                      <input matInput class=\"input-upper\" formControlName=\"pedido\" placeholder=\"Numero de Pedido\" maxlength=\"50\">\n                    </mat-form-field>\n                  </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col s12 m6 l9\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                      <mat-label>Nombre</mat-label>\n                      <input matInput class=\"input-upper\" formControlName=\"nombre\" placeholder=\"Nombre del Cliente\" maxlength=\"150\">\n                    </mat-form-field>\n                  </div>\n                  <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                      <mat-label>Telefono</mat-label>\n                      <input matInput type=\"number\" formControlName=\"telefono\" placeholder=\"Telefono del Cliente\" maxlength=\"50\">\n                    </mat-form-field>\n                  </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col s12 m6 l9\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\" >\n                      <mat-label>Direccion</mat-label>\n                      <input matInput class=\"input-upper\" formControlName=\"direccion\" placeholder=\"Direccion de Entrega\" maxlength=\"150\">\n                    </mat-form-field>\n                  </div>\n                  <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                      <mat-label>Ciudad</mat-label>\n                      <input matInput class=\"input-upper\" formControlName=\"ciudad\" placeholder=\"Ciudad de Entrega\" maxlength=\"50\">\n                    </mat-form-field>\n                  </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Articulo</mat-label>\n                        <input matInput class=\"input-upper\" formControlName=\"articulo\" placeholder=\"Referencia del Articulo\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width input-upper\">\n                        <mat-label>Tienda</mat-label>\n                        <input matInput class=\"input-upper\" formControlName=\"tienda\" placeholder=\"Tienda de Origen del producto\" maxlength=\"150\">\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" readonly class=\"example-full-width\">\n                        <mat-label>Cantidad</mat-label>\n                        <input matInput type=\"number\" readonly formControlName=\"cantidad\" placeholder=\"Cantidad de producto\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width \">\n                        <mat-label>Fecha Entrega</mat-label>\n                        <input \n                            matInput \n                            formControlName=\"fechaEnt\" \n                            placeholder=\"Fecha de Entrega\" \n                            maxlength=\"50\"\n                            readonly\n                            [matDatepicker]=\"pickFechaEnt\"\n                            >\n                            <mat-datepicker-toggle matSuffix [for]=\"pickFechaEnt\"></mat-datepicker-toggle>\n                        <mat-datepicker #pickFechaEnt></mat-datepicker>\n                    </mat-form-field>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Ruta</mat-label>\n                        <input matInput class=\"input-upper\" formControlName=\"ruta\" placeholder=\"Ruta Asignada a la Entrega\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Cedula Conductor</mat-label>\n                        <input matInput type=\"number\" formControlName=\"cedula\" placeholder=\"Cedula del Conductor Asignado\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Placa</mat-label>\n                        <input matInput class=\"input-upper\" formControlName=\"placa\" placeholder=\"Placa del Vehiculo Asigando\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>CDR</mat-label>\n                        <input matInput class=\"input-upper\" formControlName=\"cdr\" placeholder=\"CDR\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Estado Actual</mat-label>\n                        <input matInput class=\"input-upper\" formControlName=\"estado\" placeholder=\"Estado Actual de la Entrega\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Fecha de Carga</mat-label>\n                        <input \n                            matInput \n                            formControlName=\"fechaCarga\" \n                            placeholder=\"Fecha del Cargue\" \n                            maxlength=\"50\"\n                            readonly\n                            [matDatepicker]=\"pickFechaCarga\">\n                        <mat-datepicker-toggle matSuffix [for]=\"pickFechaCarga\"></mat-datepicker-toggle>\n                        <mat-datepicker #pickFechaCarga></mat-datepicker>\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Fecha de Venta</mat-label>\n                        <input \n                            matInput \n                            formControlName=\"fechaVenta\" \n                            placeholder=\"Fecha de Venta del Articulo\" \n                            maxlength=\"50\"\n                            readonly\n                            [matDatepicker]=\"pickFechaVenta\">\n                        <mat-datepicker-toggle matSuffix [for]=\"pickFechaVenta\"></mat-datepicker-toggle>\n                        <mat-datepicker #pickFechaVenta></mat-datepicker>\n                    </mat-form-field>\n                </div>\n                <div class=\"col s12 m6 l3\">\n                    <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                        <mat-label>Tipo Entrega</mat-label>\n                        <input matInput class=\"input-upper\" formControlName=\"tipoEntrega\" placeholder=\"Tipo de Entrega\" maxlength=\"50\">\n                    </mat-form-field>\n                </div>\n            </div>\n        </form>\n    </div>\n</mat-expansion-panel>\n<br>\n<div class=\"col s12 m12 l12 center-block align-to-bottom\" style = \"/* display: block;\n    height: 100%;\n    background-color: #ff1124;\n    justify-content: center;\n    align-items: center;\n    bottom: 0%; */\">\n    <div class=\"vertical-center\">\n        <button mat-raised-button style=\"\n    margin-left:2%;\n    margin-right:2%;\" color=\"primary\"\n    [disabled]=\"! this.controlesCargue.valid \"\n    (click)=\"guardarDocumento()\" >\n            Crear Entrega\n        </button>\n\n        <button mat-raised-button style=\"\n      margin-left:2%;\n      margin-right:2%;\n      bottom: 0%;\" color=\"warn\" \n      (click)=\"cancelar()\">\n            Cancelar\n        </button>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.html":
/*!****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.html ***!
  \****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\n\n<mat-expansion-panel class=\"margen-expansion\" expanded=\"true\">\n  <mat-expansion-panel-header>\n    <mat-panel-title>\n      <h6 class=\"titulo-solicitud\">Gestion Entrega</h6>\n    </mat-panel-title>\n  </mat-expansion-panel-header>\n\n  <br>\n  <form [formGroup]=\"controlesGroup\" class=\"contentTabla principal\">\n    <div class=\"row\">\n      <div style=\"display:flex; flex-direction: row; justify-content: center; align-items: center\"\n        matTooltip=\"Seleccione el estado de la entrega.\">\n        <span style=\"left: 15dp;\" >\n          <mat-radio-group [(ngModel)]=\"idNovedad\" formControlName=\"RbgNovedad\" (change)=\"setMotivo()\">\n            <mat-radio-button style=\"margin-right: 5px;\" [value]=1 >\n              Entrega Efectiva\n            </mat-radio-button>\n            <mat-radio-button style=\"margin-right: 5px;\" [value]=2 >\n              Entrega No Efectiva\n            </mat-radio-button>\n            <mat-radio-button style=\"margin-right: 5px;\" [value]=3 *ngIf=\"false\">\n              Entrega Parcial\n            </mat-radio-button>\n          </mat-radio-group>\n        </span>\n      </div>\n    </div>\n    <br>\n\n    <div class=\"row\" style=\"margin-right: 10px;\">\n      <mat-list dense style=\"/*overflow: auto; flex-grow: 1;*/ border: 1px solid #078888; /*margin: 10px;*/\"\n        class=\"col s12 m12 l12\">\n        <!-- item.idServicioPaquete -->\n        <ng-container *ngFor=\"let item of this.dataPaquetes\">\n          <mat-list-item>\n            <mat-icon mat-list-icon style=\"color: #078888; cursor: pointer; transform:scale(2)\">\n              inventory_2\n            </mat-icon>\n            <p mat-line><b>Serial: {{item.Serial}}</b></p>\n            <p mat-line>Contenido: {{item.Contiene}}</p>\n            <p mat-line>Cantidad: {{item.Cantidad}}</p>\n            <div class=\"col s12 m12 l12\" mat-line>\n              <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n                <mat-label>Motivo de No Entrega</mat-label>\n                <mat-select autoWidth=true  [disabled]=\"idNovedad==1 || idNovedad==0\" formControlName=\"{{'ctrl_' + item.idServicioPaquete}}\" >\n                  <mat-option *ngFor=\"let motivo of this.dataMotivos\" [value]=\"motivo.idMotivo\">\n                    {{motivo.descripcion}}\n                  </mat-option>\n                </mat-select>\n              </mat-form-field>\n            </div>\n            <mat-divider></mat-divider>\n          </mat-list-item>\n        </ng-container>\n  \n      </mat-list>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col s12 m12 l12\">\n        <mat-form-field appearance=\"outline\" class=\"example-full-width\">\n          <mat-label>Observaciones</mat-label>\n          <textarea matInput formControlName=\"Observaciones\" [readonly]=\"this.idNovedad != 2 && this.idNovedad != 1 \"\n            placeholder=\"Agregue una observacion sobre el cargue actual.\" maxlength=\"500\"></textarea>\n        </mat-form-field>\n      </div>\n    </div>\n  </form>\n  \n\n\n\n</mat-expansion-panel>\n\n\n<br>\n<div class=\"col s12 m12 l12 center-block align-to-bottom\" style=\"/* display: block;\n    height: 100%;\n    background-color: #ff1124;\n    justify-content: center;\n    align-items: center;\n    bottom: 0%; */\">\n  <div class=\"vertical-center\">\n    <button mat-raised-button style=\"\n    margin-left:2%;\n    margin-right:2%;\" color=\"accent\" \n     [disabled]=\"! this.controlesGroup.valid \"\n    (click)=\"terminarGestionCargue()\">\n      Terminar Entrega\n    </button>\n\n    <button mat-raised-button style=\"\n      margin-left:2%;\n      margin-right:2%;\n      bottom: 0%;\" color=\"warn\" (click)=\"cancelar()\">\n      Cancelar\n    </button>\n  </div>\n\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-form-contenido/dynamic-form-contenido.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-form-contenido/dynamic-form-contenido.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<span *ngIf=\"item !== undefined\">\r\n  <div [formGroup]=\"form\">\r\n    <div [ngSwitch]=\"item.controlType\" class=\"col s12 m12 l4\">\r\n\r\n        <mat-form-field *ngSwitchCase=\"'textbox'\" class=\"example-full-width\" [id]=\"item.key\">\r\n          <span *ngIf=\"item.type!='date'\">\r\n            <input matInput [placeholder]=\"item.label\" [formControlName]=\"item.key\" [id]=\"item.key\" [type]=\"item.type\"\r\n              [required]>\r\n\r\n          </span>\r\n          <span *ngIf=\"item.type=='date'\">\r\n            <input matInput [matDatepicker]=\"picker1\" readonly [placeholder]=\"item.label\" [attr.data-date]=\"item.type\" [formControlName]=\"item.key\">\r\n            <mat-datepicker-toggle matSuffix [for]=\"picker1\"></mat-datepicker-toggle>\r\n            <mat-datepicker #picker1></mat-datepicker>\r\n          </span>\r\n          <!--<span *ngIf=\"item.type=='date' && item.hijoDate\" >\r\n            <input matInput  [min]=\"minDatePadre\" [matDatepicker]=\"dp\" readonly [attr.data-date]=\"item.type\" (dateChange)=\"padre($event, 'padre', item.hijoDate)\"\r\n              [placeholder]=\"item.label\" [formControlName]=\"item.key\">\r\n            <mat-datepicker-toggle matSuffix [for]=\"dp\"></mat-datepicker-toggle>\r\n            <mat-datepicker #dp></mat-datepicker>\r\n          </span>\r\n          <span *ngIf=\"item.type=='date' && item.padreDate\" >\r\n            <input  matInput [min]=\"minDateHijo\" [matDatepicker]=\"picker\" readonly [attr.data-date]=\"item.type\" (dateChange)=\"cambio($event, 'padre', item.padreDates)\" [placeholder]=\"item.label\" class=\"form-control\" [formControlName]=\"item.key\">\r\n            <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n            <mat-datepicker #picker></mat-datepicker>\r\n\r\n          </span>-->\r\n        </mat-form-field>\r\n\r\n        <!--<div class=\"form-input\" *ngIf=\"item.type=='date' && item.hijoDate\">\r\n          <label>\r\n            <input class=\"fecha-calendar\" data-title=\"padre\" [id]=\"item.key+'///padre'\" [formControlName]=\"item.key\" >\r\n            <span class=\"placeholder\">{{item.label}}</span>\r\n          </label>\r\n        </div>\r\n\r\n        <div class=\"form-input\" *ngIf=\"item.type=='date' && item.padreDate\">\r\n          <label>\r\n            <input class=\"fecha-calendar\" data-title=\"hijo\" [id]=\"item.key+'///hijo'\" [formControlName]=\"item.key\" >\r\n            <span class=\"placeholder\">{{item.label}}</span>\r\n          </label>\r\n        </div>-->\r\n      <div *ngSwitchCase=\"'dropdown'\">\r\n        <select style=\"margin-top: 15px;\" [formControlName]=\"item.key\" [id]=\"item.key\" *ngIf=\"item.callback==1\"\r\n          (change)=\"cargaDropDown(item.origenCallBack, item.key, item.label);\">\r\n          <option value=\"\" disabled selected>{{item.label}}</option>\r\n          <option *ngFor=\"let opt of item.options\" [value]=\"opt.key\">\r\n            {{opt.value}}\r\n          </option>\r\n        </select>\r\n\r\n        <span *ngIf=\"!cargando\"><select style=\"margin-top: 15px;\" [formControlName]=\"item.key\" [id]=\"item.key\"\r\n            *ngIf=\"item.callback==0 && item.depende==1\">\r\n            <option value=\"\" disabled selected>{{item.label}}</option>\r\n            <option *ngFor=\"let opt of item.options\" [value]=\"opt.key\">\r\n              {{opt.value}}\r\n            </option>\r\n          </select></span>\r\n\r\n        <select style=\"margin-top: 15px;\" [formControlName]=\"item.key\" [id]=\"item.key\" *ngIf=\"item.callback==0 && item.depende==0\">\r\n          <option value=\"\" disabled selected>{{item.label}}</option>\r\n          <option *ngFor=\"let opt of item.options\" [value]=\"opt.key\">\r\n            {{opt.value}}\r\n          </option>\r\n        </select>\r\n        <mat-spinner [diameter]=\"30\" *ngIf=\"cargando && item.callback==0 && item.depende==1\"\r\n          style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n      <br>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.maxlength !== undefined\">\r\n        Tamaño Máximo {{item.maxlength}}\r\n      </span>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.pattern !== undefined\">\r\n        Solo Números\r\n      </span>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.email !== undefined\">\r\n        Email Ej: nombre@dominio.com\r\n      </span>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.minlength !== undefined\">\r\n        Tamaño Mínimo {{item.minlength}}\r\n      </span>\r\n    </div>\r\n\r\n\r\n\r\n  </div>\r\n</span>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-form/dynamic-form.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-form/dynamic-form.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n  <form *ngIf=\"items\" (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\r\n    <mat-expansion-panel [expanded]=\"expandido===true\">\r\n      <mat-expansion-panel-header>\r\n        <mat-panel-title>\r\n          <h6 class=\"titulo-solicitud\">{{descripcion}}</h6>\r\n        </mat-panel-title>\r\n      </mat-expansion-panel-header>\r\n      <div *ngFor=\"let item of items; let i=index; let even=even;\" class=\"row\">\r\n        <!--<app-dynamic-form-contenido [item]=\"item\" [form]=\"form\"></app-dynamic-form-contenido>-->\r\n        <!--<div *ngIf=\"even\">-->\r\n        <div *ngIf=\"(i % 3) === 0\">\r\n          <app-dynamic-form-contenido [item]=\"items[i]\" [form]=\"form\"></app-dynamic-form-contenido>\r\n          <app-dynamic-form-contenido [item]=\"items[i+1]\" [form]=\"form\"></app-dynamic-form-contenido>\r\n          <app-dynamic-form-contenido [item]=\"items[i+2]\" [form]=\"form\"></app-dynamic-form-contenido>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col s12 m12 l12\" style=\"text-align:center;\">\r\n          <button mat-raised-button type=\"submit\" color=\"accent\" [disabled]=\"!form.valid\">Guardar</button>\r\n          <br><br>\r\n        </div>\r\n      </div>\r\n\r\n\r\n    </mat-expansion-panel>\r\n  </form>\r\n\r\n  <!--<div *ngIf=\"payLoad\" class=\"form-row\">\r\n    <strong>Saved the following values</strong><br>{{payLoad}}\r\n  </div>-->\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-report-contenido/dynamic-report-contenido.component.html":
/*!************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-report-contenido/dynamic-report-contenido.component.html ***!
  \************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<span *ngIf=\"item !== undefined\">\r\n  <div [formGroup]=\"form\">\r\n    <div [ngSwitch]=\"item.controlType\" class=\"col s12 m12 l4\">\r\n\r\n        <mat-form-field *ngSwitchCase=\"'textbox'\" class=\"example-full-width\" [id]=\"item.key\">\r\n          <span *ngIf=\"item.type!='date'\">\r\n            <input matInput [placeholder]=\"item.label\" [formControlName]=\"item.key\" [id]=\"item.key\" [type]=\"item.type\"\r\n              [required]>\r\n\r\n          </span>\r\n          <span *ngIf=\"item.type=='date'\">\r\n            <input matInput [matDatepicker]=\"picker1\" readonly [placeholder]=\"item.label\" [attr.data-date]=\"item.type\" [formControlName]=\"item.key\">\r\n            <mat-datepicker-toggle matSuffix [for]=\"picker1\"></mat-datepicker-toggle>\r\n            <mat-datepicker #picker1></mat-datepicker>\r\n          </span>\r\n          <!--<span *ngIf=\"item.type=='date' && item.hijoDate\" >\r\n            <input matInput  [min]=\"minDatePadre\" [matDatepicker]=\"dp\" readonly [attr.data-date]=\"item.type\" (dateChange)=\"padre($event, 'padre', item.hijoDate)\"\r\n              [placeholder]=\"item.label\" [formControlName]=\"item.key\">\r\n            <mat-datepicker-toggle matSuffix [for]=\"dp\"></mat-datepicker-toggle>\r\n            <mat-datepicker #dp></mat-datepicker>\r\n          </span>\r\n          <span *ngIf=\"item.type=='date' && item.padreDate\" >\r\n            <input  matInput [min]=\"minDateHijo\" [matDatepicker]=\"picker\" readonly [attr.data-date]=\"item.type\" (dateChange)=\"cambio($event, 'padre', item.padreDates)\" [placeholder]=\"item.label\" class=\"form-control\" [formControlName]=\"item.key\">\r\n            <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n            <mat-datepicker #picker></mat-datepicker>\r\n\r\n          </span>-->\r\n        </mat-form-field>\r\n\r\n        <!--<div class=\"form-input\" *ngIf=\"item.type=='date' && item.hijoDate\">\r\n          <label>\r\n            <input class=\"fecha-calendar\" data-title=\"padre\" [id]=\"item.key+'///padre'\" [formControlName]=\"item.key\" >\r\n            <span class=\"placeholder\">{{item.label}}</span>\r\n          </label>\r\n        </div>\r\n\r\n        <div class=\"form-input\" *ngIf=\"item.type=='date' && item.padreDate\">\r\n          <label>\r\n            <input class=\"fecha-calendar\" data-title=\"hijo\" [id]=\"item.key+'///hijo'\" [formControlName]=\"item.key\" >\r\n            <span class=\"placeholder\">{{item.label}}</span>\r\n          </label>\r\n        </div>-->\r\n      <div *ngSwitchCase=\"'dropdown'\">\r\n        <select [formControlName]=\"item.key\" [id]=\"item.key\" *ngIf=\"item.callback==1\"\r\n          (change)=\"cargaDropDown(item.origenCallBack, item.key, item.label);\">\r\n          <option value=\"\" disabled selected>{{item.label}}</option>\r\n          <option *ngFor=\"let opt of item.options\" [value]=\"opt.key\">\r\n            {{opt.value}}\r\n          </option>\r\n        </select>\r\n\r\n        <span *ngIf=\"!cargando\"><select [formControlName]=\"item.key\" [id]=\"item.key\"\r\n            *ngIf=\"item.callback==0 && item.depende==1\">\r\n            <option value=\"\" disabled selected>{{item.label}}</option>\r\n            <option *ngFor=\"let opt of item.options\" [value]=\"opt.key\">\r\n              {{opt.value}}\r\n            </option>\r\n          </select></span>\r\n\r\n        <select [formControlName]=\"item.key\" [id]=\"item.key\" *ngIf=\"item.callback==0 && item.depende==0\">\r\n          <option value=\"\" disabled selected>{{item.label}}</option>\r\n          <option *ngFor=\"let opt of item.options\" [value]=\"opt.key\">\r\n            {{opt.value}}\r\n          </option>\r\n        </select>\r\n        <mat-spinner [diameter]=\"30\" *ngIf=\"cargando && item.callback==0 && item.depende==1\"\r\n          style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n      </div>\r\n      <br>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.maxlength !== undefined\">\r\n        Tamaño Máximo {{item.maxlength}}\r\n      </span>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.pattern !== undefined\">\r\n        Solo Números\r\n      </span>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.email !== undefined\">\r\n        Email Ej: nombre@dominio.com\r\n      </span>\r\n      <span class=\"classError\" *ngIf=\"!isValid && Error.minlength !== undefined\">\r\n        Tamaño Mínimo {{item.minlength}}\r\n      </span>\r\n    </div>\r\n\r\n\r\n\r\n  </div>\r\n</span>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-report/dynamic-report.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-report/dynamic-report.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n  <form *ngIf=\"items\" (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\r\n    <mat-expansion-panel [expanded]=\"expandido===true\">\r\n      <mat-expansion-panel-header>\r\n        <mat-panel-title>\r\n          <h6 class=\"titulo-solicitud\">{{descripcion}}</h6>\r\n        </mat-panel-title>\r\n      </mat-expansion-panel-header>\r\n      <div *ngFor=\"let item of items; let i=index; let even=even;\" class=\"row\">\r\n        <!--<app-dynamic-form-contenido [item]=\"item\" [form]=\"form\"></app-dynamic-form-contenido>-->\r\n        <!--<div *ngIf=\"even\">-->\r\n        <div *ngIf=\"(i % 3) === 0\">\r\n          <app-dynamic-form-contenido [item]=\"items[i]\" [form]=\"form\"></app-dynamic-form-contenido>\r\n          <app-dynamic-form-contenido [item]=\"items[i+1]\" [form]=\"form\"></app-dynamic-form-contenido>\r\n          <app-dynamic-form-contenido [item]=\"items[i+2]\" [form]=\"form\"></app-dynamic-form-contenido>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col s12 m12 l12\" style=\"text-align:center;\">\r\n          <button mat-raised-button type=\"submit\" color=\"accent\" [disabled]=\"!form.valid\">Guardar</button>\r\n          <br><br>\r\n        </div>\r\n      </div>\r\n\r\n\r\n    </mat-expansion-panel>\r\n  </form>\r\n\r\n  <!--<div *ngIf=\"payLoad\" class=\"form-row\">\r\n    <strong>Saved the following values</strong><br>{{payLoad}}\r\n  </div>-->\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-completas/entregas-completas.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-completas/entregas-completas.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  entregas-completas works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-parciales/entregas-parciales.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-parciales/entregas-parciales.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  entregas-parciales works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-transportador/entregas-transportador.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-transportador/entregas-transportador.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br />\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Informe De Entregas X Transportador</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n\r\n  <div class=\"contenedor-form\">\r\n    <form\r\n      [formGroup]=\"entregasGroup\"\r\n      (ngSubmit)=\"busqueda()\"\r\n      class=\"example-form\"\r\n    >\r\n      <div class=\"row\">\r\n        <div class=\"col s12 m6 l2\">\r\n          <span *ngIf=\"loadingAgencias\">\r\n            <mat-spinner\r\n              [diameter]=\"30\"\r\n              style=\"margin:0 auto; top:15px;\"\r\n            ></mat-spinner>\r\n          </span>\r\n          <span *ngIf=\"!loadingAgencias\">\r\n            <mat-form-field>\r\n              <mat-label>AGENCIA</mat-label>\r\n              <mat-select\r\n                formControlName=\"idAgencia\"\r\n                (change)=\"cargarUsuariosAgencia()\"\r\n              >\r\n                <mat-option\r\n                  *ngFor=\"let agencia of agencias\"\r\n                  [value]=\"agencia.id\"\r\n                >\r\n                  {{ agencia.valor }}\r\n                </mat-option>\r\n              </mat-select>\r\n            </mat-form-field>\r\n          </span>\r\n        </div>\r\n        <div class=\"col s12 m6 l4\">\r\n          <span *ngIf=\"loadingUsuarios\">\r\n            <mat-spinner\r\n              [diameter]=\"30\"\r\n              style=\"margin:0 auto; top:15px;\"\r\n            ></mat-spinner>\r\n          </span>\r\n          <span *ngIf=\"!loadingUsuarios\">\r\n            <mat-form-field class=\"example-full-width\">\r\n              <input\r\n                matInput\r\n                placeholder=\"Transportador\"\r\n                [matAutocomplete]=\"auto\"\r\n                formControlName=\"usuarioCtrl\"\r\n              />\r\n              <mat-autocomplete\r\n                #auto=\"matAutocomplete\"\r\n                [displayWith]=\"displayFn\"\r\n              >\r\n                <mat-option\r\n                  *ngFor=\"let usuario of filteredUsuarios | async\"\r\n                  [value]=\"usuario\"\r\n                >\r\n                  <span>{{ usuario.valor }}</span>\r\n                </mat-option>\r\n              </mat-autocomplete>\r\n            </mat-form-field>\r\n          </span>\r\n        </div>\r\n        <div class=\"col s12 m6 l2\">\r\n          <mat-form-field>\r\n            <input\r\n              formControlName=\"fechaInicial\"\r\n              readonly\r\n              matInput\r\n              [matDatepicker]=\"picker\"\r\n              placeholder=\"Fecha Inicial\"\r\n            />\r\n            <mat-datepicker-toggle\r\n              matSuffix\r\n              [for]=\"picker\"\r\n            ></mat-datepicker-toggle>\r\n            <mat-datepicker #picker></mat-datepicker>\r\n          </mat-form-field>\r\n        </div>\r\n        <div class=\"col s12 m6 l2\">\r\n          <mat-form-field>\r\n            <input\r\n              formControlName=\"fechaFinal\"\r\n              readonly\r\n              matInput\r\n              [matDatepicker]=\"picker1\"\r\n              placeholder=\"Fecha Final\"\r\n            />\r\n            <mat-datepicker-toggle\r\n              matSuffix\r\n              [for]=\"picker1\"\r\n            ></mat-datepicker-toggle>\r\n            <mat-datepicker #picker1></mat-datepicker>\r\n          </mat-form-field>\r\n        </div>\r\n        <div class=\"col s12 m6 l2\">\r\n          <button\r\n            mat-raised-button\r\n            color=\"accent\"\r\n            type=\"submit\"\r\n            [disabled]=\"!entregasGroup.valid || loading\"\r\n          >\r\n            Consultar\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</mat-expansion-panel>\r\n\r\n<br />\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h5 class=\"titulo-solicitud\">Entregas Realizadas</h5>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l12\">\r\n        <form [formGroup]=\"searchForm\">\r\n        <mat-form-field>\r\n        <input formControlName=\"searchText\" matInput placeholder=\"BUSCAR\" />\r\n        <mat-icon matSuffix>search</mat-icon>\r\n        <mat-hint>ORDEN SAP/ENTREGA SALIDA/PEDIDO/ARTICULO/NOMBRE CLIENTE/CONDUCTOR</mat-hint>\r\n        </mat-form-field>\r\n        </form>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m2 l2\"></div>\r\n    <div class=\"col s12 m8 l8\" *ngIf=\"loading\" style=\"text-align: center;\">\r\n            <mat-spinner\r\n            [diameter]=\"100\"\r\n            style=\"margin:0 auto; top:15px;\"\r\n          ></mat-spinner>\r\n    </div>\r\n    <div class=\"col s12 m8 l8\" *ngIf=\"!loading && dataEntregas.length==0\" style=\"text-align: center;\">\r\n        <br>    \r\n        <mat-card>\r\n            <h5 style=\"color: grey; font-weight: bold;\">No hay información para mostrar</h5>\r\n        </mat-card>\r\n    </div>\r\n    <div class=\"col s12 m8 l8\" *ngIf=\"!loading && dataEntregas.length>0\">\r\n        <div class=\"row\">\r\n            <div class=\"col s12 m12 l12\" style=\"text-align: right;\">\r\n                    <button mat-icon-button matTooltip=\"EXPORTAR A EXCEL\" (click)=\"exportarExcel();\" matTooltipPosition=\"above\">\r\n                        <mat-icon svgIcon=\"excel\"></mat-icon>                        \r\n                    </button>\r\n            </div>\r\n        </div>\r\n      <mgl-timeline [alternate]=\"alternate\" side=\"right\">\r\n        <mgl-timeline-entry\r\n          *ngFor=\"let item of dataEntregas | filter: searchForm.get('searchText').value; let i = index\"\r\n          id=\"{{ i }}\"\r\n        >\r\n          <mgl-timeline-entry-header\r\n            (click)=\"onHeaderClick($event, i)\"\r\n            style=\"cursor: pointer; text-align: center;\"\r\n          >\r\n<div style=\"background-color: gray; margin-left: 10px;\">\r\n            <span style=\"font-weight: bold; color: #FFFFFF;\">Numero Documento: </span\r\n            ><span style=\"color: #FFFFFF;\">{{ item.numeroDocumento }}</span>\r\n          </div>\r\n          </mgl-timeline-entry-header>\r\n          <mgl-timeline-entry-content>\r\n            <div class=\"row\">\r\n              <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                <span style=\"font-weight: bold;\">Orden Sap:</span>\r\n                {{ item.NroServicio }}\r\n              </div>\r\n              <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                <span style=\"font-weight: bold;\">Entrega Salida:</span>\r\n                {{ item.EntregaSalida }}\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Pedido:</span>\r\n                    {{ item.Pedido }}\r\n                </div>\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Articulo:</span>\r\n                    {{ item.Articulo }}\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col s12 m12 l12\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Cliente:</span>\r\n                    {{ item.Nombre }}\r\n                </div>                \r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Ciudad:</span>\r\n                    {{ item.Ciudad }}\r\n                </div>\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Telefono:</span>\r\n                    {{ item.Telefono }}\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Tienda:</span>\r\n                    {{ item.Tienda }}\r\n                </div>\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Cantidad:</span>\r\n                    {{ item.Cantidad }}\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Ruta:</span>\r\n                    {{ item.Ruta }}\r\n                </div>\r\n                <div class=\"col s12 m6 l6\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Placa:</span>\r\n                    {{ item.Placa }}\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col s12 m12 l12\" style=\"text-align: left;\">\r\n                    <span style=\"font-weight: bold;\">Conductor:</span>\r\n                    {{ item.NroDocId }} -- {{ item.Conductor }}\r\n                </div>                    \r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col s4 m4 l4\" style=\"text-align: center;\">\r\n                    <span style=\"font-weight: bold;\">DOCUMENTO</span>\r\n              </div>\r\n              <div class=\"col s4 m4 l4\" style=\"text-align: center;\">\r\n                    <span style=\"font-weight: bold;\">FOTO</span>\r\n              </div>\r\n              <div class=\"col s4 m4 l4\" style=\"text-align: center;\">\r\n                    <span style=\"font-weight: bold;\">FIRMA</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col s4 m4 l4\" style=\"text-align: center;\">\r\n                <mat-icon\r\n                  style=\"cursor: pointer;\"\r\n                  *ngIf=\"item.tieneDocumento > 0\"\r\n                  (click)=\"verDocumento(item.ordensap, item.idServicioEnc, 3)\"\r\n                  color=\"accent\"\r\n                  matTooltip=\"DOCUMENTO\"\r\n                  matTooltipPosition=\"above\"\r\n                >\r\n                  description\r\n                </mat-icon>\r\n                <mat-icon\r\n                  *ngIf=\"item.tieneDocumento == 0\"\r\n                  matTooltip=\"SIN DOCUMENTO\"\r\n                  matTooltipPosition=\"above\"\r\n                >\r\n                  not_interested\r\n                </mat-icon>\r\n              </div>\r\n              <div class=\"col s4 m4 l4\" style=\"text-align: center;\">\r\n                <mat-icon\r\n                  style=\"cursor: pointer;\"\r\n                  *ngIf=\"item.tieneFoto > 0\"\r\n                  (click)=\"verDocumento(item.ordensap, item.idServicioEnc, 1)\"\r\n                  color=\"accent\"\r\n                  matTooltip=\"FOTO\"\r\n                  matTooltipPosition=\"above\"\r\n                >\r\n                  photo\r\n                </mat-icon>\r\n                <mat-icon\r\n                  *ngIf=\"item.tieneFoto == 0\"\r\n                  matTooltip=\"SIN FOTO\"\r\n                  matTooltipPosition=\"above\"\r\n                >\r\n                  not_interested\r\n                </mat-icon>\r\n              </div>\r\n              <div class=\"col s4 m4 l4\" style=\"text-align: center;\">\r\n                <mat-icon\r\n                  style=\"cursor: pointer;\"\r\n                  *ngIf=\"item.tieneFirma > 0\"\r\n                  (click)=\"verDocumento(item.ordensap, item.idServicioEnc, 2)\"\r\n                  color=\"accent\"\r\n                  matTooltip=\"FIRMA\"\r\n                  matTooltipPosition=\"above\"\r\n                >\r\n                  fingerprint\r\n                </mat-icon>\r\n                <mat-icon\r\n                  *ngIf=\"item.tieneFirma == 0\"\r\n                  matTooltip=\"SIN FIRMA\"\r\n                  matTooltipPosition=\"above\"\r\n                >\r\n                  not_interested\r\n                </mat-icon>\r\n              </div>\r\n            </div>\r\n          </mgl-timeline-entry-content>\r\n          <mgl-timeline-entry-dot\r\n            (click)=\"onDotClick($event, i)\"\r\n            [style.background-color]=\"item.idTpoNovedad==1 ? '#008000' : (item.idTpoNovedad==2 ? '#ff0000' : null)\"\r\n            class=\"click\"     \r\n          >\r\n          </mgl-timeline-entry-dot>\r\n          <mgl-timeline-entry-side>\r\n            <span >{{item.fechaNovedad | date: \"yyyy-MM-dd hh:mm:ss a\"}}</span>\r\n            <br>\r\n            <span style=\"color: #A0A0A0;\">{{ item.Conductor }}</span>\r\n          </mgl-timeline-entry-side>\r\n        </mgl-timeline-entry>\r\n      </mgl-timeline>\r\n    </div>\r\n    <div class=\"col s12 m2 l2\"></div>\r\n  </div>\r\n</mat-expansion-panel>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas/entregas.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/entregas/entregas.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n  <mat-expansion-panel-header>\r\n    <mat-panel-title>\r\n      <h6 class=\"titulo-solicitud\">Informe De Entregas</h6>\r\n    </mat-panel-title>\r\n  </mat-expansion-panel-header>\r\n\r\n  <div class=\"contenedor-form\">\r\n    <form [formGroup]=\"entregasGroup\" (ngSubmit)=\"busqueda();\" class=\"example-form\">\r\n      <div class=\"row\">\r\n        <div class=\"col s12 m12 l12\">\r\n            <label id=\"example-radio-group-label\">Tipo Consulta</label><br>\r\n            <mat-radio-group\r\n              aria-labelledby=\"example-radio-group-label\"\r\n              class=\"example-radio-group\"\r\n              formControlName=\"tipoConsulta\">\r\n              <mat-radio-button class=\"example-radio-button\" *ngFor=\"let tipoConsulta of tipoConsultaSrv\" [value]=\"tipoConsulta.id\">\r\n                {{tipoConsulta.value}}\r\n              </mat-radio-button>\r\n            </mat-radio-group>\r\n        </div>\r\n      </div><br>\r\n      <div class=\"row\">\r\n        <div class=\"col s12 m6 l2\">\r\n          <span *ngIf=\"loadingAgencias\">\r\n              <mat-spinner\r\n              [diameter]=\"30\"\r\n              style=\"margin:0 auto; top:15px;\"\r\n            ></mat-spinner>\r\n          </span>\r\n          <span *ngIf=\"!loadingAgencias\">\r\n            <mat-form-field>\r\n              <mat-label>AGENCIA</mat-label>\r\n              <mat-select formControlName=\"idAgencia\" (change)=\"cargarUsuariosAgencia();\">\r\n                <mat-option *ngFor=\"let agencia of agencias\" [value]=\"agencia.id\">\r\n                  {{agencia.valor}}\r\n                </mat-option>\r\n              </mat-select>\r\n            </mat-form-field>\r\n          </span>\r\n        </div>\r\n        <div class=\"col s12 m6 l4\">\r\n            <span *ngIf=\"loadingUsuarios\">\r\n                <mat-spinner\r\n                [diameter]=\"30\"\r\n                style=\"margin:0 auto; top:15px;\"\r\n              ></mat-spinner>\r\n            </span>\r\n          <span *ngIf=\"!loadingUsuarios\">\r\n            <mat-form-field class=\"example-full-width\">\r\n                <input matInput placeholder=\"Transportador\" [matAutocomplete]=\"auto\" formControlName=\"usuarioCtrl\">\r\n                <mat-autocomplete #auto=\"matAutocomplete\" [displayWith]=\"displayFn\">\r\n                  <mat-option *ngFor=\"let usuario of filteredUsuarios | async\" [value]=\"usuario\">\r\n                    <span>{{usuario.valor}}</span>\r\n                  </mat-option>\r\n                </mat-autocomplete>\r\n            </mat-form-field>\r\n          </span>\r\n        </div>\r\n        <div class=\"col s12 m6 l2\">\r\n            <mat-form-field>\r\n                <input formControlName=\"fechaInicial\" readonly matInput [matDatepicker]=\"picker\" placeholder=\"Fecha Inicial\">\r\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n                <mat-datepicker #picker></mat-datepicker>\r\n              </mat-form-field>\r\n        </div>\r\n        <div class=\"col s12 m6 l2\">\r\n            <mat-form-field>\r\n                <input formControlName=\"fechaFinal\" readonly matInput [matDatepicker]=\"picker1\" placeholder=\"Fecha Final\">\r\n                <mat-datepicker-toggle matSuffix [for]=\"picker1\"></mat-datepicker-toggle>\r\n                <mat-datepicker #picker1></mat-datepicker>\r\n              </mat-form-field>\r\n        </div>\r\n        <div class=\"col s12 m6 l1\">\r\n            <button mat-raised-button color=\"accent\" type=\"submit\" [disabled]=\"!entregasGroup.valid || loading\">Consultar</button>\r\n        </div>\r\n         <div class=\"col s12 m6 l1\">\r\n            <button mat-raised-button color=\"primary\"  (click)=\"MostrarNuevaEntrega()\">Nuevo Cargue</button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</mat-expansion-panel>\r\n<br>\r\n<mat-expansion-panel expanded=\"true\">\r\n    <mat-expansion-panel-header>\r\n      <mat-panel-title>\r\n        <h6 class=\"titulo-solicitud\">Resultados</h6>\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n\r\n    <div class=\"contenedor-form\" *ngIf=\"loading\">\r\n        <mat-spinner\r\n          [diameter]=\"100\"\r\n          style=\"margin:0 auto; top:15px;\"\r\n        ></mat-spinner>\r\n      </div>\r\n\r\n      <table\r\n\r\n    [hidden]=\"!haveData\"\r\n    datatable\r\n    [dtOptions]=\"dtOptions\"\r\n    [dtTrigger]=\"dtTrigger\"\r\n    class=\"display\"\r\n    style=\"width:100%\"\r\n  >\r\n    <thead>\r\n      <tr>\r\n        <th>Estado Entrega</th>\r\n        <th>Gestion Web</th>\r\n        <th>Sincronizado Operador</th>\r\n        <th>En Ruta Operador</th>\r\n        <th>Numero Documento</th>\r\n        <th>Fecha Cierre</th>\r\n        <th>Fecha Creación</th>\r\n        <th>Fecha Entrega</th>\r\n        <th>Código Entrega Pedido</th>\r\n        <th>Orden SAP</th>\r\n        <th>Entrega Salida</th>\r\n        <th>Cliente</th>\r\n        <th>Teléfono</th>\r\n        <th>Dirección</th>\r\n        <th>Ciudad</th>\r\n        <th>Artículo</th>\r\n        <th>Cantidad</th>\r\n        <th>Tienda</th>\r\n        <th>Ruta</th>\r\n        <th>Cédula</th>\r\n        <th>Placa</th>\r\n        <th>Conductor</th>\r\n        <th>Agencia</th>\r\n        <th>Estado Servicio</th>\r\n        <th>Fecha Servidor</th>\r\n        <th>Documento</th>\r\n        <th>Foto</th>\r\n        <th>Firma</th>\r\n        <th>Evidencia WhatsApp</th>\r\n      </tr>\r\n    </thead>\r\n    <tbody>\r\n      <tr *ngFor=\"let item of dataEntregas\">\r\n        <td style=\"text-align: center;\">\r\n          <mat-icon *ngIf=\"item.idTpoNovedad == '1'\" style=\"color: green;\" [matTooltip]=\"item.TipoNovedad\" matTooltipPosition=\"above\">check_circle</mat-icon>\r\n          <mat-icon *ngIf=\"item.idTpoNovedad == '2'\" style=\"color: red;\" [matTooltip]=\"item.TipoNovedad\" matTooltipPosition=\"above\">error</mat-icon>\r\n          <mat-icon *ngIf=\"item.idTpoNovedad == '3'\" style=\"color: orange;\" [matTooltip]=\"item.TipoNovedad\" matTooltipPosition=\"above\">warning</mat-icon>\r\n          <mat-icon *ngIf=\"item.idTpoNovedad == 'EN RUTA'\" style=\"color: gray;\" [matTooltip]=\"item.TipoNovedad\" matTooltipPosition=\"above\">local_shipping</mat-icon>\r\n        </td>\r\n        <td style=\"text-align: center\">\r\n          <mat-icon\r\n            *ngIf=\"item.idTpoNovedad == 'EN RUTA' && item.enRutaOperador == 0 && item.sincronizado == null\"\r\n            style=\"color: orange;\" \r\n            [matTooltip]=\"'Gestionar Entrega'\"\r\n            matTooltipPosition=\"above\"\r\n            (click)=\"GestionarEntrega(item);\">\r\n            support_agent\r\n          </mat-icon>\r\n          <mat-icon\r\n            *ngIf=\" item.enRutaOperador == null && item.sincronizado == null\"\r\n            style=\"color: green;\" \r\n            [matTooltip]=\"'Gestionar Entrega'\"\r\n            matTooltipPosition=\"above\"\r\n            (click)=\"SincronizarEnRuta(item.idServicioEnc);\">\r\n            flag_circle\r\n          </mat-icon>\r\n        </td>\r\n        <td style=\"text-align: center;\">\r\n          <mat-icon *ngIf=\"item.sincronizado == 0\" (click)=\"verDetalleWS(1, item.idServicioPaquete);\" style=\"color: green; cursor: pointer;\" matTooltip=\"PROCESADO\" matTooltipPosition=\"above\">check_circle</mat-icon>\r\n          <mat-icon *ngIf=\"item.sincronizado > 0\" (click)=\"verDetalleWS(1, item.idServicioPaquete);\" style=\"color: red; cursor: pointer;\" matTooltip=\"ERROR\" matTooltipPosition=\"above\">error</mat-icon>\r\n          <mat-icon *ngIf=\"item.sincronizado == null\" style=\"color: gray;\" matTooltip=\"SIN PROCESAR\" matTooltipPosition=\"above\">error_outline</mat-icon>\r\n        </td>\r\n        <td style=\"text-align: center;\">\r\n          <mat-icon *ngIf=\"item.enRutaOperador == 0\" (click)=\"verDetalleWS(2, item.idServicioPaquete);\" style=\"color: green; cursor: pointer;\" matTooltip=\"INICIO\" matTooltipPosition=\"above\">check_circle</mat-icon>\r\n          <mat-icon *ngIf=\"item.enRutaOperador > 0\" (click)=\"verDetalleWS(2, item.idServicioPaquete);\" style=\"color: red; cursor: pointer;\" matTooltip=\"ERROR\" matTooltipPosition=\"above\">error</mat-icon>\r\n          <mat-icon *ngIf=\"item.enRutaOperador == null\" style=\"color: gray;\" matTooltip=\"SIN INICIO\" matTooltipPosition=\"above\">error_outline</mat-icon>\r\n        </td>\r\n        <td style=\"text-align: center;\">{{ item.numeroDoc }}</td>\r\n        <td>{{ item.fechaNovedad }}</td>\r\n        <td>{{ item.fechaCreacion  | date:'yyyy-MM-dd hh:mm:ss'}}</td>\r\n        <td>{{ item.fechaServicio | date:'yyyy-MM-dd'}}</td>\r\n        <td>{{ item.codigoEntregaPedido }}</td>\r\n        <td>{{ item.ordensap }}</td>\r\n        <td>{{ item.EntregaSalida }}</td>\r\n        <td>{{ item.Cliente }}</td>\r\n        <td>{{ item.Telefono }}</td>\r\n        <td>{{ item.Direccion }}</td>\r\n        <td>{{ item.Ciudad }}</td>\r\n        <td>{{ item.Articulo }}</td>\r\n        <td>{{ item.Cantidad }}</td>\r\n        <td>{{ item.Tienda }}</td>\r\n        <td>{{ item.Ruta }}</td>\r\n        <td>{{ item.NroDocId }}</td>\r\n        <td>{{ item.Placa }}</td>\r\n        <td>{{ item.Conductor }}</td>\r\n        <td>{{ item.Agencia }}</td>\r\n        <td style=\"text-align: center;\">\r\n          <span *ngIf=\"item.estadoServicio == 1\" style=\"color: green;\" >ACTIVO</span>\r\n          <span *ngIf=\"item.estadoServicio == 0\" style=\"color: red;\" >INACTIVO</span>\r\n        </td>\r\n        <td>{{ item.fechaServidor }}</td>\r\n        <td style=\"text-align: center;\">\r\n          <mat-icon style=\"cursor: pointer;\" *ngIf=\"item.tieneDocumento>0\" (click)=\"verDocumento(item.ordensap, item.idServicioEnc, 3);\" color=\"accent\" matTooltip=\"DOCUMENTO\" matTooltipPosition=\"above\">\r\n            description\r\n          </mat-icon>\r\n          <mat-icon *ngIf=\"item.tieneDocumento==0\" matTooltip=\"SIN DOCUMENTO\" matTooltipPosition=\"above\">\r\n            not_interested\r\n          </mat-icon>\r\n        </td>\r\n        <td style=\"text-align: center;\">\r\n          <mat-icon style=\"cursor: pointer;\" *ngIf=\"item.tieneFoto>0\" (click)=\"verDocumento(item.ordensap, item.idServicioEnc, 1);\" color=\"accent\" matTooltip=\"FOTO\" matTooltipPosition=\"above\">\r\n            photo\r\n          </mat-icon>\r\n          <mat-icon *ngIf=\"item.tieneFoto==0\" matTooltip=\"SIN FOTO\" matTooltipPosition=\"above\">\r\n              not_interested\r\n          </mat-icon>\r\n        </td>\r\n        <td style=\"text-align: center;\">\r\n          <mat-icon style=\"cursor: pointer;\" *ngIf=\"item.tieneFirma>0\" (click)=\"verDocumento(item.ordensap, item.idServicioEnc, 2);\" color=\"accent\" matTooltip=\"FIRMA\" matTooltipPosition=\"above\">\r\n            fingerprint\r\n          </mat-icon>\r\n          <mat-icon *ngIf=\"item.tieneFirma==0\" matTooltip=\"SIN FIRMA\" matTooltipPosition=\"above\">\r\n              not_interested\r\n            </mat-icon>\r\n        </td>\r\n        <td style=\"text-align: center;\">\r\n          <mat-icon style=\"cursor: pointer;\" *ngIf=\"item.tieneEvidencia > 0\" (click)=\"verDocumento(item.ordensap, item.idServicioEnc, 4);\" color=\"accent\" matTooltip=\"FIRMA\" matTooltipPosition=\"above\">\r\n            fingerprint\r\n          </mat-icon>\r\n          <mat-icon *ngIf=\"item.tieneFirma==0\" matTooltip=\"SIN FIRMA\" matTooltipPosition=\"above\">\r\n              not_interested\r\n            </mat-icon>\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n\r\n  </mat-expansion-panel>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/gestion-maestras/gestion-maestras.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/gestion-maestras/gestion-maestras.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br>\r\n<form [formGroup]=\"cargueGroup\">\r\n<div class=\"row\">\r\n    <div class=\"col s12 m4 l4\" *ngIf=\"loadingAgencias\">\r\n        <mat-spinner [diameter]=\"40\" style=\"top:15px;\"></mat-spinner>\r\n      </div>\r\n    <div class=\"col s12 m4 l4\" *ngIf=\"!loadingAgencias\">            \r\n            <mat-form-field>\r\n              <mat-label>AGENCIA</mat-label>\r\n              <mat-select formControlName=\"IdAgencia\">\r\n                <mat-option *ngFor=\"let agencia of agencias\" [value]=\"agencia.id\">\r\n                  {{agencia.valor}}\r\n                </mat-option>\r\n              </mat-select>\r\n            </mat-form-field>        \r\n           \r\n            \r\n    </div>\r\n</div>\r\n</form>\r\n<div class=\"center\">\r\n    <br>\r\n  <ngx-file-drop (onFileDrop)=\"dropped($event)\"\r\n  (onFileOver)=\"fileOver($event)\" (onFileLeave)=\"fileLeave($event)\" [showBrowseBtn]=\"true\" browseBtnClassName=\"load-button\" dropZoneClassName=\"caja-load-buttton\">      \r\n  </ngx-file-drop>\r\n  <div class=\"upload-table\">\r\n      <table class=\"table\" *ngIf=\"item.relativePath!=''\">\r\n          <thead>\r\n              <tr>\r\n                  <th >Nombre</th>\r\n              </tr>\r\n          </thead>\r\n          <tbody class=\"upload-name-style\">\r\n              <tr *ngFor=\"let item of files; let i=index\">\r\n                  <td><strong>{{ item.relativePath }}</strong></td>\r\n              </tr>\r\n          </tbody>\r\n      </table>\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"!sinErrores\">\r\n    <div class=\"col s12 m6 l6\">\r\n      <mat-list>\r\n        <h3 mat-subheader>Errores</h3>\r\n        <mat-list-item *ngFor=\"let error of resultadoCargue.errores\">\r\n          <mat-icon mat-list-icon style=\"color:red;\">error</mat-icon>\r\n          <p>Error: {{error.mensaje}}, linea: {{error.linea}}</p>          \r\n        </mat-list-item>        \r\n      </mat-list>\r\n      \r\n    </div>\r\n  </div>\r\n  <br>\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <mat-spinner [diameter]=\"60\" style=\"margin:0 auto; top:15px;\" *ngIf=\"procesandoCargue\"></mat-spinner>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <h4 style=\"color:#009901;\" *ngIf=\"respuestaIntegracion == 'OK'\">\r\n        Carga de información terminada correctamente.\r\n      </h4>\r\n      <h4 style=\"color:#FF0000;\" *ngIf=\"respuestaIntegracion == 'ERROR'\">\r\n        Carga de información con errores por favor revise el log.\r\n      </h4>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <div class=\"row\" *ngIf=\"errorCargue\">\r\n    <div class=\"col s12 m6 l6\">\r\n      <mat-list>\r\n        <h3 mat-subheader *ngIf=\"erroresResultado.length>0\">Errores Cargue</h3>\r\n        <mat-list-item *ngFor=\"let errorCargue of erroresResultado\">\r\n          <mat-icon mat-list-icon style=\"color:#009901;\" *ngIf=\"errorCargue.mensaje=='OK'\">done</mat-icon>\r\n          <mat-icon mat-list-icon style=\"color:#FF0000;\" *ngIf=\"errorCargue.mensaje!='OK'\">error</mat-icon>\r\n          <p>Linea: {{errorCargue.linea}} Mensaje: {{errorCargue.mensaje}}</p>          \r\n        </mat-list-item>        \r\n      </mat-list>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <div class=\"row\" *ngIf=\"item.relativePath!=''\">\r\n    <div class=\"col s12 m12 l12\">\r\n      <button *ngIf=\"!escondeProcesar\" mat-raised-button type=\"button\" color=\"accent\" [disabled]=\"!arcihvoValido || procesandoCargue\" (click)=\"procesarCargue();\">Procesar</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/inicio/inicio.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/inicio/inicio.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<br />\r\n<ng-scrollbar>\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m4 l4\">\r\n      <form [formGroup]=\"agenciaGroup\">\r\n        <mat-form-field>\r\n          <mat-label>AGENCIA</mat-label>\r\n          <mat-select formControlName=\"IdAgencia\" (valueChange)=\"generarGraficas($event)\">\r\n            <mat-option *ngFor=\"let agencia of agencias\" [value]=\"agencia.id\">\r\n              {{ agencia.valor }}\r\n            </mat-option>\r\n          </mat-select>\r\n        </mat-form-field>\r\n      </form>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col s12 m12 l6\">\r\n      <br />\r\n      <div [hidden]=\"mostrarEntregadoresStacked\">\r\n        <mat-card class=\"example-card\">\r\n          <mat-card-content fxLayoutAlign=\"center\">\r\n            <mat-spinner></mat-spinner>\r\n          </mat-card-content>\r\n        </mat-card>\r\n      </div>\r\n      <div [hidden]=\"!mostrarEntregadoresStacked\">\r\n        <mat-card class=\"example-card\">\r\n          <mat-card-header>\r\n            <div mat-card-avatar class=\"example-header-image\"></div>\r\n            <mat-card-title>Entregadores Agencia</mat-card-title>\r\n            <mat-card-subtitle>Gestión De Servicios.</mat-card-subtitle>\r\n          </mat-card-header>\r\n          <!--<ngx-chartjs [data]=\"datapieCategoria\"  type=\"pie\"></ngx-chartjs>-->\r\n          <canvas id=\"entregasStacked\">{{ entregasStacked }}</canvas>\r\n        </mat-card>\r\n      </div>\r\n      <!-- <app-contentbox show=\"true\" titulo=\"Ultimas Atenciones\" componente=\"1\"></app-contentbox>-->\r\n    </div>\r\n    <div class=\"col s12 m12 l6\">\r\n      <br />\r\n      <div [hidden]=\"mostrarAgenciasStacked\">\r\n        <mat-card class=\"example-card\">\r\n          <mat-card-content fxLayoutAlign=\"center\">\r\n            <mat-spinner></mat-spinner>\r\n          </mat-card-content>\r\n        </mat-card>\r\n      </div>\r\n      <div [hidden]=\"!mostrarAgenciasStacked\">\r\n        <mat-card class=\"example-card\">\r\n          <mat-card-header>\r\n            <div mat-card-avatar class=\"example-header-image\"></div>\r\n            <mat-card-title>Servicios Agencia</mat-card-title>\r\n            <mat-card-subtitle>Gestion Servicios Agencia</mat-card-subtitle>\r\n          </mat-card-header>\r\n          <!--<ngx-chartjs [data]=\"data\" type=\"bar\"></ngx-chartjs>-->\r\n          <canvas id=\"agenciasStacked\">{{ agenciasStacked }}</canvas>\r\n        </mat-card>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</ng-scrollbar>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--<form [formGroup]=\"formulario\" class=\"example-form\">\r\n<mat-card class=\"example-card\">\r\n  <mat-card-header>\r\n    <mat-card-title>Login</mat-card-title>\r\n  </mat-card-header>\r\n  <img mat-card-image class=\"card-login\" height=\"252px\" width=\"252px\" src=\"./assets/logo1.png\" alt=\"Photo of a Shiba Inu\">\r\n  <mat-card-content>\r\n\r\n      <table class=\"example-full-width\" cellspacing=\"0\">\r\n        <tr>\r\n          <td>\r\n            <mat-form-field class=\"example-full-width\">\r\n              <input matInput placeholder=\"Username\" formControlName=\"username\" name=\"username\" required>\r\n            </mat-form-field>\r\n          </td>\r\n        </tr>\r\n        <tr>\r\n          <td>\r\n            <mat-form-field class=\"example-full-width\">\r\n              <input matInput placeholder=\"Password\" type=\"password\" formControlName=\"password\" name=\"password\" required>\r\n            </mat-form-field>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    <mat-spinner [diameter]=\"30\" *ngIf=\"iniciandoSesion\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n  </mat-card-content>\r\n  <mat-card-actions class=\"button-login\">\r\n\r\n    <button mat-raised-button (click)=\"onSubmit()\" color=\"primary\">\r\n        <mat-icon>input</mat-icon>\r\n      Login\r\n    </button>\r\n  </mat-card-actions>\r\n</mat-card>\r\n</form>-->\r\n\r\n<div class=\"contenedor\">\r\n  <div class=\"layer\">\r\n    <form [formGroup]=\"formulario\" class=\"example-form\">\r\n      <mat-card class=\"example-card\">\r\n        <div>\r\n            <!--<img mat-card-image class=\"card-login img-logo\" src=\"./assets/logo-letras.png\" alt=\"Photo of a Shiba Inu\">-->\r\n            <img mat-card-image class=\"card-login img-logo\" src=\"./assets/profile.png\" alt=\"Photo of a Shiba Inu\">\r\n        </div>\r\n        <!--<mat-card-header style=\"justify-content:center;\">\r\n          <mat-card-title style=\"font-weight:bolder;\">Ingreso Aplicación</mat-card-title>\r\n        </mat-card-header>-->\r\n\r\n        <mat-card-content>\r\n\r\n          <table class=\"example-full-width\" cellspacing=\"0\">\r\n            <tr>\r\n              <td>\r\n                <mat-form-field class=\"example-full-width\">\r\n                  <input matInput placeholder=\"Usuario\" formControlName=\"username\" name=\"username\" required>\r\n                </mat-form-field>\r\n              </td>\r\n            </tr>\r\n            <tr>\r\n              <td>\r\n                <mat-form-field class=\"example-full-width\">\r\n                  <input matInput placeholder=\"Clave\" type=\"password\" formControlName=\"password\" name=\"password\"\r\n                    required>\r\n                </mat-form-field>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n          <mat-spinner [diameter]=\"30\" *ngIf=\"iniciandoSesion\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n        </mat-card-content>\r\n        <mat-card-actions class=\"button-login\">\r\n\r\n          <button mat-raised-button (click)=\"onSubmit()\" color=\"primary\">\r\n            <mat-icon>input</mat-icon>\r\n            Login\r\n          </button>\r\n        </mat-card-actions>\r\n      </mat-card>\r\n    </form>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modificausuario/modificausuario.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modificausuario/modificausuario.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\r\n  <!--<h2>Gestión De Usuarios</h2>-->\r\n  <div class=\"contenedor-form\" *ngIf=\"items\">\r\n    <app-dynamic-form [items]=\"items\" [descripcion]=\"descripcion\" [parametrosDestino]=\"parametrosDestino\" [procedimientoDestino]=\"procedimientoDestino\"></app-dynamic-form>\r\n  </div>\r\n  <div class=\"contenedor-form\" *ngIf=\"!items\">    \r\n    <mat-spinner [diameter]=\"100\" style=\"margin:0 auto; top:15px;\"></mat-spinner>\r\n  </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/navigation/navigation.component.html":
/*!********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/navigation/navigation.component.html ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-sidenav-container class=\"container-123\">\r\n\r\n  <mat-sidenav #sidenav [(mode)]=\"over\" [(opened)]=\"opened\" class=\"bottom-to-top\">\r\n    <div  fxLayout=\"column\" fxLayoutAlign=\"center center\" fxLayoutGap=\"10px\">\r\n      <!--<div class=\"with-bg\"></div>\r\n      <div>\r\n        <a>\r\n          <img class=\"circle\" src=\"./assets/profile.png\" width=\"100\">\r\n        </a>\r\n      </div>-->\r\n      <img style=\"width: 100%; height: auto !important;\" src=\"./assets/office.png\">\r\n    </div>\r\n    <div   class=\"py-3 text-white fondo-menu-lateral\" fxLayout=\"column\" fxLayoutAlign=\"center center\"\r\n      fxLayoutGap=\"7px\">\r\n      <div style=\"margin-left:10px;\">\r\n        <a >\r\n          <span class=\"lead black-navi\">{{usuario}}</span>\r\n        </a>\r\n      </div>\r\n      <!--<div>\r\n        <a>\r\n          <span class=\"black-navi\">usuario@networking.com</span>\r\n        </a>\r\n      </div>-->\r\n    </div>\r\n\r\n    <div class=\"mt-3\">\r\n\r\n      <mat-accordion multi=\"true\" [displayMode]=\"displayMode\" *ngIf=\"menuOptions.length>0\">\r\n        <span *ngFor=\"let item of menuOptions\" >\r\n          <mat-nav-list *ngIf=\"!item.haschildren\">\r\n            <a mat-list-item (click)=\"thisRoute(item);\" routerLinkActive=\"active-link\" [routerLink]=\"[item.ruta]\" class=\"ml-2\" style=\"font-size:15px;\">\r\n              <i class=\"material-icons\">\r\n                {{item.icono}}\r\n              </i><span class=\"itemClass\">{{item.opcion}}</span>\r\n            </a>\r\n          </mat-nav-list>\r\n          <mat-expansion-panel *ngIf=\"item.haschildren\" class=\"no-shadow\">\r\n              <mat-expansion-panel-header fxLayout=\"row\" [expandedHeight]=\"expandHeight\" [collapsedHeight]=\"collapseHeight\">\r\n                <mat-panel-title>\r\n                  <i class=\"material-icons\">\r\n                      {{item.icono}}\r\n                  </i><span class=\"itemClass\">{{item.opcion}}</span>\r\n                </mat-panel-title>\r\n              </mat-expansion-panel-header>\r\n              <mat-nav-list class=\"ml-0\" dense>\r\n                <mat-list-item *ngFor=\"let subItem of item.children\" (click)=\"thisRoute(item);\" [routerLink]=\"[subItem.ruta]\">\r\n                  <a routerLinkActive=\"active-link\">\r\n                    <i class=\"material-icons\">\r\n                      {{subItem.icono}}\r\n                    </i><span class=\"itemChildClass\">{{subItem.opcion}}</span>\r\n                  </a>\r\n                  <!-- <button mat-icon-button class=\"mr-3\">\r\n                      <mat-icon>info</mat-icon>\r\n                    </button> -->\r\n                </mat-list-item>\r\n              </mat-nav-list>\r\n            </mat-expansion-panel>\r\n        </span>\r\n\r\n      </mat-accordion>\r\n    </div>\r\n  </mat-sidenav>\r\n\r\n  <mat-sidenav-content>\r\n    <mat-toolbar color=\"primary\" class=\"header-box-shadow\">\r\n      <button mat-icon-button (click)=\"sidenav.toggle()\">\r\n        <mat-icon>menu</mat-icon>\r\n      </button>\r\n      <button mat-button>\r\n        <mat-icon class=\"mr-1\">{{opcionActual.icon}}</mat-icon>\r\n        {{opcionActual.opcion}}\r\n      </button>\r\n      <!--<span fxShow.lt-md=\"false\" fxShow.gt-sm=\"true\">\r\n        <button mat-button>\r\n          <mat-icon class=\"mr-1\">link</mat-icon>\r\n          Link</button>\r\n        <button mat-button>\r\n          <mat-icon class=\"mr-1\">link</mat-icon>\r\n          Link</button>\r\n        <button mat-button [matMenuTriggerFor]=\"dropDown\">\r\n          DropDown\r\n          <mat-icon class=\"ml-1\">arrow_drop_down</mat-icon>\r\n        </button>\r\n        <mat-menu #dropDown=\"matMenu\" overlapTrigger=\"false\">\r\n          <button mat-menu-item>\r\n            <mat-icon>dialpad</mat-icon>\r\n            <span>Dropdown Link 1</span>\r\n          </button>\r\n          <button mat-menu-item disabled>\r\n            <mat-icon>voicemail</mat-icon>\r\n            <span>Dropdown Link 2</span>\r\n          </button>\r\n        </mat-menu>\r\n      </span>-->\r\n      <span class=\"spacer\"></span>\r\n      <button mat-button [matMenuTriggerFor]=\"menu\" fxShow.lt-md=\"false\" fxShow.gt-sm=\"true\">\r\n        <mat-icon>account_circle</mat-icon>\r\n        <span class=\"ml-2\">Cuenta</span>\r\n      </button>\r\n      <button mat-icon-button [matMenuTriggerFor]=\"menu\" fxShow.lt-md=\"true\" fxShow.gt-sm=\"false\">\r\n        <mat-icon>account_circle</mat-icon>\r\n      </button>\r\n      <mat-menu #menu=\"matMenu\" overlapTrigger=\"false\">\r\n        <button mat-menu-item>\r\n          <mat-icon>account_circle</mat-icon>\r\n          <span>Mi Cuenta</span>\r\n        </button>\r\n        <button mat-menu-item>\r\n          <mat-icon>settings</mat-icon>\r\n          <span>Ajustes</span>\r\n        </button>\r\n        <!--<button mat-menu-item>\r\n          <mat-icon>money</mat-icon>\r\n          <span>Billing</span>\r\n        </button>-->\r\n      </mat-menu>\r\n      <button mat-icon-button (click)=\"logOut()\">\r\n        <mat-icon class=\"ml-3\" title=\"Logout\">exit_to_app</mat-icon>\r\n      </button>\r\n    </mat-toolbar>\r\n    <router-outlet></router-outlet>\r\n  </mat-sidenav-content>\r\n\r\n</mat-sidenav-container>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/ruta-entregas/ruta-entregas.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/ruta-entregas/ruta-entregas.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<iframe id=\"frame\" src=\"./mapas/#\" width=\"100%\" height=\"800\" frameBorder=\"0\">\r\n  No Compatible con Frames\r\n</iframe>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/creacion-paquete/creacion-paquete.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/creacion-paquete/creacion-paquete.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  creacion-paquete works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/crear-servicio/crear-servicio.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/crear-servicio/crear-servicio.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  crear-servicio works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/modificar-paquete/modificar-paquete.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/modificar-paquete/modificar-paquete.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  modificar-paquete works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/modificar-servicio/modificar-servicio.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/modificar-servicio/modificar-servicio.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  modificar-servicio works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/servicio.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/servicio.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  servicio works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/serviciosasignados/serviciosasignados.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/serviciosasignados/serviciosasignados.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"padding: 10px;\" *ngIf=\"isData\">\r\n  <br />\r\n  <mat-form-field>\r\n    <input\r\n      matInput\r\n      (keyup)=\"applyFilter($event.target.value)\"\r\n      placeholder=\"Filtro\"\r\n    />\r\n  </mat-form-field>\r\n\r\n  <div class=\"mat-elevation-z8\">\r\n    <table mat-table [dataSource]=\"dataSource\" matSort>\r\n      <!-- ID Column -->\r\n      <ng-container matColumnDef=\"NroServicio\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header=\"NroServicio\">\r\n          Numero Servicio\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let row\">{{ row.NroServicio }}</td>\r\n      </ng-container>\r\n\r\n      <!-- Progress Column -->\r\n      <ng-container matColumnDef=\"Prioridad\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header=\"Prioridad\">\r\n          Prioridad\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let row\">{{ row.Prioridad }}</td>\r\n      </ng-container>\r\n\r\n      <!-- Name Column -->\r\n      <ng-container matColumnDef=\"Nombre\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header=\"Nombre\">\r\n          Nombre\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let row\">{{ row.Nombre }}</td>\r\n      </ng-container>\r\n\r\n      <!-- Color Column -->\r\n      <ng-container matColumnDef=\"tipoDireccion\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header=\"tipoDireccion\">\r\n          Tipo Dirección\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let row\">{{ row.tipoDireccion }}</td>\r\n      </ng-container>\r\n\r\n\r\n      <ng-container matColumnDef=\"Telefono\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header=\"Telefono\">\r\n          Teléfono\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let row\">{{ row.Telefono }}</td>\r\n      </ng-container>\r\n\r\n      <ng-container matColumnDef=\"Direccion\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header=\"Direccion\">\r\n            Dirección\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let row\">{{ row.Direccion }}</td>\r\n      </ng-container>\r\n\r\n      <ng-container matColumnDef=\"Municipio\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header=\"Municipio\">\r\n            Municipio\r\n        </th>\r\n        <td mat-cell *matCellDef=\"let row\">{{ row.Municipio }}</td>\r\n      </ng-container>\r\n\r\n      <ng-container matColumnDef=\"Departamento\">\r\n          <th mat-header-cell *matHeaderCellDef mat-sort-header=\"Departamento\">\r\n              Departamento\r\n          </th>\r\n          <td mat-cell *matCellDef=\"let row\">{{ row.Departamento }}</td>\r\n        </ng-container>\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns\"></tr>\r\n    </table>\r\n\r\n    <mat-paginator [pageSizeOptions]=\"[5, 10, 25, 100]\"></mat-paginator>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/tiempos-rutas/tiempos-rutas.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/tiempos-rutas/tiempos-rutas.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  tiempos-rutas works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/ubicacion/ubicacion.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/ubicacion/ubicacion.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  ubicacion works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/usuario/usuario.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/usuario/usuario.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>\r\n  usuario works!\r\n</p>\r\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/administracion-agencia/administracion-agencia.component.css":
/*!*****************************************************************************!*\
  !*** ./src/app/administracion-agencia/administracion-agencia.component.css ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9hZG1pbmlzdHJhY2lvbi1hZ2VuY2lhL2FkbWluaXN0cmFjaW9uLWFnZW5jaWEuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFdBQVc7RUFDYiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tYWdlbmNpYS9hZG1pbmlzdHJhY2lvbi1hZ2VuY2lhLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJtYXQtZm9ybS1maWVsZCB7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/administracion-agencia/administracion-agencia.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/administracion-agencia/administracion-agencia.component.ts ***!
  \****************************************************************************/
/*! exports provided: AdministracionAgenciaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionAgenciaComponent", function() { return AdministracionAgenciaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8__);








 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
let AdministracionAgenciaComponent = class AdministracionAgenciaComponent {
    constructor(formBuilder, servicioAgencias, snackBar, ruta) {
        this.formBuilder = formBuilder;
        this.servicioAgencias = servicioAgencias;
        this.snackBar = snackBar;
        this.ruta = ruta;
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
        this.dtOptions = {
            pagingType: 'full_numbers',
            scrollX: true,
            dom: 'Bfrtip',
            buttons: [
                'colvis',
                {
                    extend: "copyHtml5",
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: "excelHtml5",
                    fileName: "CustomFileName" + ".xlsx",
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ]
        };
        this.agencias = [];
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.isEdit = false;
        this.idDescEdit = '';
        this.agenciaGroup = this.formBuilder.group({
            formDescripcion: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_6__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_6__["Validators"].maxLength(50)]]
        });
        this.loading = true;
        this.servicioAgencias.getAllAgencia(0)
            .subscribe(result => {
            this.agencias = result;
            console.log(this.agencias);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    editar(item) {
        this.idDescEdit = item.id;
        this.agenciaGroup.controls['formDescripcion'].setValue(item.valor);
        this.isEdit = true;
    }
    eliminar(item) {
        const agencia = item.id;
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuario = infoUsuario[0].IdUsuario;
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.fire({
            title: 'Eliminar Agencia?',
            text: 'Esta seguro que desea eliminar esta agencia!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.servicioAgencias.deleteAgencia(agencia, usuario)
                    .subscribe(result => {
                    this.agenciaGroup.reset();
                    this.isEdit = false;
                    this.refrescaBusqueda();
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    cancelarEdit() {
        this.agenciaGroup.controls['formDescripcion'].setValue('');
        this.isEdit = false;
    }
    procesoAgencia() {
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuarioConsulta = infoUsuario[0].IdUsuario;
        const descripcion = this.agenciaGroup.controls['formDescripcion'].value;
        const params = {
            descripcion: descripcion,
            usuario: usuarioConsulta
        };
        if (this.isEdit) { //es por que estoy editando 
            this.servicioAgencias.putAgencia(this.idDescEdit, params)
                .subscribe(result => {
                this.refrescaBusqueda();
                this.agenciaGroup.controls['formDescripcion'].setValue('');
                this.isEdit = false;
                this.snackBar.open('Agencia Actualizada', 'Actualizar Agencia', {
                    duration: 2000
                });
            });
        }
        else //es por que estoy creando 
         {
            this.servicioAgencias.postAgencia(params)
                .subscribe(result => {
                this.agenciaGroup.controls['formDescripcion'].setValue('');
                this.refrescaBusqueda();
                this.snackBar.open('Agencia Creada', 'Crear Agencia', {
                    duration: 2000
                });
            });
        }
    }
    refrescaBusqueda() {
        this.loading = true;
        this.servicioAgencias.getAllAgencia(0)
            .subscribe(result => {
            this.agencias = result;
            console.log(this.agencias);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
};
AdministracionAgenciaComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_6__["FormBuilder"] },
    { type: _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_5__["AgenciaService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_3__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_3__["DataTableDirective"])
], AdministracionAgenciaComponent.prototype, "dtElement", void 0);
AdministracionAgenciaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-agencia',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-agencia.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-agencia/administracion-agencia.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-agencia.component.css */ "./src/app/administracion-agencia/administracion-agencia.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_6__["FormBuilder"],
        _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_5__["AgenciaService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"]])
], AdministracionAgenciaComponent);



/***/ }),

/***/ "./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.css":
/*!*****************************************************************************************************!*\
  !*** ./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.css ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tY2F1c2FsZXMtbm8tZW50cmVnYS9hZG1pbmlzdHJhY2lvbi1jYXVzYWxlcy1uby1lbnRyZWdhLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.ts":
/*!****************************************************************************************************!*\
  !*** ./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.ts ***!
  \****************************************************************************************************/
/*! exports provided: AdministracionCausalesNoEntregaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionCausalesNoEntregaComponent", function() { return AdministracionCausalesNoEntregaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministracionCausalesNoEntregaComponent = class AdministracionCausalesNoEntregaComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministracionCausalesNoEntregaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-causales-no-entrega',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-causales-no-entrega.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-causales-no-entrega.component.css */ "./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AdministracionCausalesNoEntregaComponent);



/***/ }),

/***/ "./src/app/administracion-conductores/administracion-conductores.component.css":
/*!*************************************************************************************!*\
  !*** ./src/app/administracion-conductores/administracion-conductores.component.css ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tY29uZHVjdG9yZXMvYWRtaW5pc3RyYWNpb24tY29uZHVjdG9yZXMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/administracion-conductores/administracion-conductores.component.ts":
/*!************************************************************************************!*\
  !*** ./src/app/administracion-conductores/administracion-conductores.component.ts ***!
  \************************************************************************************/
/*! exports provided: AdministracionConductoresComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionConductoresComponent", function() { return AdministracionConductoresComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministracionConductoresComponent = class AdministracionConductoresComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministracionConductoresComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-conductores',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-conductores.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-conductores/administracion-conductores.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-conductores.component.css */ "./src/app/administracion-conductores/administracion-conductores.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AdministracionConductoresComponent);



/***/ }),

/***/ "./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.css":
/*!***************************************************************************************************!*\
  !*** ./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.css ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tZW1wcmVzYS10cmFuc3BvcnRlL2FkbWluaXN0cmFjaW9uLWVtcHJlc2EtdHJhbnNwb3J0ZS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.ts":
/*!**************************************************************************************************!*\
  !*** ./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.ts ***!
  \**************************************************************************************************/
/*! exports provided: AdministracionEmpresaTransporteComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionEmpresaTransporteComponent", function() { return AdministracionEmpresaTransporteComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministracionEmpresaTransporteComponent = class AdministracionEmpresaTransporteComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministracionEmpresaTransporteComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-empresa-transporte',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-empresa-transporte.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-empresa-transporte.component.css */ "./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AdministracionEmpresaTransporteComponent);



/***/ }),

/***/ "./src/app/administracion-mensajes/administracion-mensajes.component.css":
/*!*******************************************************************************!*\
  !*** ./src/app/administracion-mensajes/administracion-mensajes.component.css ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tbWVuc2FqZXMvYWRtaW5pc3RyYWNpb24tbWVuc2FqZXMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/administracion-mensajes/administracion-mensajes.component.ts":
/*!******************************************************************************!*\
  !*** ./src/app/administracion-mensajes/administracion-mensajes.component.ts ***!
  \******************************************************************************/
/*! exports provided: AdministracionMensajesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionMensajesComponent", function() { return AdministracionMensajesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministracionMensajesComponent = class AdministracionMensajesComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministracionMensajesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-mensajes',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-mensajes.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-mensajes/administracion-mensajes.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-mensajes.component.css */ "./src/app/administracion-mensajes/administracion-mensajes.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AdministracionMensajesComponent);



/***/ }),

/***/ "./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.css":
/*!*************************************************************************************************!*\
  !*** ./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.css ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tbW90aXZvLWRldm9sdWNpb24vYWRtaW5pc3RyYWNpb24tbW90aXZvLWRldm9sdWNpb24uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.ts":
/*!************************************************************************************************!*\
  !*** ./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.ts ***!
  \************************************************************************************************/
/*! exports provided: AdministracionMotivoDevolucionComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionMotivoDevolucionComponent", function() { return AdministracionMotivoDevolucionComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministracionMotivoDevolucionComponent = class AdministracionMotivoDevolucionComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministracionMotivoDevolucionComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-motivo-devolucion',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-motivo-devolucion.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-motivo-devolucion.component.css */ "./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AdministracionMotivoDevolucionComponent);



/***/ }),

/***/ "./src/app/administracion-motivos/administracion-motivos.component.css":
/*!*****************************************************************************!*\
  !*** ./src/app/administracion-motivos/administracion-motivos.component.css ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tbW90aXZvcy9hZG1pbmlzdHJhY2lvbi1tb3Rpdm9zLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/administracion-motivos/administracion-motivos.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/administracion-motivos/administracion-motivos.component.ts ***!
  \****************************************************************************/
/*! exports provided: AdministracionMotivosComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionMotivosComponent", function() { return AdministracionMotivosComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _motivos_motivos_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./motivos/motivos.component */ "./src/app/administracion-motivos/motivos/motivos.component.ts");



//import {TipoMotivoComponent} from './tipo-motivo/tipo-motivo.component';
//import {TipoMotivoClasComponent} from './tipo-motivo-clas/tipo-motivo-clas.component';

let AdministracionMotivosComponent = class AdministracionMotivosComponent {
    constructor(ruta) {
        this.ruta = ruta;
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    tabClick(tab) {
        console.log(tab);
        if (tab.index == 0) {
            this.childMotivo.cargarSelect();
        }
    }
};
AdministracionMotivosComponent.ctorParameters = () => [
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_motivos_motivos_component__WEBPACK_IMPORTED_MODULE_3__["MotivosComponent"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _motivos_motivos_component__WEBPACK_IMPORTED_MODULE_3__["MotivosComponent"])
], AdministracionMotivosComponent.prototype, "childMotivo", void 0);
AdministracionMotivosComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-motivos',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-motivos.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/administracion-motivos.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-motivos.component.css */ "./src/app/administracion-motivos/administracion-motivos.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"]])
], AdministracionMotivosComponent);



/***/ }),

/***/ "./src/app/administracion-motivos/motivos/motivos.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/administracion-motivos/motivos/motivos.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9hZG1pbmlzdHJhY2lvbi1tb3Rpdm9zL21vdGl2b3MvbW90aXZvcy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztFQUNiIiwiZmlsZSI6ImFwcC9hZG1pbmlzdHJhY2lvbi1tb3Rpdm9zL21vdGl2b3MvbW90aXZvcy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsibWF0LWZvcm0tZmllbGQge1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbiAgfVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/administracion-motivos/motivos/motivos.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/administracion-motivos/motivos/motivos.component.ts ***!
  \*********************************************************************/
/*! exports provided: MotivosComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MotivosComponent", function() { return MotivosComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_app_servicios_motivo_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/servicios/motivo.service */ "./src/app/servicios/motivo.service.ts");
/* harmony import */ var src_app_servicios_tipo_motivo_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/servicios/tipo-motivo.service */ "./src/app/servicios/tipo-motivo.service.ts");
/* harmony import */ var src_app_servicios_tipo_motivo_clas_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/servicios/tipo-motivo-clas.service */ "./src/app/servicios/tipo-motivo-clas.service.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI



let MotivosComponent = class MotivosComponent {
    constructor(serviceMotivo, serviceTipoMotivo, serviceTipoMotivoClas, formBuilder, snackBar) {
        this.serviceMotivo = serviceMotivo;
        this.serviceTipoMotivo = serviceTipoMotivo;
        this.serviceTipoMotivoClas = serviceTipoMotivoClas;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.dtOptions = {
            pagingType: 'full_numbers',
            scrollX: true,
            dom: 'Bfrtip',
            buttons: [
                'colvis',
                {
                    extend: "copyHtml5",
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: "excelHtml5",
                    fileName: "CustomFileName" + ".xlsx",
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ]
        };
        this.motivos = [];
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.isEdit = false;
        this.idDescEdit = '';
        this.tiposMotivo = [];
        this.tiposMotivoClas = [];
        this.motivoGroup = this.formBuilder.group({
            formCodigo: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(50)]],
            formDescripcion: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(50)]],
            formTipoMotivo: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            formTipoMotivoClas: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]
        });
        this.cargarSelect();
        this.loading = true;
        this.serviceMotivo.getMotivo(0)
            .subscribe(result => {
            this.motivos = result;
            console.log(this.motivos);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    cargarSelect() {
        this.serviceTipoMotivo.getTipoMotivo(0)
            .subscribe(result => {
            this.tiposMotivo = result;
        });
        this.serviceTipoMotivoClas.getTipoMotivoClas(0)
            .subscribe(result => {
            this.tiposMotivoClas = result;
        });
    }
    ngOnInit() {
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    editar(item) {
        this.idDescEdit = item.id;
        this.motivoGroup.controls['formCodigo'].setValue(item.idExMotivo);
        this.motivoGroup.controls['formDescripcion'].setValue(item.valor);
        this.motivoGroup.controls['formTipoMotivo'].setValue(item.idTpoMotivo);
        this.motivoGroup.controls['formTipoMotivoClas'].setValue(item.idTpoMotivoCla);
        this.isEdit = true;
    }
    eliminar(item) {
        const tipoMotivo = item.id;
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuario = infoUsuario[0].IdUsuario;
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
            title: 'Eliminar Motivo?',
            text: 'Esta seguro que desea eliminar este motivo!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.serviceMotivo.deleteMotivo(tipoMotivo, usuario)
                    .subscribe(result => {
                    this.motivoGroup.reset();
                    this.isEdit = false;
                    this.refrescaBusqueda();
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    cancelarEdit() {
        this.motivoGroup.reset();
        this.isEdit = false;
    }
    procesoMotivo() {
        //console.log(this.timeRunning);
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuarioConsulta = infoUsuario[0].IdUsuario;
        const codigoMotivo = this.motivoGroup.controls['formCodigo'].value;
        const descripcion = this.motivoGroup.controls['formDescripcion'].value;
        const tipoMotivo = this.motivoGroup.controls['formTipoMotivo'].value;
        const tipoMotivoClas = this.motivoGroup.controls['formTipoMotivoClas'].value;
        const params = {
            idExtMotivo: codigoMotivo,
            descripcion: descripcion,
            tipoMotivo: tipoMotivo,
            tipoMotivoCla: tipoMotivoClas,
            usuario: usuarioConsulta
        };
        if (this.isEdit) { //es por que estoy editando 
            this.serviceMotivo.putMotivo(this.idDescEdit, params)
                .subscribe(result => {
                this.refrescaBusqueda();
                this.motivoGroup.reset();
                this.isEdit = false;
                this.snackBar.open('Tipo Motivo Actualizado', 'Actualizar Tipo Motivo', {
                    duration: 2000
                });
            });
        }
        else //es por que estoy creando 
         {
            this.serviceMotivo.postMotivo(params)
                .subscribe(result => {
                this.motivoGroup.reset();
                this.refrescaBusqueda();
                this.snackBar.open('Tipo Motivo Creado', 'Crear Tipo Motivo', {
                    duration: 2000
                });
            });
        }
    }
    refrescaBusqueda() {
        this.loading = true;
        this.serviceMotivo.getMotivo(0)
            .subscribe(result => {
            this.motivos = result;
            //console.log(this.motivos);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
};
MotivosComponent.ctorParameters = () => [
    { type: src_app_servicios_motivo_service__WEBPACK_IMPORTED_MODULE_7__["MotivoService"] },
    { type: src_app_servicios_tipo_motivo_service__WEBPACK_IMPORTED_MODULE_8__["TipoMotivoService"] },
    { type: src_app_servicios_tipo_motivo_clas_service__WEBPACK_IMPORTED_MODULE_9__["TipoMotivoClasService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_2__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_2__["DataTableDirective"])
], MotivosComponent.prototype, "dtElement", void 0);
MotivosComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-motivos',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./motivos.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/motivos/motivos.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./motivos.component.css */ "./src/app/administracion-motivos/motivos/motivos.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_servicios_motivo_service__WEBPACK_IMPORTED_MODULE_7__["MotivoService"],
        src_app_servicios_tipo_motivo_service__WEBPACK_IMPORTED_MODULE_8__["TipoMotivoService"],
        src_app_servicios_tipo_motivo_clas_service__WEBPACK_IMPORTED_MODULE_9__["TipoMotivoClasService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"]])
], MotivosComponent);



/***/ }),

/***/ "./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.css":
/*!****************************************************************************************!*\
  !*** ./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.css ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9hZG1pbmlzdHJhY2lvbi1tb3Rpdm9zL3RpcG8tbW90aXZvLWNsYXMvdGlwby1tb3Rpdm8tY2xhcy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztFQUNiIiwiZmlsZSI6ImFwcC9hZG1pbmlzdHJhY2lvbi1tb3Rpdm9zL3RpcG8tbW90aXZvLWNsYXMvdGlwby1tb3Rpdm8tY2xhcy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsibWF0LWZvcm0tZmllbGQge1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbiAgfVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.ts ***!
  \***************************************************************************************/
/*! exports provided: TipoMotivoClasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TipoMotivoClasComponent", function() { return TipoMotivoClasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_app_servicios_tipo_motivo_clas_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/servicios/tipo-motivo-clas.service */ "./src/app/servicios/tipo-motivo-clas.service.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TipoMotivoClasComponent = class TipoMotivoClasComponent {
    constructor(serviceTipoMotivoClas, formBuilder, snackBar) {
        this.serviceTipoMotivoClas = serviceTipoMotivoClas;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.dtOptions = {
            pagingType: 'full_numbers',
            scrollX: true,
            dom: 'Bfrtip',
            buttons: [
                'colvis',
                {
                    extend: "copyHtml5",
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: "excelHtml5",
                    fileName: "CustomFileName" + ".xlsx",
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ]
        };
        this.tiposMotivoClas = [];
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.isEdit = false;
        this.idDescEdit = '';
        this.tipoMotivoClasGroup = this.formBuilder.group({
            formDescripcion: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(50)]]
        });
        this.loading = true;
        this.serviceTipoMotivoClas.getTipoMotivoClas(0)
            .subscribe(result => {
            this.tiposMotivoClas = result;
            console.log(this.tiposMotivoClas);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    ngOnInit() {
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    editar(item) {
        this.idDescEdit = item.id;
        this.tipoMotivoClasGroup.controls['formDescripcion'].setValue(item.valor);
        this.isEdit = true;
    }
    eliminar(item) {
        const tipoMotivoClas = item.id;
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuario = infoUsuario[0].IdUsuario;
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
            title: 'Eliminar Tipo Motivo Clas?',
            text: 'Esta seguro que desea eliminar este tipo motivo clas!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.serviceTipoMotivoClas.deleteTipoMotivoClas(tipoMotivoClas, usuario)
                    .subscribe(result => {
                    this.tipoMotivoClasGroup.reset();
                    this.isEdit = false;
                    this.refrescaBusqueda();
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    cancelarEdit() {
        this.tipoMotivoClasGroup.controls['formDescripcion'].setValue('');
        this.isEdit = false;
    }
    procesoTipoMotivoClas() {
        console.log(this.timeRunning);
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuarioConsulta = infoUsuario[0].IdUsuario;
        const descripcion = this.tipoMotivoClasGroup.controls['formDescripcion'].value;
        const params = {
            descripcion: descripcion,
            usuario: usuarioConsulta
        };
        if (this.isEdit) { //es por que estoy editando 
            this.serviceTipoMotivoClas.putTipoMotivoClas(this.idDescEdit, params)
                .subscribe(result => {
                this.refrescaBusqueda();
                this.tipoMotivoClasGroup.controls['formDescripcion'].setValue('');
                this.isEdit = false;
                this.snackBar.open('Tipo Motivo Clas Actualizado', 'Actualizar Tipo Motivo Clas', {
                    duration: 2000
                });
            });
        }
        else //es por que estoy creando 
         {
            this.serviceTipoMotivoClas.postTipoMotivoClas(params)
                .subscribe(result => {
                this.tipoMotivoClasGroup.controls['formDescripcion'].setValue('');
                this.refrescaBusqueda();
                this.snackBar.open('Tipo Motivo Clas Creado', 'Crear Tipo Motivo Clas', {
                    duration: 2000
                });
            });
        }
    }
    refrescaBusqueda() {
        this.loading = true;
        this.serviceTipoMotivoClas.getTipoMotivoClas(0)
            .subscribe(result => {
            this.tiposMotivoClas = result;
            console.log(this.tiposMotivoClas);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
};
TipoMotivoClasComponent.ctorParameters = () => [
    { type: src_app_servicios_tipo_motivo_clas_service__WEBPACK_IMPORTED_MODULE_7__["TipoMotivoClasService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_2__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_2__["DataTableDirective"])
], TipoMotivoClasComponent.prototype, "dtElement", void 0);
TipoMotivoClasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-tipo-motivo-clas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./tipo-motivo-clas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./tipo-motivo-clas.component.css */ "./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_servicios_tipo_motivo_clas_service__WEBPACK_IMPORTED_MODULE_7__["TipoMotivoClasService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"]])
], TipoMotivoClasComponent);



/***/ }),

/***/ "./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.css":
/*!******************************************************************************!*\
  !*** ./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.css ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9hZG1pbmlzdHJhY2lvbi1tb3Rpdm9zL3RpcG8tbW90aXZvL3RpcG8tbW90aXZvLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0VBQ2IiLCJmaWxlIjoiYXBwL2FkbWluaXN0cmFjaW9uLW1vdGl2b3MvdGlwby1tb3Rpdm8vdGlwby1tb3Rpdm8uY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIm1hdC1mb3JtLWZpZWxkIHtcclxuICAgIHdpZHRoOiAxMDAlO1xyXG4gIH1cclxuIl19 */");

/***/ }),

/***/ "./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.ts ***!
  \*****************************************************************************/
/*! exports provided: TipoMotivoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TipoMotivoComponent", function() { return TipoMotivoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_app_servicios_tipo_motivo_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/servicios/tipo-motivo.service */ "./src/app/servicios/tipo-motivo.service.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TipoMotivoComponent = class TipoMotivoComponent {
    constructor(serviceTipoMotivo, formBuilder, snackBar) {
        this.serviceTipoMotivo = serviceTipoMotivo;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.dtOptions = {
            pagingType: 'full_numbers',
            scrollX: true,
            dom: 'Bfrtip',
            buttons: [
                'colvis',
                {
                    extend: "copyHtml5",
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: "excelHtml5",
                    fileName: "CustomFileName" + ".xlsx",
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ]
        };
        this.tiposMotivo = [];
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.isEdit = false;
        this.idDescEdit = '';
        this.tipoMotivoGroup = this.formBuilder.group({
            formDescripcion: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(50)]]
        });
        this.loading = true;
        this.serviceTipoMotivo.getTipoMotivo(0)
            .subscribe(result => {
            this.tiposMotivo = result;
            console.log(this.tiposMotivo);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    ngOnInit() {
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    editar(item) {
        this.idDescEdit = item.id;
        this.tipoMotivoGroup.controls['formDescripcion'].setValue(item.valor);
        this.isEdit = true;
    }
    eliminar(item) {
        const tipoMotivo = item.id;
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuario = infoUsuario[0].IdUsuario;
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
            title: 'Eliminar Tipo Motivo?',
            text: 'Esta seguro que desea eliminar este tipo motivo!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.serviceTipoMotivo.deleteTipoMotivo(tipoMotivo, usuario)
                    .subscribe(result => {
                    this.tipoMotivoGroup.reset();
                    this.isEdit = false;
                    this.refrescaBusqueda();
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    cancelarEdit() {
        this.tipoMotivoGroup.controls['formDescripcion'].setValue('');
        this.isEdit = false;
    }
    procesoTipoMotivo() {
        console.log(this.timeRunning);
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuarioConsulta = infoUsuario[0].IdUsuario;
        const descripcion = this.tipoMotivoGroup.controls['formDescripcion'].value;
        const params = {
            descripcion: descripcion,
            usuario: usuarioConsulta
        };
        if (this.isEdit) { //es por que estoy editando 
            this.serviceTipoMotivo.putTipoMotivo(this.idDescEdit, params)
                .subscribe(result => {
                this.refrescaBusqueda();
                this.tipoMotivoGroup.controls['formDescripcion'].setValue('');
                this.isEdit = false;
                this.snackBar.open('Tipo Motivo Actualizado', 'Actualizar Tipo Motivo', {
                    duration: 2000
                });
            });
        }
        else //es por que estoy creando 
         {
            this.serviceTipoMotivo.postTipoMotivo(params)
                .subscribe(result => {
                this.tipoMotivoGroup.controls['formDescripcion'].setValue('');
                this.refrescaBusqueda();
                this.snackBar.open('Tipo Motivo Creado', 'Crear Tipo Motivo', {
                    duration: 2000
                });
            });
        }
    }
    refrescaBusqueda() {
        this.loading = true;
        this.serviceTipoMotivo.getTipoMotivo(0)
            .subscribe(result => {
            this.tiposMotivo = result;
            console.log(this.tiposMotivo);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
};
TipoMotivoComponent.ctorParameters = () => [
    { type: src_app_servicios_tipo_motivo_service__WEBPACK_IMPORTED_MODULE_7__["TipoMotivoService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_2__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_2__["DataTableDirective"])
], TipoMotivoComponent.prototype, "dtElement", void 0);
TipoMotivoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-tipo-motivo',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./tipo-motivo.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./tipo-motivo.component.css */ "./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_servicios_tipo_motivo_service__WEBPACK_IMPORTED_MODULE_7__["TipoMotivoService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"]])
], TipoMotivoComponent);



/***/ }),

/***/ "./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.css":
/*!*********************************************************************************************!*\
  !*** ./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.css ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9hZG1pbmlzdHJhY2lvbi10aXBvcy1ub3ZlZGFkZXMvYWRtaW5pc3RyYWNpb24tdGlwb3Mtbm92ZWRhZGVzLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0VBQ2IiLCJmaWxlIjoiYXBwL2FkbWluaXN0cmFjaW9uLXRpcG9zLW5vdmVkYWRlcy9hZG1pbmlzdHJhY2lvbi10aXBvcy1ub3ZlZGFkZXMuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIm1hdC1mb3JtLWZpZWxkIHtcclxuICAgIHdpZHRoOiAxMDAlO1xyXG4gIH1cclxuIl19 */");

/***/ }),

/***/ "./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.ts":
/*!********************************************************************************************!*\
  !*** ./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.ts ***!
  \********************************************************************************************/
/*! exports provided: AdministracionTiposNovedadesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionTiposNovedadesComponent", function() { return AdministracionTiposNovedadesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _servicios_tipo_novedad_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../servicios/tipo-novedad.service */ "./src/app/servicios/tipo-novedad.service.ts");







 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let AdministracionTiposNovedadesComponent = class AdministracionTiposNovedadesComponent {
    constructor(formBuilder, servicioTipoNovedad, snackBar, ruta) {
        this.formBuilder = formBuilder;
        this.servicioTipoNovedad = servicioTipoNovedad;
        this.snackBar = snackBar;
        this.ruta = ruta;
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
        this.dtOptions = {
            pagingType: 'full_numbers',
            scrollX: true,
            dom: 'Bfrtip',
            buttons: [
                'colvis',
                {
                    extend: "copyHtml5",
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: "excelHtml5",
                    fileName: "CustomFileName" + ".xlsx",
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ]
        };
        this.tipoNovedades = [];
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.isEdit = false;
        this.idDescEdit = '';
        this.tipoNovedadGroup = this.formBuilder.group({
            formDescripcion: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].maxLength(50)]]
        });
        this.loading = true;
        this.servicioTipoNovedad.getTiposNovedades(0)
            .subscribe(result => {
            this.tipoNovedades = result;
            console.log(this.tipoNovedades);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    editar(item) {
        this.idDescEdit = item.id;
        this.tipoNovedadGroup.controls['formDescripcion'].setValue(item.valor);
        this.isEdit = true;
    }
    eliminar(item) {
        const tipoNovedad = item.id;
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuario = infoUsuario[0].IdUsuario;
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default.a.fire({
            title: 'Eliminar Tipo Novedad?',
            text: 'Esta seguro que desea eliminar este tipo novedad!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.servicioTipoNovedad.deleteTipoNovedad(tipoNovedad, usuario)
                    .subscribe(result => {
                    this.tipoNovedadGroup.reset();
                    this.isEdit = false;
                    this.refrescaBusqueda();
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    cancelarEdit() {
        this.tipoNovedadGroup.controls['formDescripcion'].setValue('');
        this.isEdit = false;
    }
    procesoAgencia() {
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const usuarioConsulta = infoUsuario[0].IdUsuario;
        const descripcion = this.tipoNovedadGroup.controls['formDescripcion'].value;
        const params = {
            descripcion: descripcion,
            usuario: usuarioConsulta
        };
        if (this.isEdit) { //es por que estoy editando 
            this.servicioTipoNovedad.putTipoNovedad(this.idDescEdit, params)
                .subscribe(result => {
                this.refrescaBusqueda();
                this.tipoNovedadGroup.controls['formDescripcion'].setValue('');
                this.isEdit = false;
                this.snackBar.open('Tipo Novedad Actualizada', 'Actualizar Tipo Novedad', {
                    duration: 2000
                });
            });
        }
        else //es por que estoy creando 
         {
            this.servicioTipoNovedad.postTipoNovedad(params)
                .subscribe(result => {
                this.tipoNovedadGroup.controls['formDescripcion'].setValue('');
                this.refrescaBusqueda();
                this.snackBar.open('Tipo Novedad Creada', 'Crear Tipo Novedad', {
                    duration: 2000
                });
            });
        }
    }
    refrescaBusqueda() {
        this.loading = true;
        this.servicioTipoNovedad.getTiposNovedades(0)
            .subscribe(result => {
            this.tipoNovedades = result;
            console.log(this.tipoNovedades);
            this.haveData = true;
            this.loading = false;
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
};
AdministracionTiposNovedadesComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"] },
    { type: _servicios_tipo_novedad_service__WEBPACK_IMPORTED_MODULE_8__["TipoNovedadService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_3__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_3__["DataTableDirective"])
], AdministracionTiposNovedadesComponent.prototype, "dtElement", void 0);
AdministracionTiposNovedadesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-tipos-novedades',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-tipos-novedades.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-tipos-novedades.component.css */ "./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"],
        _servicios_tipo_novedad_service__WEBPACK_IMPORTED_MODULE_8__["TipoNovedadService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"]])
], AdministracionTiposNovedadesComponent);



/***/ }),

/***/ "./src/app/administracion-usuario-web/administracion-usuario-web.component.css":
/*!*************************************************************************************!*\
  !*** ./src/app/administracion-usuario-web/administracion-usuario-web.component.css ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYWRtaW5pc3RyYWNpb24tdXN1YXJpby13ZWIvYWRtaW5pc3RyYWNpb24tdXN1YXJpby13ZWIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/administracion-usuario-web/administracion-usuario-web.component.ts":
/*!************************************************************************************!*\
  !*** ./src/app/administracion-usuario-web/administracion-usuario-web.component.ts ***!
  \************************************************************************************/
/*! exports provided: AdministracionUsuarioWebComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdministracionUsuarioWebComponent", function() { return AdministracionUsuarioWebComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AdministracionUsuarioWebComponent = class AdministracionUsuarioWebComponent {
    constructor() { }
    ngOnInit() {
    }
};
AdministracionUsuarioWebComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-administracion-usuario-web',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./administracion-usuario-web.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/administracion-usuario-web/administracion-usuario-web.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./administracion-usuario-web.component.css */ "./src/app/administracion-usuario-web/administracion-usuario-web.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AdministracionUsuarioWebComponent);



/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule, routingComponents */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routingComponents", function() { return routingComponents; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _login_login_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./login/login.component */ "./src/app/login/login.component.ts");
/* harmony import */ var _inicio_inicio_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./inicio/inicio.component */ "./src/app/inicio/inicio.component.ts");
/* harmony import */ var _creacionusuarios_creacionusuarios_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./creacionusuarios/creacionusuarios.component */ "./src/app/creacionusuarios/creacionusuarios.component.ts");
/* harmony import */ var _modificausuario_modificausuario_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modificausuario/modificausuario.component */ "./src/app/modificausuario/modificausuario.component.ts");
/* harmony import */ var _gestion_maestras_gestion_maestras_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./gestion-maestras/gestion-maestras.component */ "./src/app/gestion-maestras/gestion-maestras.component.ts");
/* harmony import */ var _asignacion_servicios_asignacion_servicios_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./asignacion-servicios/asignacion-servicios.component */ "./src/app/asignacion-servicios/asignacion-servicios.component.ts");
/* harmony import */ var _serviciosasignados_serviciosasignados_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./serviciosasignados/serviciosasignados.component */ "./src/app/serviciosasignados/serviciosasignados.component.ts");
/* harmony import */ var _administracion_conductores_administracion_conductores_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./administracion-conductores/administracion-conductores.component */ "./src/app/administracion-conductores/administracion-conductores.component.ts");
/* harmony import */ var _administracion_causales_no_entrega_administracion_causales_no_entrega_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./administracion-causales-no-entrega/administracion-causales-no-entrega.component */ "./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.ts");
/* harmony import */ var _administracion_motivo_devolucion_administracion_motivo_devolucion_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./administracion-motivo-devolucion/administracion-motivo-devolucion.component */ "./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.ts");
/* harmony import */ var _administracion_empresa_transporte_administracion_empresa_transporte_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./administracion-empresa-transporte/administracion-empresa-transporte.component */ "./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.ts");
/* harmony import */ var _administracion_usuario_web_administracion_usuario_web_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./administracion-usuario-web/administracion-usuario-web.component */ "./src/app/administracion-usuario-web/administracion-usuario-web.component.ts");
/* harmony import */ var _administracion_mensajes_administracion_mensajes_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./administracion-mensajes/administracion-mensajes.component */ "./src/app/administracion-mensajes/administracion-mensajes.component.ts");
/* harmony import */ var _administracion_agencia_administracion_agencia_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./administracion-agencia/administracion-agencia.component */ "./src/app/administracion-agencia/administracion-agencia.component.ts");
/* harmony import */ var _administracion_tipos_novedades_administracion_tipos_novedades_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./administracion-tipos-novedades/administracion-tipos-novedades.component */ "./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.ts");
/* harmony import */ var _administracion_motivos_administracion_motivos_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./administracion-motivos/administracion-motivos.component */ "./src/app/administracion-motivos/administracion-motivos.component.ts");
/* harmony import */ var _asignacion_transportador_agencia_asignacion_transportador_agencia_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./asignacion-transportador-agencia/asignacion-transportador-agencia.component */ "./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.ts");
/* harmony import */ var _asignacion_transportador_vehiculo_asignacion_transportador_vehiculo_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component */ "./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.ts");
/* harmony import */ var _entregas_transportador_entregas_transportador_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./entregas-transportador/entregas-transportador.component */ "./src/app/entregas-transportador/entregas-transportador.component.ts");
/* harmony import */ var _cargues_usuario_cargues_usuario_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./cargues-usuario/cargues-usuario.component */ "./src/app/cargues-usuario/cargues-usuario.component.ts");
/* harmony import */ var _entregas_completas_entregas_completas_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./entregas-completas/entregas-completas.component */ "./src/app/entregas-completas/entregas-completas.component.ts");
/* harmony import */ var _entregas_parciales_entregas_parciales_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./entregas-parciales/entregas-parciales.component */ "./src/app/entregas-parciales/entregas-parciales.component.ts");
/* harmony import */ var _entregas_entregas_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./entregas/entregas.component */ "./src/app/entregas/entregas.component.ts");
/* harmony import */ var _tiempos_rutas_tiempos_rutas_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./tiempos-rutas/tiempos-rutas.component */ "./src/app/tiempos-rutas/tiempos-rutas.component.ts");
/* harmony import */ var _ruta_entregas_ruta_entregas_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./ruta-entregas/ruta-entregas.component */ "./src/app/ruta-entregas/ruta-entregas.component.ts");
/* harmony import */ var _ubicacion_ubicacion_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./ubicacion/ubicacion.component */ "./src/app/ubicacion/ubicacion.component.ts");





























const routes = [
    { path: 'login', component: _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"], data: { title: 'Login' } },
    { path: 'inicio', component: _inicio_inicio_component__WEBPACK_IMPORTED_MODULE_4__["InicioComponent"], data: { title: 'Nuevo' } },
    {
        path: 'creacionusuarios',
        component: _creacionusuarios_creacionusuarios_component__WEBPACK_IMPORTED_MODULE_5__["CreacionusuariosComponent"],
        data: { title: 'Nuevo' }
    },
    {
        path: 'modificausuario',
        component: _modificausuario_modificausuario_component__WEBPACK_IMPORTED_MODULE_6__["ModificausuarioComponent"],
        data: { title: 'Nuevo' }
    },
    {
        path: 'gestionmaestras',
        component: _gestion_maestras_gestion_maestras_component__WEBPACK_IMPORTED_MODULE_7__["GestionMaestrasComponent"],
        data: { title: 'Nuevo' }
    },
    {
        path: 'asignacionservicios',
        component: _asignacion_servicios_asignacion_servicios_component__WEBPACK_IMPORTED_MODULE_8__["AsignacionServiciosComponent"],
        data: { title: 'Nuevo' }
    },
    {
        path: 'serviciosasignados',
        component: _serviciosasignados_serviciosasignados_component__WEBPACK_IMPORTED_MODULE_9__["ServiciosasignadosComponent"],
        data: { title: 'Servicios Asignados' }
    },
    {
        path: 'administracionconductores',
        component: _administracion_conductores_administracion_conductores_component__WEBPACK_IMPORTED_MODULE_10__["AdministracionConductoresComponent"],
        data: { title: 'Administracion Conductores' }
    },
    {
        path: 'administracioncausalesnoentrega',
        component: _administracion_causales_no_entrega_administracion_causales_no_entrega_component__WEBPACK_IMPORTED_MODULE_11__["AdministracionCausalesNoEntregaComponent"],
        data: { title: 'Administracion Causales No Entrega' }
    },
    {
        path: 'administracionmotivodevolucion',
        component: _administracion_motivo_devolucion_administracion_motivo_devolucion_component__WEBPACK_IMPORTED_MODULE_12__["AdministracionMotivoDevolucionComponent"],
        data: { title: 'Administracion Motivos Devolucion' }
    },
    {
        path: 'administracionempresatransporte',
        component: _administracion_empresa_transporte_administracion_empresa_transporte_component__WEBPACK_IMPORTED_MODULE_13__["AdministracionEmpresaTransporteComponent"],
        data: { title: 'Administracion Empresas Transporte' }
    },
    {
        path: 'administracionusuariosweb',
        component: _administracion_usuario_web_administracion_usuario_web_component__WEBPACK_IMPORTED_MODULE_14__["AdministracionUsuarioWebComponent"],
        data: { title: 'Administracion Usuarios Web' }
    },
    {
        path: 'administracionmensajes',
        component: _administracion_mensajes_administracion_mensajes_component__WEBPACK_IMPORTED_MODULE_15__["AdministracionMensajesComponent"],
        data: { title: 'Administracion Mensajes' }
    },
    {
        path: 'administracionagencia',
        component: _administracion_agencia_administracion_agencia_component__WEBPACK_IMPORTED_MODULE_16__["AdministracionAgenciaComponent"],
        data: { title: 'Administracion Mensajes' }
    },
    {
        path: 'asignaciontransportadoragencia',
        component: _asignacion_transportador_agencia_asignacion_transportador_agencia_component__WEBPACK_IMPORTED_MODULE_19__["AsignacionTransportadorAgenciaComponent"],
        data: { title: 'Administracion Mensajes' }
    },
    {
        path: 'asignaciontransportadorvehiculo',
        component: _asignacion_transportador_vehiculo_asignacion_transportador_vehiculo_component__WEBPACK_IMPORTED_MODULE_20__["AsignacionTransportadorVehiculoComponent"],
        data: { title: 'Administracion Mensajes' }
    },
    {
        path: 'administraciontiposnovedades',
        component: _administracion_tipos_novedades_administracion_tipos_novedades_component__WEBPACK_IMPORTED_MODULE_17__["AdministracionTiposNovedadesComponent"],
        data: { title: 'Administracion Tipos Novedades' }
    },
    {
        path: 'administracionmotivos',
        component: _administracion_motivos_administracion_motivos_component__WEBPACK_IMPORTED_MODULE_18__["AdministracionMotivosComponent"],
        data: { title: 'Administracion Motivos' }
    },
    {
        path: 'entregascompletas',
        component: _entregas_completas_entregas_completas_component__WEBPACK_IMPORTED_MODULE_23__["EntregasCompletasComponent"],
        data: { title: 'Entregas Completas' }
    },
    {
        path: 'entregasparciales',
        component: _entregas_parciales_entregas_parciales_component__WEBPACK_IMPORTED_MODULE_24__["EntregasParcialesComponent"],
        data: { title: 'Entregas Parciales' }
    },
    {
        path: 'entregas',
        component: _entregas_entregas_component__WEBPACK_IMPORTED_MODULE_25__["EntregasComponent"],
        data: { title: 'Entregas' }
    },
    {
        path: 'entregastransportador',
        component: _entregas_transportador_entregas_transportador_component__WEBPACK_IMPORTED_MODULE_21__["EntregasTransportadorComponent"],
        data: { title: 'Entregas Transportador' }
    },
    {
        path: 'carguexusuario',
        component: _cargues_usuario_cargues_usuario_component__WEBPACK_IMPORTED_MODULE_22__["CarguesUsuarioComponent"],
        data: { title: 'Cargues por usuario' }
    },
    {
        path: 'tiemporutas',
        component: _tiempos_rutas_tiempos_rutas_component__WEBPACK_IMPORTED_MODULE_26__["TiemposRutasComponent"],
        data: { title: 'Tiempo Rutas' }
    },
    {
        path: 'rutaentregas',
        component: _ruta_entregas_ruta_entregas_component__WEBPACK_IMPORTED_MODULE_27__["RutaEntregasComponent"],
        data: { title: 'Ruta Entregas' }
    },
    {
        path: 'ubicacion',
        component: _ubicacion_ubicacion_component__WEBPACK_IMPORTED_MODULE_28__["UbicacionComponent"],
        data: { title: 'Ubicacion' }
    }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, { useHash: true })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);

const routingComponents = [
    _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"],
    _inicio_inicio_component__WEBPACK_IMPORTED_MODULE_4__["InicioComponent"],
    _creacionusuarios_creacionusuarios_component__WEBPACK_IMPORTED_MODULE_5__["CreacionusuariosComponent"],
    _modificausuario_modificausuario_component__WEBPACK_IMPORTED_MODULE_6__["ModificausuarioComponent"],
    _gestion_maestras_gestion_maestras_component__WEBPACK_IMPORTED_MODULE_7__["GestionMaestrasComponent"],
    _asignacion_servicios_asignacion_servicios_component__WEBPACK_IMPORTED_MODULE_8__["AsignacionServiciosComponent"],
    _administracion_conductores_administracion_conductores_component__WEBPACK_IMPORTED_MODULE_10__["AdministracionConductoresComponent"],
    _administracion_causales_no_entrega_administracion_causales_no_entrega_component__WEBPACK_IMPORTED_MODULE_11__["AdministracionCausalesNoEntregaComponent"],
    _administracion_motivo_devolucion_administracion_motivo_devolucion_component__WEBPACK_IMPORTED_MODULE_12__["AdministracionMotivoDevolucionComponent"],
    _administracion_empresa_transporte_administracion_empresa_transporte_component__WEBPACK_IMPORTED_MODULE_13__["AdministracionEmpresaTransporteComponent"],
    _administracion_usuario_web_administracion_usuario_web_component__WEBPACK_IMPORTED_MODULE_14__["AdministracionUsuarioWebComponent"],
    _administracion_mensajes_administracion_mensajes_component__WEBPACK_IMPORTED_MODULE_15__["AdministracionMensajesComponent"],
    _administracion_agencia_administracion_agencia_component__WEBPACK_IMPORTED_MODULE_16__["AdministracionAgenciaComponent"],
    _asignacion_transportador_agencia_asignacion_transportador_agencia_component__WEBPACK_IMPORTED_MODULE_19__["AsignacionTransportadorAgenciaComponent"],
    _asignacion_transportador_vehiculo_asignacion_transportador_vehiculo_component__WEBPACK_IMPORTED_MODULE_20__["AsignacionTransportadorVehiculoComponent"],
    _entregas_completas_entregas_completas_component__WEBPACK_IMPORTED_MODULE_23__["EntregasCompletasComponent"],
    _entregas_parciales_entregas_parciales_component__WEBPACK_IMPORTED_MODULE_24__["EntregasParcialesComponent"],
    _entregas_entregas_component__WEBPACK_IMPORTED_MODULE_25__["EntregasComponent"],
    _tiempos_rutas_tiempos_rutas_component__WEBPACK_IMPORTED_MODULE_26__["TiemposRutasComponent"],
    _ruta_entregas_ruta_entregas_component__WEBPACK_IMPORTED_MODULE_27__["RutaEntregasComponent"],
    _ubicacion_ubicacion_component__WEBPACK_IMPORTED_MODULE_28__["UbicacionComponent"]
];


/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYXBwLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./servicios/login-service.service */ "./src/app/servicios/login-service.service.ts");
/* harmony import */ var _servicios_signal_r_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./servicios/signal-r.service */ "./src/app/servicios/signal-r.service.ts");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");







let AppComponent = class AppComponent {
    constructor(loginService, router, signalRService, matIconRegistry, domSanitizer) {
        this.loginService = loginService;
        this.router = router;
        this.signalRService = signalRService;
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.title = 'ALLY';
        this.login = false;
        if (sessionStorage.getItem('isLoggedIn')) {
            this.login = true;
        }
        this.matIconRegistry.addSvgIcon("excel", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/excel.svg"));
        this.matIconRegistry.addSvgIcon("csv", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/csv.svg"));
    }
    ngOnInit() {
        // alert(this.loginService.getUserLoggedIn());
        if (this.loginService.getUserLoggedIn() == '1') {
            //alert("verdadero");
            //this.signalRService.startConnection();
            //this.signalRService.sinalRListener();
            this.login = true;
            let ruta = sessionStorage.getItem('ruta');
            if (ruta) {
                this.router.navigate([ruta]);
            }
            else {
                this.router.navigate(['inicio']);
            }
            //alert(this.login);
        }
        else {
            this.login = false;
            this.router.navigate(['login']);
            //alert("this.login "+this.login);
            //alert("falso");
        }
        //alert(this.login);
    }
};
AppComponent.ctorParameters = () => [
    { type: _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__["LoginService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _servicios_signal_r_service__WEBPACK_IMPORTED_MODULE_4__["SignalRService"] },
    { type: _angular_material_icon__WEBPACK_IMPORTED_MODULE_5__["MatIconRegistry"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__["DomSanitizer"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__["LoginService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _servicios_signal_r_service__WEBPACK_IMPORTED_MODULE_4__["SignalRService"],
        _angular_material_icon__WEBPACK_IMPORTED_MODULE_5__["MatIconRegistry"],
        _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__["DomSanitizer"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _core_material_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./core/material.module */ "./src/app/core/material.module.ts");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var ngx_file_drop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ngx-file-drop */ "./node_modules/ngx-file-drop/fesm2015/ngx-file-drop.js");
/* harmony import */ var _navigation_navigation_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./navigation/navigation.component */ "./src/app/navigation/navigation.component.ts");
/* harmony import */ var _toverux_ngx_sweetalert2__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @toverux/ngx-sweetalert2 */ "./node_modules/@toverux/ngx-sweetalert2/esm2015/toverux-ngx-sweetalert2.js");
/* harmony import */ var ngx_scrollbar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ngx-scrollbar */ "./node_modules/ngx-scrollbar/fesm2015/ngx-scrollbar.js");
/* harmony import */ var _http_auth_interceptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./http-auth-interceptor */ "./src/app/http-auth-interceptor.ts");
/* harmony import */ var _servicios_auth_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./servicios/auth.service */ "./src/app/servicios/auth.service.ts");
/* harmony import */ var _dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./dynamic-form/dynamic-form.component */ "./src/app/dynamic-form/dynamic-form.component.ts");
/* harmony import */ var _dynamic_form_contenido_dynamic_form_contenido_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./dynamic-form-contenido/dynamic-form-contenido.component */ "./src/app/dynamic-form-contenido/dynamic-form-contenido.component.ts");
/* harmony import */ var _creacionusuarios_creacionusuarios_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./creacionusuarios/creacionusuarios.component */ "./src/app/creacionusuarios/creacionusuarios.component.ts");
/* harmony import */ var _creacionusuarios_crear_persona_crear_persona_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./creacionusuarios/crear-persona/crear-persona.component */ "./src/app/creacionusuarios/crear-persona/crear-persona.component.ts");
/* harmony import */ var _creacionusuarios_crear_usuario_crear_usuario_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./creacionusuarios/crear-usuario/crear-usuario.component */ "./src/app/creacionusuarios/crear-usuario/crear-usuario.component.ts");
/* harmony import */ var _creacionusuarios_consultar_persona_consultar_persona_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./creacionusuarios/consultar-persona/consultar-persona.component */ "./src/app/creacionusuarios/consultar-persona/consultar-persona.component.ts");
/* harmony import */ var _creacionusuarios_consulta_persona_consulta_persona_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./creacionusuarios/consulta-persona/consulta-persona.component */ "./src/app/creacionusuarios/consulta-persona/consulta-persona.component.ts");
/* harmony import */ var _creacionusuarios_creacionpersona_creacionpersona_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./creacionusuarios/creacionpersona/creacionpersona.component */ "./src/app/creacionusuarios/creacionpersona/creacionpersona.component.ts");
/* harmony import */ var _creacionusuarios_creacionusuario_creacionusuario_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./creacionusuarios/creacionusuario/creacionusuario.component */ "./src/app/creacionusuarios/creacionusuario/creacionusuario.component.ts");
/* harmony import */ var _creacionusuarios_reporte_personas_reporte_personas_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./creacionusuarios/reporte-personas/reporte-personas.component */ "./src/app/creacionusuarios/reporte-personas/reporte-personas.component.ts");
/* harmony import */ var _usuario_usuario_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./usuario/usuario.component */ "./src/app/usuario/usuario.component.ts");
/* harmony import */ var _utils_myfilterpipe__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./utils/myfilterpipe */ "./src/app/utils/myfilterpipe.ts");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _modificausuario_modificausuario_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./modificausuario/modificausuario.component */ "./src/app/modificausuario/modificausuario.component.ts");
/* harmony import */ var _dynamic_report_dynamic_report_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./dynamic-report/dynamic-report.component */ "./src/app/dynamic-report/dynamic-report.component.ts");
/* harmony import */ var _dynamic_report_contenido_dynamic_report_contenido_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./dynamic-report-contenido/dynamic-report-contenido.component */ "./src/app/dynamic-report-contenido/dynamic-report-contenido.component.ts");
/* harmony import */ var _gestion_maestras_gestion_maestras_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./gestion-maestras/gestion-maestras.component */ "./src/app/gestion-maestras/gestion-maestras.component.ts");
/* harmony import */ var _asignacion_servicios_asignacion_servicios_component__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./asignacion-servicios/asignacion-servicios.component */ "./src/app/asignacion-servicios/asignacion-servicios.component.ts");
/* harmony import */ var _serviciosasignados_serviciosasignados_component__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./serviciosasignados/serviciosasignados.component */ "./src/app/serviciosasignados/serviciosasignados.component.ts");
/* harmony import */ var _administracion_conductores_administracion_conductores_component__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./administracion-conductores/administracion-conductores.component */ "./src/app/administracion-conductores/administracion-conductores.component.ts");
/* harmony import */ var _administracion_causales_no_entrega_administracion_causales_no_entrega_component__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./administracion-causales-no-entrega/administracion-causales-no-entrega.component */ "./src/app/administracion-causales-no-entrega/administracion-causales-no-entrega.component.ts");
/* harmony import */ var _administracion_motivo_devolucion_administracion_motivo_devolucion_component__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./administracion-motivo-devolucion/administracion-motivo-devolucion.component */ "./src/app/administracion-motivo-devolucion/administracion-motivo-devolucion.component.ts");
/* harmony import */ var _administracion_empresa_transporte_administracion_empresa_transporte_component__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./administracion-empresa-transporte/administracion-empresa-transporte.component */ "./src/app/administracion-empresa-transporte/administracion-empresa-transporte.component.ts");
/* harmony import */ var _administracion_usuario_web_administracion_usuario_web_component__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./administracion-usuario-web/administracion-usuario-web.component */ "./src/app/administracion-usuario-web/administracion-usuario-web.component.ts");
/* harmony import */ var _administracion_mensajes_administracion_mensajes_component__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./administracion-mensajes/administracion-mensajes.component */ "./src/app/administracion-mensajes/administracion-mensajes.component.ts");
/* harmony import */ var _entregas_completas_entregas_completas_component__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./entregas-completas/entregas-completas.component */ "./src/app/entregas-completas/entregas-completas.component.ts");
/* harmony import */ var _entregas_parciales_entregas_parciales_component__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./entregas-parciales/entregas-parciales.component */ "./src/app/entregas-parciales/entregas-parciales.component.ts");
/* harmony import */ var _entregas_entregas_component__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./entregas/entregas.component */ "./src/app/entregas/entregas.component.ts");
/* harmony import */ var _tiempos_rutas_tiempos_rutas_component__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./tiempos-rutas/tiempos-rutas.component */ "./src/app/tiempos-rutas/tiempos-rutas.component.ts");
/* harmony import */ var _ruta_entregas_ruta_entregas_component__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./ruta-entregas/ruta-entregas.component */ "./src/app/ruta-entregas/ruta-entregas.component.ts");
/* harmony import */ var _ubicacion_ubicacion_component__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./ubicacion/ubicacion.component */ "./src/app/ubicacion/ubicacion.component.ts");
/* harmony import */ var _dialogs_dialog_edit_persona_dialog_edit_persona_component__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./dialogs/dialog-edit-persona/dialog-edit-persona.component */ "./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.ts");
/* harmony import */ var _creacionusuarios_modificar_direccion_persona_modificar_direccion_persona_component__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component */ "./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.ts");
/* harmony import */ var _creacionusuarios_modificar_usuario_persona_modificar_usuario_persona_component__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component */ "./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.ts");
/* harmony import */ var _dialogs_dialog_copiar_encuesta_dialog_copiar_encuesta_component__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component */ "./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.ts");
/* harmony import */ var _servicio_servicio_component__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./servicio/servicio.component */ "./src/app/servicio/servicio.component.ts");
/* harmony import */ var _servicio_crear_servicio_crear_servicio_component__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./servicio/crear-servicio/crear-servicio.component */ "./src/app/servicio/crear-servicio/crear-servicio.component.ts");
/* harmony import */ var _servicio_modificar_servicio_modificar_servicio_component__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./servicio/modificar-servicio/modificar-servicio.component */ "./src/app/servicio/modificar-servicio/modificar-servicio.component.ts");
/* harmony import */ var _servicio_creacion_paquete_creacion_paquete_component__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./servicio/creacion-paquete/creacion-paquete.component */ "./src/app/servicio/creacion-paquete/creacion-paquete.component.ts");
/* harmony import */ var _servicio_modificar_paquete_modificar_paquete_component__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./servicio/modificar-paquete/modificar-paquete.component */ "./src/app/servicio/modificar-paquete/modificar-paquete.component.ts");
/* harmony import */ var _dialogs_dialog_documento_dialog_documento_component__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./dialogs/dialog-documento/dialog-documento.component */ "./src/app/dialogs/dialog-documento/dialog-documento.component.ts");
/* harmony import */ var _dialogs_dialog_producto_dialog_producto_component__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./dialogs/dialog-producto/dialog-producto.component */ "./src/app/dialogs/dialog-producto/dialog-producto.component.ts");
/* harmony import */ var _dialogs_dialog_firma_dialog_firma_component__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./dialogs/dialog-firma/dialog-firma.component */ "./src/app/dialogs/dialog-firma/dialog-firma.component.ts");
/* harmony import */ var _dialogs_dialog_web_service_dialog_web_service_component__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./dialogs/dialog-web-service/dialog-web-service.component */ "./src/app/dialogs/dialog-web-service/dialog-web-service.component.ts");
/* harmony import */ var angular_vertical_timeline__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! angular-vertical-timeline */ "./node_modules/angular-vertical-timeline/dist/index.js");
/* harmony import */ var _administracion_agencia_administracion_agencia_component__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./administracion-agencia/administracion-agencia.component */ "./src/app/administracion-agencia/administracion-agencia.component.ts");
/* harmony import */ var _asignacion_transportador_agencia_asignacion_transportador_agencia_component__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./asignacion-transportador-agencia/asignacion-transportador-agencia.component */ "./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.ts");
/* harmony import */ var _asignacion_transportador_vehiculo_asignacion_transportador_vehiculo_component__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component */ "./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.ts");
/* harmony import */ var _administracion_tipos_novedades_administracion_tipos_novedades_component__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./administracion-tipos-novedades/administracion-tipos-novedades.component */ "./src/app/administracion-tipos-novedades/administracion-tipos-novedades.component.ts");
/* harmony import */ var _administracion_motivos_administracion_motivos_component__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./administracion-motivos/administracion-motivos.component */ "./src/app/administracion-motivos/administracion-motivos.component.ts");
/* harmony import */ var _administracion_motivos_motivos_motivos_component__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./administracion-motivos/motivos/motivos.component */ "./src/app/administracion-motivos/motivos/motivos.component.ts");
/* harmony import */ var _administracion_motivos_tipo_motivo_tipo_motivo_component__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./administracion-motivos/tipo-motivo/tipo-motivo.component */ "./src/app/administracion-motivos/tipo-motivo/tipo-motivo.component.ts");
/* harmony import */ var _administracion_motivos_tipo_motivo_clas_tipo_motivo_clas_component__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component */ "./src/app/administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component.ts");
/* harmony import */ var _dialogs_dialog_agencias_dialog_agencias_component__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ./dialogs/dialog-agencias/dialog-agencias.component */ "./src/app/dialogs/dialog-agencias/dialog-agencias.component.ts");
/* harmony import */ var _entregas_transportador_entregas_transportador_component__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ./entregas-transportador/entregas-transportador.component */ "./src/app/entregas-transportador/entregas-transportador.component.ts");
/* harmony import */ var _cargues_usuario_cargues_usuario_component__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ./cargues-usuario/cargues-usuario.component */ "./src/app/cargues-usuario/cargues-usuario.component.ts");
/* harmony import */ var angular_mgl_timeline__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! angular-mgl-timeline */ "./node_modules/angular-mgl-timeline/fesm2015/angular-mgl-timeline.js");
/* harmony import */ var _pipes_filter_pipe__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ./pipes/filter.pipe */ "./src/app/pipes/filter.pipe.ts");
/* harmony import */ var _dialogs_dialogo_gestion_cargue_dialogo_gestion_cargue_component__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ./dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component */ "./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.ts");
/* harmony import */ var _dialogs_dialogo_entrega_nueva_dialogo_entrega_nueva_component__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ./dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component */ "./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.ts");












































































let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"],
            _navigation_navigation_component__WEBPACK_IMPORTED_MODULE_11__["NavigationComponent"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_7__["routingComponents"],
            _dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_16__["DynamicFormComponent"],
            _dynamic_form_contenido_dynamic_form_contenido_component__WEBPACK_IMPORTED_MODULE_17__["DynamicFormContenidoComponent"],
            _creacionusuarios_creacionusuarios_component__WEBPACK_IMPORTED_MODULE_18__["CreacionusuariosComponent"],
            _creacionusuarios_crear_persona_crear_persona_component__WEBPACK_IMPORTED_MODULE_19__["CrearPersonaComponent"],
            _creacionusuarios_crear_usuario_crear_usuario_component__WEBPACK_IMPORTED_MODULE_20__["CrearUsuarioComponent"],
            _creacionusuarios_consultar_persona_consultar_persona_component__WEBPACK_IMPORTED_MODULE_21__["ConsultarPersonaComponent"],
            _creacionusuarios_consulta_persona_consulta_persona_component__WEBPACK_IMPORTED_MODULE_22__["ConsultaPersonaComponent"],
            _creacionusuarios_creacionpersona_creacionpersona_component__WEBPACK_IMPORTED_MODULE_23__["CreacionpersonaComponent"],
            _creacionusuarios_creacionusuario_creacionusuario_component__WEBPACK_IMPORTED_MODULE_24__["CreacionusuarioComponent"],
            _creacionusuarios_reporte_personas_reporte_personas_component__WEBPACK_IMPORTED_MODULE_25__["ReportePersonasComponent"],
            _usuario_usuario_component__WEBPACK_IMPORTED_MODULE_26__["UsuarioComponent"],
            _utils_myfilterpipe__WEBPACK_IMPORTED_MODULE_27__["Myfilterpipe"],
            _modificausuario_modificausuario_component__WEBPACK_IMPORTED_MODULE_29__["ModificausuarioComponent"],
            _dynamic_report_dynamic_report_component__WEBPACK_IMPORTED_MODULE_30__["DynamicReportComponent"],
            _dynamic_report_contenido_dynamic_report_contenido_component__WEBPACK_IMPORTED_MODULE_31__["DynamicReportContenidoComponent"],
            _gestion_maestras_gestion_maestras_component__WEBPACK_IMPORTED_MODULE_32__["GestionMaestrasComponent"],
            _asignacion_servicios_asignacion_servicios_component__WEBPACK_IMPORTED_MODULE_33__["AsignacionServiciosComponent"],
            _serviciosasignados_serviciosasignados_component__WEBPACK_IMPORTED_MODULE_34__["ServiciosasignadosComponent"],
            _administracion_conductores_administracion_conductores_component__WEBPACK_IMPORTED_MODULE_35__["AdministracionConductoresComponent"],
            _administracion_causales_no_entrega_administracion_causales_no_entrega_component__WEBPACK_IMPORTED_MODULE_36__["AdministracionCausalesNoEntregaComponent"],
            _administracion_motivo_devolucion_administracion_motivo_devolucion_component__WEBPACK_IMPORTED_MODULE_37__["AdministracionMotivoDevolucionComponent"],
            _administracion_empresa_transporte_administracion_empresa_transporte_component__WEBPACK_IMPORTED_MODULE_38__["AdministracionEmpresaTransporteComponent"],
            _administracion_usuario_web_administracion_usuario_web_component__WEBPACK_IMPORTED_MODULE_39__["AdministracionUsuarioWebComponent"],
            _administracion_mensajes_administracion_mensajes_component__WEBPACK_IMPORTED_MODULE_40__["AdministracionMensajesComponent"],
            _entregas_completas_entregas_completas_component__WEBPACK_IMPORTED_MODULE_41__["EntregasCompletasComponent"],
            _entregas_parciales_entregas_parciales_component__WEBPACK_IMPORTED_MODULE_42__["EntregasParcialesComponent"],
            _entregas_entregas_component__WEBPACK_IMPORTED_MODULE_43__["EntregasComponent"],
            _tiempos_rutas_tiempos_rutas_component__WEBPACK_IMPORTED_MODULE_44__["TiemposRutasComponent"],
            _ruta_entregas_ruta_entregas_component__WEBPACK_IMPORTED_MODULE_45__["RutaEntregasComponent"],
            _ubicacion_ubicacion_component__WEBPACK_IMPORTED_MODULE_46__["UbicacionComponent"],
            _dialogs_dialog_edit_persona_dialog_edit_persona_component__WEBPACK_IMPORTED_MODULE_47__["DialogEditPersonaComponent"],
            _creacionusuarios_modificar_direccion_persona_modificar_direccion_persona_component__WEBPACK_IMPORTED_MODULE_48__["ModificarDireccionPersonaComponent"],
            _creacionusuarios_modificar_usuario_persona_modificar_usuario_persona_component__WEBPACK_IMPORTED_MODULE_49__["ModificarUsuarioPersonaComponent"],
            _dialogs_dialog_copiar_encuesta_dialog_copiar_encuesta_component__WEBPACK_IMPORTED_MODULE_50__["DialogCopiarEncuestaComponent"],
            _servicio_servicio_component__WEBPACK_IMPORTED_MODULE_51__["ServicioComponent"],
            _servicio_crear_servicio_crear_servicio_component__WEBPACK_IMPORTED_MODULE_52__["CrearServicioComponent"],
            _servicio_modificar_servicio_modificar_servicio_component__WEBPACK_IMPORTED_MODULE_53__["ModificarServicioComponent"],
            _servicio_creacion_paquete_creacion_paquete_component__WEBPACK_IMPORTED_MODULE_54__["CreacionPaqueteComponent"],
            _servicio_modificar_paquete_modificar_paquete_component__WEBPACK_IMPORTED_MODULE_55__["ModificarPaqueteComponent"],
            _dialogs_dialog_documento_dialog_documento_component__WEBPACK_IMPORTED_MODULE_56__["DialogDocumentoComponent"],
            _dialogs_dialog_producto_dialog_producto_component__WEBPACK_IMPORTED_MODULE_57__["DialogProductoComponent"],
            _dialogs_dialog_firma_dialog_firma_component__WEBPACK_IMPORTED_MODULE_58__["DialogFirmaComponent"],
            _dialogs_dialog_web_service_dialog_web_service_component__WEBPACK_IMPORTED_MODULE_59__["DialogWebServiceComponent"],
            _administracion_agencia_administracion_agencia_component__WEBPACK_IMPORTED_MODULE_61__["AdministracionAgenciaComponent"],
            _asignacion_transportador_agencia_asignacion_transportador_agencia_component__WEBPACK_IMPORTED_MODULE_62__["AsignacionTransportadorAgenciaComponent"],
            _asignacion_transportador_vehiculo_asignacion_transportador_vehiculo_component__WEBPACK_IMPORTED_MODULE_63__["AsignacionTransportadorVehiculoComponent"],
            _administracion_tipos_novedades_administracion_tipos_novedades_component__WEBPACK_IMPORTED_MODULE_64__["AdministracionTiposNovedadesComponent"],
            _administracion_motivos_administracion_motivos_component__WEBPACK_IMPORTED_MODULE_65__["AdministracionMotivosComponent"],
            _administracion_motivos_motivos_motivos_component__WEBPACK_IMPORTED_MODULE_66__["MotivosComponent"],
            _administracion_motivos_tipo_motivo_tipo_motivo_component__WEBPACK_IMPORTED_MODULE_67__["TipoMotivoComponent"],
            _administracion_motivos_tipo_motivo_clas_tipo_motivo_clas_component__WEBPACK_IMPORTED_MODULE_68__["TipoMotivoClasComponent"],
            _dialogs_dialog_agencias_dialog_agencias_component__WEBPACK_IMPORTED_MODULE_69__["DialogAgenciasComponent"],
            _entregas_transportador_entregas_transportador_component__WEBPACK_IMPORTED_MODULE_70__["EntregasTransportadorComponent"],
            _cargues_usuario_cargues_usuario_component__WEBPACK_IMPORTED_MODULE_71__["CarguesUsuarioComponent"],
            _pipes_filter_pipe__WEBPACK_IMPORTED_MODULE_73__["FilterPipe"],
            _dialogs_dialogo_gestion_cargue_dialogo_gestion_cargue_component__WEBPACK_IMPORTED_MODULE_74__["DialogoGestionCargueComponent"],
            _dialogs_dialogo_entrega_nueva_dialogo_entrega_nueva_component__WEBPACK_IMPORTED_MODULE_75__["DialogoEntregaNuevaComponent"],
        ],
        entryComponents: [
            _dialogs_dialog_edit_persona_dialog_edit_persona_component__WEBPACK_IMPORTED_MODULE_47__["DialogEditPersonaComponent"],
            _dialogs_dialog_copiar_encuesta_dialog_copiar_encuesta_component__WEBPACK_IMPORTED_MODULE_50__["DialogCopiarEncuestaComponent"],
            _dialogs_dialog_documento_dialog_documento_component__WEBPACK_IMPORTED_MODULE_56__["DialogDocumentoComponent"],
            _dialogs_dialog_web_service_dialog_web_service_component__WEBPACK_IMPORTED_MODULE_59__["DialogWebServiceComponent"],
            _dialogs_dialog_agencias_dialog_agencias_component__WEBPACK_IMPORTED_MODULE_69__["DialogAgenciasComponent"],
            _dialogs_dialogo_gestion_cargue_dialogo_gestion_cargue_component__WEBPACK_IMPORTED_MODULE_74__["DialogoGestionCargueComponent"],
            _dialogs_dialogo_entrega_nueva_dialogo_entrega_nueva_component__WEBPACK_IMPORTED_MODULE_75__["DialogoEntregaNuevaComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_7__["AppRoutingModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormsModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__["BrowserAnimationsModule"],
            _core_material_module__WEBPACK_IMPORTED_MODULE_5__["CustomMaterialModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_1__["ReactiveFormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClientModule"],
            ngx_file_drop__WEBPACK_IMPORTED_MODULE_10__["NgxFileDropModule"],
            angular_datatables__WEBPACK_IMPORTED_MODULE_6__["DataTablesModule"],
            _toverux_ngx_sweetalert2__WEBPACK_IMPORTED_MODULE_12__["SweetAlert2Module"].forRoot({
                buttonsStyling: false,
                customClass: 'modal-content',
                confirmButtonClass: 'btn btn-primary',
                cancelButtonClass: 'btn'
            }),
            ngx_scrollbar__WEBPACK_IMPORTED_MODULE_13__["NgScrollbarModule"],
            angular_vertical_timeline__WEBPACK_IMPORTED_MODULE_60__["VerticalTimelineModule"],
            angular_mgl_timeline__WEBPACK_IMPORTED_MODULE_72__["MglTimelineModule"]
        ],
        providers: [
            _servicios_auth_service__WEBPACK_IMPORTED_MODULE_15__["AuthService"],
            {
                provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HTTP_INTERCEPTORS"],
                useClass: _http_auth_interceptor__WEBPACK_IMPORTED_MODULE_14__["HttpAuthInterceptor"],
                multi: true
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_28__["MAT_DATE_LOCALE"], useValue: 'es-CO' }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/asignacion-servicios/asignacion-servicios.component.css":
/*!*************************************************************************!*\
  !*** ./src/app/asignacion-servicios/asignacion-servicios.component.css ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-full-width {\r\n  width: 100% !important;\r\n}\r\n\r\n.bolder{\r\n  font-weight: bolder;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9hc2lnbmFjaW9uLXNlcnZpY2lvcy9hc2lnbmFjaW9uLXNlcnZpY2lvcy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usc0JBQXNCO0FBQ3hCOztBQUVBO0VBQ0UsbUJBQW1CO0FBQ3JCIiwiZmlsZSI6ImFwcC9hc2lnbmFjaW9uLXNlcnZpY2lvcy9hc2lnbmFjaW9uLXNlcnZpY2lvcy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmV4YW1wbGUtZnVsbC13aWR0aCB7XHJcbiAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcclxufVxyXG5cclxuLmJvbGRlcntcclxuICBmb250LXdlaWdodDogYm9sZGVyO1xyXG59XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/asignacion-servicios/asignacion-servicios.component.ts":
/*!************************************************************************!*\
  !*** ./src/app/asignacion-servicios/asignacion-servicios.component.ts ***!
  \************************************************************************/
/*! exports provided: AsignacionServiciosComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsignacionServiciosComponent", function() { return AsignacionServiciosComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _servicios_transportador_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/transportador.service */ "./src/app/servicios/transportador.service.ts");
/* harmony import */ var _servicios_servicio_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../servicios/servicio.service */ "./src/app/servicios/servicio.service.ts");
/* harmony import */ var _servicios_helper_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../servicios/helper.service */ "./src/app/servicios/helper.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");










let AsignacionServiciosComponent = class AsignacionServiciosComponent {
    constructor(servicioTransportador, sServicio, formBuilder, _helper, ruta, snackBar) {
        this.servicioTransportador = servicioTransportador;
        this.sServicio = sServicio;
        this.formBuilder = formBuilder;
        this._helper = _helper;
        this.ruta = ruta;
        this.snackBar = snackBar;
        this.transportadores = [];
        this.asignados = [];
        this.sinAsignar = [];
        this.transportadorGroup = this.formBuilder.group({
            transportadorCtrl: ['']
        });
        this.filteredTransportadores = this.transportadorGroup
            .get('transportadorCtrl')
            .valueChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["startWith"])(''), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(transportador => transportador
            ? this._filteredTransportadores(transportador)
            : this.transportadores.slice()));
    }
    ngOnInit() {
        this.servicioTransportador.getTransportador().subscribe(data => {
            //alert(JSON.stringify(data));
            this.transportadores = data;
        });
        this.ruta.setRuta();
    }
    _filteredTransportadores(value) {
        let filterValue;
        if (typeof value === 'object') {
            filterValue = value.Valor.toLowerCase();
        }
        else {
            filterValue = value.toLowerCase();
        }
        return this.transportadores.filter(transportador => transportador.Valor.toLowerCase().indexOf(filterValue) === 0);
    }
    buscarServicios(valor) {
        const transportadorSelected = this.transportadorGroup.controls['transportadorCtrl'].value;
        this.actualizarDatos(transportadorSelected);
    }
    displayFn(project) {
        console.log(project);
        return project ? project.Valor : project;
    }
    asignarServicio(servicio) {
        //alert(JSON.stringify(servicio));
        let fecha = new Date(servicio.fechaPrestacion);
        let nfecha = moment__WEBPACK_IMPORTED_MODULE_7__(fecha).format('YYYY-MM-DD HH:mm:ss');
        //return;
        const usuarioAsignado = this.transportadorGroup.controls['transportadorCtrl'].value;
        const infoUsuario = JSON.parse(sessionStorage.infoUsuario);
        const params = {
            IdentificadorPA: 'SVCASG001',
            TokenTrans: 'dfdfdfdf',
            Data: [
                {
                    IdServicioEnc: servicio.idServicio,
                    IdUsuarioAsignado: usuarioAsignado.Id,
                    FechaVisita: nfecha,
                    IdUsuario: infoUsuario[0].IdUsuario,
                    EstadoAsignacion: 1
                }
            ]
        };
        this.sServicio.postAsignarServicio(params).subscribe(data => {
            //alert(JSON.stringify(data));
            if (data[0].Mensaje == 'Transaccion Exitosa') {
                const transportadorSelected = this.transportadorGroup.controls['transportadorCtrl'].value;
                this.actualizarDatos(transportadorSelected);
                this.snackBar.open('Informacion Registrada Exitosamente', 'Asignación Servicios', {
                    duration: 3000
                });
            }
        });
    }
    removerServicio(servicio) {
        //alert(JSON.stringify(servicio));
        const usuarioAsignado = this.transportadorGroup.controls['transportadorCtrl'].value;
        const infoUsuario = JSON.parse(sessionStorage.infoUsuario);
        const params = {
            IdentificadorPA: 'SVCASG003',
            TokenTrans: 'dfdfdfdf',
            Data: [
                {
                    IdServicioAsignacion: servicio.idServicio
                }
            ]
        };
        this.sServicio.postAsignarServicio(params).subscribe(data => {
            if (data[0].Mensaje == 'Transaccion Exitosa') {
                const transportadorSelected = this.transportadorGroup.controls['transportadorCtrl'].value;
                this.actualizarDatos(transportadorSelected);
                this.snackBar.open('Informacion Registrada Exitosamente', 'Asignación Servicios', {
                    duration: 3000
                });
            }
            //alert(JSON.stringify(data));
        });
    }
    actualizarDatos(transportadorSelected) {
        this.asignados = [];
        this.sinAsignar = [];
        this.sServicio
            .getServiciosAsignados(transportadorSelected.Id)
            .subscribe(data => {
            //this.asignados=data;
            let dataInfo;
            const origen = this._helper.where(data, { Descripcion: 'ORIGEN' });
            dataInfo = origen;
            dataInfo.forEach(element => {
                //alert(JSON.stringify(element.NroServicio));
                let item = {
                    idServicio: '',
                    NroServicio: '',
                    DireccionOrigen: '',
                    fechaPrestacion: ''
                };
                item.idServicio = element.idServicioEnc;
                item.NroServicio = element.NroServicio;
                item.DireccionOrigen = element.Direccion;
                item.fechaPrestacion = element.fechaPrestacion;
                this.asignados.push(item);
            });
            this.asignados.forEach((element, index) => {
                const destino = this._helper.where(data, {
                    Descripcion: 'DESTINO',
                    NroServicio: element.NroServicio
                });
                let dataDestino;
                dataDestino = destino;
                this.asignados[index].DireccionDestino = dataDestino[0].Direccion;
            });
            console.log('Asignados' + JSON.stringify(this.asignados));
        });
        this.sServicio.getServiciosDisponibles().subscribe(data => {
            let dataInfo;
            const origen = this._helper.where(data, { Descripcion: 'ORIGEN' });
            dataInfo = origen;
            dataInfo.forEach(element => {
                //alert(JSON.stringify(element.NroServicio));
                let item = {
                    idServicio: '',
                    NroServicio: '',
                    DireccionOrigen: '',
                    fechaPrestacion: ''
                };
                //alert(element.idServicio);
                item.idServicio = element.idServicioEnc;
                item.NroServicio = element.NroServicio;
                item.DireccionOrigen = element.Direccion;
                item.fechaPrestacion = element.fechaPrestacion;
                this.sinAsignar.push(item);
            });
            this.sinAsignar.forEach((element, index) => {
                const destino = this._helper.where(data, {
                    Descripcion: 'DESTINO',
                    NroServicio: element.NroServicio
                });
                let dataDestino;
                dataDestino = destino;
                this.sinAsignar[index].DireccionDestino = dataDestino[0].Direccion;
                //alert(JSON.stringify(this.asignados));
            });
            console.log('No Asignados' + JSON.stringify(this.sinAsignar));
        });
    }
};
AsignacionServiciosComponent.ctorParameters = () => [
    { type: _servicios_transportador_service__WEBPACK_IMPORTED_MODULE_4__["TransportadorService"] },
    { type: _servicios_servicio_service__WEBPACK_IMPORTED_MODULE_5__["ServicioService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _servicios_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_8__["Utils"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_9__["MatSnackBar"] }
];
AsignacionServiciosComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-asignacion-servicios',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./asignacion-servicios.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-servicios/asignacion-servicios.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./asignacion-servicios.component.css */ "./src/app/asignacion-servicios/asignacion-servicios.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_transportador_service__WEBPACK_IMPORTED_MODULE_4__["TransportadorService"],
        _servicios_servicio_service__WEBPACK_IMPORTED_MODULE_5__["ServicioService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _servicios_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_8__["Utils"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_9__["MatSnackBar"]])
], AsignacionServiciosComponent);



/***/ }),

/***/ "./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.css":
/*!*************************************************************************************************!*\
  !*** ./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.css ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvYXNpZ25hY2lvbi10cmFuc3BvcnRhZG9yLWFnZW5jaWEvYXNpZ25hY2lvbi10cmFuc3BvcnRhZG9yLWFnZW5jaWEuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.ts":
/*!************************************************************************************************!*\
  !*** ./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.ts ***!
  \************************************************************************************************/
/*! exports provided: AsignacionTransportadorAgenciaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsignacionTransportadorAgenciaComponent", function() { return AsignacionTransportadorAgenciaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AsignacionTransportadorAgenciaComponent = class AsignacionTransportadorAgenciaComponent {
    constructor() { }
    ngOnInit() {
    }
};
AsignacionTransportadorAgenciaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-asignacion-transportador-agencia',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./asignacion-transportador-agencia.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./asignacion-transportador-agencia.component.css */ "./src/app/asignacion-transportador-agencia/asignacion-transportador-agencia.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AsignacionTransportadorAgenciaComponent);



/***/ }),

/***/ "./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.css":
/*!***************************************************************************************************!*\
  !*** ./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.css ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9hc2lnbmFjaW9uLXRyYW5zcG9ydGFkb3ItdmVoaWN1bG8vYXNpZ25hY2lvbi10cmFuc3BvcnRhZG9yLXZlaGljdWxvLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0VBQ2IiLCJmaWxlIjoiYXBwL2FzaWduYWNpb24tdHJhbnNwb3J0YWRvci12ZWhpY3Vsby9hc2lnbmFjaW9uLXRyYW5zcG9ydGFkb3ItdmVoaWN1bG8uY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIm1hdC1mb3JtLWZpZWxkIHtcclxuICAgIHdpZHRoOiAxMDAlO1xyXG4gIH1cclxuIl19 */");

/***/ }),

/***/ "./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.ts":
/*!**************************************************************************************************!*\
  !*** ./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.ts ***!
  \**************************************************************************************************/
/*! exports provided: AsignacionTransportadorVehiculoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsignacionTransportadorVehiculoComponent", function() { return AsignacionTransportadorVehiculoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _servicios_persona_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var _servicios_vehiculo_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../servicios/vehiculo.service */ "./src/app/servicios/vehiculo.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");








let AsignacionTransportadorVehiculoComponent = class AsignacionTransportadorVehiculoComponent {
    constructor(formBuilder, servicePersona, serviceVehiculo, snackBar, ruta) {
        this.formBuilder = formBuilder;
        this.servicePersona = servicePersona;
        this.serviceVehiculo = serviceVehiculo;
        this.snackBar = snackBar;
        this.ruta = ruta;
        this.loading = false;
        this.dataPersona = [];
        this.dataPersonaVehiculo = [];
        this.tipoPersonaVehiculo = [];
        this.tienePersonaVehiculo = 0;
        this.isSelectedPersona = false;
        this.dataAsignacion = {
            idPersona: '',
            idVehiculo: '',
            idTipoPersonaVehiculo: '',
            idUsuario: ''
        };
        this.displayFn = vehiculo => {
            // now you have access to 'this'   
            //console.log(vehiculo);
            if (vehiculo != '' && vehiculo != null) {
                this.dataAsignacion.idVehiculo = vehiculo.id;
                return vehiculo ? vehiculo.valor : vehiculo;
            }
            else {
                return;
            }
        };
        this.personaGroup = this.formBuilder.group({
            formPersona: [""]
        });
        this.vehiculoGroup = this.formBuilder.group({
            formVehiculo: [""],
            formTipoPersonaVehiculo: [""]
        });
        this.serviceVehiculo.getVehiculos(0).subscribe(result => {
            this.vehiculos = result;
            this.filteredVehiculos = this.vehiculoGroup.get('formVehiculo').valueChanges
                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["startWith"])(''), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(usuario => usuario ? this._filterVehiculos(usuario) : this.vehiculos.slice()));
        });
        this.servicePersona.getTipoPersonaXVehiculo(0)
            .subscribe(result => {
            this.tipoPersonaVehiculo = result;
        });
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    /*displayFn(vehiculo) {
      //console.log(JSON.stringify(vehiculo));
      this.procesoPersonaVehiculo();
      
      return vehiculo ? vehiculo.valor : vehiculo;
    }*/
    _filterVehiculos(value) {
        let filterValue;
        if (typeof value === 'object') {
            filterValue = value.valor.toLowerCase();
        }
        else {
            filterValue = value.toLowerCase();
        }
        //console.log(filterValue);
        //const filterValue = value.valor.toLowerCase();
        return this.vehiculos.filter(vehiculo => vehiculo.valor.toLowerCase().indexOf(filterValue) > -1);
    }
    busqueda(event) {
        const busqueda = event.target.value;
        this.loading = true;
        this.servicePersona.getBusquedaPersonaTipoPerfil(busqueda, 2).subscribe(data => {
            this.isSelectedPersona = false;
            this.dataPersona = data;
            this.loading = false;
        });
    }
    detallePersona(persona) {
        this.personaSeleccionada = persona;
        console.log(this.personaSeleccionada);
        this.loading = true;
        this.dataAsignacion.idPersona = persona.IdPersona;
        this.servicePersona
            .getPersonaXVehiculo(persona.IdPersona)
            .subscribe(result => {
            this.dataPersonaVehiculo = result;
            if (this.dataPersonaVehiculo.length > 0) {
                this.tienePersonaVehiculo = 1;
            }
            else {
                this.tienePersonaVehiculo = 2;
            }
            this.loading = false;
        });
        this.isSelectedPersona = true;
        console.log(persona);
    }
    selectChange(event) {
        this.dataAsignacion.idTipoPersonaVehiculo = event;
        //this.dataAsignacion.idTipoPersonaVehiculo=this.vehiculoGroup.controls["formTipoPersonaVehiculo"].value;
        console.log(event);
    }
    procesoPersonaVehiculo() {
        //console.log(this.dataAsignacion);
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        this.dataAsignacion.idUsuario = infoUsuario[0].IdUsuario;
        this.servicePersona.postPersonaVehiculo(this.dataAsignacion)
            .subscribe(result => {
            this.isSelectedPersona = false;
            this.tienePersonaVehiculo = 0;
            this.dataPersona = [];
            this.personaGroup.reset();
            this.vehiculoGroup.reset();
            this.dataAsignacion = {
                idPersona: '',
                idVehiculo: '',
                idTipoPersonaVehiculo: '',
                idUsuario: ''
            };
            this.snackBar.open('Vehiculo Asignado', 'Asignar Vehiculo', {
                duration: 2000
            });
        });
    }
};
AsignacionTransportadorVehiculoComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _servicios_persona_service__WEBPACK_IMPORTED_MODULE_4__["PersonaService"] },
    { type: _servicios_vehiculo_service__WEBPACK_IMPORTED_MODULE_5__["VehiculoService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] }
];
AsignacionTransportadorVehiculoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-asignacion-transportador-vehiculo",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./asignacion-transportador-vehiculo.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./asignacion-transportador-vehiculo.component.css */ "./src/app/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _servicios_persona_service__WEBPACK_IMPORTED_MODULE_4__["PersonaService"],
        _servicios_vehiculo_service__WEBPACK_IMPORTED_MODULE_5__["VehiculoService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"]])
], AsignacionTransportadorVehiculoComponent);



/***/ }),

/***/ "./src/app/cargues-usuario/cargues-usuario.component.css":
/*!***************************************************************!*\
  !*** ./src/app/cargues-usuario/cargues-usuario.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-radio-button{\r\n    margin-left: 5px !important;\r\n}\r\n\r\n\r\nmat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n\r\nth, td {\r\n      white-space: nowrap !important;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9jYXJndWVzLXVzdWFyaW8vY2FyZ3Vlcy11c3VhcmlvLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSwyQkFBMkI7QUFDL0I7OztBQUdBO0lBQ0ksV0FBVztFQUNiOzs7QUFFQTtNQUNJLDhCQUE4QjtFQUNsQyIsImZpbGUiOiJhcHAvY2FyZ3Vlcy11c3VhcmlvL2Nhcmd1ZXMtdXN1YXJpby5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmV4YW1wbGUtcmFkaW8tYnV0dG9ue1xyXG4gICAgbWFyZ2luLWxlZnQ6IDVweCAhaW1wb3J0YW50O1xyXG59XHJcblxyXG5cclxubWF0LWZvcm0tZmllbGQge1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbiAgfVxyXG5cclxuICB0aCwgdGQge1xyXG4gICAgICB3aGl0ZS1zcGFjZTogbm93cmFwICFpbXBvcnRhbnQ7XHJcbiAgfVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/cargues-usuario/cargues-usuario.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/cargues-usuario/cargues-usuario.component.ts ***!
  \**************************************************************/
/*! exports provided: MY_FORMATS, CarguesUsuarioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarguesUsuarioComponent", function() { return CarguesUsuarioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../servicios/usuario.service */ "./src/app/servicios/usuario.service.ts");
/* harmony import */ var _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _servicios_archivos_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../servicios/archivos.service */ "./src/app/servicios/archivos.service.ts");















const MY_FORMATS = {
    parse: {
        dateInput: "YYYY-MM-DD"
    },
    display: {
        dateInput: "YYYY-MM-DD",
        monthYearLabel: "YYYY-MM-DD",
        dateA11yLabel: "YYYY-MM-DD",
        monthYearA11yLabel: "YYYY-MM-DD"
    }
};
let CarguesUsuarioComponent = class CarguesUsuarioComponent {
    constructor(fb, servicePersona, serviceUsuario, serviceArchivo, servicioAgencia, ruta) {
        this.fb = fb;
        this.servicePersona = servicePersona;
        this.serviceUsuario = serviceUsuario;
        this.serviceArchivo = serviceArchivo;
        this.servicioAgencia = servicioAgencia;
        this.ruta = ruta;
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.loadingAgencias = false;
        this.loadingUsuarios = false;
        this.usuarioConsulta = "";
        this.agencias = [];
        this.usuarios = [];
        this.dataCargues = [];
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.dtOptions = {
            pagingType: 'full_numbers',
            scrollX: true,
            dom: 'Bfrtip',
            buttons: [
                {
                    extend: "copyHtml5",
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: "excelHtml5",
                    fileName: "CustomFileName" + ".xlsx",
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ]
        };
        const fechaHoy = new Date();
        const nFecha = moment__WEBPACK_IMPORTED_MODULE_10__(fechaHoy, 'YYYY-MM-DD').format('YYYY-MM-DD');
        this.entregasGroup = this.fb.group({
            idAgencia: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            usuarioCtrl: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            fechaInicial: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            fechaFinal: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
        const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
        this.usuarioConsulta = infoUsuario[0].IdUsuario;
        this.loadingAgencias = true;
        this.servicioAgencia
            .getAgencia(infoUsuario[0].IdUsuario, 0)
            .subscribe(result => {
            this.agencias = result;
            this.agencias.unshift({
                id: "0",
                valor: "TODOS"
            });
            this.entregasGroup.controls["idAgencia"].setValue("0");
            this.loadingAgencias = false;
            this.entregasGroup.get("idAgencia").valueChanges.subscribe(value => {
                this.cargarUsuariosAgencia();
            });
            //console.log(this.agencias);
        });
        this.loadingUsuarios = true;
        this.serviceUsuario
            .getUsuariosPersonas(2, infoUsuario[0].IdUsuario, 0)
            .subscribe(result => {
            this.usuarios = result;
            this.usuarios.unshift({
                id: "0",
                valor: "TODOS"
            });
            this.entregasGroup.controls["usuarioCtrl"].setValue({
                id: "0",
                valor: "TODOS"
            });
            this.loadingUsuarios = false;
            this.filteredUsuarios = this.entregasGroup
                .get("usuarioCtrl")
                .valueChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["startWith"])(""), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["map"])(usuario => usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()));
        });
        this.cargarInformacion(0, this.usuarioConsulta, 0, nFecha, nFecha);
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    busqueda() {
        //console.log(this.entregasGroup.get('idAgencia').value);  
        //return;
        const usuarioConsulta = this.usuarioConsulta;
        const agencia = this.entregasGroup.get('idAgencia').value;
        const usuario = this.entregasGroup.get('usuarioCtrl').value;
        const fechaInicial = moment__WEBPACK_IMPORTED_MODULE_10__(this.entregasGroup.get('fechaInicial').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        const fechaFinal = moment__WEBPACK_IMPORTED_MODULE_10__(this.entregasGroup.get('fechaFinal').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        //console.log(tipoConsulta);
        //return;
        this.cargarInformacion(agencia, usuarioConsulta, usuario.id, fechaInicial, fechaFinal);
    }
    cargarInformacion(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal) {
        this.loading = true;
        this.serviceArchivo.getInformeCarguesRealizados(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal).subscribe(data => {
            this.dataCargues = data;
            this.loading = false;
            if (data.length > 0) {
                this.haveData = true;
            }
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    cargarUsuariosAgencia() {
        this.loadingUsuarios = true;
        const agencia = this.entregasGroup.get("idAgencia").value;
        this.serviceUsuario
            .getUsuariosPersonas(2, this.usuarioConsulta, agencia)
            .subscribe(result => {
            this.usuarios = result;
            this.usuarios.unshift({
                id: "0",
                valor: "TODOS"
            });
            this.entregasGroup.controls["usuarioCtrl"].setValue({
                id: "0",
                valor: "TODOS"
            });
            this.loadingUsuarios = false;
            this.filteredUsuarios = this.entregasGroup
                .get("usuarioCtrl")
                .valueChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["startWith"])(""), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_9__["map"])(usuario => usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()));
        });
    }
    _filterUsuarios(value) {
        let filterValue;
        if (typeof value === "object") {
            filterValue = value.valor.toLowerCase();
        }
        else {
            filterValue = value.toLowerCase();
        }
        console.log(filterValue);
        //const filterValue = value.valor.toLowerCase();
        return this.usuarios.filter(usuario => usuario.valor.toLowerCase().indexOf(filterValue) > -1);
    }
    displayFn(usuario) {
        //console.log(JSON.stringify(usuario));
        return usuario ? usuario.valor : usuario;
    }
    descargarArchivo(item) {
        const rootUrl = _constants_constants__WEBPACK_IMPORTED_MODULE_8__["Constants"].ROOT_URL;
        const agencia = item.idAgencia;
        const archivo = item.idExPlanoXAgencia;
        const url = rootUrl + '/integracionSubida/' + agencia + '/' + archivo + '/' + archivo + '.csv';
        window.open(url);
    }
};
CarguesUsuarioComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"] },
    { type: _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_6__["UsuarioService"] },
    { type: _servicios_archivos_service__WEBPACK_IMPORTED_MODULE_14__["ArchivosService"] },
    { type: _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_7__["AgenciaService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_13__["Utils"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_4__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_4__["DataTableDirective"])
], CarguesUsuarioComponent.prototype, "dtElement", void 0);
CarguesUsuarioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-cargues-usuario",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./cargues-usuario.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/cargues-usuario/cargues-usuario.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_11__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_12__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_11__["MAT_DATE_LOCALE"]]
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_11__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./cargues-usuario.component.css */ "./src/app/cargues-usuario/cargues-usuario.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"],
        _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_6__["UsuarioService"],
        _servicios_archivos_service__WEBPACK_IMPORTED_MODULE_14__["ArchivosService"],
        _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_7__["AgenciaService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_13__["Utils"]])
], CarguesUsuarioComponent);



/***/ }),

/***/ "./src/app/constants/constants.ts":
/*!****************************************!*\
  !*** ./src/app/constants/constants.ts ***!
  \****************************************/
/*! exports provided: Constants */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return Constants; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Constants {
    static get ENTORNO() {
        return "LC";
    }
    static get ROOT_URL() {
        let urlAPI;
        if (sessionStorage.getItem("urlAPI") === null) {
            var request = new XMLHttpRequest();
            request.open("GET", "./assets/config.json", false);
            request.send(null);
            if (request.status === 200) {
                urlAPI = JSON.parse(request.responseText);
                sessionStorage.setItem("urlAPI", request.responseText);
            }
        }
        else {
            urlAPI = JSON.parse(sessionStorage.getItem("urlAPI"));
        }
        return urlAPI.url;
        // let url = "";
        // switch (this.ENTORNO) {
        //   case "DV":
        //     url = "http://18.210.107.20/logisticaapi";
        //     break;
        //   case "QA":
        //     url = "http://18.210.107.20/cncaldas_webapi_qa";
        //     break;
        //   case "PR":
        //     url = "http://18.210.107.20/cncaldas_webapi";
        //     break;
        //   case "LC":
        //     url = "http://localhost/APICORE";
        //     break;
        // }
        // return url;
    }
    static get BASE_URL() {
        const url = this.ROOT_URL + "/api/";
        return url;
    }
    static get URL_LOGIN() {
        return "Auth/token";
    }
    static get URL_REFRESH() {
        return "renew";
    }
    static get URL_SIGNALR() {
        return "chathub";
    }
    static get URL_GRAFICAS_INICIO() {
        return "Auth/token";
    }
    static get URL_MENU() {
        return "menu";
    }
    static get URL_FORMULARIO() {
        return "formulario";
    }
    /*public static get URL_USUARIO(): string {
      return 'usuario';
    }*/
    static get URL_REPORTE() {
        return "Reporte";
    }
    static get URL_TRANSPORTADOR() {
        return "Transportador";
    }
    static get URL_SERVICIO() {
        return "Servicio";
    }
    static get URL_DEPARTAMENTO() {
        return "Departamento";
    }
    static get URL_CIUDAD() {
        return "Ciudad";
    }
    static get URL_TIPO_USUARIO() {
        return "TipoUsuario";
    }
    static get URL_DIRECCION() {
        return "Direccion";
    }
    static get URL_USUARIO() {
        return "UsuarioApp";
    }
    static get URL_BLOQUE() {
        return "Bloque";
    }
    static get URL_ENCUESTA() {
        return "Encuesta";
    }
    static get URL_PREGUNTA() {
        return "Pregunta";
    }
    static get URL_ENCUESTA_BLOQUE() {
        return "EncuestaBloque";
    }
    static get URL_TIPO_DOCUMENTO() {
        return "TipoDocumento";
    }
    static get URL_PERSONA() {
        return "persona";
    }
    static get URL_ARCHIVO() {
        return "Archivo";
    }
    static get URL_AGENCIA() {
        return "Agencia";
    }
    static get URL_ENTREGAS() {
        return "Entrega";
    }
    static get URL_IMAGEN() {
        return "Imagen";
    }
    static get URL_LOGWS() {
        return "LogWS";
    }
    static get URL_TIPO_NOVEDAD() {
        return "TipoNovedad";
    }
    static get URL_TIPO_MOTIVO() {
        return "TipoMotivo";
    }
    static get URL_MOTIVO() {
        return "Motivo";
    }
    static get URL_TIPO_MOTIVO_CLAS() {
        return "TipoMotivoClas";
    }
    static get URL_PERSONA_VEHICULO() {
        return "PersonaVehiculo";
    }
    static get URL_VEHICULO() {
        return "Vehiculo";
    }
    static get URL_TIPO_PERSONA_VEHICULO() {
        return "TipoPersonaVehiculo";
    }
    static get URL_GRAFICA() {
        return "Grafica";
    }
    static get URL_GESTIONENTREGAS() {
        return "GestionEntregas";
    }
}


/***/ }),

/***/ "./src/app/core/material.module.ts":
/*!*****************************************!*\
  !*** ./src/app/core/material.module.ts ***!
  \*****************************************/
/*! exports provided: CustomMaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomMaterialModule", function() { return CustomMaterialModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/autocomplete */ "./node_modules/@angular/material/esm2015/autocomplete.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/card */ "./node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/checkbox */ "./node_modules/@angular/material/esm2015/checkbox.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/datepicker */ "./node_modules/@angular/material/esm2015/datepicker.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_material_expansion__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/expansion */ "./node_modules/@angular/material/esm2015/expansion.js");
/* harmony import */ var _angular_material_form_field__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/form-field */ "./node_modules/@angular/material/esm2015/form-field.js");
/* harmony import */ var _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/grid-list */ "./node_modules/@angular/material/esm2015/grid-list.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
/* harmony import */ var _angular_material_menu__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/material/menu */ "./node_modules/@angular/material/esm2015/menu.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/progress-spinner */ "./node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var _angular_material_radio__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/material/radio */ "./node_modules/@angular/material/esm2015/radio.js");
/* harmony import */ var _angular_material_select__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/material/select */ "./node_modules/@angular/material/esm2015/select.js");
/* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/material/sidenav */ "./node_modules/@angular/material/esm2015/sidenav.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material_tabs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material/tabs */ "./node_modules/@angular/material/esm2015/tabs.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @angular/material/toolbar */ "./node_modules/@angular/material/esm2015/toolbar.js");
/* harmony import */ var _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @angular/material/tooltip */ "./node_modules/@angular/material/esm2015/tooltip.js");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @angular/flex-layout */ "./node_modules/@angular/flex-layout/esm2015/flex-layout.js");





























let CustomMaterialModule = class CustomMaterialModule {
};
CustomMaterialModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_10__["MatExpansionModule"],
            _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_4__["MatButtonModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_26__["MatToolbarModule"],
            _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatNativeDateModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_13__["MatIconModule"],
            _angular_material_menu__WEBPACK_IMPORTED_MODULE_16__["MatMenuModule"],
            _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_21__["MatSidenavModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_28__["FlexLayoutModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_15__["MatListModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardModule"],
            _angular_material_form_field__WEBPACK_IMPORTED_MODULE_11__["MatFormFieldModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_14__["MatInputModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_18__["MatProgressSpinnerModule"],
            _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_12__["MatGridListModule"],
            _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_3__["MatAutocompleteModule"],
            _angular_material_select__WEBPACK_IMPORTED_MODULE_20__["MatSelectModule"],
            _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_8__["MatDatepickerModule"],
            _angular_material_tabs__WEBPACK_IMPORTED_MODULE_25__["MatTabsModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_24__["MatTableModule"],
            _angular_material_paginator__WEBPACK_IMPORTED_MODULE_17__["MatPaginatorModule"],
            _angular_material_sort__WEBPACK_IMPORTED_MODULE_23__["MatSortModule"],
            _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_22__["MatSnackBarModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_9__["MatDialogModule"],
            _angular_material_radio__WEBPACK_IMPORTED_MODULE_19__["MatRadioModule"],
            _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_27__["MatTooltipModule"]
        ],
        exports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_material_expansion__WEBPACK_IMPORTED_MODULE_10__["MatExpansionModule"],
            _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_6__["MatCheckboxModule"],
            _angular_material_button__WEBPACK_IMPORTED_MODULE_4__["MatButtonModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_26__["MatToolbarModule"],
            _angular_material_core__WEBPACK_IMPORTED_MODULE_7__["MatNativeDateModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_13__["MatIconModule"],
            _angular_material_menu__WEBPACK_IMPORTED_MODULE_16__["MatMenuModule"],
            _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_21__["MatSidenavModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_28__["FlexLayoutModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_15__["MatListModule"],
            _angular_material_card__WEBPACK_IMPORTED_MODULE_5__["MatCardModule"],
            _angular_material_form_field__WEBPACK_IMPORTED_MODULE_11__["MatFormFieldModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_14__["MatInputModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_18__["MatProgressSpinnerModule"],
            _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_12__["MatGridListModule"],
            _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_3__["MatAutocompleteModule"],
            _angular_material_select__WEBPACK_IMPORTED_MODULE_20__["MatSelectModule"],
            _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_8__["MatDatepickerModule"],
            _angular_material_tabs__WEBPACK_IMPORTED_MODULE_25__["MatTabsModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_24__["MatTableModule"],
            _angular_material_paginator__WEBPACK_IMPORTED_MODULE_17__["MatPaginatorModule"],
            _angular_material_sort__WEBPACK_IMPORTED_MODULE_23__["MatSortModule"],
            _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_22__["MatSnackBarModule"],
            _angular_material_dialog__WEBPACK_IMPORTED_MODULE_9__["MatDialogModule"],
            _angular_material_radio__WEBPACK_IMPORTED_MODULE_19__["MatRadioModule"],
            _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_27__["MatTooltipModule"]
        ],
    })
], CustomMaterialModule);



/***/ }),

/***/ "./src/app/creacionusuarios/consulta-persona/consulta-persona.component.css":
/*!**********************************************************************************!*\
  !*** ./src/app/creacionusuarios/consulta-persona/consulta-persona.component.css ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-full-width {\r\n  width: 100% !important;\r\n}\r\n\r\n.bolder{\r\n  font-weight: bolder;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9jcmVhY2lvbnVzdWFyaW9zL2NvbnN1bHRhLXBlcnNvbmEvY29uc3VsdGEtcGVyc29uYS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usc0JBQXNCO0FBQ3hCOztBQUVBO0VBQ0UsbUJBQW1CO0FBQ3JCIiwiZmlsZSI6ImFwcC9jcmVhY2lvbnVzdWFyaW9zL2NvbnN1bHRhLXBlcnNvbmEvY29uc3VsdGEtcGVyc29uYS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmV4YW1wbGUtZnVsbC13aWR0aCB7XHJcbiAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcclxufVxyXG5cclxuLmJvbGRlcntcclxuICBmb250LXdlaWdodDogYm9sZGVyO1xyXG59XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/creacionusuarios/consulta-persona/consulta-persona.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/creacionusuarios/consulta-persona/consulta-persona.component.ts ***!
  \*********************************************************************************/
/*! exports provided: ConsultaPersonaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConsultaPersonaComponent", function() { return ConsultaPersonaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var src_app_dialogs_dialog_edit_persona_dialog_edit_persona_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component */ "./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.ts");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/servicios/helper.service */ "./src/app/servicios/helper.service.ts");








 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let ConsultaPersonaComponent = class ConsultaPersonaComponent {
    constructor(formBuilder, servicePersona, dialog, helper) {
        this.formBuilder = formBuilder;
        this.servicePersona = servicePersona;
        this.dialog = dialog;
        this.helper = helper;
        //dtOptions: DataTables.Settings = {};
        this.dtOptions = {};
        this.dataPersona = [];
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
        this.personaGroup = this.formBuilder.group({
            persona: ['']
        });
        /**/
    }
    ngOnInit() { }
    busqueda(event) {
        const busqueda = event.target.value;
        this.dtOptions = {
            pagingType: 'full_numbers',
            dom: 'Bfrtip',
            buttons: [
                'copy', 'csv', 'excel', 'pdf', 'print'
            ]
        };
        this.loading = true;
        this.servicePersona.getBusquedaPersona(busqueda).subscribe(data => {
            this.dataPersona = data;
            this.loading = false;
            if (data.length > 0) {
                this.haveData = true;
            }
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    ngOnDestroy() {
        // Do not forget to unsubscribe the event
        this.dtTrigger.unsubscribe();
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    editarPersona(persona) {
        const dialogRef = this.dialog.open(src_app_dialogs_dialog_edit_persona_dialog_edit_persona_component__WEBPACK_IMPORTED_MODULE_7__["DialogEditPersonaComponent"], {
            data: persona,
            width: '100em',
            disableClose: true
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.refrescaBusqueda();
            }
            console.log('Resultado es :' + result);
        });
    }
    eliminarPersona(persona) {
        //alert(JSON.stringify(persona));
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.fire({
            title: 'Eliminar Persona?',
            text: 'Esta seguro que desea eliminar esta persona, recuerde que las direcciones y usuarios asociados se eliminarán igualmente!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.servicePersona
                    .deletePersona(persona.IdPersona)
                    .subscribe(data => {
                    const indexPersona = this.helper.findIndex(this.dataPersona, {
                        IdPersona: persona.IdPersona
                    });
                    this.dataPersona.splice(indexPersona, 1);
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    refrescaBusqueda() {
        const busqueda = this.personaGroup.controls['persona'].value;
        this.dtOptions = {
            pagingType: 'full_numbers',
            dom: 'Bfrtip',
            buttons: [
                'copy', 'csv', 'excel', 'pdf', 'print'
            ]
        };
        this.loading = true;
        this.servicePersona.getBusquedaPersona(busqueda).subscribe(data => {
            this.dataPersona = data;
            this.loading = false;
            if (data.length > 0) {
                this.haveData = true;
            }
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
};
ConsultaPersonaComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__["PersonaService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_4__["MatDialog"] },
    { type: src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_9__["HelperService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_6__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_6__["DataTableDirective"])
], ConsultaPersonaComponent.prototype, "dtElement", void 0);
ConsultaPersonaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-consulta-persona',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./consulta-persona.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/consulta-persona/consulta-persona.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./consulta-persona.component.css */ "./src/app/creacionusuarios/consulta-persona/consulta-persona.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__["PersonaService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_4__["MatDialog"],
        src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_9__["HelperService"]])
], ConsultaPersonaComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/consultar-persona/consultar-persona.component.css":
/*!************************************************************************************!*\
  !*** ./src/app/creacionusuarios/consultar-persona/consultar-persona.component.css ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9jb25zdWx0YXItcGVyc29uYS9jb25zdWx0YXItcGVyc29uYS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/creacionusuarios/consultar-persona/consultar-persona.component.ts":
/*!***********************************************************************************!*\
  !*** ./src/app/creacionusuarios/consultar-persona/consultar-persona.component.ts ***!
  \***********************************************************************************/
/*! exports provided: ConsultarPersonaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConsultarPersonaComponent", function() { return ConsultarPersonaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ConsultarPersonaComponent = class ConsultarPersonaComponent {
    constructor() { }
    ngOnInit() {
        this.dtOptions = {
            dom: 'Bfrtip',
            buttons: ['copy', 'excel']
        };
        this.dataTable = $(this.table.nativeElement);
        this.dataTable.dataTable(this.dtOptions);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('dataTable', { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"])
], ConsultarPersonaComponent.prototype, "table", void 0);
ConsultarPersonaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-consultar-persona',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./consultar-persona.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/consultar-persona/consultar-persona.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./consultar-persona.component.css */ "./src/app/creacionusuarios/consultar-persona/consultar-persona.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ConsultarPersonaComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/creacionpersona/creacionpersona.component.css":
/*!********************************************************************************!*\
  !*** ./src/app/creacionusuarios/creacionpersona/creacionpersona.component.css ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9jcmVhY2lvbnBlcnNvbmEvY3JlYWNpb25wZXJzb25hLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/creacionusuarios/creacionpersona/creacionpersona.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/creacionusuarios/creacionpersona/creacionpersona.component.ts ***!
  \*******************************************************************************/
/*! exports provided: CreacionpersonaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreacionpersonaComponent", function() { return CreacionpersonaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/utils */ "./src/app/utils/utils.ts");




let CreacionpersonaComponent = class CreacionpersonaComponent {
    constructor(servicioFormulario, ruta, formatFormulario) {
        this.ruta = ruta;
        this.formatFormulario = formatFormulario;
        this.idFormulario = 25;
        this.parametrosDestino = [];
        this.procedimientoDestino = '';
        this.descripcion = 'Creación De Usuario';
        let response;
        servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
            this.procedimientoDestino = data[0].procedimientoDestino;
            response = this.formatFormulario.formatFormulario(data);
            this.items = response.arrayDatos;
            this.parametrosDestino = response.parametros;
            return this.items.sort((a, b) => a.order - b.order);
        });
    }
    ngOnInit() {
        //this.ruta.setRuta();
    }
};
CreacionpersonaComponent.ctorParameters = () => [
    { type: _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] }
];
CreacionpersonaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-creacionpersona',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./creacionpersona.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionpersona/creacionpersona.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./creacionpersona.component.css */ "./src/app/creacionusuarios/creacionpersona/creacionpersona.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"]])
], CreacionpersonaComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/creacionusuario/creacionusuario.component.css":
/*!********************************************************************************!*\
  !*** ./src/app/creacionusuarios/creacionusuario/creacionusuario.component.css ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9jcmVhY2lvbnVzdWFyaW8vY3JlYWNpb251c3VhcmlvLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/creacionusuarios/creacionusuario/creacionusuario.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/creacionusuarios/creacionusuario/creacionusuario.component.ts ***!
  \*******************************************************************************/
/*! exports provided: CreacionusuarioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreacionusuarioComponent", function() { return CreacionusuarioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/utils */ "./src/app/utils/utils.ts");




let CreacionusuarioComponent = class CreacionusuarioComponent {
    constructor(servicioFormulario, ruta, formatFormulario) {
        this.ruta = ruta;
        this.formatFormulario = formatFormulario;
        this.idFormulario = 25;
        this.parametrosDestino = [];
        this.procedimientoDestino = '';
        this.descripcion = 'Creación De Usuario';
        let response;
        servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
            this.procedimientoDestino = data[0].procedimientoDestino;
            response = this.formatFormulario.formatFormulario(data);
            this.items = response.arrayDatos;
            this.parametrosDestino = response.parametros;
            return this.items.sort((a, b) => a.order - b.order);
        });
    }
    ngOnInit() { }
};
CreacionusuarioComponent.ctorParameters = () => [
    { type: _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] }
];
CreacionusuarioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-creacionusuario',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./creacionusuario.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionusuario/creacionusuario.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./creacionusuario.component.css */ "./src/app/creacionusuarios/creacionusuario/creacionusuario.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"]])
], CreacionusuarioComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/creacionusuarios.component.css":
/*!*****************************************************************!*\
  !*** ./src/app/creacionusuarios/creacionusuarios.component.css ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9jcmVhY2lvbnVzdWFyaW9zLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/creacionusuarios/creacionusuarios.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/creacionusuarios/creacionusuarios.component.ts ***!
  \****************************************************************/
/*! exports provided: CreacionusuariosComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreacionusuariosComponent", function() { return CreacionusuariosComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");



let CreacionusuariosComponent = class CreacionusuariosComponent {
    constructor(ruta) {
        this.ruta = ruta;
        this.dataPersonaActualiza = 0;
    }
    ngOnInit() {
        //alert(this.router.url);
        this.ruta.setRuta();
    }
    actualizaPadrePersona(valor) {
        //alert(valor);
        this.dataPersonaActualiza += valor;
    }
};
CreacionusuariosComponent.ctorParameters = () => [
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"] }
];
CreacionusuariosComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-creacionusuarios',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./creacionusuarios.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/creacionusuarios.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./creacionusuarios.component.css */ "./src/app/creacionusuarios/creacionusuarios.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"]])
], CreacionusuariosComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/crear-persona/crear-persona.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/creacionusuarios/crear-persona/crear-persona.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9jcmVhci1wZXJzb25hL2NyZWFyLXBlcnNvbmEuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/creacionusuarios/crear-persona/crear-persona.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/creacionusuarios/crear-persona/crear-persona.component.ts ***!
  \***************************************************************************/
/*! exports provided: CrearPersonaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrearPersonaComponent", function() { return CrearPersonaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _servicios_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../servicios/helper.service */ "./src/app/servicios/helper.service.ts");
/* harmony import */ var _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../dynamic-form/dynamic-form.component */ "./src/app/dynamic-form/dynamic-form.component.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let CrearPersonaComponent = class CrearPersonaComponent {
    constructor(servicioFormulario, ruta, formatFormulario, _helper, servicioPersona) {
        this.servicioFormulario = servicioFormulario;
        this.ruta = ruta;
        this.formatFormulario = formatFormulario;
        this._helper = _helper;
        this.servicioPersona = servicioPersona;
        this.actualizaPadrePersona = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.idFormulario = 25;
        this.origenParent = 'creacionpersona';
        this.parametrosDestino = [];
        this.procedimientoDestino = '';
        this.descripcion = 'Creación De Persona';
        this.crearFormulario();
    }
    crearFormulario() {
        let response;
        this.servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
            this.procedimientoDestino = data[0].procedimientoDestino;
            //console.log(JSON.stringify(data));
            response = this.formatFormulario.formatFormulario(data);
            this.items = response.arrayDatos;
            this.parametrosDestino = response.parametros;
            return this.items.sort((a, b) => a.order - b.order);
        });
    }
    ngOnInit() { }
    dataFormulario($event) {
        //alert(JSON.stringify($event));
        const dataForm = $event;
        if (dataForm.parent === this.origenParent) {
            const respuesta = this.validators(dataForm.datos);
        }
    }
    validators(dataForm) {
        const tipoDocumentoArr = this._helper.where(dataForm.infoPayload, {
            key: 'tipoDocumento'
        });
        const numeroDocumentoArr = this._helper.where(dataForm.infoPayload, {
            key: 'numeroDocumento'
        });
        let tipoDocumento;
        let numeroDocumento;
        tipoDocumento = tipoDocumentoArr;
        numeroDocumento = numeroDocumentoArr;
        this.servicioPersona
            .getPersona(tipoDocumento[0].value, numeroDocumento[0].value)
            .subscribe(data => {
            if (data.length > 0) {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Persona',
                    text: 'Esta persona ya existe por favor verifique.',
                    type: 'error'
                });
            }
            else {
                this.servicioFormulario.postFormulario(dataForm).subscribe(data => {
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                        title: this.descripcion,
                        text: 'Informacion Almacenada Correctamente.',
                        type: 'success'
                    });
                    this.reset();
                    this.actualizaPadrePersona.emit(1);
                });
            }
        });
        return true;
    }
    reset() {
        this.resetForm.resetForm();
    }
};
CrearPersonaComponent.ctorParameters = () => [
    { type: _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _servicios_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] },
    { type: _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('resetForm', { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_7__["DynamicFormComponent"])
], CrearPersonaComponent.prototype, "resetForm", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], CrearPersonaComponent.prototype, "actualizaPadrePersona", void 0);
CrearPersonaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-crear-persona',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./crear-persona.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/crear-persona/crear-persona.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./crear-persona.component.css */ "./src/app/creacionusuarios/crear-persona/crear-persona.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _servicios_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"],
        _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"]])
], CrearPersonaComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/crear-usuario/crear-usuario.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/creacionusuarios/crear-usuario/crear-usuario.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9jcmVhci11c3VhcmlvL2NyZWFyLXVzdWFyaW8uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/creacionusuarios/crear-usuario/crear-usuario.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/creacionusuarios/crear-usuario/crear-usuario.component.ts ***!
  \***************************************************************************/
/*! exports provided: CrearUsuarioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrearUsuarioComponent", function() { return CrearUsuarioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _servicios_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../servicios/helper.service */ "./src/app/servicios/helper.service.ts");
/* harmony import */ var _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _dialogs_dialog_agencias_dialog_agencias_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../dialogs/dialog-agencias/dialog-agencias.component */ "./src/app/dialogs/dialog-agencias/dialog-agencias.component.ts");
/* harmony import */ var _dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../dynamic-form/dynamic-form.component */ "./src/app/dynamic-form/dynamic-form.component.ts");
/* harmony import */ var src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/servicios/usuario.service */ "./src/app/servicios/usuario.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");











let CrearUsuarioComponent = class CrearUsuarioComponent {
    constructor(servicioFormulario, ruta, formatFormulario, _helper, dialog, servicioPersona, servicioUsuario, snackBar) {
        this.servicioFormulario = servicioFormulario;
        this.ruta = ruta;
        this.formatFormulario = formatFormulario;
        this._helper = _helper;
        this.dialog = dialog;
        this.servicioPersona = servicioPersona;
        this.servicioUsuario = servicioUsuario;
        this.snackBar = snackBar;
        this.idFormulario = 26; //no se debe repetir
        this.origenParent = 'creacionusuario'; //no se debe repetir
        this.parametrosDestino = [];
        this.procedimientoDestino = '';
        this.descripcion = 'Creación De Usuario';
        this.crearFormulario();
    }
    crearFormulario() {
        let response;
        this.servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
            this.procedimientoDestino = data[0].procedimientoDestino;
            response = this.formatFormulario.formatFormulario(data);
            this.items = response.arrayDatos;
            this.parametrosDestino = response.parametros;
            return this.items.sort((a, b) => a.order - b.order);
        });
    }
    ngOnInit() { }
    ngOnChanges() {
        //alert('cambio valor' + this.dataPersonaActualiza);
        if (this.dataPersonaActualiza > 0) {
            this.crearFormulario();
        }
    }
    dataFormulario($event) {
        const dataForm = $event;
        if (dataForm.parent === this.origenParent) {
            const respuesta = this.validators(dataForm.datos);
        }
    }
    validators(dataForm) {
        const dialogRef = this.dialog.open(_dialogs_dialog_agencias_dialog_agencias_component__WEBPACK_IMPORTED_MODULE_7__["DialogAgenciasComponent"], {
            data: '0',
            width: '100em',
        });
        dialogRef.afterClosed().subscribe(result => {
            /*if (result) {
              this.refrescaBusqueda();
            }*/
            // console.log(JSON.stringify(dataForm));
            //console.log('Resultado es :' + result);
            if (typeof result !== "undefined") {
                const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
                let agenciasLista = '';
                result.forEach(element => {
                    agenciasLista = agenciasLista + element + ',';
                });
                agenciasLista = agenciasLista.slice(0, -1);
                //console.log(agenciasLista);   
                //return;
                const param = {
                    idPersona: dataForm.infoPayload[0].value,
                    idTipoUsuario: dataForm.infoPayload[1].value,
                    usuario: dataForm.infoPayload[2].value,
                    clave: dataForm.infoPayload[3].value,
                    descripcion: dataForm.infoPayload[4].value,
                    agencias: agenciasLista,
                    idUsuario: infoUsuario[0].IdUsuario
                };
                this.servicioUsuario.postUsuario(param)
                    .subscribe(result => {
                    this.snackBar.open('Usuario Creado', 'Crear Usuario', {
                        duration: 2000
                    });
                    this.reset();
                });
            }
        });
        //console.log(dataForm);
        /*return;
        this.servicioFormulario.postFormulario(dataForm).subscribe(data => {
          Swal.fire({
            title: this.descripcion,
            text: 'Informacion Almacenada Correctamente.',
            type: 'success'
          });
          this.reset();
        });
        return true;*/
    }
    reset() {
        this.resetForm.resetForm();
    }
};
CrearUsuarioComponent.ctorParameters = () => [
    { type: _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _servicios_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MatDialog"] },
    { type: _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"] },
    { type: src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_9__["UsuarioService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_10__["MatSnackBar"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('resetForm', { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_8__["DynamicFormComponent"])
], CrearUsuarioComponent.prototype, "resetForm", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], CrearUsuarioComponent.prototype, "dataPersonaActualiza", void 0);
CrearUsuarioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-crear-usuario',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./crear-usuario.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/crear-usuario/crear-usuario.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./crear-usuario.component.css */ "./src/app/creacionusuarios/crear-usuario/crear-usuario.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _servicios_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MatDialog"],
        _servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"],
        src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_9__["UsuarioService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_10__["MatSnackBar"]])
], CrearUsuarioComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.css":
/*!********************************************************************************************************!*\
  !*** ./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.css ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("select {\r\n  -webkit-appearance: none;\r\n     -moz-appearance: none;\r\n          appearance: none;\r\n  background-color: #FAFAFA;\r\n  background-image: url(\"/assets/caret--down-15.png\");\r\n  background-position: right;\r\n  background-repeat: no-repeat;\r\n  border-color: #b3cccc;\r\n  border-radius: .2em;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-right-color: #869999;\r\n  border-bottom-color: #869999;\r\n  color: black;\r\n  padding: .33em .5em;\r\n  width: 80%;\r\n}\r\n\r\nmat-form-field {\r\n  width: 80%;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9jcmVhY2lvbnVzdWFyaW9zL21vZGlmaWNhci1kaXJlY2Npb24tcGVyc29uYS9tb2RpZmljYXItZGlyZWNjaW9uLXBlcnNvbmEuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLHdCQUFnQjtLQUFoQixxQkFBZ0I7VUFBaEIsZ0JBQWdCO0VBQ2hCLHlCQUF5QjtFQUN6QixtREFBbUQ7RUFDbkQsMEJBQTBCO0VBQzFCLDRCQUE0QjtFQUM1QixxQkFBcUI7RUFDckIsbUJBQW1CO0VBQ25CLG1CQUFtQjtFQUNuQixpQkFBaUI7RUFDakIsMkJBQTJCO0VBQzNCLDRCQUE0QjtFQUM1QixZQUFZO0VBQ1osbUJBQW1CO0VBQ25CLFVBQVU7QUFDWjs7QUFFQTtFQUNFLFVBQVU7QUFDWiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9tb2RpZmljYXItZGlyZWNjaW9uLXBlcnNvbmEvbW9kaWZpY2FyLWRpcmVjY2lvbi1wZXJzb25hLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJzZWxlY3Qge1xyXG4gIGFwcGVhcmFuY2U6IG5vbmU7XHJcbiAgYmFja2dyb3VuZC1jb2xvcjogI0ZBRkFGQTtcclxuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoXCIvYXNzZXRzL2NhcmV0LS1kb3duLTE1LnBuZ1wiKTtcclxuICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiByaWdodDtcclxuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xyXG4gIGJvcmRlci1jb2xvcjogI2IzY2NjYztcclxuICBib3JkZXItcmFkaXVzOiAuMmVtO1xyXG4gIGJvcmRlci1zdHlsZTogc29saWQ7XHJcbiAgYm9yZGVyLXdpZHRoOiAxcHg7XHJcbiAgYm9yZGVyLXJpZ2h0LWNvbG9yOiAjODY5OTk5O1xyXG4gIGJvcmRlci1ib3R0b20tY29sb3I6ICM4Njk5OTk7XHJcbiAgY29sb3I6IGJsYWNrO1xyXG4gIHBhZGRpbmc6IC4zM2VtIC41ZW07XHJcbiAgd2lkdGg6IDgwJTtcclxufVxyXG5cclxubWF0LWZvcm0tZmllbGQge1xyXG4gIHdpZHRoOiA4MCU7XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.ts":
/*!*******************************************************************************************************!*\
  !*** ./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.ts ***!
  \*******************************************************************************************************/
/*! exports provided: ModificarDireccionPersonaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModificarDireccionPersonaComponent", function() { return ModificarDireccionPersonaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var src_app_servicios_departamentos_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/servicios/departamentos.service */ "./src/app/servicios/departamentos.service.ts");
/* harmony import */ var src_app_servicios_ciudades_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/servicios/ciudades.service */ "./src/app/servicios/ciudades.service.ts");
/* harmony import */ var src_app_servicios_direccion_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/servicios/direccion.service */ "./src/app/servicios/direccion.service.ts");







let ModificarDireccionPersonaComponent = class ModificarDireccionPersonaComponent {
    constructor(fb, servicioDepartamento, ciudadService, servicioDireccion, snackBar) {
        this.fb = fb;
        this.servicioDepartamento = servicioDepartamento;
        this.ciudadService = ciudadService;
        this.servicioDireccion = servicioDireccion;
        this.snackBar = snackBar;
        this.propagar = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.departamentos = [];
        this.ciudades = [];
        this.loadingDireccion = false;
        this.direccionGroup = this.fb.group({
            NombreDireccion: [''],
            IdPersContacto: [''],
            Telefono: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].maxLength(20)]],
            Telefono2: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].maxLength(20)]],
            idDepto: [''],
            idMunicipio: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]],
            Direccion: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].maxLength(20)]],
            Observacion: ['']
        });
    }
    ngOnInit() {
        console.log(this.dataModificaDireccion);
        this.refreshData();
    }
    ngOnChanges() {
        this.refreshData();
    }
    setValuesForm() {
        this.direccionGroup.controls['NombreDireccion'].setValue(this.dataModificaDireccion.NombreDireccion);
        this.direccionGroup.controls['idDepto'].setValue(this.dataModificaDireccion.idDepto);
        this.direccionGroup.controls['idMunicipio'].setValue(this.dataModificaDireccion.idMunicipio);
        this.direccionGroup.controls['Direccion'].setValue(this.dataModificaDireccion.Direccion);
        this.direccionGroup.controls['Telefono'].setValue(this.dataModificaDireccion.Telefono);
        this.direccionGroup.controls['Telefono2'].setValue(this.dataModificaDireccion.Telefono2);
        this.direccionGroup.controls['Observacion'].setValue(this.dataModificaDireccion.Observacion);
    }
    refreshData() {
        this.loadingDireccion = true;
        this.servicioDepartamento.getDepartamentos().subscribe(data => {
            this.departamentos = data;
            console.log(JSON.stringify(this.departamentos));
            this.ciudadService
                .getCiudades(this.dataModificaDireccion.idDepto)
                .subscribe(result => {
                this.loadingDireccion = false;
                this.ciudades = result;
                this.setValuesForm();
            });
        });
    }
    submitForm() {
        let direccion = this.direccionGroup.value;
        direccion.IdPersContacto = this.dataModificaDireccion.IdPersonaDireccion;
        //console.log(JSON.stringify(direccion));  
        direccion.Direccion = direccion.Direccion.toUpperCase();
        direccion.Observacion = direccion.Observacion.toUpperCase();
        this.servicioDireccion.putDireccion(direccion).subscribe(result => {
            this.propagar.emit(this.dataModificaDireccion);
            this.snackBar.open('Dirección Actualizada', 'Actualizar Dirección', {
                duration: 2000
            });
        });
    }
};
ModificarDireccionPersonaComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: src_app_servicios_departamentos_service__WEBPACK_IMPORTED_MODULE_4__["DepartamentosService"] },
    { type: src_app_servicios_ciudades_service__WEBPACK_IMPORTED_MODULE_5__["CiudadesService"] },
    { type: src_app_servicios_direccion_service__WEBPACK_IMPORTED_MODULE_6__["DireccionService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_2__["MatSnackBar"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], ModificarDireccionPersonaComponent.prototype, "propagar", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], ModificarDireccionPersonaComponent.prototype, "dataModificaDireccion", void 0);
ModificarDireccionPersonaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-modificar-direccion-persona',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./modificar-direccion-persona.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./modificar-direccion-persona.component.css */ "./src/app/creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"],
        src_app_servicios_departamentos_service__WEBPACK_IMPORTED_MODULE_4__["DepartamentosService"],
        src_app_servicios_ciudades_service__WEBPACK_IMPORTED_MODULE_5__["CiudadesService"],
        src_app_servicios_direccion_service__WEBPACK_IMPORTED_MODULE_6__["DireccionService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_2__["MatSnackBar"]])
], ModificarDireccionPersonaComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.css":
/*!****************************************************************************************************!*\
  !*** ./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.css ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("select {\r\n  -webkit-appearance: none;\r\n     -moz-appearance: none;\r\n          appearance: none;\r\n  background-color: #FAFAFA;\r\n  background-image: url(\"/assets/caret--down-15.png\");\r\n  background-position: right;\r\n  background-repeat: no-repeat;\r\n  border-color: #b3cccc;\r\n  border-radius: .2em;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-right-color: #869999;\r\n  border-bottom-color: #869999;\r\n  color: black;\r\n  padding: .33em .5em;\r\n  width: 80%;\r\n}\r\n\r\nmat-form-field {\r\n  width: 80%;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9jcmVhY2lvbnVzdWFyaW9zL21vZGlmaWNhci11c3VhcmlvLXBlcnNvbmEvbW9kaWZpY2FyLXVzdWFyaW8tcGVyc29uYS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usd0JBQWdCO0tBQWhCLHFCQUFnQjtVQUFoQixnQkFBZ0I7RUFDaEIseUJBQXlCO0VBQ3pCLG1EQUFtRDtFQUNuRCwwQkFBMEI7RUFDMUIsNEJBQTRCO0VBQzVCLHFCQUFxQjtFQUNyQixtQkFBbUI7RUFDbkIsbUJBQW1CO0VBQ25CLGlCQUFpQjtFQUNqQiwyQkFBMkI7RUFDM0IsNEJBQTRCO0VBQzVCLFlBQVk7RUFDWixtQkFBbUI7RUFDbkIsVUFBVTtBQUNaOztBQUVBO0VBQ0UsVUFBVTtBQUNaIiwiZmlsZSI6ImFwcC9jcmVhY2lvbnVzdWFyaW9zL21vZGlmaWNhci11c3VhcmlvLXBlcnNvbmEvbW9kaWZpY2FyLXVzdWFyaW8tcGVyc29uYS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsic2VsZWN0IHtcclxuICBhcHBlYXJhbmNlOiBub25lO1xyXG4gIGJhY2tncm91bmQtY29sb3I6ICNGQUZBRkE7XHJcbiAgYmFja2dyb3VuZC1pbWFnZTogdXJsKFwiL2Fzc2V0cy9jYXJldC0tZG93bi0xNS5wbmdcIik7XHJcbiAgYmFja2dyb3VuZC1wb3NpdGlvbjogcmlnaHQ7XHJcbiAgYmFja2dyb3VuZC1yZXBlYXQ6IG5vLXJlcGVhdDtcclxuICBib3JkZXItY29sb3I6ICNiM2NjY2M7XHJcbiAgYm9yZGVyLXJhZGl1czogLjJlbTtcclxuICBib3JkZXItc3R5bGU6IHNvbGlkO1xyXG4gIGJvcmRlci13aWR0aDogMXB4O1xyXG4gIGJvcmRlci1yaWdodC1jb2xvcjogIzg2OTk5OTtcclxuICBib3JkZXItYm90dG9tLWNvbG9yOiAjODY5OTk5O1xyXG4gIGNvbG9yOiBibGFjaztcclxuICBwYWRkaW5nOiAuMzNlbSAuNWVtO1xyXG4gIHdpZHRoOiA4MCU7XHJcbn1cclxuXHJcbm1hdC1mb3JtLWZpZWxkIHtcclxuICB3aWR0aDogODAlO1xyXG59XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.ts":
/*!***************************************************************************************************!*\
  !*** ./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.ts ***!
  \***************************************************************************************************/
/*! exports provided: ModificarUsuarioPersonaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModificarUsuarioPersonaComponent", function() { return ModificarUsuarioPersonaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var src_app_servicios_tipo_usuario_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/servicios/tipo-usuario.service */ "./src/app/servicios/tipo-usuario.service.ts");
/* harmony import */ var src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/servicios/usuario.service */ "./src/app/servicios/usuario.service.ts");
/* harmony import */ var src_app_servicios_agencia_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");







let ModificarUsuarioPersonaComponent = class ModificarUsuarioPersonaComponent {
    constructor(fb, servicioTiposUsuario, servicioUsuario, servicioAgencia, snackBar) {
        this.fb = fb;
        this.servicioTiposUsuario = servicioTiposUsuario;
        this.servicioUsuario = servicioUsuario;
        this.servicioAgencia = servicioAgencia;
        this.snackBar = snackBar;
        this.propagar = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.tiposUsuario = [];
        this.loadingUsuario = false;
        this.agencias = [];
        //console.log(this.dataModificaUsuario);
        this.usuarioGrupo = this.fb.group({
            IdUsuario: [""],
            IdTpoUsuario: ["", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]],
            Usuario: ["", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].maxLength(250)]],
            Clave: ["", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].maxLength(250)]],
            Descripcion: ["", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].maxLength(250)]],
            formAgencias: ["", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]]
        });
        this.servicioAgencia.getAllAgencia(0).subscribe(result => {
            this.agencias = result;
        });
    }
    ngOnInit() {
        this.refreshData();
    }
    ngOnChanges() {
        this.refreshData();
    }
    setValuesForm() {
        const agenciaArr = Array.from(this.dataModificaUsuario.agencias.split(",")).map(item => Number(item));
        this.usuarioGrupo.controls["IdUsuario"].setValue(this.dataModificaUsuario.IdUsuario);
        this.usuarioGrupo.controls["IdTpoUsuario"].setValue(this.dataModificaUsuario.IdTpoUsuario);
        this.usuarioGrupo.controls["Usuario"].setValue(this.dataModificaUsuario.Usuario);
        this.usuarioGrupo.controls["Clave"].setValue(this.dataModificaUsuario.Clave);
        this.usuarioGrupo.controls["Descripcion"].setValue(this.dataModificaUsuario.Descripcion);
        this.usuarioGrupo.controls["formAgencias"].setValue(agenciaArr);
    }
    refreshData() {
        this.loadingUsuario = true;
        this.servicioTiposUsuario.getTiposUsuario().subscribe(result => {
            this.tiposUsuario = result;
            this.loadingUsuario = false;
            this.setValuesForm();
        });
    }
    eliminarUsuario() { }
    submitForm() {
        let usuario = this.usuarioGrupo.value;
        usuario.Descripcion = usuario.Descripcion.toUpperCase();
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        let agenciasLista = "";
        usuario.formAgencias.forEach(element => {
            agenciasLista = agenciasLista + element + ",";
        });
        agenciasLista = agenciasLista.slice(0, -1);
        usuario.formAgencias = agenciasLista;
        usuario.usuarioActualiza = infoUsuario[0].IdUsuario;
        //console.log(JSON.stringify(usuario));
        //return;
        this.servicioUsuario.putUsuario(usuario).subscribe(result => {
            this.propagar.emit(this.dataModificaUsuario);
            //console.log("aqui es");
            this.snackBar.open("Usuario Actualizado", "Actualizar Usuario", {
                duration: 2000
            });
        });
    }
};
ModificarUsuarioPersonaComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: src_app_servicios_tipo_usuario_service__WEBPACK_IMPORTED_MODULE_4__["TipoUsuarioService"] },
    { type: src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_5__["UsuarioService"] },
    { type: src_app_servicios_agencia_service__WEBPACK_IMPORTED_MODULE_6__["AgenciaService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_2__["MatSnackBar"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], ModificarUsuarioPersonaComponent.prototype, "propagar", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], ModificarUsuarioPersonaComponent.prototype, "dataModificaUsuario", void 0);
ModificarUsuarioPersonaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-modificar-usuario-persona",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./modificar-usuario-persona.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./modificar-usuario-persona.component.css */ "./src/app/creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"],
        src_app_servicios_tipo_usuario_service__WEBPACK_IMPORTED_MODULE_4__["TipoUsuarioService"],
        src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_5__["UsuarioService"],
        src_app_servicios_agencia_service__WEBPACK_IMPORTED_MODULE_6__["AgenciaService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_2__["MatSnackBar"]])
], ModificarUsuarioPersonaComponent);



/***/ }),

/***/ "./src/app/creacionusuarios/reporte-personas/reporte-personas.component.css":
/*!**********************************************************************************!*\
  !*** ./src/app/creacionusuarios/reporte-personas/reporte-personas.component.css ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvY3JlYWNpb251c3Vhcmlvcy9yZXBvcnRlLXBlcnNvbmFzL3JlcG9ydGUtcGVyc29uYXMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/creacionusuarios/reporte-personas/reporte-personas.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/creacionusuarios/reporte-personas/reporte-personas.component.ts ***!
  \*********************************************************************************/
/*! exports provided: ReportePersonasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReportePersonasComponent", function() { return ReportePersonasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/utils */ "./src/app/utils/utils.ts");




let ReportePersonasComponent = class ReportePersonasComponent {
    constructor(servicioFormulario, ruta, formatFormulario) {
        this.ruta = ruta;
        this.formatFormulario = formatFormulario;
        this.idFormulario = 1;
        this.parametrosDestino = [];
        this.procedimientoDestino = '';
        this.descripcion = 'Reporte Persona';
        let response;
        servicioFormulario.getFormularioReporte(this.idFormulario).subscribe(data => {
            this.procedimientoDestino = data[0].procedimientoDestino;
            response = this.formatFormulario.formatFormulario(data);
            this.items = response.arrayDatos;
            this.parametrosDestino = response.parametros;
            return this.items.sort((a, b) => a.order - b.order);
        });
    }
    ngOnInit() { }
    salidaReporte($event) {
        this.salidaReporte = $event;
        alert(JSON.stringify(this.salidaReporte));
    }
};
ReportePersonasComponent.ctorParameters = () => [
    { type: _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] }
];
ReportePersonasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-reporte-personas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./reporte-personas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/creacionusuarios/reporte-personas/reporte-personas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./reporte-personas.component.css */ "./src/app/creacionusuarios/reporte-personas/reporte-personas.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"]])
], ReportePersonasComponent);



/***/ }),

/***/ "./src/app/dialogs/dialog-agencias/dialog-agencias.component.css":
/*!***********************************************************************!*\
  !*** ./src/app/dialogs/dialog-agencias/dialog-agencias.component.css ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9kaWFsb2dzL2RpYWxvZy1hZ2VuY2lhcy9kaWFsb2ctYWdlbmNpYXMuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFdBQVc7RUFDYiIsImZpbGUiOiJhcHAvZGlhbG9ncy9kaWFsb2ctYWdlbmNpYXMvZGlhbG9nLWFnZW5jaWFzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJtYXQtZm9ybS1maWVsZCB7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/dialogs/dialog-agencias/dialog-agencias.component.ts":
/*!**********************************************************************!*\
  !*** ./src/app/dialogs/dialog-agencias/dialog-agencias.component.ts ***!
  \**********************************************************************/
/*! exports provided: DialogAgenciasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogAgenciasComponent", function() { return DialogAgenciasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var src_app_servicios_agencia_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");





let DialogAgenciasComponent = class DialogAgenciasComponent {
    constructor(dataDialog, servicioAgencia, formBuilder) {
        this.dataDialog = dataDialog;
        this.servicioAgencia = servicioAgencia;
        this.formBuilder = formBuilder;
        this.agencias = [];
        this.agenciasSet = '';
        this.loading = false;
        console.log(this.dataDialog);
        this.agenciaGroup = this.formBuilder.group({
            formAgencias: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
        });
        this.loading = true;
        this.servicioAgencia.getAllAgencia(0)
            .subscribe(result => {
            this.loading = false;
            this.agencias = result;
        });
    }
    ngOnInit() {
    }
    setAgencias(selected) {
        this.agenciasSet = this.agenciaGroup.controls['formAgencias'].value;
    }
};
DialogAgenciasComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: src_app_servicios_agencia_service__WEBPACK_IMPORTED_MODULE_3__["AgenciaService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] }
];
DialogAgenciasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog-agencias',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog-agencias.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-agencias/dialog-agencias.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog-agencias.component.css */ "./src/app/dialogs/dialog-agencias/dialog-agencias.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Object, src_app_servicios_agencia_service__WEBPACK_IMPORTED_MODULE_3__["AgenciaService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"]])
], DialogAgenciasComponent);



/***/ }),

/***/ "./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.css":
/*!*************************************************************************************!*\
  !*** ./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.css ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".input-size{\r\n  width: 90%;\r\n}\r\n\r\nmat-form-field {\r\n  width: 97%;\r\n}\r\n\r\nmat-list-item:hover{\r\n  background-color: aliceblue !important;\r\n  cursor: pointer;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9kaWFsb2dzL2RpYWxvZy1jb3BpYXItZW5jdWVzdGEvZGlhbG9nLWNvcGlhci1lbmN1ZXN0YS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsVUFBVTtBQUNaOztBQUVBO0VBQ0UsVUFBVTtBQUNaOztBQUVBO0VBQ0Usc0NBQXNDO0VBQ3RDLGVBQWU7QUFDakIiLCJmaWxlIjoiYXBwL2RpYWxvZ3MvZGlhbG9nLWNvcGlhci1lbmN1ZXN0YS9kaWFsb2ctY29waWFyLWVuY3Vlc3RhLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuaW5wdXQtc2l6ZXtcclxuICB3aWR0aDogOTAlO1xyXG59XHJcblxyXG5tYXQtZm9ybS1maWVsZCB7XHJcbiAgd2lkdGg6IDk3JTtcclxufVxyXG5cclxubWF0LWxpc3QtaXRlbTpob3ZlcntcclxuICBiYWNrZ3JvdW5kLWNvbG9yOiBhbGljZWJsdWUgIWltcG9ydGFudDtcclxuICBjdXJzb3I6IHBvaW50ZXI7XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.ts":
/*!************************************************************************************!*\
  !*** ./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.ts ***!
  \************************************************************************************/
/*! exports provided: DialogCopiarEncuestaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogCopiarEncuestaComponent", function() { return DialogCopiarEncuestaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_servicios_encuesta_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/servicios/encuesta.service */ "./src/app/servicios/encuesta.service.ts");



let DialogCopiarEncuestaComponent = class DialogCopiarEncuestaComponent {
    constructor(encuestaService) {
        this.encuestaService = encuestaService;
        this.encuestas = [];
        this.loadingEncuesta = false;
        this.encuestaCopiar = {};
        this.nombreEncuesta = '';
        this.idEncuesta = '';
        this.loadingDetalle = false;
        this.showBtn = 0;
        this.isDetail = false;
        this.numeroPregunta = 0;
    }
    ngOnInit() {
        this.obtenerEncuestas();
    }
    obtenerEncuestas() {
        this.loadingEncuesta = true;
        this.encuestaService.getEncuestas().subscribe(data => {
            this.encuestas = data;
            this.loadingEncuesta = false;
        });
    }
    selectEncuesta(encuesta) {
        this.loadingDetalle = true;
        //console.log(JSON.stringify(encuesta));
        this.nombreEncuesta = encuesta.valor;
        this.idEncuesta = encuesta.id;
        this.encuestaService.getEncuestaCopiar(encuesta.id).subscribe(datos => {
            this.isDetail = true;
            this.encuestaCopiar = datos;
            this.loadingDetalle = false;
            //console.log(JSON.stringify(this.encuestaCopiar));
        });
    }
    selectEdit(event) {
        event.stopPropagation();
        console.log('select edit');
    }
    mouseHover(id) {
        //console.log('hover');
        this.showBtn = id;
    }
    mouseOut() {
        this.showBtn = 0;
        //console.log('out');
    }
    volver() {
        this.nombreEncuesta = '';
        this.idEncuesta = '';
        this.isDetail = false;
    }
    copiarEncuesta() {
        alert(this.idEncuesta);
    }
};
DialogCopiarEncuestaComponent.ctorParameters = () => [
    { type: src_app_servicios_encuesta_service__WEBPACK_IMPORTED_MODULE_2__["EncuestaService"] }
];
DialogCopiarEncuestaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog-copiar-encuesta',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog-copiar-encuesta.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog-copiar-encuesta.component.css */ "./src/app/dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_servicios_encuesta_service__WEBPACK_IMPORTED_MODULE_2__["EncuestaService"]])
], DialogCopiarEncuestaComponent);



/***/ }),

/***/ "./src/app/dialogs/dialog-documento/dialog-documento.component.css":
/*!*************************************************************************!*\
  !*** ./src/app/dialogs/dialog-documento/dialog-documento.component.css ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZGlhbG9ncy9kaWFsb2ctZG9jdW1lbnRvL2RpYWxvZy1kb2N1bWVudG8uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/dialogs/dialog-documento/dialog-documento.component.ts":
/*!************************************************************************!*\
  !*** ./src/app/dialogs/dialog-documento/dialog-documento.component.ts ***!
  \************************************************************************/
/*! exports provided: DialogDocumentoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogDocumentoComponent", function() { return DialogDocumentoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_servicios_imagen_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/servicios/imagen.service */ "./src/app/servicios/imagen.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! jspdf */ "./node_modules/jspdf/dist/jspdf.min.js");
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(jspdf__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");






let DialogDocumentoComponent = class DialogDocumentoComponent {
    constructor(dataDialog, dialogRef, servicioImagen, sanitizer) {
        this.dataDialog = dataDialog;
        this.dialogRef = dialogRef;
        this.servicioImagen = servicioImagen;
        this.sanitizer = sanitizer;
        this.imagenes = [];
        this.imagenesBase64 = [];
        this.loading = false;
        this.dataModified = false;
        this.ordenSAP = dataDialog.ordenSAP;
        this.idServicio = dataDialog.idServicio;
        this.tipoImagen = dataDialog.tipoImagen;
        this.loading = true;
        this.servicioImagen.getImagenes(this.idServicio, this.tipoImagen).subscribe(result => {
            result.forEach(element => {
                this.loading = false;
                this.imagenes.push(this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + element.imagen));
                this.imagenesBase64.push(element.imagen);
            });
        });
    }
    ngOnInit() {
    }
    crearPDF() {
        let doc = new jspdf__WEBPACK_IMPORTED_MODULE_4__('p', 'mm', 'letter');
        let label = '';
        if (this.tipoImagen == 1) {
            label = '-Fotos';
        }
        else if (this.tipoImagen == 2) {
            label = '-Firma';
        }
        else if (this.tipoImagen == 3) {
            label = '-Documentos';
        }
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        let i = 0;
        this.imagenesBase64.forEach(element => {
            doc.addImage(element, 'PNG', 0, 0, width, height);
            i++;
            if (this.imagenesBase64.length > 1 && i < this.imagenesBase64.length) {
                doc.addPage();
            }
        });
        doc.save(this.ordenSAP + label + '.pdf');
    }
};
DialogDocumentoComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialog"] },
    { type: src_app_servicios_imagen_service__WEBPACK_IMPORTED_MODULE_2__["ImagenService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"] }
];
DialogDocumentoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog-documento',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog-documento.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-documento/dialog-documento.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog-documento.component.css */ "./src/app/dialogs/dialog-documento/dialog-documento.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Object, _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialog"],
        src_app_servicios_imagen_service__WEBPACK_IMPORTED_MODULE_2__["ImagenService"],
        _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"]])
], DialogDocumentoComponent);



/***/ }),

/***/ "./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.css":
/*!*******************************************************************************!*\
  !*** ./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.css ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".oscuro{\r\n  font-weight: bolder;\r\n}\r\n\r\nselect {\r\n  -webkit-appearance: none;\r\n     -moz-appearance: none;\r\n          appearance: none;\r\n  background-color: #FAFAFA;\r\n  background-image: url(\"/assets/caret--down-15.png\");\r\n  background-position: right;\r\n  background-repeat: no-repeat;\r\n  border-color: #b3cccc;\r\n  border-radius: .2em;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-right-color: #869999;\r\n  border-bottom-color: #869999;\r\n  color: black;\r\n  padding: .33em .5em;\r\n  width: 80%;\r\n}\r\n\r\nmat-form-field {\r\n  width: 80%;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9kaWFsb2dzL2RpYWxvZy1lZGl0LXBlcnNvbmEvZGlhbG9nLWVkaXQtcGVyc29uYS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsbUJBQW1CO0FBQ3JCOztBQUVBO0VBQ0Usd0JBQWdCO0tBQWhCLHFCQUFnQjtVQUFoQixnQkFBZ0I7RUFDaEIseUJBQXlCO0VBQ3pCLG1EQUFtRDtFQUNuRCwwQkFBMEI7RUFDMUIsNEJBQTRCO0VBQzVCLHFCQUFxQjtFQUNyQixtQkFBbUI7RUFDbkIsbUJBQW1CO0VBQ25CLGlCQUFpQjtFQUNqQiwyQkFBMkI7RUFDM0IsNEJBQTRCO0VBQzVCLFlBQVk7RUFDWixtQkFBbUI7RUFDbkIsVUFBVTtBQUNaOztBQUVBO0VBQ0UsVUFBVTtBQUNaIiwiZmlsZSI6ImFwcC9kaWFsb2dzL2RpYWxvZy1lZGl0LXBlcnNvbmEvZGlhbG9nLWVkaXQtcGVyc29uYS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm9zY3Vyb3tcclxuICBmb250LXdlaWdodDogYm9sZGVyO1xyXG59XHJcblxyXG5zZWxlY3Qge1xyXG4gIGFwcGVhcmFuY2U6IG5vbmU7XHJcbiAgYmFja2dyb3VuZC1jb2xvcjogI0ZBRkFGQTtcclxuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoXCIvYXNzZXRzL2NhcmV0LS1kb3duLTE1LnBuZ1wiKTtcclxuICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiByaWdodDtcclxuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xyXG4gIGJvcmRlci1jb2xvcjogI2IzY2NjYztcclxuICBib3JkZXItcmFkaXVzOiAuMmVtO1xyXG4gIGJvcmRlci1zdHlsZTogc29saWQ7XHJcbiAgYm9yZGVyLXdpZHRoOiAxcHg7XHJcbiAgYm9yZGVyLXJpZ2h0LWNvbG9yOiAjODY5OTk5O1xyXG4gIGJvcmRlci1ib3R0b20tY29sb3I6ICM4Njk5OTk7XHJcbiAgY29sb3I6IGJsYWNrO1xyXG4gIHBhZGRpbmc6IC4zM2VtIC41ZW07XHJcbiAgd2lkdGg6IDgwJTtcclxufVxyXG5cclxubWF0LWZvcm0tZmllbGQge1xyXG4gIHdpZHRoOiA4MCU7XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.ts":
/*!******************************************************************************!*\
  !*** ./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.ts ***!
  \******************************************************************************/
/*! exports provided: DialogEditPersonaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogEditPersonaComponent", function() { return DialogEditPersonaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var src_app_servicios_tipo_documento_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/servicios/tipo-documento.service */ "./src/app/servicios/tipo-documento.service.ts");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_app_servicios_direccion_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/servicios/direccion.service */ "./src/app/servicios/direccion.service.ts");
/* harmony import */ var src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/servicios/usuario.service */ "./src/app/servicios/usuario.service.ts");
/* harmony import */ var src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! src/app/servicios/helper.service */ "./src/app/servicios/helper.service.ts");
/* harmony import */ var src_app_dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! src/app/dynamic-form/dynamic-form.component */ "./src/app/dynamic-form/dynamic-form.component.ts");
/* harmony import */ var src_app_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var src_app_utils_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var src_app_servicios_departamentos_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! src/app/servicios/departamentos.service */ "./src/app/servicios/departamentos.service.ts");
/* harmony import */ var src_app_servicios_ciudades_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! src/app/servicios/ciudades.service */ "./src/app/servicios/ciudades.service.ts");







 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI









let DialogEditPersonaComponent = class DialogEditPersonaComponent {
    constructor(dataDialog, dialogRef, servicePersona, serviceTipoDocumento, servicioDireccion, servicioUsuario, fb, snackBar, helper, servicioFormulario, formatFormulario, servicioDepartamento, servicioCiudad) {
        this.dataDialog = dataDialog;
        this.dialogRef = dialogRef;
        this.servicePersona = servicePersona;
        this.serviceTipoDocumento = serviceTipoDocumento;
        this.servicioDireccion = servicioDireccion;
        this.servicioUsuario = servicioUsuario;
        this.fb = fb;
        this.snackBar = snackBar;
        this.helper = helper;
        this.servicioFormulario = servicioFormulario;
        this.formatFormulario = formatFormulario;
        this.servicioDepartamento = servicioDepartamento;
        this.servicioCiudad = servicioCiudad;
        this.idFormulario = 28; //no se debe repetir
        this.origenParent = 'dialogeditpersona'; //no se debe repetir
        this.parametrosDestino = [];
        this.procedimientoDestino = '';
        this.dataModified = false;
        this.tipoDocumentosSelect = [];
        this.loadingPersona = false;
        this.loadingDetalle = false;
        this.direcciones = [];
        this.usuarios = [];
        this.modificaDireccion = false;
        this.modificaUsuario = false;
        this.creaDireccion = false;
        this.departamentosDireccion = [];
        this.ciudadesDireccion = [];
        /**CREACION DIRECCION */
        this.descripcion = 'Creación De Dirección';
        let response;
        this.servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
            this.procedimientoDestino = data[0].procedimientoDestino;
            response = this.formatFormulario.formatFormulario(data);
            this.items = response.arrayDatos;
            this.parametrosDestino = response.parametros;
            return this.items.sort((a, b) => a.order - b.order);
        });
        /**END CREACION DIRECCION */
        this.personaGroup = this.fb.group({
            IdPersona: [''],
            NroDocId: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            IdTpoIdenti: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            Nombre: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(250)]],
            Apellido: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(250)]],
            FechaNac: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            Telefono: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(30)]]
        });
        this.direccionGroup = this.fb.group({
            nombreDireccion: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            telefono: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(20)]],
            telefono2: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(20)],
            departamento: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            ciudad: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            direccion: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            observacion: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(4000)]
        });
    }
    ngOnInit() {
        console.log(JSON.stringify(this.dataDialog));
        this.loadingDetalle = true;
        this.getPersonaDetalle();
        this.loadingPersona = true;
        this.serviceTipoDocumento.getTiposDocumento().subscribe(result => {
            this.loadingPersona = false;
            this.tipoDocumentosSelect = result;
            this.personaGroup.controls['IdPersona'].setValue(this.dataDialog.IdPersona);
            this.personaGroup.controls['NroDocId'].setValue(this.dataDialog.NroDocId);
            this.personaGroup.controls['IdTpoIdenti'].setValue(this.dataDialog.IdTpoIdenti);
            this.personaGroup.controls['Nombre'].setValue(this.dataDialog.Nombre);
            this.personaGroup.controls['Apellido'].setValue(this.dataDialog.Apellido);
            this.personaGroup.controls['FechaNac'].setValue(this.dataDialog.FechaNac);
            this.personaGroup.controls['Telefono'].setValue(this.dataDialog.Telefono);
        });
        this.servicioDepartamento.getDepartamentos()
            .subscribe(result => {
            //console.log(result);
            this.departamentosDireccion = result;
        });
    }
    getPersonaDetalle() {
        this.servicePersona
            .getPersonaDetalle(this.dataDialog.IdPersona)
            .subscribe(result => {
            this.loadingDetalle = false;
            this.direcciones = result[0];
            this.usuarios = result[1];
        });
    }
    /**CREACION DIRECCION */
    dataFormulario($event) {
        const dataForm = $event;
        if (dataForm.parent === this.origenParent) {
            const respuesta = this.validators(dataForm.datos);
        }
    }
    validators(dataForm) {
        //alert('aqui');
        dataForm.infoPayload.push({
            key: 'idPersona',
            parametro: 'v_IdPersona',
            value: this.dataDialog.IdPersona
        });
        this.servicioFormulario.postFormulario(dataForm).subscribe(data => {
            //this.getPersonaDetalle();      
            this.snackBar.open('Direccion Agregada', 'Crear Dirección', {
                duration: 2000
            });
            this.reset();
        });
        return true;
    }
    reset() {
        this.resetForm.resetForm();
    }
    /**END CREACION DIRECCION */
    ActualizarPersona() {
        this.dialogRef.closeAll();
    }
    crearDireccion() {
        this.modificaDireccion = false;
        //alert(this.creaDireccion);
        this.creaDireccion = !this.creaDireccion;
        //alert(this.creaDireccion);
    }
    editarDireccion(direccion) {
        //alert(JSON.stringify(direccion));
        this.dataModificaDireccion = direccion;
        this.modificaDireccion = true;
        this.creaDireccion = false;
    }
    eliminarDireccion(direccion) {
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default.a.fire({
            title: 'Eliminar Dirección?',
            text: 'Esta seguro que desea eliminar esta dirección!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.servicioDireccion
                    .deleteDireccion(direccion.IdPersonaDireccion)
                    .subscribe(data => {
                    const indexDireccion = this.helper.findIndex(this.direcciones, {
                        IdPersContacto: direccion.IdPersContacto
                    });
                    this.direcciones.splice(indexDireccion, 1);
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    editarUsuario(usuario) {
        //alert(JSON.stringify(direccion));
        this.dataModificaUsuario = usuario;
        this.modificaUsuario = true;
    }
    eliminarUsuario(usuario) {
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default.a.fire({
            title: 'Eliminar Usuario?',
            text: 'Esta seguro que desea eliminar este usuario!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, Eliminar!'
        }).then(result => {
            if (result.value) {
                this.servicioUsuario
                    .deleteUsuario(usuario.IdUsuario)
                    .subscribe(data => {
                    const indexUsuario = this.helper.findIndex(this.usuarios, {
                        IdUsuario: usuario.IdUsuario
                    });
                    this.usuarios.splice(indexUsuario, 1);
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_7___default.a.fire('Eliminado!', 'Registro Eliminado.', 'success');
                });
            }
        });
    }
    submitForm() {
        let persona = this.personaGroup.value;
        persona.FechaNac = moment__WEBPACK_IMPORTED_MODULE_8__(persona.FechaNac, 'YYYY-MM-DD').format('YYYY-MM-DD');
        persona.Nombre = persona.Nombre.toUpperCase();
        persona.Apellido = persona.Apellido.toUpperCase();
        this.servicePersona.putPersona(persona).subscribe(result => {
            this.dataModified = true;
            this.snackBar.open('Persona Actualizada', 'Actualizar Persona', {
                duration: 2000
            });
        });
    }
    procesaPropagar(mensaje) {
        //console.log(mensaje);
        this.loadingDetalle = true;
        this.getPersonaDetalle();
    }
    procesaPropagarDireccion(direccion) {
        this.loadingDetalle = true;
        this.getPersonaDetalle();
    }
    getCiudades(event) {
        const depto = event.target.value;
        this.servicioCiudad.getCiudades(depto)
            .subscribe(result => {
            this.ciudadesDireccion = result;
        });
    }
    resetFormDireccion() {
        this.direccionGroup.controls['nombreDireccion'].setValue('');
        this.direccionGroup.controls['telefono'].setValue('');
        this.direccionGroup.controls['telefono2'].setValue('');
        this.direccionGroup.controls['departamento'].setValue('');
        this.direccionGroup.controls['ciudad'].setValue('');
        this.direccionGroup.controls['direccion'].setValue('');
        this.direccionGroup.controls['observacion'].setValue('');
    }
    nuevaDireccion() {
        let persona = this.direccionGroup.value;
        persona.idPersona = this.dataDialog.IdPersona;
        console.log(JSON.stringify(persona));
        this.servicioDireccion.postDireccion(persona)
            .subscribe(result => {
            this.loadingDetalle = true;
            this.getPersonaDetalle();
            this.resetFormDireccion();
            this.snackBar.open('Dirección Creada', 'Modulo Direccion', {
                duration: 2000
            });
        });
    }
};
DialogEditPersonaComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] },
    { type: src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__["PersonaService"] },
    { type: src_app_servicios_tipo_documento_service__WEBPACK_IMPORTED_MODULE_6__["TipoDocumentoService"] },
    { type: src_app_servicios_direccion_service__WEBPACK_IMPORTED_MODULE_9__["DireccionService"] },
    { type: src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_10__["UsuarioService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_11__["HelperService"] },
    { type: src_app_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_13__["SetFormService"] },
    { type: src_app_utils_utils__WEBPACK_IMPORTED_MODULE_14__["Utils"] },
    { type: src_app_servicios_departamentos_service__WEBPACK_IMPORTED_MODULE_15__["DepartamentosService"] },
    { type: src_app_servicios_ciudades_service__WEBPACK_IMPORTED_MODULE_16__["CiudadesService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('resetForm', { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", src_app_dynamic_form_dynamic_form_component__WEBPACK_IMPORTED_MODULE_12__["DynamicFormComponent"])
], DialogEditPersonaComponent.prototype, "resetForm", void 0);
DialogEditPersonaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog-edit-persona',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog-edit-persona.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog-edit-persona.component.css */ "./src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Object, _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialog"],
        src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__["PersonaService"],
        src_app_servicios_tipo_documento_service__WEBPACK_IMPORTED_MODULE_6__["TipoDocumentoService"],
        src_app_servicios_direccion_service__WEBPACK_IMPORTED_MODULE_9__["DireccionService"],
        src_app_servicios_usuario_service__WEBPACK_IMPORTED_MODULE_10__["UsuarioService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_11__["HelperService"],
        src_app_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_13__["SetFormService"],
        src_app_utils_utils__WEBPACK_IMPORTED_MODULE_14__["Utils"],
        src_app_servicios_departamentos_service__WEBPACK_IMPORTED_MODULE_15__["DepartamentosService"],
        src_app_servicios_ciudades_service__WEBPACK_IMPORTED_MODULE_16__["CiudadesService"]])
], DialogEditPersonaComponent);



/***/ }),

/***/ "./src/app/dialogs/dialog-firma/dialog-firma.component.css":
/*!*****************************************************************!*\
  !*** ./src/app/dialogs/dialog-firma/dialog-firma.component.css ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZGlhbG9ncy9kaWFsb2ctZmlybWEvZGlhbG9nLWZpcm1hLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/dialogs/dialog-firma/dialog-firma.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/dialogs/dialog-firma/dialog-firma.component.ts ***!
  \****************************************************************/
/*! exports provided: DialogFirmaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogFirmaComponent", function() { return DialogFirmaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DialogFirmaComponent = class DialogFirmaComponent {
    constructor() { }
    ngOnInit() {
    }
};
DialogFirmaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog-firma',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog-firma.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-firma/dialog-firma.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog-firma.component.css */ "./src/app/dialogs/dialog-firma/dialog-firma.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], DialogFirmaComponent);



/***/ }),

/***/ "./src/app/dialogs/dialog-producto/dialog-producto.component.css":
/*!***********************************************************************!*\
  !*** ./src/app/dialogs/dialog-producto/dialog-producto.component.css ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZGlhbG9ncy9kaWFsb2ctcHJvZHVjdG8vZGlhbG9nLXByb2R1Y3RvLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/dialogs/dialog-producto/dialog-producto.component.ts":
/*!**********************************************************************!*\
  !*** ./src/app/dialogs/dialog-producto/dialog-producto.component.ts ***!
  \**********************************************************************/
/*! exports provided: DialogProductoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogProductoComponent", function() { return DialogProductoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DialogProductoComponent = class DialogProductoComponent {
    constructor() { }
    ngOnInit() {
    }
};
DialogProductoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog-producto',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog-producto.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-producto/dialog-producto.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog-producto.component.css */ "./src/app/dialogs/dialog-producto/dialog-producto.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], DialogProductoComponent);



/***/ }),

/***/ "./src/app/dialogs/dialog-web-service/dialog-web-service.component.css":
/*!*****************************************************************************!*\
  !*** ./src/app/dialogs/dialog-web-service/dialog-web-service.component.css ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n.timeline{\r\n  --uiTimelineMainColor: var(--timelineMainColor, #222);\r\n  --uiTimelineSecondaryColor: var(--timelineSecondaryColor, #fff);\r\n\r\n  position: relative;\r\n  padding-top: 3rem;\r\n  padding-bottom: 3rem;\r\n}\r\n\r\n.timeline:before{\r\n  content: \"\";\r\n  width: 4px;\r\n  height: 100%;\r\n  background-color: var(--uiTimelineMainColor);\r\n\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n.timeline__group{\r\n  position: relative;\r\n}\r\n\r\n.timeline__group:not(:first-of-type){\r\n  margin-top: 4rem;\r\n}\r\n\r\n.timeline__year{\r\n  padding: .5rem 1.5rem;\r\n  color: var(--uiTimelineSecondaryColor);\r\n  background-color: var(--uiTimelineMainColor);\r\n\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.timeline__box{\r\n  position: relative;\r\n}\r\n\r\n.timeline__box:not(:last-of-type){\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.timeline__box:before{\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 2px;\r\n  background-color: var(--uiTimelineMainColor);\r\n\r\n  position: absolute;\r\n  left: 0;\r\n  z-index: -1;\r\n}\r\n\r\n.timeline__date{\r\n  min-width: 65px;\r\n  position: absolute;\r\n  left: 0;\r\n\r\n  box-sizing: border-box;\r\n  padding: .5rem 1.5rem;\r\n  text-align: center;\r\n\r\n  background-color: var(--uiTimelineMainColor);\r\n  color: var(--uiTimelineSecondaryColor);\r\n  border-radius: 7px;\r\n}\r\n\r\n.timeline__day{\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  display: block;\r\n}\r\n\r\n.timeline__month{\r\n  display: block;\r\n  font-size: .8em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.timeline__post{\r\n  padding: 1.5rem 2rem;\r\n  border-radius: 2px;\r\n  border-left: 3px solid var(--uiTimelineMainColor);\r\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 1px 2px 0 rgba(0, 0, 0, .24);\r\n  background-color: var(--uiTimelineSecondaryColor);\r\n}\r\n\r\n@media screen and (min-width: 641px){\r\n\r\n  .timeline:before{\r\n    left: 30px;\r\n  }\r\n\r\n  .timeline__group{\r\n    padding-top: 25px;\r\n  }\r\n\r\n  .timeline__box{\r\n    padding-left: 80px;\r\n  }\r\n\r\n  .timeline__box:before{\r\n    top: 50%;\r\n    transform: translateY(-50%);  \r\n  }  \r\n\r\n  .timeline__date{\r\n    top: 50%;\r\n    margin-top: -27px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 640px){\r\n\r\n  .timeline:before{\r\n    left: 0;\r\n  }\r\n\r\n  .timeline__group{\r\n    padding-top: 40px;\r\n  }\r\n\r\n  .timeline__box{\r\n    padding-left: 20px;\r\n    padding-top: 70px;\r\n  }\r\n\r\n  .timeline__box:before{\r\n    top: 90px;\r\n  }    \r\n\r\n  .timeline__date{\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.timeline{\r\n  --timelineMainColor: #D5DCE6;\r\n  font-size: 16px;\r\n}\r\n\r\n/*\r\n=====\r\nDEMO\r\n=====\r\n*/\r\n\r\n@media (min-width: 768px){\r\n\r\n  html{\r\n    font-size: 62.5%;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px){\r\n\r\n  html{\r\n    font-size: 55%;\r\n  }\r\n}\r\n\r\nbody{\r\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Open Sans, Ubuntu, Fira Sans, Helvetica Neue, sans-serif;\r\n  font-size: 1.6rem;\r\n  color: #222;\r\n\r\n  background-color: #f0f0f0;\r\n  margin: 0;\r\n  -webkit-overflow-scrolling: touch;   \r\n  overflow-y: scroll;\r\n  \r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\np{\r\n  margin-top: 0;\r\n  margin-bottom: 1.5rem;\r\n  line-height: 1.5;\r\n}\r\n\r\np:last-child{\r\n  margin-bottom: 0;\r\n}\r\n\r\n.page{\r\n  max-width: 800px;\r\n  padding: 10rem 2rem 3rem;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  order: 1;\r\n}\r\n\r\n/* \r\nPatreon\r\n*/\r\n\r\n.r-link{\r\n  --uirLinkDisplay: var(--rLinkDisplay, inline-flex);\r\n  --uirLinkTextColor: var(--rLinkTextColor);\r\n  --uirLinkTextDecoration: var(--rLinkTextDecoration, none);\r\n  display: var(--uirLinkDisplay) !important;\r\n  color: var(--uirLinkTextColor) !important;\r\n  -webkit-text-decoration: var(--uirLinkTextDecoration) !important;\r\n          text-decoration: var(--uirLinkTextDecoration) !important;\r\n}\r\n\r\n.patreon{\r\n  padding-top: 15px;\r\n  padding-bottom: 20px;\r\n  background-color: #fff;\r\n}\r\n\r\n.patreon__container{\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  max-width: 768px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.patreon__msg{\r\n  display: block;\r\n}\r\n\r\n.patreon__link{\r\n  --rLinkTextColor: #fff;\r\n  padding: 10px 30px;\r\n  text-transform: uppercase;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  background-color: #ff6262;\r\n  border-radius: 25px;\r\n  justify-content: center;\r\n}\r\n\r\n@media (max-width: 640px){\r\n  \r\n  .patreon__link{\r\n    margin-top: 12px;\r\n  }\r\n}\r\n\r\n@media (min-width: 641px){\r\n  \r\n  .patreon__container{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .patreon__link{\r\n    flex: none;\r\n    margin-left: 25px;\r\n  }\r\n}\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dialogs/dialog-web-service/dialog-web-service.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/dialogs/dialog-web-service/dialog-web-service.component.ts ***!
  \****************************************************************************/
/*! exports provided: DialogWebServiceComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogWebServiceComponent", function() { return DialogWebServiceComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_servicios_log_ws_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/servicios/log-ws.service */ "./src/app/servicios/log-ws.service.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");





let DialogWebServiceComponent = class DialogWebServiceComponent {
    constructor(dataDialog, servicioLogWS, sanitizer) {
        this.dataDialog = dataDialog;
        this.servicioLogWS = servicioLogWS;
        this.sanitizer = sanitizer;
        this.detalleLogWS = [];
        this.dataModified = false;
        this.red = this.sanitizer.bypassSecurityTrustStyle('#FF0000');
        this.green = this.sanitizer.bypassSecurityTrustStyle('#008000');
        this.idTipoWS = dataDialog.idTipoWS;
        this.idPaquete = dataDialog.idPaquete;
        console.log(dataDialog);
        this.servicioLogWS.getDetalleWS(this.idTipoWS, this.idPaquete)
            .subscribe(result => {
            this.detalleLogWS = result;
            this.detalleLogWS.forEach((element, indice) => {
                this.detalleLogWS[indice].fecha = new Date(element.fecha);
            });
            console.log(this.detalleLogWS);
        });
    }
    ngOnInit() {
    }
};
DialogWebServiceComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_3__["MAT_DIALOG_DATA"],] }] },
    { type: src_app_servicios_log_ws_service__WEBPACK_IMPORTED_MODULE_2__["LogWsService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["DomSanitizer"] }
];
DialogWebServiceComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog-web-service',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog-web-service.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialog-web-service/dialog-web-service.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog-web-service.component.css */ "./src/app/dialogs/dialog-web-service/dialog-web-service.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_3__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Object, src_app_servicios_log_ws_service__WEBPACK_IMPORTED_MODULE_2__["LogWsService"],
        _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["DomSanitizer"]])
], DialogWebServiceComponent);



/***/ }),

/***/ "./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.css":
/*!***********************************************************************************!*\
  !*** ./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.css ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n    width: 98%;\r\n\r\n  }\r\n  \r\n  td {\r\n    /*padding: 3px 10px;*/\r\n    width: 1px;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .form-control{\r\n    display: block;\r\n    margin: 2em auto;\r\n    padding: 0.5em 0.25em;\r\n    border: none;\r\n    border-radius: 0.2em;\r\n    font-size: 1.5em;\r\n    text-align: center;\r\n    box-shadow: 0 0 1em 1em rgba(0,0,0,0.2);\r\n  \r\n \r\n    }\r\n  \r\n  .margen-expansion {\r\n    margin: 5px !important;\r\n  }\r\n  \r\n  body{\r\n    background:\r\n      radial-gradient(closest-corner, rgba(16, 47, 70, 0) 60%, rgba(16, 47, 70, 0.26)),\r\n      linear-gradient(108deg, #26D0CE, #1A2980 90%);\r\n  }\r\n  \r\n  html, body {\r\n    min-height:100vh;\r\n    height: auto;\r\n  }\r\n  \r\n  .input-upper{\r\n    text-transform: uppercase;\r\n} \r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9kaWFsb2dzL2RpYWxvZ28tZW50cmVnYS1udWV2YS9kaWFsb2dvLWVudHJlZ2EtbnVldmEuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFVBQVU7O0VBRVo7O0VBRUE7SUFDRSxxQkFBcUI7SUFDckIsVUFBVTtJQUNWLG1CQUFtQjtFQUNyQjs7RUFFQTtJQUNFLGNBQWM7SUFDZCxnQkFBZ0I7SUFDaEIscUJBQXFCO0lBQ3JCLFlBQVk7SUFDWixvQkFBb0I7SUFDcEIsZ0JBQWdCO0lBQ2hCLGtCQUFrQjtJQUNsQix1Q0FBdUM7OztJQUd2Qzs7RUFFRjtJQUNFLHNCQUFzQjtFQUN4Qjs7RUFDQTtJQUNFOzttREFFK0M7RUFDakQ7O0VBQ0E7SUFDRSxnQkFBZ0I7SUFDaEIsWUFBWTtFQUNkOztFQUNBO0lBQ0UseUJBQXlCO0FBQzdCIiwiZmlsZSI6ImFwcC9kaWFsb2dzL2RpYWxvZ28tZW50cmVnYS1udWV2YS9kaWFsb2dvLWVudHJlZ2EtbnVldmEuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIm1hdC1mb3JtLWZpZWxkIHtcclxuICAgIHdpZHRoOiA5OCU7XHJcblxyXG4gIH1cclxuICBcclxuICB0ZCB7XHJcbiAgICAvKnBhZGRpbmc6IDNweCAxMHB4OyovXHJcbiAgICB3aWR0aDogMXB4O1xyXG4gICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcclxuICB9XHJcbiAgXHJcbiAgLmZvcm0tY29udHJvbHtcclxuICAgIGRpc3BsYXk6IGJsb2NrO1xyXG4gICAgbWFyZ2luOiAyZW0gYXV0bztcclxuICAgIHBhZGRpbmc6IDAuNWVtIDAuMjVlbTtcclxuICAgIGJvcmRlcjogbm9uZTtcclxuICAgIGJvcmRlci1yYWRpdXM6IDAuMmVtO1xyXG4gICAgZm9udC1zaXplOiAxLjVlbTtcclxuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcclxuICAgIGJveC1zaGFkb3c6IDAgMCAxZW0gMWVtIHJnYmEoMCwwLDAsMC4yKTtcclxuICBcclxuIFxyXG4gICAgfVxyXG4gIFxyXG4gIC5tYXJnZW4tZXhwYW5zaW9uIHtcclxuICAgIG1hcmdpbjogNXB4ICFpbXBvcnRhbnQ7XHJcbiAgfVxyXG4gIGJvZHl7XHJcbiAgICBiYWNrZ3JvdW5kOlxyXG4gICAgICByYWRpYWwtZ3JhZGllbnQoY2xvc2VzdC1jb3JuZXIsIHJnYmEoMTYsIDQ3LCA3MCwgMCkgNjAlLCByZ2JhKDE2LCA0NywgNzAsIDAuMjYpKSxcclxuICAgICAgbGluZWFyLWdyYWRpZW50KDEwOGRlZywgIzI2RDBDRSwgIzFBMjk4MCA5MCUpO1xyXG4gIH1cclxuICBodG1sLCBib2R5IHtcclxuICAgIG1pbi1oZWlnaHQ6MTAwdmg7XHJcbiAgICBoZWlnaHQ6IGF1dG87XHJcbiAgfVxyXG4gIC5pbnB1dC11cHBlcntcclxuICAgIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XHJcbn0gIl19 */");

/***/ }),

/***/ "./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.ts":
/*!**********************************************************************************!*\
  !*** ./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.ts ***!
  \**********************************************************************************/
/*! exports provided: MY_FORMATS, DialogoEntregaNuevaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogoEntregaNuevaComponent", function() { return DialogoEntregaNuevaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../servicios/servicio-gestion-cargue.service */ "./src/app/servicios/servicio-gestion-cargue.service.ts");
/* harmony import */ var _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");








 // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI


const MY_FORMATS = {
    parse: {
        dateInput: "YYYY-MM-DD",
    },
    display: {
        dateInput: "YYYY-MM-DD",
        monthYearLabel: "YYYY-MM-DD",
        dateA11yLabel: "YYYY-MM-DD",
        monthYearA11yLabel: "YYYY-MM-DD",
    },
};
let DialogoEntregaNuevaComponent = class DialogoEntregaNuevaComponent {
    constructor(dialogRef, data, formBuilder, servicioGestionCargue, servicioAgencias) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.servicioGestionCargue = servicioGestionCargue;
        this.servicioAgencias = servicioAgencias;
        this.CurrUsuarioConsulta = 0;
        this.agencias = [];
        this.usuarioConsulta = '';
        this.infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        this.usuarioConsulta = this.infoUsuario[0].IdUsuario;
        this.controlesCargue = this.formBuilder.group({
            agencia: [0, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, this.customValidatorAgenciaFn()]],
            ordenSap: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            entrega: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            pedido: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            nombre: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            telefono: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            direccion: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            ciudad: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            articulo: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            tienda: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            cantidad: [1, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            fechaEnt: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            ruta: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            cedula: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            placa: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            cdr: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            estado: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            fechaCarga: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            fechaVenta: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            tipoEntrega: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]
        });
    }
    ngOnInit() {
        this.cargarAgencias();
    }
    cargarAgencias() {
        this.servicioAgencias.getAgencia(this.infoUsuario[0].IdUsuario, 0)
            .subscribe(result => {
            this.agencias = result;
            this.controlesCargue.controls['agencia'].setValue('0');
            //console.log(this.agencias);
        });
    }
    guardarDocumento() {
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.fire({
            title: 'Guardando datos !',
            html: 'Un momento por favor.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            showConfirmButton: false,
            onBeforeOpen() {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.showLoading();
            },
        });
        let FechaCarga = moment__WEBPACK_IMPORTED_MODULE_4__(this.controlesCargue.controls["fechaCarga"].value, "YYYY-MM-DD").format("DD/MM/YYYY");
        let FechaVenta = moment__WEBPACK_IMPORTED_MODULE_4__(this.controlesCargue.controls["fechaVenta"].value, "YYYY-MM-DD").format("DD/MM/YYYY");
        let FechaEntrega = moment__WEBPACK_IMPORTED_MODULE_4__(this.controlesCargue.controls["fechaEnt"].value, "YYYY-MM-DD").format("DD/MM/YYYY");
        let entrega = {
            idUsuarioConsulta: this.usuarioConsulta,
            idAgencia: this.controlesCargue.controls["agencia"].value,
            ordenSap: this.controlesCargue.controls["ordenSap"].value,
            entrega: this.controlesCargue.controls["entrega"].value,
            pedido: this.controlesCargue.controls["pedido"].value,
            nombre: this.controlesCargue.controls["nombre"].value,
            telefono: this.controlesCargue.controls["telefono"].value,
            direccion: this.controlesCargue.controls["direccion"].value,
            ciudad: this.controlesCargue.controls["ciudad"].value,
            articulo: this.controlesCargue.controls["articulo"].value,
            tienda: this.controlesCargue.controls["tienda"].value,
            cantidad: this.controlesCargue.controls["cantidad"].value,
            fechaEnt: FechaEntrega,
            ruta: this.controlesCargue.controls["ruta"].value,
            cedula: this.controlesCargue.controls["cedula"].value,
            placa: this.controlesCargue.controls["placa"].value,
            cdr: this.controlesCargue.controls["cdr"].value,
            estado: this.controlesCargue.controls["estado"].value,
            fechaCarga: FechaCarga,
            fechaVenta: FechaVenta,
            tipoEntrega: this.controlesCargue.controls["tipoEntrega"].value
        };
        console.log(entrega);
        this.servicioGestionCargue
            .EntregaNueva(entrega)
            .subscribe(() => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.close();
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_8___default.a.fire({
                title: "Cargue Guardado",
                text: "Se ha guardado el cargue con exito.",
                type: "success",
                confirmButtonColor: '#127570',
                allowOutsideClick: false,
            }).then((result) => {
                this.dataSalida = {
                    resultado: 'OK',
                };
                this.dialogRef.close(this.dataSalida);
            });
        });
        // this.servicioGestionCargue
        //   .EntregaVerificar(entrega)
        //   .subscribe((result) => {
        //     if (result.length == 0) {
        //       this.servicioGestionCargue
        //         .EntregaNueva(entrega)
        //         .subscribe(() => {
        //           Swal.close();
        //           Swal.fire({
        //             title: "Cargue Guardado",
        //             text: "Se ha guardado el cargue con exito.",
        //             type: "success",
        //             confirmButtonColor: '#127570',
        //             allowOutsideClick: false,
        //           }).then((result) => {
        //             this.dataSalida = {
        //               resultado: 'OK',
        //             };
        //             this.dialogRef.close(this.dataSalida);
        //           }
        //           );
        //         });
        //     }
        //     else{
        //       console.log(result);
        //       Swal.close();
        //       Swal.fire({
        //         title: "Cargue Atencion",
        //         text: "Este cargue ya se encuentra programado.",
        //         type: "warning",
        //         confirmButtonColor: '#127570',
        //         allowOutsideClick: false,
        //       });
        //     }
        //   });
    }
    customValidatorAgenciaFn() {
        return (control) => {
            const valid = (control.value > 0);
            return valid ? null : { amountMinError: true };
        };
    }
    cancelar() {
        this.dataSalida = {
            resultado: 'KO',
        };
        this.dialogRef.close(this.dataSalida);
    }
};
DialogoEntregaNuevaComponent.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_7__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_6__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_9__["ServicioGestionCargueService"] },
    { type: _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_10__["AgenciaService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_6__["ViewChild"])(_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormGroupDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormGroupDirective"])
], DialogoEntregaNuevaComponent.prototype, "formGroupDirective", void 0);
DialogoEntregaNuevaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_6__["Component"])({
        selector: 'app-dialogo-entrega-nueva',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialogo-entrega-nueva.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_3__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MAT_DATE_LOCALE"]],
            },
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_2__["MAT_DATE_FORMATS"], useValue: MY_FORMATS
            }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialogo-entrega-nueva.component.css */ "./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_6__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material__WEBPACK_IMPORTED_MODULE_7__["MatDialogRef"], Object, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_9__["ServicioGestionCargueService"],
        _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_10__["AgenciaService"]])
], DialogoEntregaNuevaComponent);



/***/ }),

/***/ "./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.css":
/*!*************************************************************************************!*\
  !*** ./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.css ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("mat-form-field {\r\n  width: 98%;\r\n}\r\n\r\ntd {\r\n  /*padding: 3px 10px;*/\r\n  width: 1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.form-control{\r\n  display: block;\r\n  margin: 2em auto;\r\n  padding: 0.5em 0.25em;\r\n  border: none;\r\n  border-radius: 0.2em;\r\n  font-size: 1.5em;\r\n  text-align: center;\r\n  box-shadow: 0 0 1em 1em rgba(0,0,0,0.2);\r\n}\r\n\r\n.margen-expansion {\r\n  margin: 5px !important;\r\n}\r\n\r\nbody{\r\n  background:\r\n    radial-gradient(closest-corner, rgba(16, 47, 70, 0) 60%, rgba(16, 47, 70, 0.26)),\r\n    linear-gradient(108deg, #26D0CE, #1A2980 90%);\r\n}\r\n\r\nhtml, body {\r\n  min-height:100vh;\r\n  height: auto;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9kaWFsb2dzL2RpYWxvZ28tZ2VzdGlvbi1jYXJndWUvZGlhbG9nby1nZXN0aW9uLWNhcmd1ZS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsVUFBVTtBQUNaOztBQUVBO0VBQ0UscUJBQXFCO0VBQ3JCLFVBQVU7RUFDVixtQkFBbUI7QUFDckI7O0FBRUE7RUFDRSxjQUFjO0VBQ2QsZ0JBQWdCO0VBQ2hCLHFCQUFxQjtFQUNyQixZQUFZO0VBQ1osb0JBQW9CO0VBQ3BCLGdCQUFnQjtFQUNoQixrQkFBa0I7RUFDbEIsdUNBQXVDO0FBQ3pDOztBQUVBO0VBQ0Usc0JBQXNCO0FBQ3hCOztBQUNBO0VBQ0U7O2lEQUUrQztBQUNqRDs7QUFDQTtFQUNFLGdCQUFnQjtFQUNoQixZQUFZO0FBQ2QiLCJmaWxlIjoiYXBwL2RpYWxvZ3MvZGlhbG9nby1nZXN0aW9uLWNhcmd1ZS9kaWFsb2dvLWdlc3Rpb24tY2FyZ3VlLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJtYXQtZm9ybS1maWVsZCB7XHJcbiAgd2lkdGg6IDk4JTtcclxufVxyXG5cclxudGQge1xyXG4gIC8qcGFkZGluZzogM3B4IDEwcHg7Ki9cclxuICB3aWR0aDogMXB4O1xyXG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XHJcbn1cclxuXHJcbi5mb3JtLWNvbnRyb2x7XHJcbiAgZGlzcGxheTogYmxvY2s7XHJcbiAgbWFyZ2luOiAyZW0gYXV0bztcclxuICBwYWRkaW5nOiAwLjVlbSAwLjI1ZW07XHJcbiAgYm9yZGVyOiBub25lO1xyXG4gIGJvcmRlci1yYWRpdXM6IDAuMmVtO1xyXG4gIGZvbnQtc2l6ZTogMS41ZW07XHJcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG4gIGJveC1zaGFkb3c6IDAgMCAxZW0gMWVtIHJnYmEoMCwwLDAsMC4yKTtcclxufVxyXG5cclxuLm1hcmdlbi1leHBhbnNpb24ge1xyXG4gIG1hcmdpbjogNXB4ICFpbXBvcnRhbnQ7XHJcbn1cclxuYm9keXtcclxuICBiYWNrZ3JvdW5kOlxyXG4gICAgcmFkaWFsLWdyYWRpZW50KGNsb3Nlc3QtY29ybmVyLCByZ2JhKDE2LCA0NywgNzAsIDApIDYwJSwgcmdiYSgxNiwgNDcsIDcwLCAwLjI2KSksXHJcbiAgICBsaW5lYXItZ3JhZGllbnQoMTA4ZGVnLCAjMjZEMENFLCAjMUEyOTgwIDkwJSk7XHJcbn1cclxuaHRtbCwgYm9keSB7XHJcbiAgbWluLWhlaWdodDoxMDB2aDtcclxuICBoZWlnaHQ6IGF1dG87XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.ts":
/*!************************************************************************************!*\
  !*** ./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.ts ***!
  \************************************************************************************/
/*! exports provided: DialogoGestionCargueComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogoGestionCargueComponent", function() { return DialogoGestionCargueComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../servicios/servicio-gestion-cargue.service */ "./src/app/servicios/servicio-gestion-cargue.service.ts");





 // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let DialogoGestionCargueComponent = class DialogoGestionCargueComponent {
    constructor(dialogRef, data, formBuilder, servicioGestionCargue) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.servicioGestionCargue = servicioGestionCargue;
        this.CurrUsuarioConsulta = 0;
        this.dataMotivos = [];
        this.dataPaquetes = [];
        this.idNovedad = 0;
        this.controlPaqueteMotivo = new _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormArray"]([]);
        const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
        this.CurrUsuarioConsulta = infoUsuario[0].IdUsuario;
        this.controlesGroup = this.formBuilder.group({
            Observaciones: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            RbgNovedad: [0, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]
        } /*,{ updateOn: "blur" }*/);
    }
    ngOnInit() {
        this.entregaAct = this.data.entrega;
        console.log(this.data);
        this.CargarMotivos();
        this.CargarPaquetes();
        console.log(this.entregaAct);
    }
    CargarMotivos() {
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.fire({
            title: 'Cargando datos !',
            html: 'Un momento por favor.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            showConfirmButton: false,
            onBeforeOpen() {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.showLoading();
            },
        });
        this.servicioGestionCargue.MotivosConsultar(3).subscribe((data) => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.close();
            this.dataMotivos = data;
        });
    }
    CargarPaquetes() {
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.fire({
            title: 'Cargando datos !',
            html: 'Un momento por favor.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            showConfirmButton: false,
            onBeforeOpen() {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.showLoading();
            },
        });
        this.servicioGestionCargue.PaquetesConsultar(this.entregaAct.idServicioEnc).subscribe((data) => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.close();
            this.dataPaquetes = data;
            for (let i = 0; i < this.dataPaquetes.length; i++) {
                this.controlesGroup.addControl("ctrl_" + this.dataPaquetes[i].idServicioPaquete, new _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormControl"](null, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, , this.customValidator()]));
                // this.controlPaqueteMotivo.push(
                // );
            }
        });
    }
    customValidator() {
        return (control) => {
            const valid = (this.idNovedad == 1 && control.value == 31 || (this.idNovedad == 2 && control.value != 0));
            console.log(valid);
            return valid ? null : { amountMinError: true };
        };
    }
    setMotivo() {
        let valueMotivo = 0;
        valueMotivo = this.idNovedad == 1 ? 31 : 0;
        for (let i = 0; i < this.dataPaquetes.length; i++) {
            this.controlesGroup.get("ctrl_" + this.dataPaquetes[i].idServicioPaquete).setValue(valueMotivo);
        }
    }
    terminarGestionCargue() {
        let gestion;
        let paquetesGestion = [];
        for (let i = 0; i < this.dataPaquetes.length; i++) {
            let paquete = {
                idServicioPaquete: this.dataPaquetes[i].idServicioPaquete,
                idMotivo: this.idNovedad == 1 ? 1 : this.controlesGroup.get("ctrl_" + this.dataPaquetes[i].idServicioPaquete).value,
                cantidadFinal: 0
            };
            paquetesGestion.push(paquete);
        }
        gestion = {
            idUsuarioConsulta: this.CurrUsuarioConsulta,
            idServicioEnc: this.entregaAct.idServicioEnc,
            idMotivo: this.idNovedad == 1 ? 1 : 14,
            idTpoNovedad: this.idNovedad,
            observaciones: this.controlesGroup.get("Observaciones").value,
            paquetes: paquetesGestion
        };
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.fire({
            title: 'Guardando datos !',
            html: 'Un momento por favor.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            showConfirmButton: false,
            onBeforeOpen() {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.showLoading();
            },
        });
        this.servicioGestionCargue
            .EntregaGuardar(gestion)
            .subscribe(() => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.close();
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.fire({
                title: "Cargue Guardado",
                text: "Se ha guardado el cargue con exito.",
                type: "success",
                confirmButtonColor: '#127570',
                allowOutsideClick: false,
            }).then((result) => {
                this.enviarEntregaEorder(this.entregaAct.idUsuarioAsignado);
            });
        });
    }
    enviarEntregaEorder(idUsuario) {
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.fire({
            title: 'Enviando a EORDER !',
            html: 'Un momento por favor.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            showConfirmButton: false,
            onBeforeOpen() {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.showLoading();
            },
        });
        const link = document.createElement("a");
        link.setAttribute("target", "_blank");
        link.setAttribute("href", "http://18.210.107.20/cncaldas_bifrost_qa/api/DataBaseSync/Respaldo/un/" + idUsuario + "/amb/300");
        //link.setAttribute("download",tipo + consecutivoSiigo + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.close();
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_5___default.a.fire({
            title: "Cargue Enviado",
            text: "Se ha Enviado el cargue por favor verifique el resultado de la transacción.",
            type: "warning",
            confirmButtonColor: '#127570',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                this.dataSalida = {
                    resultado: 'OK',
                };
                this.dialogRef.close(this.dataSalida);
            }
        });
        // this.servicioGestionCargue
        // .EntregasProcesar(idUsuario)
        // .subscribe(() => {
        // }
        // );
    }
    cancelar() {
        this.dataSalida = {
            resultado: 'KO',
        };
        this.dialogRef.close(this.dataSalida);
    }
};
DialogoGestionCargueComponent.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_6__["ServicioGestionCargueService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["ViewChild"])(_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormGroupDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormGroupDirective"])
], DialogoGestionCargueComponent.prototype, "formGroupDirective", void 0);
DialogoGestionCargueComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'app-dialogo-gestion-cargue',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialogo-gestion-cargue.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialogo-gestion-cargue.component.css */ "./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialogRef"], Object, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_6__["ServicioGestionCargueService"]])
], DialogoGestionCargueComponent);



/***/ }),

/***/ "./src/app/dynamic-form-contenido/dynamic-form-contenido.component.css":
/*!*****************************************************************************!*\
  !*** ./src/app/dynamic-form-contenido/dynamic-form-contenido.component.css ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".classError {\r\n  color: #E01010 !important;\r\n}\r\n\r\nselect {\r\n  -webkit-appearance: none;\r\n     -moz-appearance: none;\r\n          appearance: none;\r\n  background-color: #FAFAFA;\r\n  background-image: url(\"/assets/caret--down-15.png\");\r\n  background-position: right;\r\n  background-repeat: no-repeat;\r\n  border-color: #b3cccc;\r\n  border-radius: .2em;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-right-color: #869999;\r\n  border-bottom-color: #869999;\r\n  color: black;\r\n  padding: .33em .5em;\r\n  width: 80%;\r\n}\r\n\r\ninput {\r\n  width: 80%;\r\n}\r\n\r\nselect::-ms-expand {\r\n  display: none;\r\n}\r\n\r\nmat-form-field {\r\n  width: 80%;\r\n}\r\n\r\n.form-input {\r\n  margin: 40px 0;\r\n  width: 100%;\r\n}\r\n\r\n.form-input label {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  min-height: 45px;\r\n}\r\n\r\n.form-input .placeholder {\r\n  position: absolute;\r\n  display: block;\r\n  top: 23px;\r\n  z-index: 2;\r\n  font-size: 16px;\r\n  transition: all 200ms ease-in-out;\r\n  width: 100%;\r\n  cursor: text;\r\n}\r\n\r\n.form-input input {\r\n  position: absolute;\r\n  top: 15px;\r\n  z-index: 1;\r\n  width: 100%;\r\n  font-size: 16px;\r\n  border: 0;\r\n  border-bottom: 1px solid grey;\r\n  transition: border-color 200ms ease-in-out;\r\n  outline: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.form-input input {\r\n  height: 30px;\r\n}\r\n\r\n.form-input input:focus,\r\n.form-input input:valid {\r\n  border-bottom: 1px solid grey;\r\n}\r\n\r\n.form-input input:focus + .placeholder,\r\n.form-input input:valid + .placeholder {\r\n  top: 0;\r\n  cursor: inherit;\r\n  font-size: 10px;\r\n  color: grey;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/dynamic-form-contenido/dynamic-form-contenido.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/dynamic-form-contenido/dynamic-form-contenido.component.ts ***!
  \****************************************************************************/
/*! exports provided: MY_FORMATS, DynamicFormContenidoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicFormContenidoComponent", function() { return DynamicFormContenidoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _model_form_estructura_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../model-form/estructura-base */ "./src/app/model-form/estructura-base.ts");
/* harmony import */ var _servicios_dropdown_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/dropdown.service */ "./src/app/servicios/dropdown.service.ts");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");







const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD'
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY-MM-DD',
        dateA11yLabel: 'YYYY-MM-DD',
        monthYearA11yLabel: 'YYYY-MM-DD'
    }
};
let DynamicFormContenidoComponent = class DynamicFormContenidoComponent {
    constructor(servicioCargaInformacion) {
        this.servicioCargaInformacion = servicioCargaInformacion;
        this.cargando = false;
        this.minDatePadre = new Date(2010, 1, 1);
        this.maxDatePadre = new Date(2020, 0, 1);
        this.minDateHijo = new Date(2010, 1, 1);
        this.maxDateHijo = new Date(2020, 0, 1);
        this.dateController1 = true;
        this.dateController2 = true;
        this.nombre = 'jose';
    }
    ngOnInit() {
        //alert(JSON.stringify(this.item));
        /*$(document).ready(function(){
          $(".fecha-calendar").datepicker({
            dateFormat: 'yy-mm-dd',
            onSelect: function(fechaParam) {
             let elemento = $(this).attr('id');
             let tipo = $(this).attr("data-title");
    
    
             if (tipo == 'padre') {
              let fechaHijo = this.form.controls[elemento].value;
              let fechaPadre = fechaParam;
              if (fechaPadre > fechaHijo) {//SI LA FECHA INICIAL ES IGUAL
    
              }
    
              let minDate = $(this).datepicker('getDate');
              alert(minDate);
              $("#"+elemento).datepicker( "option", "minDate", minDate);
            }
            else if (tipo == 'hijo') {
              let fechaPadre = this.form.controls[elemento].value;
              let fechaHijo = fechaParam;
    
    
            }
    
    
            }
          });
    
    
    
          $(".fecha-calendar").datepicker().datepicker("setDate", new Date());
    
        });*/
    }
    /*ngAfterViewInit(): void {
      $.widget("custom.combobox", {
        _create: function () {
          this.wrapper = $("<span>")
            .addClass("custom-combobox")
            .insertAfter(this.element);
  
          this.element.hide();
          this._createAutocomplete();
          this._createShowAllButton();
        },
  
        _createAutocomplete: function () {
          var selected = this.element.children(":selected"),
            value = selected.val() ? selected.text() : "";
  
          this.input = $("<input>")
            .appendTo(this.wrapper)
            .val(value)
            .attr("title", "")
            .addClass("custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left")
            .autocomplete({
              delay: 0,
              minLength: 0,
              source: $.proxy(this, "_source")
            })
            .tooltip({
              classes: {
                "ui-tooltip": "ui-state-highlight"
              }
            });
  
          this._on(this.input, {
            autocompleteselect: function (event, ui) {
              ui.item.option.selected = true;
              this._trigger("select", event, {
                item: ui.item.option
              });
            },
  
            autocompletechange: "_removeIfInvalid"
          });
        },
  
        _createShowAllButton: function () {
          var input = this.input,
            wasOpen = false;
  
          $("<a>")
            .attr("tabIndex", -1)
            .attr("title", "Show All Items")
            .tooltip()
            .appendTo(this.wrapper)
            .button({
              icons: {
                primary: "ui-icon-triangle-1-s"
              },
              text: false
            })
            .removeClass("ui-corner-all")
            .addClass("custom-combobox-toggle ui-corner-right")
            .on("mousedown", function () {
              wasOpen = input.autocomplete("widget").is(":visible");
            })
            .on("click", function () {
              input.trigger("focus");
  
              // Close if already visible
              if (wasOpen) {
                return;
              }
  
              // Pass empty string as value to search for, displaying all results
              input.autocomplete("search", "");
            });
        },
  
        _source: function (request, response) {
          var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
          response(this.element.children("option").map(function () {
            var text = $(this).text();
            if (this.value && (!request.term || matcher.test(text)))
              return {
                label: text,
                value: text,
                option: this
              };
          }));
        },
  
        _removeIfInvalid: function (event, ui) {
  
          // Selected an item, nothing to do
          if (ui.item) {
            return;
          }
  
          // Search for a match (case-insensitive)
          var value = this.input.val(),
            valueLowerCase = value.toLowerCase(),
            valid = false;
          this.element.children("option").each(function () {
            if ($(this).text().toLowerCase() === valueLowerCase) {
              this.selected = valid = true;
              return false;
            }
          });
  
          // Found a match, nothing to do
          if (valid) {
            return;
          }
  
          // Remove invalid value
          this.input
            .val("")
            .attr("title", value + " didn't match any item")
            .tooltip("open");
          this.element.val("");
          this._delay(function () {
            this.input.tooltip("close").attr("title", "");
          }, 2500);
          this.input.autocomplete("instance").term = "";
        },
  
        _destroy: function () {
          this.wrapper.remove();
          this.element.show();
        }
      });
  
      $(".combobox").combobox();
      $("#toggle").on("click", function () {
        $(".combobox").toggle();
      });
    }*/
    cargaDropDown(origenDatos, opt, label) {
        //alert(origenDatos);
        this.id = this.form.get(opt).value;
        //alert(origenDatos);
        //this.form.get(origenDatos)
        //alert(JSON.stringify(this.form.get(origenDatos)));
        this.cargando = true;
        this.servicioCargaInformacion
            .getData(origenDatos, this.id)
            .subscribe(data => {
            //this.dataFiltered=data;
            //alert(origenDatos);
            /*$("#" + origenDatos)
              .empty();*/
            $('#' + origenDatos)
                .find('option')
                .not(':first')
                .remove();
            /*$("#" + origenDatos)
            .append('<option value="" disabled selected>' + label + '</option>');*/
            data.forEach(element => {
                $('#' + origenDatos).append('<option value="' + element.id + '">' + element.valor + '</option>');
            });
            //$("#"+origenDatos+" option:eq(0)").attr("selected","selected");
            $('#' + origenDatos).val('');
            this.form.controls[origenDatos].setValue('');
            this.cargando = false;
            //$("#" + origenDatos).selectmenu().selectmenu('refresh', true);
        });
    }
    setValue() { }
    seleccionaFecha(event, tipo, elemento) {
        if (tipo == 'padre') {
            let fechaHijo = this.form.controls[elemento].value;
            let fechaPadre = event.value;
            if (fechaPadre > fechaHijo) {
                //SI LA FECHA INICIAL ES IGUAL
                this.form.controls[elemento].setValue(fechaPadre);
            }
            this.minDateHijo = new Date(2019, 1, 23);
            //alert(this.minDateHijo);
        }
        else if (tipo == 'hijo') {
            let fechaPadre = this.form.controls[elemento].value;
            let fechaHijo = event.value;
        }
    }
    padre(event, tipo, elemento) {
        //this.minDateHijo = new Date(2019, 1, 19);
        //this.minDatePadre = new Date(2019, 1, 15);
        //this.nombre="Pablo";
        //alert("aqui");
        /*setTimeout(function () {
          this.dateController2=true;
       }, 300);*/
        //alert(event.value);
        //event.stopPropagation();
        /*alert(event.value);
        alert(this.form.controls[elemento].value);
        let fechaPadre = _moment(event.value).format('YYYY-MM-DD');
        if(fechaPadre>this.form.controls[elemento].value){
          alert("fecha inicial mayor a fecha final");
        }*/
    }
    get isValid() {
        return this.form.controls[this.item.key].valid;
    }
    get Error() {
        // alert(this.form.controls[this.item.key].errors);
        return this.form.controls[this.item.key].errors;
    }
};
DynamicFormContenidoComponent.ctorParameters = () => [
    { type: _servicios_dropdown_service__WEBPACK_IMPORTED_MODULE_4__["DropdownService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _model_form_estructura_base__WEBPACK_IMPORTED_MODULE_3__["EstructuraBase"])
], DynamicFormContenidoComponent.prototype, "item", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormGroup"])
], DynamicFormContenidoComponent.prototype, "form", void 0);
DynamicFormContenidoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dynamic-form-contenido',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dynamic-form-contenido.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-form-contenido/dynamic-form-contenido.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_5__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MAT_DATE_LOCALE"]]
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dynamic-form-contenido.component.css */ "./src/app/dynamic-form-contenido/dynamic-form-contenido.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_dropdown_service__WEBPACK_IMPORTED_MODULE_4__["DropdownService"]])
], DynamicFormContenidoComponent);



/***/ }),

/***/ "./src/app/dynamic-form/dynamic-form.component.css":
/*!*********************************************************!*\
  !*** ./src/app/dynamic-form/dynamic-form.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZHluYW1pYy1mb3JtL2R5bmFtaWMtZm9ybS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/dynamic-form/dynamic-form.component.ts":
/*!********************************************************!*\
  !*** ./src/app/dynamic-form/dynamic-form.component.ts ***!
  \********************************************************/
/*! exports provided: MY_FORMATS, DynamicFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicFormComponent", function() { return DynamicFormComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_estructura_control_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../servicios/estructura-control.service */ "./src/app/servicios/estructura-control.service.ts");
/* harmony import */ var _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");




 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI



const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD'
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY-MM-DD',
        dateA11yLabel: 'YYYY-MM-DD',
        monthYearA11yLabel: 'YYYY-MM-DD'
    }
};
let DynamicFormComponent = class DynamicFormComponent {
    constructor(fcs, servicioFormulario) {
        this.fcs = fcs;
        this.servicioFormulario = servicioFormulario;
        this.items = [];
        this.dataFormulario = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.payLoad = '';
        this.expandido = true;
    }
    ngOnInit() { }
    ngOnChanges() {
        this.form = this.fcs.toFormGroup(this.items);
    }
    isValidDate(value) {
        const dateWrapper = new Date(value);
        return !isNaN(dateWrapper.getDate());
    }
    onSubmit() {
        this.payLoad = JSON.stringify(this.form.value);
        const arrNumber = [];
        $('input[data-date]').each(function () {
            arrNumber.push($(this).val());
            const nFecha = moment__WEBPACK_IMPORTED_MODULE_5__($(this).val(), 'YYYY-MM-DD').format('YYYY-MM-DD');
            $(this).val(nFecha);
        });
        if (arrNumber.length == 2) {
            /*let date1 = new Date(arrNumber[0]);
        let date2 = new Date(arrNumber[1]);
        let fechaInicial = _moment(date1).format('YYYY-MM-DD');
        let fechaFinal = _moment(date2).format('YYYY-MM-DD');
        alert(fechaInicial);
        alert(fechaFinal);
        if(fechaInicial>fechaFinal){
          alert("fecha inicial mayor");
        }  */
            if (arrNumber[0] > arrNumber[1]) {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_4___default.a.fire({
                    title: this.descripcion,
                    text: 'La fecha inicial no debe ser mayor a la final. revise.',
                    type: 'error'
                });
                return;
            }
        }
        const jsonPayload = this.form.value;
        this.parametrosDestino.forEach((element, indexDestino) => {
            for (const key in jsonPayload) {
                if (jsonPayload.hasOwnProperty(element.key)) {
                    const index = key.indexOf(element.key);
                    if (index !== -1) {
                        if (key.includes('fecha')) {
                            jsonPayload[key] = moment__WEBPACK_IMPORTED_MODULE_5__(jsonPayload[key], 'YYYY-MM-DD').format('YYYY-MM-DD');
                        }
                        this.parametrosDestino[indexDestino].value = jsonPayload[key];
                    }
                }
            }
        });
        const infoPayload = {
            procedimientoDestino: this.procedimientoDestino,
            infoPayload: this.parametrosDestino
        };
        const dataResponse = {
            parent: this.origenParent,
            datos: infoPayload
        };
        this.dataFormulario.emit(dataResponse);
        /*this.servicioFormulario.postFormulario(infoPayload).subscribe(data => {
          Swal.fire({
            title: this.descripcion,
            text: 'Informacion Almacenada Correctamente.',
            type: 'success'
          });
        });
    
    
        this.form.reset();
        $(':input').val('');
        $(':select').val('');*/
    }
    resetForm() {
        this.form.reset();
        $(':input').val('');
        //$(':select').val('');
    }
};
DynamicFormComponent.ctorParameters = () => [
    { type: _servicios_estructura_control_service__WEBPACK_IMPORTED_MODULE_2__["EstructuraControlService"] },
    { type: _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_3__["SetFormService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], DynamicFormComponent.prototype, "items", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], DynamicFormComponent.prototype, "descripcion", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], DynamicFormComponent.prototype, "procedimientoDestino", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], DynamicFormComponent.prototype, "parametrosDestino", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], DynamicFormComponent.prototype, "origenParent", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], DynamicFormComponent.prototype, "dataFormulario", void 0);
DynamicFormComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dynamic-form',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dynamic-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-form/dynamic-form.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_7__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MAT_DATE_LOCALE"]]
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dynamic-form.component.css */ "./src/app/dynamic-form/dynamic-form.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_estructura_control_service__WEBPACK_IMPORTED_MODULE_2__["EstructuraControlService"],
        _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_3__["SetFormService"]])
], DynamicFormComponent);



/***/ }),

/***/ "./src/app/dynamic-report-contenido/dynamic-report-contenido.component.css":
/*!*********************************************************************************!*\
  !*** ./src/app/dynamic-report-contenido/dynamic-report-contenido.component.css ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZHluYW1pYy1yZXBvcnQtY29udGVuaWRvL2R5bmFtaWMtcmVwb3J0LWNvbnRlbmlkby5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/dynamic-report-contenido/dynamic-report-contenido.component.ts":
/*!********************************************************************************!*\
  !*** ./src/app/dynamic-report-contenido/dynamic-report-contenido.component.ts ***!
  \********************************************************************************/
/*! exports provided: MY_FORMATS, DynamicReportContenidoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicReportContenidoComponent", function() { return DynamicReportContenidoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _model_form_estructura_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../model-form/estructura-base */ "./src/app/model-form/estructura-base.ts");
/* harmony import */ var _servicios_dropdown_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/dropdown.service */ "./src/app/servicios/dropdown.service.ts");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");







const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD'
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY-MM-DD',
        dateA11yLabel: 'YYYY-MM-DD',
        monthYearA11yLabel: 'YYYY-MM-DD'
    }
};
let DynamicReportContenidoComponent = class DynamicReportContenidoComponent {
    constructor(servicioCargaInformacion) {
        this.servicioCargaInformacion = servicioCargaInformacion;
        this.cargando = false;
        this.minDatePadre = new Date(2010, 1, 1);
        this.maxDatePadre = new Date(2020, 0, 1);
        this.minDateHijo = new Date(2010, 1, 1);
        this.maxDateHijo = new Date(2020, 0, 1);
        this.dateController1 = true;
        this.dateController2 = true;
        this.nombre = 'jose';
    }
    ngOnInit() { }
    cargaDropDown(origenDatos, opt, label) {
        //alert(origenDatos);
        this.id = this.form.get(opt).value;
        //alert(origenDatos);
        //this.form.get(origenDatos)
        //alert(JSON.stringify(this.form.get(origenDatos)));
        this.cargando = true;
        this.servicioCargaInformacion.getData(origenDatos, this.id)
            .subscribe(data => {
            //this.dataFiltered=data;
            //alert(origenDatos);
            /*$("#" + origenDatos)
              .empty();*/
            $("#" + origenDatos).find('option').not(':first').remove();
            /*$("#" + origenDatos)
            .append('<option value="" disabled selected>' + label + '</option>');*/
            data.forEach(element => {
                $("#" + origenDatos)
                    .append('<option value="' + element.id + '">' + element.valor + '</option>');
            });
            //$("#"+origenDatos+" option:eq(0)").attr("selected","selected");
            $("#" + origenDatos).val("");
            this.form.controls[origenDatos].setValue("");
            this.cargando = false;
            //$("#" + origenDatos).selectmenu().selectmenu('refresh', true);
        });
    }
    setValue() {
    }
    seleccionaFecha(event, tipo, elemento) {
        if (tipo == 'padre') {
            let fechaHijo = this.form.controls[elemento].value;
            let fechaPadre = event.value;
            if (fechaPadre > fechaHijo) { //SI LA FECHA INICIAL ES IGUAL
                this.form.controls[elemento].setValue(fechaPadre);
            }
            this.minDateHijo = new Date(2019, 1, 23);
            //alert(this.minDateHijo);
        }
        else if (tipo == 'hijo') {
            let fechaPadre = this.form.controls[elemento].value;
            let fechaHijo = event.value;
        }
    }
    padre(event, tipo, elemento) {
        //this.minDateHijo = new Date(2019, 1, 19);
        //this.minDatePadre = new Date(2019, 1, 15);
        //this.nombre="Pablo";
        //alert("aqui");
        /*setTimeout(function () {
          this.dateController2=true;
       }, 300);*/
        //alert(event.value);
        //event.stopPropagation();
        /*alert(event.value);
        alert(this.form.controls[elemento].value);
        let fechaPadre = _moment(event.value).format('YYYY-MM-DD');
        if(fechaPadre>this.form.controls[elemento].value){
          alert("fecha inicial mayor a fecha final");
        }*/
    }
    get isValid() { return this.form.controls[this.item.key].valid; }
    get Error() {
        // alert(this.form.controls[this.item.key].errors);
        return this.form.controls[this.item.key].errors;
    }
};
DynamicReportContenidoComponent.ctorParameters = () => [
    { type: _servicios_dropdown_service__WEBPACK_IMPORTED_MODULE_4__["DropdownService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _model_form_estructura_base__WEBPACK_IMPORTED_MODULE_3__["EstructuraBase"])
], DynamicReportContenidoComponent.prototype, "item", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormGroup"])
], DynamicReportContenidoComponent.prototype, "form", void 0);
DynamicReportContenidoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dynamic-report-contenido',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dynamic-report-contenido.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-report-contenido/dynamic-report-contenido.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_5__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MAT_DATE_LOCALE"]]
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_6__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dynamic-report-contenido.component.css */ "./src/app/dynamic-report-contenido/dynamic-report-contenido.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_dropdown_service__WEBPACK_IMPORTED_MODULE_4__["DropdownService"]])
], DynamicReportContenidoComponent);



/***/ }),

/***/ "./src/app/dynamic-report/dynamic-report.component.css":
/*!*************************************************************!*\
  !*** ./src/app/dynamic-report/dynamic-report.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZHluYW1pYy1yZXBvcnQvZHluYW1pYy1yZXBvcnQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/dynamic-report/dynamic-report.component.ts":
/*!************************************************************!*\
  !*** ./src/app/dynamic-report/dynamic-report.component.ts ***!
  \************************************************************/
/*! exports provided: MY_FORMATS, DynamicReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicReportComponent", function() { return DynamicReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_estructura_control_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../servicios/estructura-control.service */ "./src/app/servicios/estructura-control.service.ts");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var _servicios_reporte_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../servicios/reporte.service */ "./src/app/servicios/reporte.service.ts");



 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI




const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD'
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY-MM-DD',
        dateA11yLabel: 'YYYY-MM-DD',
        monthYearA11yLabel: 'YYYY-MM-DD'
    }
};
let DynamicReportComponent = class DynamicReportComponent {
    constructor(fcs, servicioReporte) {
        this.fcs = fcs;
        this.servicioReporte = servicioReporte;
        this.items = [];
        this.salidaReporte = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.payLoad = '';
        this.expandido = true;
    }
    ngOnInit() { }
    ngOnChanges() {
        this.form = this.fcs.toFormGroup(this.items);
    }
    isValidDate(value) {
        const dateWrapper = new Date(value);
        return !isNaN(dateWrapper.getDate());
    }
    onSubmit() {
        this.payLoad = JSON.stringify(this.form.value);
        const arrNumber = [];
        $('input[data-date]').each(function () {
            arrNumber.push($(this).val());
            const nFecha = moment__WEBPACK_IMPORTED_MODULE_4__($(this).val(), 'YYYY-MM-DD').format('YYYY-MM-DD');
            $(this).val(nFecha);
        });
        if (arrNumber.length == 2) {
            /*let date1 = new Date(arrNumber[0]);
        let date2 = new Date(arrNumber[1]);
        let fechaInicial = _moment(date1).format('YYYY-MM-DD');
        let fechaFinal = _moment(date2).format('YYYY-MM-DD');
        alert(fechaInicial);
        alert(fechaFinal);
        if(fechaInicial>fechaFinal){
          alert("fecha inicial mayor");
        }  */
            if (arrNumber[0] > arrNumber[1]) {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_3___default.a.fire({
                    title: this.descripcion,
                    text: 'La fecha inicial no debe ser mayor a la final. revise.',
                    type: 'error'
                });
                return;
            }
        }
        const jsonPayload = this.form.value;
        this.parametrosDestino.forEach((element, indexDestino) => {
            for (const key in jsonPayload) {
                if (jsonPayload.hasOwnProperty(element.key)) {
                    const index = key.indexOf(element.key);
                    if (index !== -1) {
                        if (key.includes('fecha')) {
                            jsonPayload[key] = moment__WEBPACK_IMPORTED_MODULE_4__(jsonPayload[key], 'YYYY-MM-DD').format('YYYY-MM-DD');
                        }
                        this.parametrosDestino[indexDestino].value = jsonPayload[key];
                    }
                }
            }
        });
        const infoPayload = {
            procedimientoDestino: this.procedimientoDestino,
            infoPayload: this.parametrosDestino
        };
        this.servicioReporte.postReporte(infoPayload).subscribe(data => {
            this.salidaReporte.emit(data);
            /*Swal.fire({
              title: this.descripcion,
              text: 'Informacion Almacenada Correctamente.',
              type: 'success'
            });*/
        });
        this.form.reset();
        $(':input').val('');
        $(':select').val('');
    }
};
DynamicReportComponent.ctorParameters = () => [
    { type: _servicios_estructura_control_service__WEBPACK_IMPORTED_MODULE_2__["EstructuraControlService"] },
    { type: _servicios_reporte_service__WEBPACK_IMPORTED_MODULE_7__["ReporteService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], DynamicReportComponent.prototype, "items", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], DynamicReportComponent.prototype, "descripcion", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], DynamicReportComponent.prototype, "procedimientoDestino", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], DynamicReportComponent.prototype, "parametrosDestino", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], DynamicReportComponent.prototype, "salidaReporte", void 0);
DynamicReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dynamic-report',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dynamic-report.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/dynamic-report/dynamic-report.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_6__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MAT_DATE_LOCALE"]]
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_5__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dynamic-report.component.css */ "./src/app/dynamic-report/dynamic-report.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_estructura_control_service__WEBPACK_IMPORTED_MODULE_2__["EstructuraControlService"],
        _servicios_reporte_service__WEBPACK_IMPORTED_MODULE_7__["ReporteService"]])
], DynamicReportComponent);



/***/ }),

/***/ "./src/app/entregas-completas/entregas-completas.component.css":
/*!*********************************************************************!*\
  !*** ./src/app/entregas-completas/entregas-completas.component.css ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZW50cmVnYXMtY29tcGxldGFzL2VudHJlZ2FzLWNvbXBsZXRhcy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/entregas-completas/entregas-completas.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/entregas-completas/entregas-completas.component.ts ***!
  \********************************************************************/
/*! exports provided: EntregasCompletasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntregasCompletasComponent", function() { return EntregasCompletasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let EntregasCompletasComponent = class EntregasCompletasComponent {
    constructor() { }
    ngOnInit() {
    }
};
EntregasCompletasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-entregas-completas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./entregas-completas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-completas/entregas-completas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./entregas-completas.component.css */ "./src/app/entregas-completas/entregas-completas.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], EntregasCompletasComponent);



/***/ }),

/***/ "./src/app/entregas-parciales/entregas-parciales.component.css":
/*!*********************************************************************!*\
  !*** ./src/app/entregas-parciales/entregas-parciales.component.css ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvZW50cmVnYXMtcGFyY2lhbGVzL2VudHJlZ2FzLXBhcmNpYWxlcy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/entregas-parciales/entregas-parciales.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/entregas-parciales/entregas-parciales.component.ts ***!
  \********************************************************************/
/*! exports provided: EntregasParcialesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntregasParcialesComponent", function() { return EntregasParcialesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let EntregasParcialesComponent = class EntregasParcialesComponent {
    constructor() { }
    ngOnInit() {
    }
};
EntregasParcialesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-entregas-parciales',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./entregas-parciales.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-parciales/entregas-parciales.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./entregas-parciales.component.css */ "./src/app/entregas-parciales/entregas-parciales.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], EntregasParcialesComponent);



/***/ }),

/***/ "./src/app/entregas-transportador/entregas-transportador.component.css":
/*!*****************************************************************************!*\
  !*** ./src/app/entregas-transportador/entregas-transportador.component.css ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-radio-button{\r\n    margin-left: 5px !important;\r\n}\r\n\r\n\r\nmat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n\r\n.icono-time-line{\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    margin: auto;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    overflow: auto;\r\n  }\r\n\r\n\r\n.punto-style-ok{\r\n    background-color: #008000 !important; \r\n    cursor:pointer;    \r\n  }\r\n\r\n\r\n.punto-style-err{\r\n    background-color: #ff0000 !important; \r\n    cursor:pointer;    \r\n  }\r\n\r\n\r\n.click{\r\n    cursor: pointer !important;\r\n  }\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9lbnRyZWdhcy10cmFuc3BvcnRhZG9yL2VudHJlZ2FzLXRyYW5zcG9ydGFkb3IuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLDJCQUEyQjtBQUMvQjs7O0FBR0E7SUFDSSxXQUFXO0VBQ2I7OztBQUVBO0lBQ0Usa0JBQWtCO0lBQ2xCLE9BQU87SUFDUCxRQUFRO0lBQ1IsTUFBTTtJQUNOLFNBQVM7SUFDVCxZQUFZO0lBQ1osZUFBZTtJQUNmLGdCQUFnQjtJQUNoQixjQUFjO0VBQ2hCOzs7QUFFQTtJQUNFLG9DQUFvQztJQUNwQyxjQUFjO0VBQ2hCOzs7QUFFQTtJQUNFLG9DQUFvQztJQUNwQyxjQUFjO0VBQ2hCOzs7QUFFQTtJQUNFLDBCQUEwQjtFQUM1QiIsImZpbGUiOiJhcHAvZW50cmVnYXMtdHJhbnNwb3J0YWRvci9lbnRyZWdhcy10cmFuc3BvcnRhZG9yLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZXhhbXBsZS1yYWRpby1idXR0b257XHJcbiAgICBtYXJnaW4tbGVmdDogNXB4ICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcblxyXG5tYXQtZm9ybS1maWVsZCB7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcblxyXG4gIC5pY29uby10aW1lLWxpbmV7XHJcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XHJcbiAgICBsZWZ0OiAwO1xyXG4gICAgcmlnaHQ6IDA7XHJcbiAgICB0b3A6IDA7XHJcbiAgICBib3R0b206IDA7XHJcbiAgICBtYXJnaW46IGF1dG87XHJcbiAgICBtYXgtd2lkdGg6IDEwMCU7XHJcbiAgICBtYXgtaGVpZ2h0OiAxMDAlO1xyXG4gICAgb3ZlcmZsb3c6IGF1dG87XHJcbiAgfVxyXG5cclxuICAucHVudG8tc3R5bGUtb2t7XHJcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjMDA4MDAwICFpbXBvcnRhbnQ7IFxyXG4gICAgY3Vyc29yOnBvaW50ZXI7ICAgIFxyXG4gIH1cclxuXHJcbiAgLnB1bnRvLXN0eWxlLWVycntcclxuICAgIGJhY2tncm91bmQtY29sb3I6ICNmZjAwMDAgIWltcG9ydGFudDsgXHJcbiAgICBjdXJzb3I6cG9pbnRlcjsgICAgXHJcbiAgfVxyXG5cclxuICAuY2xpY2t7XHJcbiAgICBjdXJzb3I6IHBvaW50ZXIgIWltcG9ydGFudDtcclxuICB9Il19 */");

/***/ }),

/***/ "./src/app/entregas-transportador/entregas-transportador.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/entregas-transportador/entregas-transportador.component.ts ***!
  \****************************************************************************/
/*! exports provided: MY_FORMATS, EntregasTransportadorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntregasTransportadorComponent", function() { return EntregasTransportadorComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/usuario.service */ "./src/app/servicios/usuario.service.ts");
/* harmony import */ var _servicios_entrega_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../servicios/entrega.service */ "./src/app/servicios/entrega.service.ts");
/* harmony import */ var _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var xlsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! xlsx */ "./node_modules/xlsx/xlsx.js");
/* harmony import */ var xlsx__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(xlsx__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _dialogs_dialog_documento_dialog_documento_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../dialogs/dialog-documento/dialog-documento.component */ "./src/app/dialogs/dialog-documento/dialog-documento.component.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");










const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';





const MY_FORMATS = {
    parse: {
        dateInput: "YYYY-MM-DD"
    },
    display: {
        dateInput: "YYYY-MM-DD",
        monthYearLabel: "YYYY-MM-DD",
        dateA11yLabel: "YYYY-MM-DD",
        monthYearA11yLabel: "YYYY-MM-DD"
    }
};
let EntregasTransportadorComponent = class EntregasTransportadorComponent {
    constructor(fb, servicePersona, serviceUsuario, serviceEntrega, servicioAgencia, dialog, ruta) {
        this.fb = fb;
        this.servicePersona = servicePersona;
        this.serviceUsuario = serviceUsuario;
        this.serviceEntrega = serviceEntrega;
        this.servicioAgencia = servicioAgencia;
        this.dialog = dialog;
        this.ruta = ruta;
        this.loadingAgencias = false;
        this.loadingUsuarios = false;
        this.loading = false;
        this.usuarioConsulta = "";
        this.agencias = [];
        this.usuarios = [];
        this.dataEntregas = [];
        this.haveData = false;
        this.timeRunning = 0;
        this.alternate = false;
        this.isExpanded = false;
        this.mostrarIcono = true;
        this.entregasGroup = this.fb.group({
            idAgencia: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            usuarioCtrl: ["", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            fechaInicial: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            fechaFinal: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
        this.searchForm = this.fb.group({
            searchText: [""]
        });
        const fechaHoy = new Date();
        const nFecha = moment__WEBPACK_IMPORTED_MODULE_8__(fechaHoy, "YYYY-MM-DD").format("YYYY-MM-DD");
        const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
        this.usuarioConsulta = infoUsuario[0].IdUsuario;
        this.loadingAgencias = true;
        this.servicioAgencia
            .getAgencia(infoUsuario[0].IdUsuario, 0)
            .subscribe(result => {
            this.agencias = result;
            this.agencias.unshift({
                id: "0",
                valor: "TODOS"
            });
            this.entregasGroup.controls["idAgencia"].setValue("0");
            this.loadingAgencias = false;
            this.entregasGroup.get("idAgencia").valueChanges.subscribe(value => {
                this.cargarUsuariosAgencia();
            });
            //console.log(this.agencias);
        });
        this.loadingUsuarios = true;
        this.serviceUsuario
            .getUsuariosPersonas(2, infoUsuario[0].IdUsuario, 0)
            .subscribe(result => {
            this.usuarios = result;
            this.usuarios.unshift({
                id: "0",
                valor: "TODOS"
            });
            this.entregasGroup.controls["usuarioCtrl"].setValue({
                id: "0",
                valor: "TODOS"
            });
            this.loadingUsuarios = false;
            this.filteredUsuarios = this.entregasGroup
                .get("usuarioCtrl")
                .valueChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["startWith"])(""), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])(usuario => usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()));
        });
        this.cargarInformacion(0, this.usuarioConsulta, 0, nFecha, nFecha);
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    cargarInformacion(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal) {
        this.loading = true;
        this.serviceEntrega
            .getInformeEntregasRealizadas(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal)
            .subscribe(data => {
            this.dataEntregas = data;
            //console.log(this.dataEntregas);
            this.loading = false;
            if (data.length > 0) {
                this.haveData = true;
            }
            if (this.timeRunning == 0) {
                //this.dtTrigger.next();
            }
            else {
                //this.reRender();
            }
            this.timeRunning++;
        });
    }
    cargarUsuariosAgencia() {
        this.loadingUsuarios = true;
        const agencia = this.entregasGroup.get("idAgencia").value;
        this.serviceUsuario
            .getUsuariosPersonas(2, this.usuarioConsulta, agencia)
            .subscribe(result => {
            this.usuarios = result;
            this.usuarios.unshift({
                id: "0",
                valor: "TODOS"
            });
            this.entregasGroup.controls["usuarioCtrl"].setValue({
                id: "0",
                valor: "TODOS"
            });
            this.loadingUsuarios = false;
            this.filteredUsuarios = this.entregasGroup
                .get("usuarioCtrl")
                .valueChanges.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["startWith"])(""), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])(usuario => usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()));
        });
    }
    _filterUsuarios(value) {
        let filterValue;
        if (typeof value === "object") {
            filterValue = value.valor.toLowerCase();
        }
        else {
            filterValue = value.toLowerCase();
        }
        console.log(filterValue);
        //const filterValue = value.valor.toLowerCase();
        return this.usuarios.filter(usuario => usuario.valor.toLowerCase().indexOf(filterValue) > -1);
    }
    displayFn(usuario) {
        //console.log(JSON.stringify(usuario));
        return usuario ? usuario.valor : usuario;
    }
    onHeaderClick(event, index) {
    }
    onDotClick(event, index) {
    }
    busqueda() {
        //console.log(this.entregasGroup.get('idAgencia').value);  
        //return;
        const usuarioConsulta = this.usuarioConsulta;
        const agencia = this.entregasGroup.get('idAgencia').value;
        const usuario = this.entregasGroup.get('usuarioCtrl').value;
        const fechaInicial = moment__WEBPACK_IMPORTED_MODULE_8__(this.entregasGroup.get('fechaInicial').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        const fechaFinal = moment__WEBPACK_IMPORTED_MODULE_8__(this.entregasGroup.get('fechaFinal').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        //console.log(tipoConsulta);
        //return;
        this.cargarInformacion(agencia, usuarioConsulta, usuario.id, fechaInicial, fechaFinal);
    }
    verDocumento(ordenSAP, idServicio, tipoImagen) {
        const params = {
            ordenSAP: ordenSAP,
            idServicio: idServicio,
            tipoImagen: tipoImagen
        };
        const dialogRef = this.dialog.open(_dialogs_dialog_documento_dialog_documento_component__WEBPACK_IMPORTED_MODULE_13__["DialogDocumentoComponent"], {
            data: params,
            width: '100em',
        });
        dialogRef.afterClosed().subscribe(result => {
            /*if (result) {
              this.refrescaBusqueda();
            }*/
            console.log('Resultado es :' + result);
        });
    }
    exportarExcel() {
        const fileName = 'entregasRealizadas.xlsx';
        let data = JSON.parse(JSON.stringify(this.dataEntregas));
        //let data = this.dataEntregas;
        data.forEach(element => {
            delete element.busqueda;
            delete element.tieneFoto;
            delete element.tieneFirma;
            delete element.tieneDocumento;
            delete element.sincronizado;
            delete element.enRutaOperador;
            delete element.idUsuarioAsignado;
            delete element.idTpoNovedad;
        });
        const ws = xlsx__WEBPACK_IMPORTED_MODULE_9__["utils"].json_to_sheet(data);
        const wb = xlsx__WEBPACK_IMPORTED_MODULE_9__["utils"].book_new();
        xlsx__WEBPACK_IMPORTED_MODULE_9__["utils"].book_append_sheet(wb, ws, 'entregas');
        xlsx__WEBPACK_IMPORTED_MODULE_9__["writeFile"](wb, fileName);
    }
};
EntregasTransportadorComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__["PersonaService"] },
    { type: _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_4__["UsuarioService"] },
    { type: _servicios_entrega_service__WEBPACK_IMPORTED_MODULE_5__["EntregaService"] },
    { type: _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_6__["AgenciaService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_14__["MatDialog"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_12__["Utils"] }
];
EntregasTransportadorComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-entregas-transportador",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./entregas-transportador.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas-transportador/entregas-transportador.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_11__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MAT_DATE_LOCALE"]]
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./entregas-transportador.component.css */ "./src/app/entregas-transportador/entregas-transportador.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _servicios_persona_service__WEBPACK_IMPORTED_MODULE_3__["PersonaService"],
        _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_4__["UsuarioService"],
        _servicios_entrega_service__WEBPACK_IMPORTED_MODULE_5__["EntregaService"],
        _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_6__["AgenciaService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_14__["MatDialog"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_12__["Utils"]])
], EntregasTransportadorComponent);



/***/ }),

/***/ "./src/app/entregas/entregas.component.css":
/*!*************************************************!*\
  !*** ./src/app/entregas/entregas.component.css ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".example-radio-button{\r\n    margin-left: 5px !important;\r\n}\r\n\r\n\r\nmat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n\r\nth, td {\r\n      white-space: nowrap !important;\r\n  }\r\n\r\n\r\n  \r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9lbnRyZWdhcy9lbnRyZWdhcy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksMkJBQTJCO0FBQy9COzs7QUFHQTtJQUNJLFdBQVc7RUFDYjs7O0FBRUE7TUFDSSw4QkFBOEI7RUFDbEMiLCJmaWxlIjoiYXBwL2VudHJlZ2FzL2VudHJlZ2FzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZXhhbXBsZS1yYWRpby1idXR0b257XHJcbiAgICBtYXJnaW4tbGVmdDogNXB4ICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcblxyXG5tYXQtZm9ybS1maWVsZCB7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcblxyXG4gIHRoLCB0ZCB7XHJcbiAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXAgIWltcG9ydGFudDtcclxuICB9XHJcblxyXG5cclxuICAiXX0= */");

/***/ }),

/***/ "./src/app/entregas/entregas.component.ts":
/*!************************************************!*\
  !*** ./src/app/entregas/entregas.component.ts ***!
  \************************************************/
/*! exports provided: MY_FORMATS, EntregasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MY_FORMATS", function() { return MY_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntregasComponent", function() { return EntregasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _dialogs_dialogo_gestion_cargue_dialogo_gestion_cargue_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component */ "./src/app/dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/servicios/persona.service */ "./src/app/servicios/persona.service.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/servicios/helper.service */ "./src/app/servicios/helper.service.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../servicios/usuario.service */ "./src/app/servicios/usuario.service.ts");
/* harmony import */ var _servicios_entrega_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../servicios/entrega.service */ "./src/app/servicios/entrega.service.ts");
/* harmony import */ var _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");
/* harmony import */ var _dialogs_dialog_documento_dialog_documento_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../dialogs/dialog-documento/dialog-documento.component */ "./src/app/dialogs/dialog-documento/dialog-documento.component.ts");
/* harmony import */ var _dialogs_dialog_web_service_dialog_web_service_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../dialogs/dialog-web-service/dialog-web-service.component */ "./src/app/dialogs/dialog-web-service/dialog-web-service.component.ts");
/* harmony import */ var _dialogs_dialogo_entrega_nueva_dialogo_entrega_nueva_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component */ "./src/app/dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component.ts");
/* harmony import */ var _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../servicios/servicio-gestion-cargue.service */ "./src/app/servicios/servicio-gestion-cargue.service.ts");









 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI












const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD'
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY-MM-DD',
        dateA11yLabel: 'YYYY-MM-DD',
        monthYearA11yLabel: 'YYYY-MM-DD'
    }
};
let EntregasComponent = class EntregasComponent {
    constructor(formBuilder, servicePersona, serviceUsuario, serviceEntrega, servicioAgencia, dialog, helper, ruta, servicioGestionCargue) {
        this.formBuilder = formBuilder;
        this.servicePersona = servicePersona;
        this.serviceUsuario = serviceUsuario;
        this.serviceEntrega = serviceEntrega;
        this.servicioAgencia = servicioAgencia;
        this.dialog = dialog;
        this.helper = helper;
        this.ruta = ruta;
        this.servicioGestionCargue = servicioGestionCargue;
        //dtOptions: any = {};
        this.dataEntregas = [];
        this.haveData = false;
        this.loading = false;
        this.timeRunning = 0;
        this.agencias = [];
        this.usuarioConsulta = '';
        this.loadingAgencias = false;
        this.loadingUsuarios = false;
        this.dtTrigger = new rxjs__WEBPACK_IMPORTED_MODULE_7__["Subject"]();
        this.tipoConsultaSrv = [
            {
                id: 1,
                value: 'Fecha Entrega'
            },
            {
                id: 2,
                value: 'Fecha Creación'
            },
            {
                id: 3,
                value: 'Fecha Cierre'
            }
        ];
        this.dtOptions = {
            pagingType: 'full_numbers',
            scrollX: true,
            dom: 'Bfrtip',
            buttons: [
                'colvis',
                {
                    extend: "copyHtml5",
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: "excelHtml5",
                    fileName: "CustomFileName" + ".xlsx",
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ]
        };
        const fechaHoy = new Date();
        const nFecha = moment__WEBPACK_IMPORTED_MODULE_11__(fechaHoy, 'YYYY-MM-DD').format('YYYY-MM-DD');
        this.entregasGroup = this.formBuilder.group({
            idAgencia: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            usuarioCtrl: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            fechaInicial: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            fechaFinal: [new Date(), _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            tipoConsulta: [1, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]
        });
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        this.usuarioConsulta = infoUsuario[0].IdUsuario;
        this.loadingAgencias = true;
        this.servicioAgencia.getAgencia(infoUsuario[0].IdUsuario, 0)
            .subscribe(result => {
            this.agencias = result;
            this.agencias.unshift({
                id: '0',
                valor: 'TODOS'
            });
            this.entregasGroup.controls['idAgencia'].setValue('0');
            this.loadingAgencias = false;
            this.entregasGroup.get('idAgencia').valueChanges.subscribe(value => {
                this.cargarUsuariosAgencia();
            });
            //console.log(this.agencias);
        });
        this.loadingUsuarios = true;
        this.serviceUsuario.getUsuariosPersonas(2, infoUsuario[0].IdUsuario, 0)
            .subscribe(result => {
            this.usuarios = result;
            this.usuarios.unshift({
                id: '0',
                valor: 'TODOS'
            });
            this.entregasGroup.controls['usuarioCtrl'].setValue({
                id: '0',
                valor: 'TODOS'
            });
            this.loadingUsuarios = false;
            this.filteredUsuarios = this.entregasGroup.get('usuarioCtrl').valueChanges
                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["startWith"])(''), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(usuario => usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()));
        });
        this.cargarInformacion(0, this.usuarioConsulta, 0, nFecha, nFecha, 1);
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    ngOnDestroy() {
        // Do not forget to unsubscribe the event
        this.dtTrigger.unsubscribe();
    }
    displayFn(usuario) {
        //console.log(JSON.stringify(usuario));
        return usuario ? usuario.valor : usuario;
    }
    _filterUsuarios(value) {
        let filterValue;
        if (typeof value === 'object') {
            filterValue = value.valor.toLowerCase();
        }
        else {
            filterValue = value.toLowerCase();
        }
        console.log(filterValue);
        //const filterValue = value.valor.toLowerCase();
        return this.usuarios.filter(usuario => usuario.valor.toLowerCase().indexOf(filterValue) > -1);
    }
    busqueda() {
        //console.log(this.entregasGroup.get('idAgencia').value);
        //return;
        const usuarioConsulta = this.usuarioConsulta;
        const agencia = this.entregasGroup.get('idAgencia').value;
        const usuario = this.entregasGroup.get('usuarioCtrl').value;
        const fechaInicial = moment__WEBPACK_IMPORTED_MODULE_11__(this.entregasGroup.get('fechaInicial').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        const fechaFinal = moment__WEBPACK_IMPORTED_MODULE_11__(this.entregasGroup.get('fechaFinal').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        const tipoConsulta = this.entregasGroup.get('tipoConsulta').value;
        //console.log(tipoConsulta);
        //return;
        this.cargarInformacion(agencia, usuarioConsulta, usuario.id, fechaInicial, fechaFinal, tipoConsulta);
    }
    cargarInformacion(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal, tipoConsulta) {
        this.loading = true;
        this.serviceEntrega.getInformeEntregas(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal, tipoConsulta).subscribe(data => {
            this.dataEntregas = data;
            this.loading = false;
            if (data.length > 0) {
                this.haveData = true;
            }
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    cargarUsuariosAgencia() {
        this.loadingUsuarios = true;
        const agencia = this.entregasGroup.get('idAgencia').value;
        this.serviceUsuario.getUsuariosPersonas(2, this.usuarioConsulta, agencia)
            .subscribe(result => {
            this.usuarios = result;
            this.usuarios.unshift({
                id: '0',
                valor: 'TODOS'
            });
            this.entregasGroup.controls['usuarioCtrl'].setValue({
                id: '0',
                valor: 'TODOS'
            });
            this.loadingUsuarios = false;
            this.filteredUsuarios = this.entregasGroup.get('usuarioCtrl').valueChanges
                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["startWith"])(''), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(usuario => usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()));
        });
    }
    reRender() {
        this.dtElement.dtInstance.then((dtInstance) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }
    refrescaBusqueda() {
        const busqueda = this.entregasGroup.controls['persona'].value;
        this.dtOptions = {
            pagingType: 'full_numbers',
            dom: 'Bfrtip',
            buttons: [
                'copy', 'csv', 'excel', 'pdf', 'print'
            ]
        };
        this.loading = true;
        this.servicePersona.getBusquedaPersona(busqueda).subscribe(data => {
            this.dataEntregas = data;
            this.loading = false;
            if (data.length > 0) {
                this.haveData = true;
            }
            if (this.timeRunning == 0) {
                this.dtTrigger.next();
            }
            else {
                this.reRender();
            }
            this.timeRunning++;
        });
    }
    verDocumento(ordenSAP, idServicio, tipoImagen) {
        const params = {
            ordenSAP: ordenSAP,
            idServicio: idServicio,
            tipoImagen: tipoImagen
        };
        const dialogRef = this.dialog.open(_dialogs_dialog_documento_dialog_documento_component__WEBPACK_IMPORTED_MODULE_18__["DialogDocumentoComponent"], {
            data: params,
            width: '100em',
        });
        dialogRef.afterClosed().subscribe(result => {
            /*if (result) {
              this.refrescaBusqueda();
            }*/
            console.log('Resultado es :' + result);
        });
    }
    verDetalleWS(idTipoWS, idPaquete) {
        const params = {
            idTipoWS: idTipoWS,
            idPaquete: idPaquete
        };
        const dialogRef = this.dialog.open(_dialogs_dialog_web_service_dialog_web_service_component__WEBPACK_IMPORTED_MODULE_19__["DialogWebServiceComponent"], {
            data: params,
            width: '100em',
        });
        dialogRef.afterClosed().subscribe(result => {
            /*if (result) {
              this.refrescaBusqueda();
            }*/
            console.log('Resultado es :' + result);
        });
    }
    GestionarEntrega(entrega) {
        const dialogRef = this.dialog.open(_dialogs_dialogo_gestion_cargue_dialogo_gestion_cargue_component__WEBPACK_IMPORTED_MODULE_1__["DialogoGestionCargueComponent"], {
            data: {
                entrega: entrega,
            },
            //width: 'auto',
            width: '40%',
            // //height: '95%',
            minHeight: '70%',
            disableClose: true,
            hasBackdrop: false,
            role: 'alertdialog',
        });
        dialogRef.afterClosed()
            .subscribe((data) => {
            if (data.resultado == 'OK') {
                this.busqueda();
            }
            else {
                console.log(data.resultado);
            }
        });
    }
    SincronizarEnRuta(idServicioEnc) {
        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.fire({
            title: "Cargues",
            text: "Desea sincronizar esta entrega al estado \"en ruta\".",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#127570',
            allowOutsideClick: false,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Si, Sincronizar!",
        }).then((result) => {
            if (result.value) {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.fire({
                    title: 'Sincronizado Entrega !',
                    html: 'Un momento por favor.',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    onBeforeOpen() {
                        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.showLoading();
                    },
                });
                this.servicioGestionCargue
                    .EntregasProcesar(0, idServicioEnc)
                    .subscribe(() => {
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.close();
                    sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.fire("Entregas!", "La entrega ha sido sincronizada, su nuevo estado es: \"en ruta\".", "success");
                    this.busqueda();
                });
            }
        });
    }
    MostrarNuevaEntrega() {
        var resultado;
        const dialogRef = this.dialog.open(_dialogs_dialogo_entrega_nueva_dialogo_entrega_nueva_component__WEBPACK_IMPORTED_MODULE_20__["DialogoEntregaNuevaComponent"], {
            data: {},
            //width: 'auto',
            width: '90%',
            // //height: '95%',
            minHeight: '70%',
            disableClose: true,
            hasBackdrop: true,
            role: 'alertdialog',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result.resultado == "OK") {
                //this.consultaData(2);
                this.busqueda();
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.fire({
                    title: "Cargues",
                    text: "Desea sincronizar todos los cargues pendientes al estado \"en ruta\".",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#127570',
                    allowOutsideClick: false,
                    cancelButtonText: "Cancelar",
                    confirmButtonText: "Si, Sincronizar!",
                }).then((result) => {
                    if (result.value) {
                        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.fire({
                            title: 'Sincronizado Entregas !',
                            html: 'Un momento por favor.',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            onBeforeOpen() {
                                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.showLoading();
                            },
                        });
                        this.servicioGestionCargue
                            .EntregasProcesar(0, 0)
                            .subscribe(() => {
                            this.busqueda();
                            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.close();
                            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_9___default.a.fire("Entregas!", "Sincronizados todos los cargues al estado en ruta.", "success");
                        });
                    }
                });
            }
            console.log("Resultado es :" + result.resultado);
        });
    }
};
EntregasComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"] },
    { type: _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_15__["UsuarioService"] },
    { type: _servicios_entrega_service__WEBPACK_IMPORTED_MODULE_16__["EntregaService"] },
    { type: _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_17__["AgenciaService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MatDialog"] },
    { type: src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_10__["HelperService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_14__["Utils"] },
    { type: _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_21__["ServicioGestionCargueService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["ViewChild"])(angular_datatables__WEBPACK_IMPORTED_MODULE_8__["DataTableDirective"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", angular_datatables__WEBPACK_IMPORTED_MODULE_8__["DataTableDirective"])
], EntregasComponent.prototype, "dtElement", void 0);
EntregasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-entregas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./entregas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/entregas/entregas.component.html")).default,
        providers: [
            {
                provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_12__["DateAdapter"],
                useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_13__["MomentDateAdapter"],
                deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_12__["MAT_DATE_LOCALE"]]
            },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_12__["MAT_DATE_FORMATS"], useValue: MY_FORMATS }
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./entregas.component.css */ "./src/app/entregas/entregas.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"],
        src_app_servicios_persona_service__WEBPACK_IMPORTED_MODULE_5__["PersonaService"],
        _servicios_usuario_service__WEBPACK_IMPORTED_MODULE_15__["UsuarioService"],
        _servicios_entrega_service__WEBPACK_IMPORTED_MODULE_16__["EntregaService"],
        _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_17__["AgenciaService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_6__["MatDialog"],
        src_app_servicios_helper_service__WEBPACK_IMPORTED_MODULE_10__["HelperService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_14__["Utils"],
        _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_21__["ServicioGestionCargueService"]])
], EntregasComponent);



/***/ }),

/***/ "./src/app/gestion-maestras/gestion-maestras.component.css":
/*!*****************************************************************!*\
  !*** ./src/app/gestion-maestras/gestion-maestras.component.css ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n.letra{\r\n    color: brown;\r\n}\r\n\r\n.mat-list-item {\r\n    justify-content: flex-start;\r\n  }\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9nZXN0aW9uLW1hZXN0cmFzL2dlc3Rpb24tbWFlc3RyYXMuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQ0E7SUFDSSxZQUFZO0FBQ2hCOztBQUVBO0lBQ0ksMkJBQTJCO0VBQzdCIiwiZmlsZSI6ImFwcC9nZXN0aW9uLW1hZXN0cmFzL2dlc3Rpb24tbWFlc3RyYXMuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIlxyXG4ubGV0cmF7XHJcbiAgICBjb2xvcjogYnJvd247XHJcbn1cclxuXHJcbi5tYXQtbGlzdC1pdGVtIHtcclxuICAgIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDtcclxuICB9Il19 */");

/***/ }),

/***/ "./src/app/gestion-maestras/gestion-maestras.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/gestion-maestras/gestion-maestras.component.ts ***!
  \****************************************************************/
/*! exports provided: GestionMaestrasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GestionMaestrasComponent", function() { return GestionMaestrasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var xlsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! xlsx */ "./node_modules/xlsx/xlsx.js");
/* harmony import */ var xlsx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(xlsx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _servicios_archivos_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/archivos.service */ "./src/app/servicios/archivos.service.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");
/* harmony import */ var _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../servicios/servicio-gestion-cargue.service */ "./src/app/servicios/servicio-gestion-cargue.service.ts");


 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI







let GestionMaestrasComponent = class GestionMaestrasComponent {
    constructor(ruta, servicioArchivo, fb, snackBar, servicioAgencia, servicioGestionCargue) {
        this.ruta = ruta;
        this.servicioArchivo = servicioArchivo;
        this.fb = fb;
        this.snackBar = snackBar;
        this.servicioAgencia = servicioAgencia;
        this.servicioGestionCargue = servicioGestionCargue;
        this.item = {
            relativePath: ''
        };
        this.arcihvoValido = false;
        this.resultadoCargue = {};
        this.sinErrores = true;
        this.procesandoCargue = false;
        this.escondeProcesar = false;
        this.erroresResultado = [];
        this.loadingAgencias = false;
        this.agencias = [];
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        this.loadingAgencias = true;
        this.servicioAgencia.getAgencia(infoUsuario[0].IdUsuario, 0) //se envia cero para devolver todas las agencias y el id de agencia para devovler una especifica
            .subscribe(result => {
            this.agencias = result;
            this.loadingAgencias = false;
        });
        this.cargueGroup = this.fb.group({
            IdAgencia: ['']
        });
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    dropped(event) {
        const agencia = this.cargueGroup.controls['IdAgencia'].value;
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        if (!agencia) {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2___default.a.fire('Error Cargue Archivo!', 'Seleccione una agencia e intente cargar de nuevo.', 'error');
            return;
        }
        this.files = event;
        for (const droppedFile of this.files) {
            // Is it a file?
            if (droppedFile.fileEntry.isFile) {
                const fileEntry = droppedFile.fileEntry;
                fileEntry.file((file) => {
                    // Here you can access the real file
                    console.log('aqui subo');
                    console.log(droppedFile.relativePath, file);
                    this.servicioArchivo.postArchivo(agencia, infoUsuario[0].IdUsuario, file, droppedFile.relativePath)
                        .subscribe(result => {
                        if (result.errores.length == 0) {
                            this.arcihvoValido = true;
                            this.sinErrores = true;
                            this.escondeProcesar = false;
                            this.respuestaIntegracion = '';
                            this.snackBar.open('Archivo Validado Correctamente', 'Cargar Archivo', {
                                duration: 2000
                            });
                        }
                        else {
                            this.arcihvoValido = false;
                            this.sinErrores = false;
                            this.resultadoCargue = result;
                        }
                        console.log('si cargooooo');
                        this.item.relativePath = droppedFile.relativePath;
                        console.log(JSON.stringify(result));
                        this.infoCargue = result;
                    });
                });
            }
            else {
                // It was a directory (empty directories are added, otherwise only files)
                const fileEntry = droppedFile.fileEntry;
                console.log(droppedFile.relativePath, fileEntry);
            }
        }
    }
    droppedXLS(event) {
        this.files = event;
        for (const droppedFile of this.files) {
            // Is it a file?
            if (droppedFile.fileEntry.isFile) {
                const fileEntry = droppedFile.fileEntry;
                fileEntry.file((file) => {
                    // Here you can access the real file
                    console.log('aqui subo');
                    console.log(droppedFile.relativePath, file);
                    this.servicioArchivo.postArchivo(1, 1, file, droppedFile.relativePath)
                        .subscribe(result => {
                        console.log('si cargooooo');
                        this.item.relativePath = droppedFile.relativePath;
                        console.log(JSON.stringify(result));
                    });
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        /* read workbook */
                        const bstr = e.target.result;
                        const wb = xlsx__WEBPACK_IMPORTED_MODULE_3__["read"](bstr, { type: 'binary' });
                        /* grab first sheet */
                        const wsname = wb.SheetNames[0];
                        const ws = wb.Sheets[wsname];
                        /* save data */
                        this.data = (xlsx__WEBPACK_IMPORTED_MODULE_3__["utils"].sheet_to_json(ws, { header: 1 }));
                        console.log(JSON.stringify(this.data));
                    };
                    console.log(this.files[0].fileEntry);
                    reader.readAsBinaryString(file);
                    /**
                    // You could upload it like this:
                    const formData = new FormData()
                    formData.append('logo', file, relativePath)
          
                    // Headers
                    const headers = new HttpHeaders({
                      'security-token': 'mytoken'
                    })
          
                    this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
                    .subscribe(data => {
                      // Sanitized logo returned from backend
                    })
                    **/
                });
            }
            else {
                // It was a directory (empty directories are added, otherwise only files)
                const fileEntry = droppedFile.fileEntry;
                console.log(droppedFile.relativePath, fileEntry);
            }
        }
    }
    fileOver(event) {
        console.log(event);
    }
    fileLeave(event) {
        console.log(event);
    }
    procesarCargue() {
        const agencia = this.cargueGroup.controls['IdAgencia'].value;
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        const jsonCargue = {
            agencia: agencia,
            idUsuario: infoUsuario[0].IdUsuario,
            rutaArchivo: this.infoCargue.ruta,
            nombreArchivo: this.infoCargue.nombreArchivo,
            totalCols: this.infoCargue.totalCols
        };
        this.procesandoCargue = true;
        this.servicioArchivo.postProcesoCargue(jsonCargue)
            .subscribe(result => {
            //console.log(JSON.stringify(result));
            this.procesandoCargue = false;
            this.respuestaIntegracion = result[0].respuestaIntegracion;
            this.errorCargue = result[0].error;
            if (this.errorCargue) {
                let i = 0;
                result.forEach(element => {
                    if (i > 1) {
                        this.erroresResultado.push(element);
                    }
                    i++;
                });
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2___default.a.fire({
                    title: "Cargues",
                    text: "Desea sincronizar todos los cargues pendientes al estado \"en ruta\".",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#127570',
                    allowOutsideClick: false,
                    cancelButtonText: "Cancelar",
                    confirmButtonText: "Si, Sincronizar!",
                }).then((result) => {
                    if (result.value) {
                        sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2___default.a.fire({
                            title: 'Sincronizado Entregas !',
                            html: 'Un momento por favor.',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            onBeforeOpen() {
                                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2___default.a.showLoading();
                            },
                        });
                        this.servicioGestionCargue
                            .EntregasProcesar(agencia, 0)
                            .subscribe(() => {
                            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2___default.a.close();
                            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_2___default.a.fire("Entregas!", "Sincronizados todos los cargues al estado en ruta.", "success");
                        });
                    }
                });
            }
            //console.log(JSON.stringify(this.erroresResultado));
            this.escondeProcesar = true;
        }, err => {
            this.procesandoCargue = false;
            this.escondeProcesar = true;
        });
    }
};
GestionMaestrasComponent.ctorParameters = () => [
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_5__["Utils"] },
    { type: _servicios_archivos_service__WEBPACK_IMPORTED_MODULE_4__["ArchivosService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_6__["FormBuilder"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_8__["AgenciaService"] },
    { type: _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_9__["ServicioGestionCargueService"] }
];
GestionMaestrasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-gestion-maestras',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./gestion-maestras.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/gestion-maestras/gestion-maestras.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./gestion-maestras.component.css */ "./src/app/gestion-maestras/gestion-maestras.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_utils_utils__WEBPACK_IMPORTED_MODULE_5__["Utils"],
        _servicios_archivos_service__WEBPACK_IMPORTED_MODULE_4__["ArchivosService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_6__["FormBuilder"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_8__["AgenciaService"],
        _servicios_servicio_gestion_cargue_service__WEBPACK_IMPORTED_MODULE_9__["ServicioGestionCargueService"]])
], GestionMaestrasComponent);



/***/ }),

/***/ "./src/app/http-auth-interceptor.ts":
/*!******************************************!*\
  !*** ./src/app/http-auth-interceptor.ts ***!
  \******************************************/
/*! exports provided: HttpAuthInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpAuthInterceptor", function() { return HttpAuthInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _servicios_auth_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./servicios/auth.service */ "./src/app/servicios/auth.service.ts");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./constants/constants */ "./src/app/constants/constants.ts");







let HttpAuthInterceptor = class HttpAuthInterceptor {
    constructor(injector, router) {
        this.injector = injector;
        this.router = router;
        this.inflightAuthRequest = null;
        this.blacklist = [
            /(((https?):\/\/|www\.)theinfogrid.com\/auth\/)/,
            'some-other-url-pattern',
            'some-other-pattern'
        ];
    }
    intercept(req, next) {
        // exempt some paths from authentication
        //console.log(req);
        if (req.url == _constants_constants__WEBPACK_IMPORTED_MODULE_6__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_6__["Constants"].URL_LOGIN) {
            //alert("si entro");  
            return next.handle(req);
        }
        if (req.url == _constants_constants__WEBPACK_IMPORTED_MODULE_6__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_6__["Constants"].URL_REFRESH) {
            ///alert("si entro");  
            return next.handle(req);
        }
        /*if (req.headers.get('Auth/token') === 'true') {  || 'https://localhost:44361/api/formulario/1'
          return next.handle(req);
        }*/
        const authService = this.injector.get(_servicios_auth_service__WEBPACK_IMPORTED_MODULE_5__["AuthService"]);
        if (!this.inflightAuthRequest) {
            //console.log("siempre");
            this.inflightAuthRequest = authService.getToken();
            //this.inflightAuthRequest = sessionStorage.getItem('token');
            //console.log(this.inflightAuthRequest);
        }
        return this.inflightAuthRequest.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["switchMap"])((newToken) => {
            // unset request inflight
            this.inflightAuthRequest = null;
            //console.log("-->"+newToken+"<--");
            // use the newly returned token
            const authReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + (newToken ? newToken : ''))
            });
            return next.handle(authReq);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            // checks if a url is to an admin api or not
            if (error.status === 401) {
                // check if the response is from the token refresh end point
                const isFromRefreshTokenEndpoint = !!error.headers.get('unableToRefreshToken');
                if (isFromRefreshTokenEndpoint) {
                    localStorage.clear();
                    this.router.navigate(['/login']);
                    return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(error);
                }
                if (!this.inflightAuthRequest) {
                    //alert("aqui");
                    this.inflightAuthRequest = authService.refreshToken();
                    if (!this.inflightAuthRequest) {
                        // remove existing tokens
                        localStorage.clear();
                        this.router.navigate(['/login']);
                        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(error);
                    }
                }
                return this.inflightAuthRequest.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["switchMap"])((newToken) => {
                    // unset inflight request
                    this.inflightAuthRequest = null;
                    // clone the original request
                    const authReqRepeat = req.clone({
                        headers: req.headers.set('token', newToken)
                    });
                    // resend the request
                    return next.handle(authReqRepeat);
                }));
            }
            else {
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(error);
            }
        }));
    }
    blacklistCheckup($url) {
        let returnValue = false;
        for (const i of Object.keys(this.blacklist)) {
            if (this.blacklist[i].exec($url) !== null) {
                returnValue = true;
                break;
            }
        }
        return returnValue;
    }
};
HttpAuthInterceptor.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
HttpAuthInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"], _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], HttpAuthInterceptor);



/***/ }),

/***/ "./src/app/inicio/inicio.component.css":
/*!*********************************************!*\
  !*** ./src/app/inicio/inicio.component.css ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".top-content{\r\n    padding-top:10px !important;\r\n}\r\n\r\n.bold-icon{\r\n    font-weight: bold !important;    \r\n}\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9pbmljaW8vaW5pY2lvLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSwyQkFBMkI7QUFDL0I7O0FBRUE7SUFDSSw0QkFBNEI7QUFDaEMiLCJmaWxlIjoiYXBwL2luaWNpby9pbmljaW8uY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi50b3AtY29udGVudHtcclxuICAgIHBhZGRpbmctdG9wOjEwcHggIWltcG9ydGFudDtcclxufVxyXG5cclxuLmJvbGQtaWNvbntcclxuICAgIGZvbnQtd2VpZ2h0OiBib2xkICFpbXBvcnRhbnQ7ICAgIFxyXG59Il19 */");

/***/ }),

/***/ "./src/app/inicio/inicio.component.ts":
/*!********************************************!*\
  !*** ./src/app/inicio/inicio.component.ts ***!
  \********************************************/
/*! exports provided: InicioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InicioComponent", function() { return InicioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _servicios_graficas_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../servicios/graficas.service */ "./src/app/servicios/graficas.service.ts");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _servicios_colors_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/colors.service */ "./src/app/servicios/colors.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! chart.js */ "./node_modules/chart.js/dist/Chart.js");
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(chart_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");
/* harmony import */ var _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../servicios/agencia.service */ "./src/app/servicios/agencia.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");










let InicioComponent = class InicioComponent {
    constructor(colorService, graficaService, servicioAgencia, formBuilder, router, ruta) {
        this.colorService = colorService;
        this.graficaService = graficaService;
        this.servicioAgencia = servicioAgencia;
        this.formBuilder = formBuilder;
        this.router = router;
        this.ruta = ruta;
        this.url = "";
        this.datapieCategoria = {};
        this.labelsCategorias = [];
        this.dataCategorias = [];
        this.backgroundColorCategoria = [];
        this.hoverBackgroundColorCategoria = [];
        this.dataBarEmpresa = {};
        this.labelsEmpresas = [];
        this.dataEmpresas = [];
        this.backgroundColorEmpresa = [];
        this.datapieMedio = {};
        this.labelsMedios = [];
        this.dataMedios = [];
        this.backgroundColorMedio = [];
        /*dataBarPrioridad = {};
        dataServicePrioridades: any;
        labelsPrioridades = [];
        dataPrioridades = [];
        backgroundColorPrioridad = [];*/
        this.colorSpinner = "primary";
        this.dataBarAsesor = {};
        this.labelsAsesores = [];
        this.dataAsesores = [];
        this.backgroundColorAsesor = [];
        this.mostrarEntregadoresStacked = false;
        this.mostrarAgenciasStacked = false;
        this.mostrarMedios = false;
        this.mostrarAsesor = false;
        this.contenidoAlerta = '';
        this.agencias = [];
        this.url = _constants_constants__WEBPACK_IMPORTED_MODULE_3__["Constants"].BASE_URL;
        this.agenciaGroup = this.formBuilder.group({
            IdAgencia: ['']
        });
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        this.servicioAgencia.getAgencia(infoUsuario[0].IdUsuario, 0) //se envia cero para devolver todas las agencias y el id de agencia para devovler una especifica
            .subscribe(result => {
            this.agencias = result;
            this.agenciaGroup.controls['IdAgencia'].setValue(this.agencias[0].id);
            this.generarGraficas(this.agencias[0].id);
        });
        //alert("llega");
        // override the route reuse strategy
        /*this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        }
    
        this.router.events.subscribe((evt) => {
          if (evt instanceof NavigationEnd) {
            // trick the Router into believing it's last link wasn't previously loaded
            this.router.navigated = false;
            // if you need to scroll back to top, here is the right place
            window.scrollTo(0, 0);
          }
        });*/
    }
    generarGraficas(agencias) {
        //console.log(agencias);
        //this.entregasStacked.destroy();
        this.mostrarEntregadoresStacked = false;
        this.mostrarAgenciasStacked = false;
        /*if(!this.entregasStacked === undefined){
          this.entregasStacked.destroy();
        }
        if(!this.agenciasStacked === undefined){
          this.agenciasStacked.destroy();
        }*/
        agencias = '|' + agencias + '|';
        this.getGraficas('entregadores', agencias);
        this.getGraficas('agencias', agencias);
    }
    getGraficas(grafica, agencia) {
        //###################CATEGORIA######################//
        if (grafica == 'entregadores') {
            this.graficaService.getGraficaEntregadoresStacked(agencia, 1)
                .subscribe((data) => {
                const dataServer = data;
                const labels = [];
                const dataSets = [];
                const dataAsignados = [];
                const dataEntregados = [];
                const dataPendientes = [];
                let bgAsignados = [];
                let bgEntregados = [];
                let bgPendientes = [];
                dataServer.forEach(element => {
                    labels.push(element.Nombre.substring(0, 10));
                    dataAsignados.push(element.gestionados);
                    dataEntregados.push(element.entregados);
                    dataPendientes.push(element.pendientes);
                    bgAsignados.push('#45add6');
                    bgEntregados.push('#37cc0e');
                    bgPendientes.push('#cc0e27');
                });
                const configBarStackedData = {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                label: 'Asignados',
                                data: dataAsignados,
                                backgroundColor: bgAsignados
                            },
                            {
                                label: 'Gestionados',
                                data: dataEntregados,
                                backgroundColor: bgEntregados
                            },
                            {
                                label: 'Pendientes',
                                data: dataPendientes,
                                backgroundColor: bgPendientes
                            }
                        ]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                    stacked: true,
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }],
                            xAxes: [{
                                    stacked: true,
                                    ticks: {
                                        beginAtZero: true,
                                        fontSize: 10,
                                        autoSkip: false,
                                        maxRotation: 90,
                                        minRotation: 90
                                    }
                                }]
                        }
                    }
                };
                this.mostrarEntregadoresStacked = true;
                //console.log(JSON.stringify(configBarStackedData));
                if (this.entregasStacked)
                    this.entregasStacked.destroy();
                let canvas = document.getElementById("entregasStacked");
                this.entregasStacked = new chart_js__WEBPACK_IMPORTED_MODULE_6__(canvas, configBarStackedData);
            });
        }
        //###################END CATEGORIA######################//
        //###################EMPRESAS###########################//
        else if (grafica == 'agencias') {
            this.graficaService.getGraficaEntregadoresStacked(agencia, 2)
                .subscribe((data) => {
                const dataServer = data;
                const labels = [];
                const dataSets = [];
                const dataAsignados = [];
                const dataCerrados = [];
                const dataEnviadosOk = [];
                const dataEnviadosError = [];
                dataServer.forEach(element => {
                    labels.push(element.descripcion);
                    dataAsignados.push(element.gestionados);
                    dataCerrados.push(element.gestionados);
                    dataEnviadosOk.push(element.enviadosOk);
                    dataEnviadosError.push(element.enviadosError);
                });
                const configBarStackedData = {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                label: 'Asignados',
                                data: dataAsignados,
                                backgroundColor: ['#ebdb2d', '#ebdb2d', '#ebdb2d', '#ebdb2d']
                            },
                            {
                                label: 'Gestionados',
                                data: dataCerrados,
                                backgroundColor: ['#37cc0e', '#37cc0e', '#37cc0e', '#37cc0e']
                            },
                            {
                                label: 'Enviados OK',
                                data: dataEnviadosOk,
                                backgroundColor: ['#45add6', '#45add6', '#45add6', '#45add6']
                            },
                            {
                                label: 'Enviados Error',
                                data: dataEnviadosError,
                                backgroundColor: ['#cc0e27', '#cc0e27', '#cc0e27', '#cc0e27']
                            }
                        ]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                    stacked: true,
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }],
                            xAxes: [{
                                    stacked: true,
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }]
                        }
                    }
                };
                this.mostrarAgenciasStacked = true;
                //console.log(JSON.stringify(configBarStackedData));
                if (this.agenciasStacked)
                    this.agenciasStacked.destroy();
                let canvas = document.getElementById("agenciasStacked");
                this.agenciasStacked = new chart_js__WEBPACK_IMPORTED_MODULE_6__(canvas, configBarStackedData);
            });
        }
        //#####################END EMPRESA##########################//
        //###################MEDIOS######################//
        else if (grafica == 'medios') {
            this.graficaService.getGrafica(grafica)
                .subscribe((data) => {
                //alert(JSON.stringify(this.labelsCategorias));
                this.dataServiceMedios = data;
                this.mostrarMedios = true;
                this.dataServiceMedios.forEach((value, key) => {
                    this.labelsMedios.push(value.MEDIO);
                    this.dataMedios.push(value.cantidad);
                    let color = this.colorService.getRandomColor(key);
                    this.backgroundColorMedio.push(color);
                });
                let configPieMedio = {
                    type: 'pie',
                    data: {
                        datasets: [{
                                data: this.dataMedios,
                                backgroundColor: this.backgroundColorMedio,
                                label: 'Dataset 1'
                            }],
                        labels: this.labelsMedios
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        responsive: true
                    }
                };
                let canvasPieMedio = document.getElementById("pieMedios");
                this.PieMedio = new chart_js__WEBPACK_IMPORTED_MODULE_6__(canvasPieMedio, configPieMedio);
            });
        }
        //###################END MEDIOS######################//
        //###################PRIORIDADES###########################//
        /*else if (grafica == 'prioridades') {
          this.graficaService.getGrafica(grafica)
            .subscribe((data) => {
              //alert(JSON.stringify(this.labelsCategorias));
              this.dataServicePrioridades = data;
              this.dataServicePrioridades.forEach((value: any, key: any) => {
                this.labelsPrioridades.push(value.PRIORIDAD);
                this.dataPrioridades.push(value.cantidad);
                let color = this.colorService.getRandomColor(key);
                this.backgroundColorPrioridad.push(color);
                //this.hoverBackgroundColorCategoria.push(color);
    
    
                //alert(JSON.stringify(value));
              });
    
              let configBarPrioridades = {
                type: 'bar',
                data: {
                  datasets: [{
                    label: 'Solicitudes',
                    backgroundColor: this.backgroundColorPrioridad,
                    borderColor: this.backgroundColorPrioridad,
                    borderWidth: 1,
                    data: this.dataPrioridades
                  }],
                  labels: this.labelsPrioridades
                },
                options: {
                  legend: {
                    display: false
                  },
                  responsive: true
                }
              };
    
              let canvasBarPrioridad: any = document.getElementById("barPrioridades");
    
              this.BarEmpresa = new chart(canvasBarPrioridad, configBarPrioridades);
    
            });
        }*/
        //#####################END PRIORIDADES##########################//
        //###################ASESORES###########################//
        else if (grafica == 'asesores') {
            this.graficaService.getGrafica(grafica)
                .subscribe((data) => {
                //alert(JSON.stringify(this.labelsCategorias));
                this.dataServiceAsesores = data;
                this.mostrarAsesor = true;
                this.dataServiceAsesores.forEach((value, key) => {
                    this.labelsAsesores.push(value.nombre);
                    this.dataAsesores.push(value.cantidad);
                    let color = this.colorService.getRandomColor(key);
                    this.backgroundColorAsesor.push(color);
                    //this.hoverBackgroundColorCategoria.push(color);
                    //alert(JSON.stringify(value));
                });
                let configBarAsesores = {
                    type: 'bar',
                    data: {
                        datasets: [{
                                label: 'Solicitudes',
                                backgroundColor: this.backgroundColorAsesor,
                                borderColor: this.backgroundColorAsesor,
                                borderWidth: 1,
                                data: this.dataAsesores
                            }],
                        labels: this.labelsAsesores
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        responsive: true
                    }
                };
                let canvasBarAsesor = document.getElementById("barAsesores");
                this.agenciasStacked = new chart_js__WEBPACK_IMPORTED_MODULE_6__(canvasBarAsesor, configBarAsesores);
            });
        }
        //#####################END ASESORES##########################//
    }
    cargar() {
        alert("Aqui inicio");
    }
    ngOnInit() {
        //this.cargar();
        //this.getGraficas('medios');
        //this.getGraficas('asesores');
        this.ruta.setRuta();
    }
};
InicioComponent.ctorParameters = () => [
    { type: _servicios_colors_service__WEBPACK_IMPORTED_MODULE_4__["ColorsService"] },
    { type: _servicios_graficas_service__WEBPACK_IMPORTED_MODULE_2__["GraficasService"] },
    { type: _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_8__["AgenciaService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
InicioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_5__["Component"])({
        selector: 'app-inicio',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./inicio.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/inicio/inicio.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./inicio.component.css */ "./src/app/inicio/inicio.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_colors_service__WEBPACK_IMPORTED_MODULE_4__["ColorsService"],
        _servicios_graficas_service__WEBPACK_IMPORTED_MODULE_2__["GraficasService"],
        _servicios_agencia_service__WEBPACK_IMPORTED_MODULE_8__["AgenciaService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], InicioComponent);



/***/ }),

/***/ "./src/app/login/login.component.css":
/*!*******************************************!*\
  !*** ./src/app/login/login.component.css ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".contenedor {\r\n  height: 100vh;\r\n\r\n  background: url('fondo.jpg') no-repeat center center fixed;\r\n  background-size: cover;\r\n  position: relative;\r\n}\r\n\r\n.layer {\r\n  background-color: rgba(248, 247, 216, 0.6);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.img-logo {\r\n  height: 20vh !important;\r\n  width: 20vh !important;\r\n  position: relative !important;\r\n  top: 15px !important;\r\n}\r\n\r\n.example-form {\r\n  position: absolute;\r\n  margin-top: 10%;\r\n  left: 0;\r\n  right: 0;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.example-icon {\r\n  padding: 0 14px;\r\n}\r\n\r\n.example-spacer {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.example-card {\r\n  width: 400px;\r\n  margin: 10% auto;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n  text-align: center;\r\n}\r\n\r\n.mat-card-title {\r\n  font-size: 16px;\r\n}\r\n\r\n.example-full-width {\r\n  width: 100% !important;\r\n}\r\n\r\n.card-login {\r\n  width: 80%;\r\n}\r\n\r\n.button-login {\r\n  text-align: right;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9sb2dpbi9sb2dpbi5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBYTs7RUFFYiwwREFBdUU7RUFJdkUsc0JBQXNCO0VBQ3RCLGtCQUFrQjtBQUNwQjs7QUFFQTtFQUNFLDBDQUEwQztFQUMxQyxrQkFBa0I7RUFDbEIsTUFBTTtFQUNOLE9BQU87RUFDUCxXQUFXO0VBQ1gsWUFBWTtBQUNkOztBQUVBO0VBQ0UsdUJBQXVCO0VBQ3ZCLHNCQUFzQjtFQUN0Qiw2QkFBNkI7RUFDN0Isb0JBQW9CO0FBQ3RCOztBQUVBO0VBQ0Usa0JBQWtCO0VBQ2xCLGVBQWU7RUFDZixPQUFPO0VBQ1AsUUFBUTtFQUNSLGlCQUFpQjtFQUNqQixrQkFBa0I7QUFDcEI7O0FBRUE7RUFDRSxlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsY0FBYztBQUNoQjs7QUFFQTtFQUNFLFlBQVk7RUFDWixnQkFBZ0I7RUFDaEIsZUFBZTtFQUNmLGtCQUFrQjtFQUNsQixrQkFBa0I7QUFDcEI7O0FBRUE7RUFDRSxlQUFlO0FBQ2pCOztBQUVBO0VBQ0Usc0JBQXNCO0FBQ3hCOztBQUVBO0VBQ0UsVUFBVTtBQUNaOztBQUVBO0VBQ0UsaUJBQWlCO0FBQ25CIiwiZmlsZSI6ImFwcC9sb2dpbi9sb2dpbi5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRlbmVkb3Ige1xyXG4gIGhlaWdodDogMTAwdmg7XHJcblxyXG4gIGJhY2tncm91bmQ6IHVybChcIi4uLy4uL2Fzc2V0cy9mb25kby5qcGdcIikgbm8tcmVwZWF0IGNlbnRlciBjZW50ZXIgZml4ZWQ7XHJcbiAgLXdlYmtpdC1iYWNrZ3JvdW5kLXNpemU6IGNvdmVyO1xyXG4gIC1tb3otYmFja2dyb3VuZC1zaXplOiBjb3ZlcjtcclxuICAtby1iYWNrZ3JvdW5kLXNpemU6IGNvdmVyO1xyXG4gIGJhY2tncm91bmQtc2l6ZTogY292ZXI7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG59XHJcblxyXG4ubGF5ZXIge1xyXG4gIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMjQ4LCAyNDcsIDIxNiwgMC42KTtcclxuICBwb3NpdGlvbjogYWJzb2x1dGU7XHJcbiAgdG9wOiAwO1xyXG4gIGxlZnQ6IDA7XHJcbiAgd2lkdGg6IDEwMCU7XHJcbiAgaGVpZ2h0OiAxMDAlO1xyXG59XHJcblxyXG4uaW1nLWxvZ28ge1xyXG4gIGhlaWdodDogMjB2aCAhaW1wb3J0YW50O1xyXG4gIHdpZHRoOiAyMHZoICFpbXBvcnRhbnQ7XHJcbiAgcG9zaXRpb246IHJlbGF0aXZlICFpbXBvcnRhbnQ7XHJcbiAgdG9wOiAxNXB4ICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcbi5leGFtcGxlLWZvcm0ge1xyXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcclxuICBtYXJnaW4tdG9wOiAxMCU7XHJcbiAgbGVmdDogMDtcclxuICByaWdodDogMDtcclxuICBtYXJnaW4tbGVmdDogYXV0bztcclxuICBtYXJnaW4tcmlnaHQ6IGF1dG87XHJcbn1cclxuXHJcbi5leGFtcGxlLWljb24ge1xyXG4gIHBhZGRpbmc6IDAgMTRweDtcclxufVxyXG5cclxuLmV4YW1wbGUtc3BhY2VyIHtcclxuICBmbGV4OiAxIDEgYXV0bztcclxufVxyXG5cclxuLmV4YW1wbGUtY2FyZCB7XHJcbiAgd2lkdGg6IDQwMHB4O1xyXG4gIG1hcmdpbjogMTAlIGF1dG87XHJcbiAgbWFyZ2luLXRvcDogMHB4O1xyXG4gIG1hcmdpbi1ib3R0b206IDBweDtcclxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbn1cclxuXHJcbi5tYXQtY2FyZC10aXRsZSB7XHJcbiAgZm9udC1zaXplOiAxNnB4O1xyXG59XHJcblxyXG4uZXhhbXBsZS1mdWxsLXdpZHRoIHtcclxuICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xyXG59XHJcblxyXG4uY2FyZC1sb2dpbiB7XHJcbiAgd2lkdGg6IDgwJTtcclxufVxyXG5cclxuLmJ1dHRvbi1sb2dpbiB7XHJcbiAgdGV4dC1hbGlnbjogcmlnaHQ7XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/login/login.component.ts":
/*!******************************************!*\
  !*** ./src/app/login/login.component.ts ***!
  \******************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../servicios/login-service.service */ "./src/app/servicios/login-service.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");




//import { NgForm } from '@angular/forms';

let LoginComponent = class LoginComponent {
    constructor(route, authService, router, formBuilder) {
        this.route = route;
        this.authService = authService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.iniciandoSesion = false;
        this.title = 'Login';
        this.subtitle = 'Welcome owner';
        this.showSpinner = false;
    }
    ngOnInit() {
        //alert("aqui");
        this.formulario = this.formBuilder.group({
            username: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            password: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]
        });
        //alert(this.authService.getUserLoggedIn());
        if (this.authService.getUserLoggedIn() == '0') {
            //alert("si es falso");
            this.router.navigate(['login']);
        }
        else {
            //alert("Aqui");
            //alert("si es verdadero");
            this.router.navigate(['inicio']);
        }
        /*if (this.authService.getUserLoggedIn()) {
          this.router.navigate(['write']); // if user was logged in before, redirect to default landing page
        }*/
    }
    get f() {
        return this.formulario.controls;
    }
    onSubmit() {
        // stop here if form is invalid
        if (this.formulario.invalid) {
            return;
        }
        console.warn(this.formulario.value);
        //return;
        this.iniciandoSesion = true;
        this.authService.setUserLoggedIn(this.formulario.value).subscribe(data => {
            //alert(JSON.stringify(data));
            //alert();
            //console.log(JSON.stringify(data));
            let infoLogin = JSON.stringify(data);
            sessionStorage.setItem('infoUsuario', infoLogin);
            sessionStorage.setItem('token', data[0].token);
            sessionStorage.setItem('refresh_token', data[0].refresh_token);
            this.iniciandoSesion = false;
            //return;
            if (data.length === 1 && data[0].respuesta !== 'ERROR') {
                // auth service returns boolean value
                console.log('validas credentials');
                this.router.navigate(['inicio']);
                location.reload();
            }
            else {
                console.log('invalid credentials');
            }
        }, error => {
            this.iniciandoSesion = false;
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__["LoginService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/login/login.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"],
        _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__["LoginService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"]])
], LoginComponent);



/***/ }),

/***/ "./src/app/model-form/estructura-base.ts":
/*!***********************************************!*\
  !*** ./src/app/model-form/estructura-base.ts ***!
  \***********************************************/
/*! exports provided: EstructuraBase */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EstructuraBase", function() { return EstructuraBase; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class EstructuraBase {
    constructor(options = {}) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.callback = options.callback === undefined ? 1 : options.callback;
        this.origenCallBack = options.origenCallBack || '';
        this.depende = options.depende === undefined ? 1 : options.depende;
        this.maxlength = options['maxlength'] === undefined ? 1 : options['maxlength'];
        this.minlength = options['minlength'] === undefined ? 1 : options['minlength'];
        this.email = options['email'] === undefined ? 1 : options['email'];
        this.number = options['number'] === undefined ? 1 : options['number'];
        this.parametroDestino = options.parametroDestino || '';
        this.hijoDate = options.hijoDate || '';
        this.padreDate = options.padreDate || '';
        this.type = options.type || '';
    }
}


/***/ }),

/***/ "./src/app/model-form/form-dropdown.ts":
/*!*********************************************!*\
  !*** ./src/app/model-form/form-dropdown.ts ***!
  \*********************************************/
/*! exports provided: FormDropdown */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormDropdown", function() { return FormDropdown; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _estructura_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./estructura-base */ "./src/app/model-form/estructura-base.ts");


class FormDropdown extends _estructura_base__WEBPACK_IMPORTED_MODULE_1__["EstructuraBase"] {
    constructor(options = {}) {
        super(options);
        this.controlType = 'dropdown';
        this.options = [];
        this.options = options['options'] || [];
    }
}


/***/ }),

/***/ "./src/app/model-form/form-textbox.ts":
/*!********************************************!*\
  !*** ./src/app/model-form/form-textbox.ts ***!
  \********************************************/
/*! exports provided: FormTextbox */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormTextbox", function() { return FormTextbox; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _estructura_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./estructura-base */ "./src/app/model-form/estructura-base.ts");


class FormTextbox extends _estructura_base__WEBPACK_IMPORTED_MODULE_1__["EstructuraBase"] {
    //type: string;
    /*maxlength:number;
    minlength:number;
    email: number;
    number:number;*/
    constructor(options = {}) {
        super(options);
        this.controlType = 'textbox';
        //this.type = options['type'] || '';
        /*this.maxlength = options['maxlength'] === undefined ? 1 : options['maxlength'];
        this.minlength = options['minlength'] === undefined ? 1 : options['minlength'];
        this.email = options['email'] === undefined ? 1 : options['email'];
        this.number = options['number'] === undefined ? 1 : options['number'];*/
    }
}


/***/ }),

/***/ "./src/app/modificausuario/modificausuario.component.css":
/*!***************************************************************!*\
  !*** ./src/app/modificausuario/modificausuario.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvbW9kaWZpY2F1c3VhcmlvL21vZGlmaWNhdXN1YXJpby5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/modificausuario/modificausuario.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/modificausuario/modificausuario.component.ts ***!
  \**************************************************************/
/*! exports provided: ModificausuarioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModificausuarioComponent", function() { return ModificausuarioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../servicios/set-form.service */ "./src/app/servicios/set-form.service.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");




let ModificausuarioComponent = class ModificausuarioComponent {
    constructor(servicioFormulario, ruta, formatFormulario) {
        this.ruta = ruta;
        this.formatFormulario = formatFormulario;
        this.idFormulario = 20;
        this.parametrosDestino = [];
        this.procedimientoDestino = "";
        //this.destino=Constants.URL_USUARIO;
        this.descripcion = "Modificación De Usuario";
        let arrayDatos = [];
        servicioFormulario.getFormulario(this.idFormulario)
            .subscribe((data) => {
            //arrayDatos = this.formatFormulario.formatFormulario(data);
            this.items = arrayDatos;
            console.log(JSON.stringify(this.parametrosDestino));
            return this.items.sort((a, b) => a.order - b.order);
        });
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
};
ModificausuarioComponent.ctorParameters = () => [
    { type: _servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"] }
];
ModificausuarioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-modificausuario',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./modificausuario.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modificausuario/modificausuario.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./modificausuario.component.css */ "./src/app/modificausuario/modificausuario.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_set_form_service__WEBPACK_IMPORTED_MODULE_2__["SetFormService"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_3__["Utils"]])
], ModificausuarioComponent);



/***/ }),

/***/ "./src/app/navigation/navigation.component.css":
/*!*****************************************************!*\
  !*** ./src/app/navigation/navigation.component.css ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".spacer {\r\n    flex: 1 1 auto;\r\n  }\r\n  \r\n  .container-123 {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n  }\r\n  \r\n  mat-sidenav {\r\n    width: 250px;\r\n  }\r\n  \r\n  .circle {\r\n    border-radius: 50%;\r\n  }\r\n  \r\n  .with-bg {\r\n    background: url('office.png') no-repeat center;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: -1;\r\n    max-height: 130px;\r\n  }\r\n  \r\n  .no-shadow {\r\n    box-shadow: none !important;\r\n  }\r\n  \r\n  ::ng-deep .mat-expansion-panel-body {\r\n    padding: 0px !important;\r\n    padding-left: 10px !important;\r\n  }\r\n  \r\n  .header-box-shadow {\r\n    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);\r\n  }\r\n  \r\n  .bottom-to-top {\r\n    border: 0px;\r\n    border-right: 1px;\r\n    border-style: solid;\r\n    -o-border-image:\r\n    linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;\r\n       border-image:\r\n    linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%\r\n  }\r\n  \r\n  .itemClass{\r\n    padding-top: 5px;\r\n    padding-left: 5px;\r\n  }\r\n  \r\n  .itemChildClass {\r\n    position: absolute;\r\n    padding-top: 3px !important;\r\n    padding-left: 4px !important;    \r\n  }\r\n  \r\n  .white-navi{\r\n    color:#ffffff !important;\r\n  }\r\n  \r\n  .black-navi{\r\n    color:#000000 !important;\r\n    font-size: 13px;\r\n    font-weight: bolder;\r\n  }\r\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/navigation/navigation.component.ts":
/*!****************************************************!*\
  !*** ./src/app/navigation/navigation.component.ts ***!
  \****************************************************/
/*! exports provided: NavigationComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationComponent", function() { return NavigationComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/flex-layout */ "./node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../servicios/login-service.service */ "./src/app/servicios/login-service.service.ts");
/* harmony import */ var _servicios_menu_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../servicios/menu.service */ "./src/app/servicios/menu.service.ts");
/* harmony import */ var _servicios_helper_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../servicios/helper.service */ "./src/app/servicios/helper.service.ts");






//import { element } from '@angular/core/src/render3';
let NavigationComponent = class NavigationComponent {
    constructor(media, servicioLogin, servicioMenu, _helper) {
        this.servicioLogin = servicioLogin;
        this.servicioMenu = servicioMenu;
        this._helper = _helper;
        this.opened = true;
        this.over = 'side';
        this.expandHeight = '42px';
        this.collapseHeight = '42px';
        this.displayMode = 'flat';
        this.opcionActual = {
            opcion: 'Inicio',
            ruta: '/inicio',
            icon: 'home'
        };
        this.usuario = '';
        this.menuOptions = [];
        /*menuOptions =
          [
      
            {
              "opcion": "Inicio",
              "icon": "home",
              "ruta": "/inicio",
              "hasChildren": false
            },
            {
              "opcion": "Administracion",
              "icon": "record_voice_over",
              "hasChildren": true,
              "children": [
                {
                  "opcion": "Nuevo",
                  "ruta": "/creacionusuarios",
                  "icon": "add_circle"
                },
                {
                  "opcion": "Gestión",
                  "ruta": "/gestionusuarios",
                  "icon": "search"
                }
              ]
            },
            {
              "opcion": "Cuentas",
              "icon": "perm_contact_calendar",
              "hasChildren": true,
              "children": [
                {
                  "opcion": "Nueva",
                  "ruta": "/inicio",
                  "icon": "add_circle"
                },
                {
                  "opcion": "Consultar",
                  "ruta": "/inicio",
                  "icon": "search"
                }
              ]
            },
            {
              "opcion": "Contactos",
              "icon": "contacts",
              "hasChildren": true,
              "children": [
                {
                  "opcion": "Nueva",
                  "ruta": "/inicio",
                  "icon": "add_circle"
                },
                {
                  "opcion": "Consultar",
                  "ruta": "/inicio",
                  "icon": "search"
                }
              ]
            },
            {
              "opcion": "Informes",
              "icon": "assignment",
              "hasChildren": true,
              "children": [
                {
                  "opcion": "General",
                  "ruta": "/inicio",
                  "icon": "call_split"
                },
                {
                  "opcion": "Especifico",
                  "ruta": "/inicio",
                  "icon": "call_merge"
                }
              ]
            },
            {
              "opcion": "Administracion",
              "icon": "work",
              "hasChildren": true,
              "children": [
                {
                  "opcion": "Usuarios",
                  "ruta": "/inicio",
                  "icon": "group"
                },
                {
                  "opcion": "Configuracion",
                  "ruta": "/inicio",
                  "icon": "settings"
                }
              ]
            }
      
          ];*/
        this._fruits = ['Apple', 'Banana', 'Grapefruit'];
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        this.usuario = infoUsuario[0].Nombre;
        this.watcher = media.media$.subscribe((change) => {
            if (change.mqAlias === 'sm' || change.mqAlias === 'xs') {
                this.opened = false;
                this.over = 'over';
            }
            else {
                this.opened = true;
                this.over = 'side';
            }
        });
    }
    ngOnInit() {
        // this._helper.each(this._fruits, console.log);
        let infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        this.servicioMenu.getMenu(infoUsuario[0].IdTpoUsuario).subscribe(data => {
            //console.log(JSON.stringify(data));
            let menuJSON = [];
            let submenuJSON = [];
            menuJSON = this._helper.filter(data, function (menu) {
                return (menu.haschildren == 1 ||
                    (menu.haschildren == 0 && menu.idpadre == null));
            });
            //alert(JSON.stringify(menuJSON));
            submenuJSON = this._helper.filter(data, function (menu) {
                return menu.haschildren == 0 && menu.idpadre != null;
            });
            //console.log(JSON.stringify(submenuJSON));
            //alert(JSON.stringify(submenuJSON));
            menuJSON.forEach(element => {
                if (element.haschildren == 1) {
                    element.haschildren = true;
                    element.children = [];
                }
                else {
                    element.haschildren = false;
                }
            });
            //console.log(JSON.stringify(menuJSON));
            //console.log(JSON.stringify(submenuJSON));
            submenuJSON.forEach(element => {
                let idPadre = element.idpadre;
                //alert(idPadre);
                //alert(JSON.stringify(menuJSON));
                let indiceMenu = this._helper.findIndex(menuJSON, { idmenu: idPadre });
                //alert(JSON.stringify(indiceMenu));
                if (element.haschildren == 1) {
                    element.haschildren = true;
                }
                else {
                    element.haschildren = false;
                }
                //console.log(JSON.stringify(menuJSON));
                //console.log(indiceMenu);
                menuJSON[indiceMenu].children.push({
                    opcion: element.opcion,
                    ruta: element.ruta,
                    icono: element.icono,
                    order: element.orden
                });
                // alert(JSON.stringify(element));
                // alert(indiceMenu);
            });
            menuJSON.forEach(element => {
                // alert(JSON.stringify(element));
                if (element.haschildren) {
                    let valor = this._helper.sortBy(element.children, 'order');
                    // alert(JSON.stringify(valor));
                    element.children = valor;
                }
            });
            // console.log(JSON.stringify(menuJSON));
            this.menuOptions = menuJSON;
            // console.log(JSON.stringify(this.menuOptions));
            /*data.forEach(element => {
      
            });*/
            // console.log(JSON.stringify(res));
        });
    }
    thisRoute(item) {
        this.opcionActual = {
            opcion: item.opcion,
            ruta: item.ruta,
            icon: item.icon
        };
        // alert(JSON.stringify(item));
    }
    logOut() {
        this.servicioLogin.setUserLoggedOut();
    }
};
NavigationComponent.ctorParameters = () => [
    { type: _angular_flex_layout__WEBPACK_IMPORTED_MODULE_2__["MediaObserver"] },
    { type: _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__["LoginService"] },
    { type: _servicios_menu_service__WEBPACK_IMPORTED_MODULE_4__["MenuService"] },
    { type: _servicios_helper_service__WEBPACK_IMPORTED_MODULE_5__["HelperService"] }
];
NavigationComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-navigation',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./navigation.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/navigation/navigation.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./navigation.component.css */ "./src/app/navigation/navigation.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_flex_layout__WEBPACK_IMPORTED_MODULE_2__["MediaObserver"],
        _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_3__["LoginService"],
        _servicios_menu_service__WEBPACK_IMPORTED_MODULE_4__["MenuService"],
        _servicios_helper_service__WEBPACK_IMPORTED_MODULE_5__["HelperService"]])
], NavigationComponent);



/***/ }),

/***/ "./src/app/pipes/filter.pipe.ts":
/*!**************************************!*\
  !*** ./src/app/pipes/filter.pipe.ts ***!
  \**************************************/
/*! exports provided: FilterPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FilterPipe", function() { return FilterPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FilterPipe = class FilterPipe {
    transform(items, searchText) {
        //console.log(items);
        if (!items)
            return [];
        if (!searchText)
            return items;
        //console.log(searchText);
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.busqueda.toLowerCase().includes(searchText);
        });
    }
};
FilterPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'filter'
    })
], FilterPipe);



/***/ }),

/***/ "./src/app/ruta-entregas/ruta-entregas.component.css":
/*!***********************************************************!*\
  !*** ./src/app/ruta-entregas/ruta-entregas.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvcnV0YS1lbnRyZWdhcy9ydXRhLWVudHJlZ2FzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/ruta-entregas/ruta-entregas.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/ruta-entregas/ruta-entregas.component.ts ***!
  \**********************************************************/
/*! exports provided: RutaEntregasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RutaEntregasComponent", function() { return RutaEntregasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");



let RutaEntregasComponent = class RutaEntregasComponent {
    constructor(ruta) {
        this.ruta = ruta;
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
};
RutaEntregasComponent.ctorParameters = () => [
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"] }
];
RutaEntregasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-ruta-entregas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./ruta-entregas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/ruta-entregas/ruta-entregas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./ruta-entregas.component.css */ "./src/app/ruta-entregas/ruta-entregas.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_utils_utils__WEBPACK_IMPORTED_MODULE_2__["Utils"]])
], RutaEntregasComponent);



/***/ }),

/***/ "./src/app/servicio/creacion-paquete/creacion-paquete.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/servicio/creacion-paquete/creacion-paquete.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvc2VydmljaW8vY3JlYWNpb24tcGFxdWV0ZS9jcmVhY2lvbi1wYXF1ZXRlLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/servicio/creacion-paquete/creacion-paquete.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/servicio/creacion-paquete/creacion-paquete.component.ts ***!
  \*************************************************************************/
/*! exports provided: CreacionPaqueteComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreacionPaqueteComponent", function() { return CreacionPaqueteComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CreacionPaqueteComponent = class CreacionPaqueteComponent {
    constructor() { }
    ngOnInit() {
    }
};
CreacionPaqueteComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-creacion-paquete',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./creacion-paquete.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/creacion-paquete/creacion-paquete.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./creacion-paquete.component.css */ "./src/app/servicio/creacion-paquete/creacion-paquete.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], CreacionPaqueteComponent);



/***/ }),

/***/ "./src/app/servicio/crear-servicio/crear-servicio.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/servicio/crear-servicio/crear-servicio.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvc2VydmljaW8vY3JlYXItc2VydmljaW8vY3JlYXItc2VydmljaW8uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/servicio/crear-servicio/crear-servicio.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/servicio/crear-servicio/crear-servicio.component.ts ***!
  \*********************************************************************/
/*! exports provided: CrearServicioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrearServicioComponent", function() { return CrearServicioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CrearServicioComponent = class CrearServicioComponent {
    constructor() { }
    ngOnInit() {
    }
};
CrearServicioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-crear-servicio',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./crear-servicio.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/crear-servicio/crear-servicio.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./crear-servicio.component.css */ "./src/app/servicio/crear-servicio/crear-servicio.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], CrearServicioComponent);



/***/ }),

/***/ "./src/app/servicio/modificar-paquete/modificar-paquete.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/servicio/modificar-paquete/modificar-paquete.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvc2VydmljaW8vbW9kaWZpY2FyLXBhcXVldGUvbW9kaWZpY2FyLXBhcXVldGUuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/servicio/modificar-paquete/modificar-paquete.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/servicio/modificar-paquete/modificar-paquete.component.ts ***!
  \***************************************************************************/
/*! exports provided: ModificarPaqueteComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModificarPaqueteComponent", function() { return ModificarPaqueteComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ModificarPaqueteComponent = class ModificarPaqueteComponent {
    constructor() { }
    ngOnInit() {
    }
};
ModificarPaqueteComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-modificar-paquete',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./modificar-paquete.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/modificar-paquete/modificar-paquete.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./modificar-paquete.component.css */ "./src/app/servicio/modificar-paquete/modificar-paquete.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ModificarPaqueteComponent);



/***/ }),

/***/ "./src/app/servicio/modificar-servicio/modificar-servicio.component.css":
/*!******************************************************************************!*\
  !*** ./src/app/servicio/modificar-servicio/modificar-servicio.component.css ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvc2VydmljaW8vbW9kaWZpY2FyLXNlcnZpY2lvL21vZGlmaWNhci1zZXJ2aWNpby5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/servicio/modificar-servicio/modificar-servicio.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/servicio/modificar-servicio/modificar-servicio.component.ts ***!
  \*****************************************************************************/
/*! exports provided: ModificarServicioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModificarServicioComponent", function() { return ModificarServicioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ModificarServicioComponent = class ModificarServicioComponent {
    constructor() { }
    ngOnInit() {
    }
};
ModificarServicioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-modificar-servicio',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./modificar-servicio.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/modificar-servicio/modificar-servicio.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./modificar-servicio.component.css */ "./src/app/servicio/modificar-servicio/modificar-servicio.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ModificarServicioComponent);



/***/ }),

/***/ "./src/app/servicio/servicio.component.css":
/*!*************************************************!*\
  !*** ./src/app/servicio/servicio.component.css ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvc2VydmljaW8vc2VydmljaW8uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/servicio/servicio.component.ts":
/*!************************************************!*\
  !*** ./src/app/servicio/servicio.component.ts ***!
  \************************************************/
/*! exports provided: ServicioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServicioComponent", function() { return ServicioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ServicioComponent = class ServicioComponent {
    constructor() { }
    ngOnInit() {
    }
};
ServicioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-servicio',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./servicio.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/servicio/servicio.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./servicio.component.css */ "./src/app/servicio/servicio.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ServicioComponent);



/***/ }),

/***/ "./src/app/servicios/agencia.service.ts":
/*!**********************************************!*\
  !*** ./src/app/servicios/agencia.service.ts ***!
  \**********************************************/
/*! exports provided: AgenciaService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AgenciaService", function() { return AgenciaService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let AgenciaService = class AgenciaService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getAllAgencia(idAgencia) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_AGENCIA + "/" + idAgencia;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Agencias",
                    text: "Error Cargando Agencias.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getAgencia(idUsuario, idAgencia) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_AGENCIA +
            "/" +
            idUsuario +
            "/" +
            idAgencia;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Agencias",
                    text: "Error Cargando Agencias.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postAgencia(params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_AGENCIA;
        return this.http.post(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Agencias",
                    text: "Verifique la informacion ingresada.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putAgencia(idAgencia, params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_AGENCIA + "/" + idAgencia;
        return this.http.put(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Agencia",
                    text: "Error actualizando información de la agencia.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteAgencia(agencia, usuario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_AGENCIA +
            "/" +
            agencia +
            "/" +
            usuario;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Agencia",
                    text: "Error eliminado información de la agencia.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
AgenciaService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
AgenciaService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], AgenciaService);



/***/ }),

/***/ "./src/app/servicios/archivos.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/archivos.service.ts ***!
  \***********************************************/
/*! exports provided: ArchivosService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArchivosService", function() { return ArchivosService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let ArchivosService = class ArchivosService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getInformeCarguesRealizados(agencia, usuarioConsulta, idUsuario, fechaInicial, fechaFinal) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ARCHIVO + '/' + idUsuario + '/' + fechaInicial + '/' + fechaFinal + '/' + agencia + '/' + usuarioConsulta;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Cargues',
                    text: 'Error Mostrando Cargues Realizados.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postArchivo(idProceso, idUsuario, archivo, nombre) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ARCHIVO +
            "/" +
            idProceso +
            "/" +
            idUsuario;
        const formData = new FormData();
        formData.append("file", archivo, nombre);
        return this.http.post(url, formData).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Carga De Archivo",
                    text: "Verifique la estructura del archivo.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postProcesoCargue(infoCargue) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ARCHIVO;
        return this.http.post(url, infoCargue).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Proceso Cargue",
                    text: "Verifique El Proceso.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
ArchivosService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
ArchivosService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], ArchivosService);



/***/ }),

/***/ "./src/app/servicios/auth.service.ts":
/*!*******************************************!*\
  !*** ./src/app/servicios/auth.service.ts ***!
  \*******************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _auth0_angular_jwt__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @auth0/angular-jwt */ "./node_modules/@auth0/angular-jwt/index.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");







let AuthService = class AuthService {
    constructor(http) {
        this.http = http;
    }
    refreshToken() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_6__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_6__["Constants"].URL_REFRESH;
        //alert("respuesta");
        // append refresh token if you have one
        const refreshToken = String(sessionStorage.getItem('refresh_token'));
        const expiredToken = String(sessionStorage.getItem('token'));
        let infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
        //alert(JSON.stringify(infoUsuario));
        return this.http
            .get(url, {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]()
                .set('refreshtoken', refreshToken)
                .set('token', expiredToken)
                .set('idusuario', String(infoUsuario[0].IdUsuario)),
            observe: 'response'
        })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["share"])(), // <========== YOU HAVE TO SHARE THIS OBSERVABLE TO AVOID MULTIPLE REQUEST BEING SENT SIMULTANEOUSLY
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            const token = res.headers.get('token');
            const newRefreshToken = res.headers.get('refresh_token');
            let body = JSON.stringify(Object.assign({}, res.body));
            let bodyJSON = JSON.parse(body);
            //console.log(JSON.stringify(bodyJSON.token));
            // store the new tokens
            sessionStorage.setItem('refresh_token', bodyJSON.refresh_token);
            sessionStorage.removeItem('token');
            sessionStorage.setItem('token', bodyJSON.token);
            return bodyJSON.token;
        }));
    }
    getToken() {
        //alert("aqui");
        const token = sessionStorage.getItem('token');
        const decoder = new _auth0_angular_jwt__WEBPACK_IMPORTED_MODULE_5__["JwtHelperService"]();
        const isTokenExpired = decoder.isTokenExpired(token);
        //console.log("expiro: "+isTokenExpired);
        if (!isTokenExpired) {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(token);
        }
        return this.refreshToken();
    }
};
AuthService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"]])
], AuthService);



/***/ }),

/***/ "./src/app/servicios/ciudades.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/ciudades.service.ts ***!
  \***********************************************/
/*! exports provided: CiudadesService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CiudadesService", function() { return CiudadesService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let CiudadesService = class CiudadesService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getCiudades(depto) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_CIUDAD + '/' + depto;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Tipo Documento',
                    text: 'Error Cargando Tipos Documento.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
CiudadesService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
CiudadesService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], CiudadesService);



/***/ }),

/***/ "./src/app/servicios/colors.service.ts":
/*!*********************************************!*\
  !*** ./src/app/servicios/colors.service.ts ***!
  \*********************************************/
/*! exports provided: ColorsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorsService", function() { return ColorsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ColorsService = class ColorsService {
    constructor() {
        /*colores = [
          "#008000",
          "#20b2aa",
          "#ff0000",
          "#ffe4e1",
          "#ffd700",
          "#00ffff",
          "#ffc0cb",
          "#40e0d0",
          "#e6e6fa",
          "#d3ffce",
          "#0000ff",
          "#ffa500",
          "#f0f8ff",
          "#b0e0e6",
          "#7fffd4",
          "#c6e2ff",
          "#faebd7",
          "#cccccc",
          "#eeeeee",
          "#fa8072",
          "#800080",
          "#ffb6c1",
          "#800000",
          "#00ff00",
          "#333333",
          "#003366",
          "#ffff00",
          "#008080",
          "#c0c0c0",
          "#ffc3a0",
          "#f08080",
          "#66cdaa",
          "#f6546a",
          "#fff68f",
          "#468499",
          "#ff6666",
          "#666666",
          "#c39797",
          "#00ced1",
          "#ffdab9",
          "#ff00ff",
          "#ff7373",
          "#660066",
          "#088da5",
          "#c0d6e4",
          "#f5f5f5",
          "#8b0000",
          "#0e2f44",
          "#ff7f50",
          "#afeeee",
          "#990000",
          "#808080",
          "#dddddd",
          "#b4eeb4",
          "#daa520",
          "#ffff66",
          "#00ff7f",
          "#cbbeb5",
          "#f5f5dc",
          "#8a2be2",
          "#81d8d0",
          "#ff4040",
          "#b6fcd5",
          "#66cccc",
          "#a0db8e",
          "#794044",
          "#3399ff",
          "#cc0000",
          "#ccff00",
          "#000080",
          "#3b5998",
          "#0099cc",
          "#999999",
          "#6897bb",
          "#191970",
          "#31698a",
          "#ff4444",
          "#fef65b",
          "#ff1493",
          "#f7f7f7",
          "#191919",
          "#6dc066"
          ];*/
        this.colores = [
            "#63b598",
            "#ce7d78",
            "#ea9e70",
            "#a48a9e",
            "#c6e1e8",
            "#648177",
            "#0d5ac1",
            "#f205e6",
            "#1c0365",
            "#14a9ad",
            "#4ca2f9",
            "#a4e43f",
            "#d298e2",
            "#6119d0",
            "#d2737d",
            "#c0a43c",
            "#f2510e",
            "#651be6",
            "#79806e",
            "#61da5e",
            "#cd2f00",
            "#9348af",
            "#01ac53",
            "#c5a4fb",
            "#996635",
            "#b11573",
            "#4bb473",
            "#75d89e",
            "#2f3f94",
            "#2f7b99",
            "#da967d",
            "#34891f",
            "#b0d87b",
            "#ca4751",
            "#7e50a8",
            "#c4d647",
            "#e0eeb8",
            "#11dec1",
            "#289812",
            "#566ca0",
            "#ffdbe1",
            "#2f1179",
            "#935b6d",
            "#916988",
            "#513d98",
            "#aead3a",
            "#9e6d71",
            "#4b5bdc",
            "#0cd36d",
            "#250662",
            "#cb5bea",
            "#228916",
            "#ac3e1b",
            "#df514a",
            "#539397",
            "#880977",
            "#f697c1",
            "#ba96ce",
            "#679c9d",
            "#c6c42c",
            "#5d2c52",
            "#48b41b",
            "#e1cf3b",
            "#5be4f0",
            "#57c4d8",
            "#a4d17a",
            "#225b8",
            "#be608b",
            "#96b00c",
            "#088baf",
            "#f158bf",
            "#e145ba",
            "#ee91e3",
            "#05d371",
            "#5426e0",
            "#4834d0",
            "#802234",
            "#6749e8",
            "#0971f0",
            "#8fb413",
            "#b2b4f0",
            "#c3c89d",
            "#c9a941",
            "#41d158",
            "#fb21a3",
            "#51aed9",
            "#5bb32d",
            "#807fb",
            "#21538e",
            "#89d534",
            "#d36647",
            "#7fb411",
            "#0023b8",
            "#3b8c2a",
            "#986b53",
            "#f50422",
            "#983f7a",
            "#ea24a3",
            "#79352c",
            "#521250",
            "#c79ed2",
            "#d6dd92",
            "#e33e52",
            "#b2be57",
            "#fa06ec",
            "#1bb699",
            "#6b2e5f",
            "#64820f",
            "#1c271",
            "#21538e",
            "#89d534",
            "#d36647",
            "#7fb411",
            "#0023b8",
            "#3b8c2a",
            "#986b53",
            "#f50422",
            "#983f7a",
            "#ea24a3",
            "#79352c",
            "#521250",
            "#c79ed2",
            "#d6dd92",
            "#e33e52",
            "#b2be57",
            "#fa06ec",
            "#1bb699",
            "#6b2e5f",
            "#64820f",
            "#1c271",
            "#9cb64a",
            "#996c48",
            "#9ab9b7",
            "#06e052",
            "#e3a481",
            "#0eb621",
            "#fc458e",
            "#b2db15",
            "#aa226d",
            "#792ed8",
            "#73872a",
            "#520d3a",
            "#cefcb8",
            "#a5b3d9",
            "#7d1d85",
            "#c4fd57",
            "#f1ae16",
            "#8fe22a",
            "#ef6e3c",
            "#243eeb",
            "#1dc18",
            "#dd93fd",
            "#3f8473",
            "#e7dbce",
            "#421f79",
            "#7a3d93",
            "#635f6d",
            "#93f2d7",
            "#9b5c2a",
            "#15b9ee",
            "#0f5997",
            "#409188",
            "#911e20",
            "#1350ce",
            "#10e5b1",
            "#fff4d7",
            "#cb2582",
            "#ce00be",
            "#32d5d6",
            "#17232",
            "#608572",
            "#c79bc2",
            "#00f87c",
            "#77772a",
            "#6995ba",
            "#fc6b57",
            "#f07815",
            "#8fd883",
            "#060e27",
            "#96e591",
            "#21d52e",
            "#d00043",
            "#b47162",
            "#1ec227",
            "#4f0f6f",
            "#1d1d58",
            "#947002",
            "#bde052",
            "#e08c56",
            "#28fcfd",
            "#bb09b",
            "#36486a",
            "#d02e29",
            "#1ae6db",
            "#3e464c",
            "#a84a8f",
            "#911e7e",
            "#3f16d9",
            "#0f525f",
            "#ac7c0a",
            "#b4c086",
            "#c9d730",
            "#30cc49",
            "#3d6751",
            "#fb4c03",
            "#640fc1",
            "#62c03e",
            "#d3493a",
            "#88aa0b",
            "#406df9",
            "#615af0",
            "#4be47",
            "#2a3434",
            "#4a543f",
            "#79bca0",
            "#a8b8d4",
            "#00efd4",
            "#7ad236",
            "#7260d8",
            "#1deaa7",
            "#06f43a",
            "#823c59",
            "#e3d94c",
            "#dc1c06",
            "#f53b2a",
            "#b46238",
            "#2dfff6",
            "#a82b89",
            "#1a8011",
            "#436a9f",
            "#1a806a",
            "#4cf09d",
            "#c188a2",
            "#67eb4b",
            "#b308d3",
            "#fc7e41",
            "#af3101",
            "#ff065",
            "#71b1f4",
            "#a2f8a5",
            "#e23dd0",
            "#d3486d",
            "#00f7f9",
            "#474893",
            "#3cec35",
            "#1c65cb",
            "#5d1d0c",
            "#2d7d2a",
            "#ff3420",
            "#5cdd87",
            "#a259a4",
            "#e4ac44",
            "#1bede6",
            "#8798a4",
            "#d7790f",
            "#b2c24f",
            "#de73c2",
            "#d70a9c",
            "#25b67",
            "#88e9b8",
            "#c2b0e2",
            "#86e98f",
            "#ae90e2",
            "#1a806b",
            "#436a9e",
            "#0ec0ff",
            "#f812b3",
            "#b17fc9",
            "#8d6c2f",
            "#d3277a",
            "#2ca1ae",
            "#9685eb",
            "#8a96c6",
            "#dba2e6",
            "#76fc1b",
            "#608fa4",
            "#20f6ba",
            "#07d7f6",
            "#dce77a",
            "#77ecca"
        ];
        this.newColor = ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080'];
    }
    getRandomColor(i) {
        /*let letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }*/
        /*let color = "hsl(" + 360 * Math.random() + ',' +
                     (25 + 70 * Math.random()) + '%,' +
                     (85 + 10 * Math.random()) + '%)';*/
        //let color = this.colores[Math.floor(Math.random() * this.colores.length)];
        let color = this.colores[i];
        return color;
    }
};
ColorsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ColorsService);



/***/ }),

/***/ "./src/app/servicios/departamentos.service.ts":
/*!****************************************************!*\
  !*** ./src/app/servicios/departamentos.service.ts ***!
  \****************************************************/
/*! exports provided: DepartamentosService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DepartamentosService", function() { return DepartamentosService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let DepartamentosService = class DepartamentosService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getDepartamentos() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_DEPARTAMENTO;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Departamentos',
                    text: 'Error Cargando Departamentos.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
DepartamentosService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
DepartamentosService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], DepartamentosService);



/***/ }),

/***/ "./src/app/servicios/direccion.service.ts":
/*!************************************************!*\
  !*** ./src/app/servicios/direccion.service.ts ***!
  \************************************************/
/*! exports provided: DireccionService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DireccionService", function() { return DireccionService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let DireccionService = class DireccionService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    postDireccion(direccion) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_DIRECCION;
        //alert(url);
        return this.http.post(url, direccion).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Dirección',
                    text: 'Verifique la informacion ingresada.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putDireccion(direccion) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_DIRECCION;
        return this.http.put(url, direccion).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Dirección',
                    text: 'Error actualizando información de la dirección.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteDireccion(direccion) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_DIRECCION + '/' + direccion;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Dirección',
                text: 'Error eliminado información de la dirección.',
                type: 'error'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
DireccionService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
DireccionService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], DireccionService);



/***/ }),

/***/ "./src/app/servicios/dropdown.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/dropdown.service.ts ***!
  \***********************************************/
/*! exports provided: DropdownService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownService", function() { return DropdownService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let DropdownService = class DropdownService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getData(origen, id) {
        let url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + origen + '/' + id;
        //alert(url);
        return this.http.get(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Formulario',
                    text: 'Error Cargando la informacion.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
DropdownService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
DropdownService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], DropdownService);



/***/ }),

/***/ "./src/app/servicios/encuesta.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/encuesta.service.ts ***!
  \***********************************************/
/*! exports provided: EncuestaService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EncuestaService", function() { return EncuestaService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let EncuestaService = class EncuestaService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getEncuestas() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ENCUESTA;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Encuesta',
                    text: 'Error Cargando Encuestas.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getEncuestaCopiar(idEncuesta) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ENCUESTA + '/' + idEncuesta;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Encuesta',
                text: 'Error Cargando Encuestas.',
                type: 'error'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putReordenaEncuestaBloque(encuestaBloque) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ENCUESTA_BLOQUE + '/1';
        return this.http.put(url, encuestaBloque).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Bloque Encuesta',
                text: 'Error Reordenando bloque encuesta.',
                type: 'error'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putEncuestaBloque(encuestaBloque) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ENCUESTA_BLOQUE;
        return this.http.put(url, encuestaBloque).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Bloque Encuesta',
                text: 'Error agregando bloque encuesta.',
                type: 'error'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteEncuestaBloque(encuestaBloque) {
        const options = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]({
                'Content-Type': 'application/json'
            }),
            body: encuestaBloque
        };
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ENCUESTA_BLOQUE;
        return this.http.delete(url, options).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Bloque Encuesta',
                text: 'Error eliminando bloque encuesta.',
                type: 'error'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
EncuestaService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
EncuestaService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], EncuestaService);



/***/ }),

/***/ "./src/app/servicios/entrega.service.ts":
/*!**********************************************!*\
  !*** ./src/app/servicios/entrega.service.ts ***!
  \**********************************************/
/*! exports provided: EntregaService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntregaService", function() { return EntregaService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let EntregaService = class EntregaService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getInformeEntregas(agencia, usuarioConsulta, idUsuario, fechaInicial, fechaFinal, tipoConsulta) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ENTREGAS + '/' + idUsuario + '/' + fechaInicial + '/' + fechaFinal + '/' + tipoConsulta + '/' + agencia + '/' + usuarioConsulta;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Entregas',
                    text: 'Error Cargando Entregas.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getInformeEntregasRealizadas(agencia, usuarioConsulta, idUsuario, fechaInicial, fechaFinal) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_ENTREGAS + '/' + idUsuario + '/' + fechaInicial + '/' + fechaFinal + '/' + agencia + '/' + usuarioConsulta;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Entregas',
                    text: 'Error Cargando Entregas Realizadas.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
EntregaService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
EntregaService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], EntregaService);



/***/ }),

/***/ "./src/app/servicios/estructura-control.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/servicios/estructura-control.service.ts ***!
  \*********************************************************/
/*! exports provided: EstructuraControlService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EstructuraControlService", function() { return EstructuraControlService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let EstructuraControlService = class EstructuraControlService {
    constructor() { }
    toFormGroup(questions) {
        let group = {};
        questions.forEach(question => {
            //alert(JSON.stringify(question));
            let arrayValidator = [];
            if (question.type == 'date') {
                let today = new Date();
                let formatToday = moment__WEBPACK_IMPORTED_MODULE_3__(today).format('YYYY-MM-DD');
                group[question.key] = new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](formatToday);
            }
            else {
                group[question.key] = new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](question.value || '');
            }
            if (question.required) {
                arrayValidator.push(_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required);
            }
            if (question.maxlength > 0) {
                arrayValidator.push(_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].maxLength(question.maxlength));
            }
            if (question.minlength > 0) {
                arrayValidator.push(_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].minLength(question.minlength));
            }
            if (question.email == 1) {
                arrayValidator.push(_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].email);
            }
            if (question.number == 1) {
                arrayValidator.push(_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].pattern('^[0-9]*$'));
            }
            group[question.key].setValidators(arrayValidator);
            /*group[question.key].setValidators([question.required ? Validators.required : '', (question.maxlength>0) ? Validators.maxLength(question.maxlength) : '']);
      
      
            if(question.required && question.maxlength==0 && question.minlength==0 && question.email==0 && question.number==0){
              group[question.key].setValidators([Validators.required]);
            }
      
            if(question.required && question.maxlength>0 && question.minlength==0 && question.email==0 && question.number==0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength)]);
            }
      
      
            if(question.required && question.maxlength>0 && question.minlength>0 && question.email==0 && question.number==0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength)]);
            }
      
            if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number==0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength), Validators.email]);
            }
      
      
            if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number>0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength), Validators.email, Validators.pattern("^[0-9]*$")]);
            }
      
            //END REQUERIDO TRUE
      
            //COMIENZO REQUERIDO FALSE
      
            if(!question.required && question.maxlength==0 && question.minlength==0 && question.email==0 && question.number==0){
              //group[question.key].setValidators([Validators.required]);
            }
      
            if(!question.required && question.maxlength>0 && question.minlength==0 && question.email==0 && question.number==0){
              group[question.key].setValidators([Validators.maxLength(question.maxlength)]);
            }
      
      
            if(!question.required && question.maxlength>0 && question.minlength>0 && question.email==0 && question.number==0){
              group[question.key].setValidators([Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength)]);
            }
      
            if(!question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number==0){
              group[question.key].setValidators(Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength), Validators.email]);
            }
      
      
            if(!question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number>0){
              group[question.key].setValidators([Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength), Validators.email, Validators.pattern("^[0-9]*$")]);
            }
      
            //END REQUERIDO = FALSE
      
            //COMIENZO MAXLENGTH >0
      
      
      
      
            if(question.required && question.maxlength>0 && question.minlength==0 && question.email==0 && question.number==0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength)]);
            }
      
      
            if(question.required && question.maxlength>0 && question.minlength>0 && question.email==0 && question.number==0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength)]);
            }
      
            if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number==0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength), Validators.email]);
            }
      
      
            if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number>0){
              group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
                Validators.minLength(question.minlength), Validators.email, Validators.pattern("^[0-9]*$")]);
            }*/
            //group[question.key].setValidators(Validators.maxLength(5));
            /*let validadores:ValidatorFn[];
      
            if(question.required){
              alert(validadores);
              validadores.push(Validators.required);
            }
      
            group[question.key] = question.required ? new FormControl(question.value || '', validadores)
              : new FormControl(question.value || '');*/
        });
        return new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormGroup"](group);
    }
};
EstructuraControlService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], EstructuraControlService);



/***/ }),

/***/ "./src/app/servicios/graficas.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/graficas.service.ts ***!
  \***********************************************/
/*! exports provided: GraficasService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GraficasService", function() { return GraficasService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let GraficasService = class GraficasService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getGrafica(grafica) {
        let url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_GRAFICAS_INICIO + grafica;
        return this.http.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Graficas',
                    text: 'Error Cargando Graficas.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getGraficaEntregadoresStacked(agencias, tipo) {
        let url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_GRAFICA + '/' + agencias + '/' + tipo;
        return this.http.get(url)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            /*swal(
              'Error Graficas',
              JSON.stringify(err),
              'error'
            );*/
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Graficas',
                    text: 'Error Cargando Graficas.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
GraficasService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
GraficasService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], GraficasService);



/***/ }),

/***/ "./src/app/servicios/helper.service.ts":
/*!*********************************************!*\
  !*** ./src/app/servicios/helper.service.ts ***!
  \*********************************************/
/*! exports provided: HelperService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelperService", function() { return HelperService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var underscore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! underscore */ "./node_modules/underscore/underscore.js");
/* harmony import */ var underscore__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(underscore__WEBPACK_IMPORTED_MODULE_2__);



let HelperService = class HelperService {
    constructor() { }
    each(array, delegate) {
        return underscore__WEBPACK_IMPORTED_MODULE_2__["each"](array, delegate);
    }
    where(array, search) {
        return underscore__WEBPACK_IMPORTED_MODULE_2__["where"](array, search);
    }
    filter(array, propiedades) {
        return underscore__WEBPACK_IMPORTED_MODULE_2__["filter"](array, propiedades);
    }
    find(array, propiedades) {
        return underscore__WEBPACK_IMPORTED_MODULE_2__["find"](array, propiedades);
    }
    findIndex(array, propiedades) {
        return underscore__WEBPACK_IMPORTED_MODULE_2__["findIndex"](array, propiedades);
    }
    sortBy(array, propiedades) {
        return underscore__WEBPACK_IMPORTED_MODULE_2__["sortBy"](array, propiedades);
    }
    findKey(object, propiedades) {
        return underscore__WEBPACK_IMPORTED_MODULE_2__["findKey"](object, propiedades);
    }
};
HelperService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], HelperService);



/***/ }),

/***/ "./src/app/servicios/imagen.service.ts":
/*!*********************************************!*\
  !*** ./src/app/servicios/imagen.service.ts ***!
  \*********************************************/
/*! exports provided: ImagenService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImagenService", function() { return ImagenService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let ImagenService = class ImagenService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getImagenes(idServicio, tipoImagen) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_IMAGEN + '/' + idServicio + '/' + tipoImagen;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Tipo Documento',
                    text: 'Error Cargando Tipos Documento.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
ImagenService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
ImagenService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], ImagenService);



/***/ }),

/***/ "./src/app/servicios/log-ws.service.ts":
/*!*********************************************!*\
  !*** ./src/app/servicios/log-ws.service.ts ***!
  \*********************************************/
/*! exports provided: LogWsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogWsService", function() { return LogWsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let LogWsService = class LogWsService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getDetalleWS(idTipoWS, idPaquete) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_LOGWS + '/' + idTipoWS + '/' + idPaquete;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Log Web Service',
                    text: 'Error Cargando Log Web Service.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
LogWsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
LogWsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], LogWsService);



/***/ }),

/***/ "./src/app/servicios/login-service.service.ts":
/*!****************************************************!*\
  !*** ./src/app/servicios/login-service.service.ts ***!
  \****************************************************/
/*! exports provided: LoginService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginService", function() { return LoginService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
let LoginService = class LoginService {
    constructor(http) {
        //this.isUserLoggedIn = false;
        //alert("entra ");
        //localStorage.setItem('isLoggedIn', this.isUserLoggedIn);
        this.http = http;
    }
    setUserLoggedIn(infoLogin) {
        var btoaString = infoLogin.username + ':' + infoLogin.password;
        let url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_LOGIN;
        //alert(btoaString);
        //alert(url);
        this.isUserLoggedIn = '1';
        sessionStorage.setItem('isLoggedIn', this.isUserLoggedIn);
        let httpHeaders = new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]()
            .set('Authorization', 'Basic ' + btoa(btoaString))
            .set('Content-Type', 'application/json');
        /*const httpOptions = {
          headers: headers_object
        };*/
        return this.http.post(url, null, { headers: httpHeaders })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            //this.setUserLoggedOut();
            sessionStorage.clear();
            //alert(JSON.stringify(err));
            //console.log("lanza error");     
            //'Error Consulta Estados ',JSON.stringify(err),'error'     
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Login',
                text: 'Verifique la informacion ingresada.',
                type: 'error',
                confirmButtonColor: '#127570'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getUserLoggedIn() {
        //return false;
        let respuesta = '';
        if (!sessionStorage.getItem('isLoggedIn') || sessionStorage.getItem('isLoggedIn') == '0') {
            respuesta = '0';
        }
        else {
            respuesta = '1';
        }
        return respuesta;
    }
    setUserLoggedOut() {
        //this.isUserLoggedIn = '0';
        //sessionStorage.setItem('isLoggedIn', this.isUserLoggedIn);
        sessionStorage.clear();
        location.reload();
    }
};
LoginService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
LoginService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"]])
], LoginService);



/***/ }),

/***/ "./src/app/servicios/menu.service.ts":
/*!*******************************************!*\
  !*** ./src/app/servicios/menu.service.ts ***!
  \*******************************************/
/*! exports provided: MenuService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MenuService", function() { return MenuService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let MenuService = class MenuService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getMenu(id) {
        let url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_MENU + '/' + id;
        console.log(url);
        /*let token = sessionStorage.getItem('token');
          let httpHeaders = new HttpHeaders()
          .set('Authorization', 'Bearer '+token)
          .set('Content-Type', 'application/json'); */
        return this.http.get(url /*, {headers:httpHeaders}*/)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Menu',
                    text: 'Error Cargando El Menu.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
MenuService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
MenuService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"],
        _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], MenuService);



/***/ }),

/***/ "./src/app/servicios/motivo.service.ts":
/*!*********************************************!*\
  !*** ./src/app/servicios/motivo.service.ts ***!
  \*********************************************/
/*! exports provided: MotivoService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MotivoService", function() { return MotivoService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let MotivoService = class MotivoService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getMotivo(idMotivo) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_MOTIVO + '/' + idMotivo;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Motivo',
                    text: 'Error Cargando Motivo.',
                    type: 'error'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postMotivo(params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_MOTIVO;
        return this.http.post(url, params)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else if (err.status === 409) {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Motivo',
                    text: 'Este Codigo Ya Existe, veirifique la información.',
                    type: 'error',
                    confirmButtonColor: '#127570'
                });
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: 'Error Motivo',
                    text: 'Verifique la informacion ingresada.',
                    type: 'error',
                    confirmButtonColor: '#127570'
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putMotivo(idMotivo, params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_MOTIVO + '/' + idMotivo;
        return this.http.put(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Motivo',
                text: 'Error actualizando información del motivo.',
                type: 'error'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteMotivo(idMotivo, usuario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_MOTIVO + '/' + idMotivo + '/' + usuario;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: 'Error Motivo',
                text: 'Error eliminado información del motivo.',
                type: 'error'
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
MotivoService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
MotivoService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], MotivoService);



/***/ }),

/***/ "./src/app/servicios/persona.service.ts":
/*!**********************************************!*\
  !*** ./src/app/servicios/persona.service.ts ***!
  \**********************************************/
/*! exports provided: PersonaService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PersonaService", function() { return PersonaService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let PersonaService = class PersonaService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getPersona(tipoDocumento, numeroDocumento) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA +
            "/" +
            tipoDocumento +
            "/" +
            numeroDocumento;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Persona",
                    text: "Error Cargando Persona.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getBusquedaPersona(busqueda) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA + "/" + busqueda;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Persona",
                    text: "Error Cargando Persona.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getBusquedaPersonaTipoPerfil(busqueda, tipoPerfil) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA +
            "/" +
            busqueda +
            "/tipoPerfil/" +
            tipoPerfil;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Persona",
                    text: "Error Cargando Persona.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getPersonaXVehiculo(idPersona) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA_VEHICULO + "/" + idPersona;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Persona Vehiculo",
                    text: "Error Cargando Persona Vehiculo.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getTipoPersonaXVehiculo(id) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_PERSONA_VEHICULO + "/" + id;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Persona Vehiculo",
                    text: "Error Cargando Tipo Persona Vehiculo.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getPersonaDetalle(idPersona) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA + "/" + idPersona + "/tipo/1";
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Persona",
                    text: "Error Cargando Persona.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postPersonaVehiculo(params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA_VEHICULO;
        return this.http.post(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Agencias",
                    text: "Verifique la informacion ingresada.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putPersona(persona) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA;
        return this.http.put(url, persona).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Persona",
                    text: "Error actualizando información de la persona.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deletePersona(persona) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_PERSONA + "/" + persona;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Persona",
                    text: "Error eliminado información de la persona.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
PersonaService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
PersonaService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], PersonaService);



/***/ }),

/***/ "./src/app/servicios/reporte.service.ts":
/*!**********************************************!*\
  !*** ./src/app/servicios/reporte.service.ts ***!
  \**********************************************/
/*! exports provided: ReporteService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReporteService", function() { return ReporteService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let ReporteService = class ReporteService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    postReporte(infoPayload) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_REPORTE;
        //alert(url);
        return this.http.post(url, infoPayload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Formulario",
                    text: "Verifique la informacion ingresada.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
ReporteService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
ReporteService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], ReporteService);



/***/ }),

/***/ "./src/app/servicios/servicio-gestion-cargue.service.ts":
/*!**************************************************************!*\
  !*** ./src/app/servicios/servicio-gestion-cargue.service.ts ***!
  \**************************************************************/
/*! exports provided: ServicioGestionCargueService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServicioGestionCargueService", function() { return ServicioGestionCargueService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let ServicioGestionCargueService = class ServicioGestionCargueService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    PaquetesConsultar(idServicioEncabezado) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_GESTIONENTREGAS + '/paquetes/' + idServicioEncabezado;
        return this.returnMetodo(url, "ENTREGAS", "Error al consultar paquetes", "error", TipoSincronizacion.Get, null);
    }
    MotivosConsultar(idTpoMotivo) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_GESTIONENTREGAS + '/motivos/' + idTpoMotivo;
        return this.returnMetodo(url, "ENTREGAS", "Error al consultar paquetes", "error", TipoSincronizacion.Get, null);
    }
    EntregaGuardar(NvoEntrega) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_GESTIONENTREGAS + '/entregaCrear/';
        return this.returnMetodo(url, "GESTION ENTREGA", "Error al crear la nueva gestion de entrega", "error", TipoSincronizacion.Create, NvoEntrega);
    }
    EntregasProcesar(idAgencia, idServicioEnc) {
        const url = "http://18.210.107.20/cncaldas_bifrost_qa/api/DataBaseSync/RunAllOnRoute/all/amb/300/" + idAgencia + "/" + idServicioEnc;
        return this.returnMetodo(url, "GESTION ENTREGA", "Error al enviar la informacion de la entrega EORDER", "error", TipoSincronizacion.Get, null);
    }
    EntregaNueva(NvoEntrega) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_GESTIONENTREGAS + '/entregaGuardar/';
        return this.returnMetodo(url, "GESTION ENTREGA", "Error al crear la nueva entrega", "error", TipoSincronizacion.Create, NvoEntrega);
    }
    EntregaVerificar(NvoEntrega) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_GESTIONENTREGAS + '/entregaVerificarExiste/';
        return this.returnMetodo(url, "ENTREGAS", "Error al verificar paquete", "error", TipoSincronizacion.Get, NvoEntrega);
    }
    returnMetodo(url, tituloErr, msgErr, icnErr, tipoSincron, bodyData) {
        const fnErr = Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])((err) => {
            console.log(err);
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: tituloErr,
                    text: msgErr,
                    type: "error",
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        });
        switch (tipoSincron) {
            case TipoSincronizacion.Create:
                return this.http.post(url, bodyData).pipe(fnErr);
                break;
            case TipoSincronizacion.Delete:
                return this.http.delete(url).pipe(fnErr);
                break;
            case TipoSincronizacion.Get:
                return this.http.get(url).pipe(fnErr);
                break;
            case TipoSincronizacion.Update:
                return this.http.put(url, bodyData).pipe(fnErr);
                break;
        }
    }
};
ServicioGestionCargueService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
ServicioGestionCargueService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], ServicioGestionCargueService);

var TipoSincronizacion;
(function (TipoSincronizacion) {
    TipoSincronizacion[TipoSincronizacion["Get"] = 0] = "Get";
    TipoSincronizacion[TipoSincronizacion["Delete"] = 1] = "Delete";
    TipoSincronizacion[TipoSincronizacion["Update"] = 2] = "Update";
    TipoSincronizacion[TipoSincronizacion["Create"] = 3] = "Create";
})(TipoSincronizacion || (TipoSincronizacion = {}));


/***/ }),

/***/ "./src/app/servicios/servicio.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/servicio.service.ts ***!
  \***********************************************/
/*! exports provided: ServicioService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServicioService", function() { return ServicioService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let ServicioService = class ServicioService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getServiciosDisponibles() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_SERVICIO;
        return this.http.get(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Transportador",
                    text: "Error Cargando la informacion.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getServiciosAsignados(id) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_SERVICIO + "/" + id;
        return this.http.get(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: "Error Transportador",
                text: "Error Cargando la informacion.",
                type: "error"
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getInformeServiciosAsignados() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_SERVICIO + "/6/5";
        return this.http.get(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: "Error Transportador",
                text: "Error Cargando la informacion.",
                type: "error"
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postAsignarServicio(infoPayload) {
        const url = '';
        //alert(url);
        return this.http.post(url, infoPayload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                title: "Error Formulario",
                text: "Verifique la informacion ingresada.",
                type: "error"
            });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
ServicioService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
ServicioService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], ServicioService);



/***/ }),

/***/ "./src/app/servicios/set-form.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/set-form.service.ts ***!
  \***********************************************/
/*! exports provided: SetFormService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SetFormService", function() { return SetFormService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let SetFormService = class SetFormService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getFormulario(idFormulario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_FORMULARIO + "/" + idFormulario;
        return this.http.get(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Formulario",
                    text: "Error Cargando Formulario.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getFormularioReporte(idReporte) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_REPORTE + "/" + idReporte;
        //alert(url);
        return this.http.get(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Reporte",
                    text: "Error Cargando Reporte.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postFormulario(infoPayload) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_FORMULARIO;
        const token = sessionStorage.getItem("token");
        const httpHeaders = new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]()
            .set("Authorization", "Bearer " + token)
            .set("Content-Type", "application/json");
        return this.http.post(url, infoPayload, { headers: httpHeaders }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Formulario",
                    text: "Verifique la informacion ingresada.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
SetFormService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
SetFormService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], SetFormService);



/***/ }),

/***/ "./src/app/servicios/signal-r.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/signal-r.service.ts ***!
  \***********************************************/
/*! exports provided: SignalRService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SignalRService", function() { return SignalRService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _aspnet_signalr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @aspnet/signalr */ "./node_modules/@aspnet/signalr/dist/esm/index.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");




let SignalRService = class SignalRService {
    constructor() {
        this.startConnection = () => {
            this.hubConnection = new _aspnet_signalr__WEBPACK_IMPORTED_MODULE_2__["HubConnectionBuilder"]()
                .withUrl(_constants_constants__WEBPACK_IMPORTED_MODULE_3__["Constants"].ROOT_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_3__["Constants"].URL_SIGNALR)
                .build();
            this.hubConnection
                .start()
                .then(() => {
                console.log('Connection started');
                let infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
                this.hubConnection.invoke("Join", "SuperAdmin", infoUsuario[0].IdTabla);
                clearInterval(this.interval);
            })
                .catch(err => console.log('Error while starting connection: ' + err));
            this.hubConnection.onclose(() => {
                this.interval = setInterval(this.startConnection, 5000);
                //console.log("se cierra la conexion");
            });
        };
        this.sinalRListener = () => {
            this.hubConnection.on('recibeData', (data) => {
                console.log(data);
            });
        };
    }
};
SignalRService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], SignalRService);



/***/ }),

/***/ "./src/app/servicios/tipo-documento.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/servicios/tipo-documento.service.ts ***!
  \*****************************************************/
/*! exports provided: TipoDocumentoService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TipoDocumentoService", function() { return TipoDocumentoService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TipoDocumentoService = class TipoDocumentoService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getTiposDocumento() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_DOCUMENTO;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Documento",
                    text: "Error Cargando Tipos Documento.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
TipoDocumentoService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
TipoDocumentoService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], TipoDocumentoService);



/***/ }),

/***/ "./src/app/servicios/tipo-motivo-clas.service.ts":
/*!*******************************************************!*\
  !*** ./src/app/servicios/tipo-motivo-clas.service.ts ***!
  \*******************************************************/
/*! exports provided: TipoMotivoClasService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TipoMotivoClasService", function() { return TipoMotivoClasService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TipoMotivoClasService = class TipoMotivoClasService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getTipoMotivoClas(idTipoMotivoClas) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO_CLAS +
            "/" +
            idTipoMotivoClas;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo",
                    text: "Error Cargando Tipo Motivo.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postTipoMotivoClas(params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO_CLAS;
        return this.http.post(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo Clas",
                    text: "Verifique la informacion ingresada.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putTipoMotivoClas(idTipoMotivoClas, params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO_CLAS +
            "/" +
            idTipoMotivoClas;
        return this.http.put(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo Clas",
                    text: "Error actualizando información del tipo motivo clas.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteTipoMotivoClas(idTipoMotivoClas, usuario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO_CLAS +
            "/" +
            idTipoMotivoClas +
            "/" +
            usuario;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo Clas",
                    text: "Error eliminado información del tipo motivo clas.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
TipoMotivoClasService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
TipoMotivoClasService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], TipoMotivoClasService);



/***/ }),

/***/ "./src/app/servicios/tipo-motivo.service.ts":
/*!**************************************************!*\
  !*** ./src/app/servicios/tipo-motivo.service.ts ***!
  \**************************************************/
/*! exports provided: TipoMotivoService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TipoMotivoService", function() { return TipoMotivoService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TipoMotivoService = class TipoMotivoService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getTipoMotivo(idTipoMotivo) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO + "/" + idTipoMotivo;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo",
                    text: "Error Cargando Tipo Motivo.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postTipoMotivo(params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO;
        return this.http.post(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo",
                    text: "Verifique la informacion ingresada.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putTipoMotivo(idTipoMotivo, params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO + "/" + idTipoMotivo;
        return this.http.put(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo",
                    text: "Error actualizando información del tipo motivo.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteTipoMotivo(idTipoMotivo, usuario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_MOTIVO +
            "/" +
            idTipoMotivo +
            "/" +
            usuario;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Motivo",
                    text: "Error eliminado información del tipo motivo.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
TipoMotivoService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
TipoMotivoService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], TipoMotivoService);



/***/ }),

/***/ "./src/app/servicios/tipo-novedad.service.ts":
/*!***************************************************!*\
  !*** ./src/app/servicios/tipo-novedad.service.ts ***!
  \***************************************************/
/*! exports provided: TipoNovedadService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TipoNovedadService", function() { return TipoNovedadService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TipoNovedadService = class TipoNovedadService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getTiposNovedades(idTipoNovedad) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_NOVEDAD + "/" + idTipoNovedad;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Novedad",
                    text: "Error Cargando Tipos Novedades.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    postTipoNovedad(params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_NOVEDAD;
        return this.http.post(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Novedad",
                    text: "Verifique la informacion ingresada.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putTipoNovedad(idTipoNovedad, params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_NOVEDAD + "/" + idTipoNovedad;
        return this.http.put(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Novedad",
                    text: "Error actualizando información del tipo novedad.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteTipoNovedad(idTipoNovedad, usuario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_NOVEDAD +
            "/" +
            idTipoNovedad +
            "/" +
            usuario;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Novedad",
                    text: "Error eliminado información tipo novedad.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
TipoNovedadService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
TipoNovedadService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], TipoNovedadService);



/***/ }),

/***/ "./src/app/servicios/tipo-usuario.service.ts":
/*!***************************************************!*\
  !*** ./src/app/servicios/tipo-usuario.service.ts ***!
  \***************************************************/
/*! exports provided: TipoUsuarioService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TipoUsuarioService", function() { return TipoUsuarioService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TipoUsuarioService = class TipoUsuarioService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getTiposUsuario() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TIPO_USUARIO;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Tipo Documento",
                    text: "Error Cargando Tipos Documento.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
TipoUsuarioService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
TipoUsuarioService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], TipoUsuarioService);



/***/ }),

/***/ "./src/app/servicios/transportador.service.ts":
/*!****************************************************!*\
  !*** ./src/app/servicios/transportador.service.ts ***!
  \****************************************************/
/*! exports provided: TransportadorService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransportadorService", function() { return TransportadorService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let TransportadorService = class TransportadorService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getTransportador() {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_TRANSPORTADOR;
        return this.http.get(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Transportador",
                    text: "Error Cargando la informacion.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
TransportadorService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
TransportadorService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], TransportadorService);



/***/ }),

/***/ "./src/app/servicios/usuario.service.ts":
/*!**********************************************!*\
  !*** ./src/app/servicios/usuario.service.ts ***!
  \**********************************************/
/*! exports provided: UsuarioService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UsuarioService", function() { return UsuarioService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let UsuarioService = class UsuarioService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    postUsuario(params) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_USUARIO;
        return this.http.post(url, params).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Usuario",
                    text: "Verifique la informacion ingresada.",
                    type: "error",
                    confirmButtonColor: "#127570"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    putUsuario(usuario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_USUARIO;
        return this.http.put(url, usuario).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Usuario",
                    text: "Error actualizando información del usuario.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    deleteUsuario(usuario) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_USUARIO + "/" + usuario;
        return this.http.delete(url).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Usuario",
                    text: "Error eliminado información del usuario.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
    getUsuariosPersonas(tipoUsuario, idUsuario, agencia) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL +
            _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_USUARIO +
            "/" +
            tipoUsuario +
            "/" +
            idUsuario +
            "/" +
            agencia;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Usuario",
                    text: "Error Cargando Usuarios.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
UsuarioService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
UsuarioService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], UsuarioService);



/***/ }),

/***/ "./src/app/servicios/vehiculo.service.ts":
/*!***********************************************!*\
  !*** ./src/app/servicios/vehiculo.service.ts ***!
  \***********************************************/
/*! exports provided: VehiculoService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VehiculoService", function() { return VehiculoService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/constants */ "./src/app/constants/constants.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! sweetalert2/dist/sweetalert2.all.js */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");






 //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

let VehiculoService = class VehiculoService {
    constructor(http, utils) {
        this.http = http;
        this.utils = utils;
    }
    getVehiculos(idVehiculo) {
        const url = _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].BASE_URL + _constants_constants__WEBPACK_IMPORTED_MODULE_1__["Constants"].URL_VEHICULO + "/" + idVehiculo;
        return this.http.get(url /*, {headers:httpHeaders}*/).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(err => {
            console.log(JSON.stringify(err));
            if (err.status === 401) {
                this.utils.cerrarSesion();
            }
            else {
                sweetalert2_dist_sweetalert2_all_js__WEBPACK_IMPORTED_MODULE_6___default.a.fire({
                    title: "Error Vehiculo",
                    text: "Error Cargando Vehiculo.",
                    type: "error"
                });
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["throwError"])(err);
        }));
    }
};
VehiculoService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"] }
];
VehiculoService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: "root"
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _utils_utils__WEBPACK_IMPORTED_MODULE_7__["Utils"]])
], VehiculoService);



/***/ }),

/***/ "./src/app/serviciosasignados/serviciosasignados.component.css":
/*!*********************************************************************!*\
  !*** ./src/app/serviciosasignados/serviciosasignados.component.css ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvc2VydmljaW9zYXNpZ25hZG9zL3NlcnZpY2lvc2FzaWduYWRvcy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/serviciosasignados/serviciosasignados.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/serviciosasignados/serviciosasignados.component.ts ***!
  \********************************************************************/
/*! exports provided: ServiciosasignadosComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServiciosasignadosComponent", function() { return ServiciosasignadosComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _servicios_servicio_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../servicios/servicio.service */ "./src/app/servicios/servicio.service.ts");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/utils */ "./src/app/utils/utils.ts");







let ServiciosasignadosComponent = class ServiciosasignadosComponent {
    constructor(sServicio, ruta) {
        this.sServicio = sServicio;
        this.ruta = ruta;
        this.displayedColumns = [
            'NroServicio',
            'Prioridad',
            'Nombre',
            'tipoDireccion',
            'Telefono',
            'Direccion',
            'Municipio',
            'Departamento'
        ];
        this.isData = false;
        this.sServicio.getInformeServiciosAsignados().subscribe(data => {
            console.log(JSON.stringify(data));
            this.isData = true;
            this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_5__["MatTableDataSource"](data);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        });
    }
    ngOnInit() {
        this.ruta.setRuta();
    }
    applyFilter(filterValue) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
};
ServiciosasignadosComponent.ctorParameters = () => [
    { type: _servicios_servicio_service__WEBPACK_IMPORTED_MODULE_2__["ServicioService"] },
    { type: _utils_utils__WEBPACK_IMPORTED_MODULE_6__["Utils"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_4__["MatSort"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_4__["MatSort"])
], ServiciosasignadosComponent.prototype, "sort", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], ServiciosasignadosComponent.prototype, "paginator", void 0);
ServiciosasignadosComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-serviciosasignados',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./serviciosasignados.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/serviciosasignados/serviciosasignados.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./serviciosasignados.component.css */ "./src/app/serviciosasignados/serviciosasignados.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_servicios_servicio_service__WEBPACK_IMPORTED_MODULE_2__["ServicioService"], _utils_utils__WEBPACK_IMPORTED_MODULE_6__["Utils"]])
], ServiciosasignadosComponent);



/***/ }),

/***/ "./src/app/tiempos-rutas/tiempos-rutas.component.css":
/*!***********************************************************!*\
  !*** ./src/app/tiempos-rutas/tiempos-rutas.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvdGllbXBvcy1ydXRhcy90aWVtcG9zLXJ1dGFzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/tiempos-rutas/tiempos-rutas.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/tiempos-rutas/tiempos-rutas.component.ts ***!
  \**********************************************************/
/*! exports provided: TiemposRutasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TiemposRutasComponent", function() { return TiemposRutasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let TiemposRutasComponent = class TiemposRutasComponent {
    constructor() { }
    ngOnInit() {
    }
};
TiemposRutasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-tiempos-rutas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./tiempos-rutas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/tiempos-rutas/tiempos-rutas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./tiempos-rutas.component.css */ "./src/app/tiempos-rutas/tiempos-rutas.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], TiemposRutasComponent);



/***/ }),

/***/ "./src/app/ubicacion/ubicacion.component.css":
/*!***************************************************!*\
  !*** ./src/app/ubicacion/ubicacion.component.css ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvdWJpY2FjaW9uL3ViaWNhY2lvbi5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/ubicacion/ubicacion.component.ts":
/*!**************************************************!*\
  !*** ./src/app/ubicacion/ubicacion.component.ts ***!
  \**************************************************/
/*! exports provided: UbicacionComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UbicacionComponent", function() { return UbicacionComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let UbicacionComponent = class UbicacionComponent {
    constructor() { }
    ngOnInit() {
    }
};
UbicacionComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-ubicacion',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./ubicacion.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/ubicacion/ubicacion.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./ubicacion.component.css */ "./src/app/ubicacion/ubicacion.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], UbicacionComponent);



/***/ }),

/***/ "./src/app/usuario/usuario.component.css":
/*!***********************************************!*\
  !*** ./src/app/usuario/usuario.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhcHAvdXN1YXJpby91c3VhcmlvLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/usuario/usuario.component.ts":
/*!**********************************************!*\
  !*** ./src/app/usuario/usuario.component.ts ***!
  \**********************************************/
/*! exports provided: UsuarioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UsuarioComponent", function() { return UsuarioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let UsuarioComponent = class UsuarioComponent {
    constructor() { }
    ngOnInit() {
    }
};
UsuarioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-usuario',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./usuario.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/usuario/usuario.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./usuario.component.css */ "./src/app/usuario/usuario.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], UsuarioComponent);



/***/ }),

/***/ "./src/app/utils/myfilterpipe.ts":
/*!***************************************!*\
  !*** ./src/app/utils/myfilterpipe.ts ***!
  \***************************************/
/*! exports provided: Myfilterpipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Myfilterpipe", function() { return Myfilterpipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let Myfilterpipe = class Myfilterpipe {
    transform(items, selectedCargaId) {
        /*if (!items || !selectedCargaId) {
            return items;
        }*/
        console.log(JSON.stringify(items));
        items = selectedCargaId;
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        //return items.filter(item => item.options.cargaId === selectedCargaId);
        return items;
    }
};
Myfilterpipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'myfilter',
        pure: false
    })
], Myfilterpipe);



/***/ }),

/***/ "./src/app/utils/utils.ts":
/*!********************************!*\
  !*** ./src/app/utils/utils.ts ***!
  \********************************/
/*! exports provided: Utils */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Utils", function() { return Utils; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _model_form_form_textbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../model-form/form-textbox */ "./src/app/model-form/form-textbox.ts");
/* harmony import */ var _model_form_form_dropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model-form/form-dropdown */ "./src/app/model-form/form-dropdown.ts");
/* harmony import */ var _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../servicios/login-service.service */ "./src/app/servicios/login-service.service.ts");






let Utils = class Utils {
    constructor(router, servicioLogin) {
        this.router = router;
        this.servicioLogin = servicioLogin;
    }
    setRuta() {
        sessionStorage.setItem('ruta', this.router.url);
    }
    cerrarSesion() {
        this.servicioLogin.setUserLoggedOut();
    }
    formatFormulario(data) {
        //console.log(JSON.stringify(data));
        let arrayDatos = [];
        let parametrosDestino = [];
        let procedimientoDestino = '';
        data.forEach(element => {
            //let respuesta = "";
            //alert(JSON.stringify(element));
            parametrosDestino.push({
                key: element.key,
                parametro: element.parametroDestino
            });
            procedimientoDestino = element.procedimientoDestino;
            if (element.required == 1) {
                element.required = true;
            }
            else {
                element.required = false;
            }
            if (element.type == 'text' ||
                element.type == 'password' ||
                element.type == 'email' ||
                element.type == 'number' ||
                element.type == 'date') {
                //alert(JSON.stringify(element));
                arrayDatos.push(new _model_form_form_textbox__WEBPACK_IMPORTED_MODULE_3__["FormTextbox"](element));
            }
            else if (element.type == 'dropdown') {
                arrayDatos.push(new _model_form_form_dropdown__WEBPACK_IMPORTED_MODULE_4__["FormDropdown"](element));
            }
        });
        const response = {
            parametros: parametrosDestino,
            arrayDatos: arrayDatos
        };
        //alert(JSON.stringify(response));
        return response;
    }
};
Utils.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_5__["LoginService"] }
];
Utils = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"], _servicios_login_service_service__WEBPACK_IMPORTED_MODULE_5__["LoginService"]])
], Utils);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! D:\Proyectos\Ally\CnCaldas\FrontEnd\src\main.ts */"./src/main.ts");


/***/ }),

/***/ 1:
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/*!************************!*\
  !*** stream (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map